(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[128,26,30,34,37],{

/***/ "+Rc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaTrigger; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("XiOS");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("EkOT");
/* harmony import */ var _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("YZTm");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("1JJ2");
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("m1JM");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("sRdV");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("U6GL");
/* harmony import */ var _frameworks_form_inputs_input_button_InputButton__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("W+NJ");
/* harmony import */ var _frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("U2fG");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_24__);










var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var CUSTOM_HEADER_HEIGHT = 44;
var CriteriaTrigger = function CriteriaTrigger(props) {
  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_15__[/* useResponsive */ "b"])(),
      isAppMounted = _useResponsive.isAppMounted,
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_10__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_11__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0];

  var pageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_12__[/* usePageContext */ "b"])();
  var rootRef = Object(react__WEBPACK_IMPORTED_MODULE_10__["useRef"])();
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__[/* useTracking */ "a"])();

  var customLayerHeader = __jsx("div", {
    className: "flex items-center justify-between fixed z-1 top-0 inset-x-0 bg-white border-b px-15",
    style: {
      height: CUSTOM_HEADER_HEIGHT,
      maxHeight: CUSTOM_HEADER_HEIGHT
    }
  }, __jsx("button", {
    onClick: props.onClose,
    type: "button",
    className: "leading-0 ms-auto flex-1"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    hasRtl: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_14__[/* ICONS */ "a"].ARROW_TAIL_LEFT,
    width: "calc(18rem / 16)"
  }), __jsx("span", {
    className: "sr-only"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('common.backNavigation'))), __jsx("span", {
    className: "mx-auto px-10 text-center w-full"
  }, props.layerHeader), __jsx("span", {
    className: "flex-1 h-full"
  }, props.layerHeaderSlot));

  var buttons = props.buttons.map(function (btnProps) {
    var children = btnProps.children,
        allOtherProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(btnProps, ["children"]);

    return __jsx("div", {
      key: Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_16__[/* generateUniqueId */ "b"])([btnProps.theme, btnProps.color, btnProps.colorBg, btnProps.colorBorder], 'criteria-btn-')
    }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_19__[/* Button */ "a"], allOtherProps, children));
  });
  var criteriaDropdownOrLayer = isDesktop ? __jsx("div", {
    className: "flex flex-2"
  }, __jsx(_frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_21__[/* DropDown */ "a"], {
    className: "flex-1" // $FlowFixMe
    ,
    contentStyle: _objectSpread({
      minWidth: props.dropDownMinWidth || 300
    }, props.dropDownStyle),
    isExpanded: props.isOpen,
    onClose: props.onClose,
    relative: props.isDropDownRelative,
    hasArrow: false,
    rootRef: rootRef,
    theme: "hollow",
    unmountsOnClose: true
  }, function () {
    return __jsx(react__WEBPACK_IMPORTED_MODULE_10___default.a.Fragment, null, props.children, props.reassurance.shouldDisplay && __jsx("div", {
      className: "pt-0 p-10 max-w-1/2 mx-auto text-mediumGrey text-start text-10"
    }, props.reassurance.text), !!buttons.length && __jsx("div", {
      className: "p-20"
    }, props.buttonsSlot && __jsx("div", {
      className: "pb-10"
    }, props.buttonsSlot), __jsx("div", {
      className: "flex gap-10 items-center justify-between"
    }, buttons)));
  })) : __jsx(_frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_23__[/* Layer */ "b"], {
    ariaLabelledby: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_13__[/* ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER */ "p"],
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('common.close'),
    customHeader: {
      content: customLayerHeader,
      height: CUSTOM_HEADER_HEIGHT
    },
    hasAnimateEnter: true,
    onClose: props.onClose
  }, __jsx("div", {
    className: "flex flex-col h-full"
  }, __jsx("div", {
    className: "scroll-y"
  }, props.children, props.reassurance.shouldDisplay && __jsx("div", {
    className: "sm:border-t-1 mt-10 lg:mt-0 mx-10 sm:pt-10 text-mediumGrey text-start text-12"
  }, props.reassurance.text)), buttons.length && __jsx("div", {
    className: "bg-white border-t-1 p-15 shadow mt-auto"
  }, props.buttonsSlot && __jsx("div", {
    className: "pb-10"
  }, props.buttonsSlot), __jsx("div", {
    className: "flex items-center justify-between mt-auto lg:px-0 relative w-full text-end"
  }, buttons))));
  var defaultTheme = isDesktop ? 'default' : 'remote';
  var theme = props.theme ? props.theme : defaultTheme;
  return __jsx("div", {
    "data-testid": props.dataTestId,
    ref: rootRef,
    className: classnames__WEBPACK_IMPORTED_MODULE_24___default()({
      'border-success border-1': !!props.badgeCount
    }, props.className)
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_24___default()('relative', {
      'criteria-arrow': props.isOpen
    })
  }, __jsx(_frameworks_form_inputs_input_button_InputButton__WEBPACK_IMPORTED_MODULE_22__[/* InputButton */ "a"], {
    badgeCount: props.badgeCount,
    className: "w-full",
    dataTestId: "criteria-trigger-button",
    hasSwitch: props.hasSwitch,
    iconName: props.buttonIcon,
    isActive: props.isOpen,
    isFilled: props.buttonIsFilled,
    isLoading: isDesktop && props.isLoading,
    key: String(isAppMounted),
    onClear: isDesktop ? function () {
      props.onClear && props.onClear();
    } : undefined,
    onClick: function onClick(e) {
      e === null || e === void 0 ? void 0 : e.preventDefault();

      if (props.isOpen) {
        props.onClose && props.onClose();
      } else {
        props.onOpen && props.onOpen();

        if (props.trackingLabel && criteriaContext.trackingActionName) {
          track({
            actionGA: criteriaContext.trackingActionName,
            categoryGA: pageContext.pageId,
            labelGA: props.trackingLabel
          });
        }
      }
    },
    theme: theme
  }, props.buttonLabel)), props.isOpen && criteriaDropdownOrLayer);
};
CriteriaTrigger.defaultProps = {
  buttons: [],
  reassurance: {
    shouldDisplay: false,
    text: ''
  }
};

/***/ }),

/***/ "+mhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureCity; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PFCZ");



function setDepartureCity(_ref) {
  var value = _ref.value;
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_CITY */ "b"], {
    value: value
  });
}



/***/ }),

/***/ "/FsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_AVAILABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_EXCLUSIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_NO_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_NO_DEPARTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_NOT_BOOKABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_SIBLING_SUMMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_SIBLING_WINTER; });
var API_AVAILABLE = 'available';
var API_CLOSED = 'closed';
var API_EXCLUSIVITY = 'exclusivity';
var API_FULL = 'full';
var API_NO_FLIGHT = 'noFlight';
var API_NO_DEPARTURE = 'noDeparture';
var API_OPEN = 'open';
var API_SIBLING_SUMMER = 'siblingSummer';
var API_SIBLING_WINTER = 'siblingWinter';
var API_NOT_BOOKABLE = [API_CLOSED, API_EXCLUSIVITY, API_FULL, API_NO_DEPARTURE, API_SIBLING_SUMMER, API_SIBLING_WINTER];


/***/ }),

/***/ "05PS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ getCalendar; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getSelectedMonth; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ getCalendarLoading; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ getDays; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ getPricesByDays; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ getDepartureDateBookable; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getAvailableDurations; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getInitialDuration; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ getCalendarTripPrice; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ getCalendarTripPriceLoading; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getBlockInputDepartureDate; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getCalendarDepartureCity; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getCalendarProductId; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getIsPriceCalendarSelection; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("x0AG");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("E9XD");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("Rfxz");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("JTJg");

// EXTERNAL MODULE: ./src/utils/api-availability/constants.js
var constants = __webpack_require__("/FsK");

// CONCATENATED MODULE: ./src/utils/api-availability/availabilityUtils.js




function isBookable(availability) {
  return !!availability && !constants["d" /* API_NOT_BOOKABLE */].includes(availability);
}


// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/store/calendar/calendar.selector.js
















var INITIAL_LIST = [];
var INITIAL_CALENDAR = {};

function getMonthIndex() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var monthId = arguments.length > 1 ? arguments[1] : undefined;
  return months.findIndex(function (_ref) {
    var id = _ref.id;
    return id === monthId;
  });
}

function getMonthIndexFromDays() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dayId = arguments.length > 1 ? arguments[1] : undefined;
  /**
   * return if a day is elligible based on:
   * - dayContent.id equals dayId parameter
   * - dayContent.isCurrentMonth at true
   * @param  {Object} day  objet day from calendar.months[i]
   * @return {boolean}     this day is elligible
   */

  var matchBasedOnDay = function matchBasedOnDay(_ref2) {
    var dayContent = _ref2.dayContent;
    return dayContent.id === dayId && dayContent.isCurrentMonth;
  };

  return months.findIndex(function (_ref3) {
    var days = _ref3.days;
    return days.some(matchBasedOnDay);
  });
}

function getCurrentMonth() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedDay = arguments.length > 1 ? arguments[1] : undefined;
  var selectedDayMonthIndex = arguments.length > 2 ? arguments[2] : undefined;
  var firstMonthIndex = arguments.length > 3 ? arguments[3] : undefined;
  return selectedDay && selectedDayMonthIndex > -1 ? months[selectedDayMonthIndex] : months[firstMonthIndex];
}

function getDaysFromMonths(calendar, monthId) {
  var months = calendar.months;
  var monthIndex = getMonthIndex(months, monthId);
  return get_default()(months, "".concat(monthIndex, ".days"));
}

function getDaysFromDays(calendar, dayId) {
  var months = calendar.months,
      firstAvailableMonthIndex = calendar.firstAvailableMonthIndex;
  var selectedDayMonthIndex = getMonthIndexFromDays(months, dayId);
  var month = getCurrentMonth(months, dayId, selectedDayMonthIndex, firstAvailableMonthIndex);
  return get_default()(month, 'days', INITIAL_LIST);
}

function getDaysSelector() {
  var calendar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_CALENDAR;
  var selectedMonth = arguments.length > 1 ? arguments[1] : undefined;
  var selectedDay = arguments.length > 2 ? arguments[2] : undefined;

  if (isEmpty_default()(calendar)) {
    return INITIAL_LIST;
  }

  var daysFromMonths = getDaysFromMonths(calendar, selectedMonth);
  var daysFromDays = getDaysFromDays(calendar, selectedDay);
  return !daysFromMonths || daysFromMonths === daysFromDays ? daysFromDays : daysFromMonths;
}

var calendarSelector = function calendarSelector(_ref4) {
  var calendar = _ref4.calendar;
  return calendar;
};

var getCalendar = Object(lib["createSelector"])(calendarSelector, function (_ref5) {
  var calendar = _ref5.calendar;
  return calendar;
});
var getSelectedMonth = Object(lib["createSelector"])(calendarSelector, function (_ref6) {
  var selectedMonth = _ref6.selectedMonth;
  return selectedMonth;
});
var getCalendarLoading = Object(lib["createSelector"])(calendarSelector, function (_ref7) {
  var isLoading = _ref7.isLoading;
  return isLoading;
});
var getDays = Object(lib["createSelector"])(getCalendar, getSelectedMonth, tripCriteria_selector["b" /* getDepartureDate */], getDaysSelector);
var getPricesByDays = Object(lib["createSelector"])(calendarSelector, function (_ref8) {
  var byDays = _ref8.byDays;
  return byDays;
});
var getDepartureDateBookable = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], getCalendarLoading, function (_ref9, departureDate, isLoading) {
  var _byDays$dayId;

  var byDays = _ref9.byDays;

  if (!departureDate || isLoading) {
    return false;
  }

  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);
  return byDays && byDays[dayId] && isBookable((_byDays$dayId = byDays[dayId]) === null || _byDays$dayId === void 0 ? void 0 : _byDays$dayId.availability);
});
var getAvailableDurations = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], function (_ref10, departureDate) {
  var _bookableDates$months, _bookableDates$months2, _bookableDates$months3;

  var bookableDates = _ref10.bookableDates,
      bookableDatesLoading = _ref10.bookableDatesLoading;

  if (bookableDatesLoading) {
    return [];
  }

  if (!departureDate || !bookableDates) {
    return null;
  }

  var monthId = moment_default()(departureDate).format(apiDate["b" /* API_MONTH_ID */]);
  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);
  return Array.isArray(bookableDates === null || bookableDates === void 0 ? void 0 : bookableDates.months) ? (bookableDates === null || bookableDates === void 0 ? void 0 : (_bookableDates$months = bookableDates.months.find(function (m) {
    return m.id.toString() === monthId;
  })) === null || _bookableDates$months === void 0 ? void 0 : (_bookableDates$months2 = _bookableDates$months.days.find(function (d) {
    return d.id.toString() === dayId;
  })) === null || _bookableDates$months2 === void 0 ? void 0 : (_bookableDates$months3 = _bookableDates$months2.availabilities.filter(function (a) {
    return a.status === 'AVAILABLE' || a.status === 'UNKNOWN';
  })) === null || _bookableDates$months3 === void 0 ? void 0 : _bookableDates$months3.reduce(function (acc, a) {
    return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(a.durations));
  }, [])) || null : null;
});
var getInitialDuration = Object(lib["createSelector"])(calendarSelector, function (_ref11) {
  var initialDuration = _ref11.initialDuration;
  return initialDuration;
});
var getCalendarTripPrice = Object(lib["createSelector"])(calendarSelector, function (_ref12) {
  var tripPrice = _ref12.tripPrice;
  return tripPrice;
});
var getCalendarTripPriceLoading = Object(lib["createSelector"])(calendarSelector, function (_ref13) {
  var tripPriceIsLoading = _ref13.tripPriceIsLoading;
  return tripPriceIsLoading;
});
var getBlockInputDepartureDate = Object(lib["createSelector"])(calendarSelector, function (_ref14) {
  var blockInputDepartureDate = _ref14.blockInputDepartureDate;
  return blockInputDepartureDate;
});
var getCalendarDepartureCity = Object(lib["createSelector"])(calendarSelector, function (_ref15) {
  var departureCity = _ref15.departureCity;
  return departureCity;
});
var getCalendarProductId = Object(lib["createSelector"])(calendarSelector, function (_ref16) {
  var productId = _ref16.productId;
  return productId;
});
var getIsPriceCalendarSelection = Object(lib["createSelector"])(calendarSelector, function (_ref17) {
  var isPriceCalendarSelection = _ref17.isPriceCalendarSelection;
  return isPriceCalendarSelection;
});

/***/ }),

/***/ "0ibg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setKeywords; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");


function setKeywords(keywords) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SEARCH_SET_KEYWORDS */ "u"], {
    keywords: keywords
  });
}

/***/ }),

/***/ "0oug":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__("4GWN");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "15pl":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "1P7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFormattedLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCursorClass; });
function getFormattedLabel() {
  var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!placeholder) {
    return '';
  }

  return isRequired ? "".concat(placeholder, "*") : placeholder;
}
function getCursorClass(_ref) {
  var hasPointer = _ref.hasPointer,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly;

  if (isDisabled) {
    return 'cursor-not-allowed';
  }

  if (isReadOnly) {
    return 'cursor-default';
  }

  if (isLoading) {
    return 'cursor-wait';
  }

  return hasPointer ? 'cursor-pointer' : '';
}

/***/ }),

/***/ "1aYn":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("S3pA"),
    isArrayLike = __webpack_require__("9y2L"),
    keys = __webpack_require__("BlJA");

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ "1bWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setKids; });
/* unused harmony export updateKid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setKidsWithoutClearProposals; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* eslint-disable flowtype/no-weak-types */



function setKids(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS */ "c"], {
    kids: kids
  });
}

function setKidsWithoutClearProposals(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */ "d"], {
    kids: kids
  });
}

function resetKids() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_RESET_KIDS */ "b"]);
}

function updateKid(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_KID */ "e"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}



/***/ }),

/***/ "1xc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FacetCategory_FacetCategory; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetList.jsx + 1 modules
var FacetList = __webpack_require__("YMTf");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/SearchFacets.utils.js
var SearchFacets_utils = __webpack_require__("zjU+");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetLists.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var FacetLists_FacetLists = function FacetLists(_ref) {
  var activeCustomFacets = _ref.activeCustomFacets,
      activeFacets = _ref.activeFacets,
      facetsFromSearch = _ref.facetsFromSearch,
      onChange = _ref.onChange,
      templateConfig = _ref.templateConfig;
  var capitalizeLabels = templateConfig.capitalizeLabels,
      _templateConfig$facet = templateConfig.facetLists,
      facetListsConfig = _templateConfig$facet === void 0 ? [] : _templateConfig$facet;

  var localizeFacetLabel = function localizeFacetLabel(facet, facetLabels) {
    if (!facetLabels) {
      return facet;
    }

    var localizedLabel = Object(SearchFacets_utils["b" /* getFacetLocalizedLabel */])({
      facetValue: facet.value,
      facetLabels: facetLabels
    });

    if (!localizedLabel) {
      return facet;
    }

    return _objectSpread(_objectSpread({}, facet), {}, {
      label: localizedLabel
    });
  };

  return __jsx(react["Fragment"], null, facetListsConfig.map(function (_ref2) {
    var deep = _ref2.deep,
        subFacetId = _ref2.id,
        facetLabels = _ref2.facetLabels,
        titleLabel = _ref2.titleLabel;
    var facetFromSearch = facetsFromSearch.find(function (_ref3) {
      var id = _ref3.id;
      return id === subFacetId;
    });

    if (!facetFromSearch || !facetFromSearch.list) {
      return;
    }

    if (!deep) {
      return __jsx(FacetList["a" /* FacetList */], {
        activeCustomFacets: activeCustomFacets[subFacetId],
        activeFacets: activeFacets[subFacetId],
        capitalizeLabels: capitalizeLabels,
        className: "FacetList-".concat(subFacetId),
        facets: facetFromSearch.list.map(function (facet) {
          return localizeFacetLabel(facet, facetLabels);
        }),
        key: subFacetId,
        name: subFacetId,
        onChange: onChange,
        title: Object(i18n["h" /* t */])(titleLabel)
      });
    }

    return facetFromSearch.list.map(function (_ref4) {
      var label = _ref4.label,
          _ref4$list = _ref4.list,
          list = _ref4$list === void 0 ? [] : _ref4$list,
          value = _ref4.value;
      return __jsx(FacetList["a" /* FacetList */], {
        activeCustomFacets: activeCustomFacets[subFacetId],
        activeFacets: activeFacets[subFacetId],
        capitalizeLabels: capitalizeLabels,
        className: "FacetList-".concat(subFacetId),
        facets: list.map(function (facet) {
          return localizeFacetLabel(facet, facetLabels);
        }) || [],
        key: value,
        name: subFacetId,
        onChange: onChange,
        title: label || Object(i18n["h" /* t */])(titleLabel)
      });
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetCategory.jsx
var FacetCategory_jsx = react_default.a.createElement;


var FacetCategory_FacetCategory = function FacetCategory(props) {
  return FacetCategory_jsx(FacetLists_FacetLists, props);
};

/***/ }),

/***/ "2M3I":
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__("9au6"),
    isIterateeCall = __webpack_require__("R5u7"),
    toFinite = __webpack_require__("fWyh");

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ "393O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_WHEN_EVENT; });
var OPEN_CRITERIA_WHEN_EVENT = 'openCriteriaWhen';

/***/ }),

/***/ "3OwS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__("gz38"),
    Collapse = _require.Collapse;

var _require2 = __webpack_require__("I2LH"),
    UnmountClosed = _require2.UnmountClosed; // Default export


module.exports = UnmountClosed; // Extra "named exports"

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

/***/ }),

/***/ "3y23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FacetList_utils_getChoices; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/utils/string/stringUtils.js
var stringUtils = __webpack_require__("E8Xq");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetLabel.jsx
var __jsx = react_default.a.createElement;

function FacetLabel(_ref) {
  var children = _ref.children;

  if (!children) {
    // Safeguard: API can return facets with null names, that must be ignored.
    return null;
  }

  return __jsx("span", null, children);
}
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetList.utils.js









var FacetList_utils_jsx = react_default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}








 // eslint-disable-next-line clubmed/no-fake-component

var FacetList_utils_getChoices = function getChoices(_ref) {
  var activeCustomFacets = _ref.activeCustomFacets,
      activeFacets = _ref.activeFacets,
      _ref$capitalizeLabels = _ref.capitalizeLabels,
      capitalizeLabels = _ref$capitalizeLabels === void 0 ? false : _ref$capitalizeLabels,
      facets = _ref.facets,
      _ref$isWorldMapFullSc = _ref.isWorldMapFullScreen,
      isWorldMapFullScreen = _ref$isWorldMapFullSc === void 0 ? false : _ref$isWorldMapFullSc; // Safeguard: API can return facets with null names, that must be ignored.
  // $FlowFixMe

  return facets === null || facets === void 0 ? void 0 : facets.filter(function (_ref2) {
    var badgeIconProps = _ref2.badgeIconProps,
        label = _ref2.label;
    return Boolean((badgeIconProps === null || badgeIconProps === void 0 ? void 0 : badgeIconProps.iconName) || label);
  }).map(function (_ref3) {
    var badgeIconProps = _ref3.badgeIconProps,
        label = _ref3.label,
        count = _ref3.count,
        value = _ref3.value;
    var isCruiseOrTour = value === '5_CRUISE' || value === '0_TOUR';

    var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
        isTablet = _useResponsive.isTablet;

    var labelElement = FacetList_utils_jsx(FacetLabel, {
      count: count
    }, capitalizeLabels ? Object(stringUtils["b" /* capitalizeFromUppercase */])(label) : label);

    if (badgeIconProps === null || badgeIconProps === void 0 ? void 0 : badgeIconProps.iconName) {
      var newBadgeIconProps = _objectSpread({}, badgeIconProps); // Disable cruise & tour icons when full screen


      if (isWorldMapFullScreen && isCruiseOrTour) {
        newBadgeIconProps = _objectSpread(_objectSpread({}, newBadgeIconProps), {}, {
          className: "".concat(newBadgeIconProps.className, " cursor-not-allowed"),
          colorBg: colors["a" /* COLORS */].GREY,
          colorBorder: colors["a" /* COLORS */].GREY
        });
      }

      labelElement = FacetList_utils_jsx(Badge["a" /* Badge */], newBadgeIconProps);

      if (isTablet) {
        var tooltip = isWorldMapFullScreen && isCruiseOrTour ? Object(i18n["h" /* t */])('faceting.filters.typesOfStay.undisplay_product_map') : badgeIconProps === null || badgeIconProps === void 0 ? void 0 : badgeIconProps.alt;
        labelElement = FacetList_utils_jsx(PopOver["a" /* PopOver */], {
          ariaLabel: (badgeIconProps === null || badgeIconProps === void 0 ? void 0 : badgeIconProps.alt) || '',
          content: FacetList_utils_jsx("span", {
            className: "font-normal font-sans bg-white after:drop-shadow-md mb-10 px-10 py-5 rounded-2  text-14 text-black"
          }, tooltip),
          theme: "typesOfStaySearchFilter",
          triggerOnHover: true
        }, labelElement);
      }
    }

    return {
      isDisabled: isWorldMapFullScreen && isCruiseOrTour,
      isIconOnly: Boolean(badgeIconProps === null || badgeIconProps === void 0 ? void 0 : badgeIconProps.iconName),
      isSelected: activeCustomFacets && activeCustomFacets[value] || activeFacets && activeFacets[value],
      label: labelElement,
      value: value
    };
  });
};

/***/ }),

/***/ "4+vj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPertimmDateFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatPertimmDate; });
/* unused harmony export loadFacetingTopCountries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadOffsetSell; });
/* unused harmony export loadProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadProductsWithIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return searchWithFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadChildcareAvailabilities; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("piMb");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("4mDm");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("5s+n");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("PKPk");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("3bBZ");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("y316");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("L73y");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("KL6I");
/* harmony import */ var _components_widgets_criteria_criteria_facets_search_facets_SearchFacets_utils__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__("zjU+");


























function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_23__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}












var PERTIMM_ENGLISH_SPEAKING_LOCALE = 'en';
function getPertimmDateFormat(locale) {
  return (locale === null || locale === void 0 ? void 0 : locale.slice(0, 2)) === PERTIMM_ENGLISH_SPEAKING_LOCALE ? 'YYYY/MM/DD' : 'DD/MM/YYYY';
}
function formatPertimmDate(departureDate, locale) {
  var format = getPertimmDateFormat(locale);
  return departureDate.isValid() ? departureDate.format(format) : '';
}

function getResortThumbnailArgsConfig(appContext) {
  var query = "query {\n    config {\n      thumbnails {\n        tourDurationPlaceholder\n        cruiseTimingPlaceholder\n        cruiseDurationPlaceholder\n        dateFormat\n      }\n    }\n  }";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_PRODUCT_CONFIG */ "ud"]
  });
}

function getAllProductsInfo(_ref) {
  var appContext = _ref.appContext,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      _ref$ids = _ref.ids,
      ids = _ref$ids === void 0 ? [] : _ref$ids;
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease;
  var _options$offerId = options.offerId,
      offerId = _options$offerId === void 0 ? '' : _options$offerId,
      _options$offerName = options.offerName,
      offerName = _options$offerName === void 0 ? '' : _options$offerName,
      _options$productIds = options.productIds,
      productIds = _options$productIds === void 0 ? [] : _options$productIds;
  return getResortThumbnailArgsConfig(appContext).then(function (data) {
    var resortThumbnailQueryArgs = _objectSpread({
      content: cmsContent,
      release: cmsRelease,
      isMice: false,
      offerName: offerName,
      offerId: offerId
    }, data.config.thumbnails);

    var allProductsId = productIds.length ? ids.filter(function (id) {
      return productIds.includes(id);
    }) : ids;

    if (!allProductsId.length) {
      return Promise.resolve({
        resorts: []
      });
    }

    var query = "query {\n      resorts(resortIds : [\"".concat(allProductsId.join('","'), "\"]) {\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_27__[/* default */ "b"])(resortThumbnailQueryArgs, {
      withoutPrice: true
    }), "\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_PRODUCTS */ "sd"]
    });
  });
}

function loadFacetingTopCountries(_ref2) {
  var appContext = _ref2.appContext;
  var query = "query {\n    config {\n      faceting {\n        topCountries {\n          enabled\n           title\n           items {\n             id\n           }\n        }\n      }\n    }\n  }";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_FACETING_TOP_COUNTRIES */ "qd"]
  });
}
function loadOffsetSell(_ref3) {
  var appContext = _ref3.appContext;
  var query = "\n    query {\n      locale {\n        joyviewOffsetSell\n        resortOffsetSell\n      }\n    }\n  ";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_OFFSET_SELL */ "rd"]
  });
}
function loadProducts(_ref4) {
  var appContext = _ref4.appContext,
      options = _ref4.options;
  return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_26__[/* getIdsFromProducts */ "a"])(appContext).then(function (ids) {
    return getAllProductsInfo({
      appContext: appContext,
      options: options,
      ids: ids
    });
  });
}
function loadProductsWithIds(_ref5) {
  var appContext = _ref5.appContext,
      productIds = _ref5.productIds;
  return getAllProductsInfo({
    appContext: appContext,
    options: {},
    ids: productIds
  });
}
function searchWithFacets(_ref6) {
  var criteria = _ref6.criteria,
      options = _ref6.options,
      appContext = _ref6.appContext;
  var facetingTopCountriesPromise = loadFacetingTopCountries({
    appContext: appContext
  });
  var productsPromise = loadProducts({
    appContext: appContext,
    options: options
  });
  var userIsSeller = Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_34__[/* isSeller */ "g"])(appContext); // $FlowFixMe

  var searchPromise = Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_26__[/* searchWithFacets */ "c"])({
    criteria: _objectSpread(_objectSpread({}, criteria), {}, {
      tripDuration: userIsSeller ? null : criteria.tripDuration
    }),
    appContext: appContext
  });
  return Promise.all([facetingTopCountriesPromise, productsPromise, searchPromise]).then(function (_ref7) {
    var _ref8 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"])(_ref7, 3),
        facetingTopCountriesInfo = _ref8[0],
        productsInfo = _ref8[1],
        pertimmResults = _ref8[2];

    var facetingTopCountries = lodash_get__WEBPACK_IMPORTED_MODULE_24___default()(facetingTopCountriesInfo, 'config.faceting.topCountries');

    var filteredProducts = lodash_get__WEBPACK_IMPORTED_MODULE_24___default()(pertimmResults, 'answers', []).reduce(function (acc, result) {
      var resultProductId = lodash_get__WEBPACK_IMPORTED_MODULE_24___default()(result, 'meta.product_id[0]');

      var resort = productsInfo.resorts.find(function (_ref9) {
        var id = _ref9.id;
        return id === resultProductId;
      });
      var isAllAttendeeAllowed = !!resort && (!criteria.kids || criteria.kids.every(function (_ref10) {
        var birthdate = _ref10.birthdate;
        return Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_30__[/* getKidAgeInMonths */ "k"])({
          birthdate: birthdate,
          departureDate: criteria.departureDate
        }) >= resort.minAuthorizedAge.value;
      }));
      return resort && isAllAttendeeAllowed ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__[/* default */ "a"])(acc), [resort]) : acc;
    }, []);

    var sortedFilteredProducts = criteria.productIds && criteria.productIds.length > 0 ? criteria.productIds.map(function (id) {
      return filteredProducts.find(function (product) {
        return product.id === id;
      });
    }) : filteredProducts;
    return _objectSpread(_objectSpread({
      facetingTopCountries: facetingTopCountries
    }, pertimmResults), {}, {
      query: criteria.query || '',
      search: {
        products: sortedFilteredProducts.filter(Boolean)
      }
    });
  });
}

function getTransportArgs(criteria) {
  var departureCityFilter = lodash_get__WEBPACK_IMPORTED_MODULE_24___default()(criteria, 'filters', []).find(function (filter) {
    return filter.id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_31__[/* DEPARTURE_CITY_FACET_ID */ "r"];
  });

  var selectedDepartureCity = lodash_get__WEBPACK_IMPORTED_MODULE_24___default()(departureCityFilter, 'name');

  switch (selectedDepartureCity) {
    case 'NO':
      return {
        forceWithoutTransport: true,
        departureCity: ''
      };

    case undefined:
      return {
        forceWithoutTransport: false,
        departureCity: criteria.defaultDepartureCity || ''
      };

    default:
      return {
        forceWithoutTransport: false,
        departureCity: selectedDepartureCity
      };
  }
}

function loadPrices(_ref11) {
  var appContext = _ref11.appContext,
      _ref11$criteria = _ref11.criteria,
      criteria = _ref11$criteria === void 0 ? {} : _ref11$criteria,
      withFlexibility = _ref11.withFlexibility;
  var _criteria$offerName = criteria.offerName,
      offerName = _criteria$offerName === void 0 ? '' : _criteria$offerName,
      _criteria$offerId = criteria.offerId,
      offerId = _criteria$offerId === void 0 ? '' : _criteria$offerId,
      _criteria$productIds = criteria.productIds,
      productIds = _criteria$productIds === void 0 ? [] : _criteria$productIds,
      duration = criteria.duration;

  var _getTransportArgs = getTransportArgs(criteria),
      departureCity = _getTransportArgs.departureCity,
      forceWithoutTransport = _getTransportArgs.forceWithoutTransport;

  var date = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_33__[/* formatTimestampDate */ "b"])(criteria.departureDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_31__[/* DATE_FORMAT */ "o"]) || '';
  var dateStart = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_33__[/* formatTimestampDate */ "b"])(criteria.minDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_31__[/* DATE_FORMAT */ "o"]) || '';
  var dateEnd = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_33__[/* formatTimestampDate */ "b"])(criteria.maxDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_31__[/* DATE_FORMAT */ "o"]) || '';
  var hasDateRange = dateStart && dateEnd && (!date || withFlexibility);
  var query = "\n    query {\n      resorts(\n        optimizedPriceCalls: true,\n        ".concat(date ? "date: \"".concat(date, "\",") : '', "\n        ").concat(hasDateRange ? "dateStart: \"".concat(dateStart, "\",") : '', "\n        ").concat(hasDateRange ? "dateEnd: \"".concat(dateEnd, "\",") : '', "\n        resortIds: [\"").concat(productIds.join('","'), "\"],\n        departureCity: \"").concat(departureCity, "\",\n        duration: ").concat(String(duration || null), ",\n        offerName: \"").concat(offerName, "\",\n        offerId: \"").concat(offerId, "\",\n        forceWithoutTransport: ").concat(String(forceWithoutTransport), ",\n      ) {\n        id\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_27__[/* getPriceFields */ "c"])(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_27__[/* cleanupArgs */ "a"])({
    isMice: false,
    optimizedPriceCalls: true,
    resortIds: productIds,
    departureCity: departureCity,
    duration: duration || undefined,
    // for flow: criteria duration can be null, but cleanupArgs doesn't accept null as parameter.
    offerName: offerName,
    offerId: offerId,
    forceWithoutTransport: forceWithoutTransport,
    content: appContext.cmsContent,
    release: appContext.cmsRelease,
    date: date,
    dateStart: dateStart,
    dateEnd: dateEnd
  })), "\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_PRODUCT_PRICE */ "vd"]
  });
}
function loadChildcareAvailabilities(_ref12) {
  var appContext = _ref12.appContext,
      _ref12$criteria = _ref12.criteria,
      criteria = _ref12$criteria === void 0 ? {} : _ref12$criteria;
  var childcareActiveFilters = criteria.childcareActiveFilters,
      _criteria$productIds2 = criteria.productIds,
      productIds = _criteria$productIds2 === void 0 ? [] : _criteria$productIds2,
      arrivalDate = criteria.departureDate,
      duration = criteria.duration,
      kids = criteria.kids;
  var concernedAttendeesBirthdates = [];

  if ((kids === null || kids === void 0 ? void 0 : kids.length) > 0) {
    concernedAttendeesBirthdates = concernedAttendeesBirthdates.concat(kids.map(function (_ref13) {
      var birthdate = _ref13.birthdate;
      return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_33__[/* formatTimestampDate */ "b"])(birthdate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_32__[/* API_DATE_FORMAT */ "a"]);
    }));
  }

  if ((childcareActiveFilters === null || childcareActiveFilters === void 0 ? void 0 : childcareActiveFilters.length) > 0 && moment__WEBPACK_IMPORTED_MODULE_25___default()(arrivalDate).isValid()) {
    concernedAttendeesBirthdates = concernedAttendeesBirthdates.concat(childcareActiveFilters.map(function (filterName) {
      return moment__WEBPACK_IMPORTED_MODULE_25___default()(arrivalDate).subtract(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_31__[/* CHILDCARE_FILTER_FACET_AVERAGE_MONTHS */ "e"][Object(_components_widgets_criteria_criteria_facets_search_facets_SearchFacets_utils__WEBPACK_IMPORTED_MODULE_35__[/* getFacetLocalizedLabelKey */ "c"])(filterName)], 'months').format(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_32__[/* API_DATE_FORMAT */ "a"]);
    }));
  }

  if (concernedAttendeesBirthdates.length === 0) {
    return Promise.resolve();
  }

  var query = "\n    query {\n      childcareSearch(\n        arrival_date: \"".concat(Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_33__[/* formatTimestampDate */ "b"])(arrivalDate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_32__[/* API_DATE_FORMAT */ "a"]) || '', "\",\n        product_ids: [\"").concat(productIds.join('","'), "\"],\n        concerned_attendees_birthdates: [\"").concat(concernedAttendeesBirthdates.join('","'), "\"],\n        duration: ").concat(String(duration || null), ",\n      ) {\n        id\n        productId,\n        availability,\n        isIncluded,\n        ageMin,\n        ageMax\n        remainingStock\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_PRODUCT_CHILDCARE */ "td"]
  });
}

/***/ }),

/***/ "45Yg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRIP_INFORMATION_SET_FLEXIBILITY; });
var TRIP_INFORMATION_SET_FLEXIBILITY = 'TRIP_INFORMATION_SET_FLEXIBILITY';

/***/ }),

/***/ "47go":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    var STATE_OUTPUT       = 0,
        STATE_HTML         = 1,
        STATE_PRE_COMMENT  = 2,
        STATE_COMMENT      = 3,
        WHITESPACE         = /\s/,
        ALLOWED_TAGS_REGEX = /<(\w*)>/g;

    function striptags(html, allowableTags) {
        var html = html || '',
            state = STATE_OUTPUT,
            depth = 0,
            output = '',
            tagBuffer = '',
            inQuote = false,
            i, length, c;

        if (typeof allowableTags === 'string') {
            // Parse the string into an array of tags
            allowableTags = parseAllowableTags(allowableTags);
        } else if (!Array.isArray(allowableTags)) {
            // If it is not an array, explicitly set to null
            allowableTags = null;
        }

        for (i = 0, length = html.length; i < length; i++) {
            c = html[i];

            switch (c) {
                case '<': {
                    // ignore '<' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // '<' followed by a space is not a valid tag, continue
                    if (html[i + 1] == ' ') {
                        consumeCharacter(c);
                        break;
                    }

                    // change to STATE_HTML
                    if (state == STATE_OUTPUT) {
                        state = STATE_HTML;

                        consumeCharacter(c);
                        break;
                    }

                    // ignore additional '<' characters when inside a tag
                    if (state == STATE_HTML) {
                        depth++;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '>': {
                    // something like this is happening: '<<>>'
                    if (depth) {
                        depth--;
                        break;
                    }

                    // ignore '>' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // an HTML tag was closed
                    if (state == STATE_HTML) {
                        inQuote = state = 0;

                        if (allowableTags) {
                            tagBuffer += '>';
                            flushTagBuffer();
                        }

                        break;
                    }

                    // '<!' met its ending '>'
                    if (state == STATE_PRE_COMMENT) {
                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    // if last two characters were '--', then end comment
                    if (state == STATE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '-') {

                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                // catch both single and double quotes
                case '"':
                case '\'': {
                    if (state == STATE_HTML) {
                        if (inQuote == c) {
                            // end quote found
                            inQuote = false;
                        } else if (!inQuote) {
                            // start quote only if not already in one
                            inQuote = c;
                        }
                    }

                    consumeCharacter(c);
                    break;
                }

                case '!': {
                    if (state == STATE_HTML &&
                        html[i - 1] == '<') {

                        // looks like we might be starting a comment
                        state = STATE_PRE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '-': {
                    // if the previous two characters were '!-', this is a comment
                    if (state == STATE_PRE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '!') {

                        state = STATE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case 'E':
                case 'e': {
                    // check for DOCTYPE, because it looks like a comment and isn't
                    if (state == STATE_PRE_COMMENT &&
                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {

                        state = STATE_HTML;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                default: {
                    consumeCharacter(c);
                }
            }
        }

        function consumeCharacter(c) {
            if (state == STATE_OUTPUT) {
                output += c;
            } else if (allowableTags && state == STATE_HTML) {
                tagBuffer += c;
            }
        }

        function flushTagBuffer() {
            var normalized = '',
                nonWhitespaceSeen = false,
                i, length, c;

            normalizeTagBuffer:
            for (i = 0, length = tagBuffer.length; i < length; i++) {
                c = tagBuffer[i].toLowerCase();

                switch (c) {
                    case '<': {
                        break;
                    }

                    case '>': {
                        break normalizeTagBuffer;
                    }

                    case '/': {
                        nonWhitespaceSeen = true;
                        break;
                    }

                    default: {
                        if (!c.match(WHITESPACE)) {
                            nonWhitespaceSeen = true;
                            normalized += c;
                        } else if (nonWhitespaceSeen) {
                            break normalizeTagBuffer;
                        }
                    }
                }
            }

            if (allowableTags.indexOf(normalized) !== -1) {
                output += tagBuffer;
            }

            tagBuffer = '';
        }

        return output;
    }

    /**
     * Return an array containing tags that are allowed to pass through the
     * algorithm.
     *
     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
     * @return array|null An array of allowed tags or null if none.
     */
    function parseAllowableTags(allowableTags) {
        var tagsArray = [],
            match;

        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
            tagsArray.push(match[1]);
        }

        return tagsArray.length !== 0 ? tagsArray : null;
    }

    return striptags;
}));


/***/ }),

/***/ "4jPf":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ "4oK2":
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__("BRr/"),
    decode = __webpack_require__("oW49");

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),

/***/ "5C2K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useDelayUnmount; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useDelayUnmount(isMounted, delayTime) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      shouldRender = _useState[0],
      setShouldRender = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var timeoutId;

    if (isMounted && !shouldRender) {
      setShouldRender(true);
    } else if (!isMounted && shouldRender) {
      timeoutId = setTimeout(function () {
        return setShouldRender(false);
      }, delayTime);
    }

    return function () {
      return clearTimeout(timeoutId);
    };
  }, [isMounted, delayTime, shouldRender]);
  return shouldRender;
}

/***/ }),

/***/ "5WP5":
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__("dnX/");

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ "5Yz+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var apply = __webpack_require__("K6Rb");
var toIndexedObject = __webpack_require__("/GqU");
var toIntegerOrInfinity = __webpack_require__("WSbT");
var lengthOfArrayLike = __webpack_require__("B/qT");
var arrayMethodIsStrict = __webpack_require__("pkCn");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "6sUC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("hh1v");

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "6wD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateTripDateCriteria; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function updateTripDateCriteria(options) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* UPDATE_TRIP_DATE_CRITERIA */ "y"], options);
}



/***/ }),

/***/ "8PLQ":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Abreve\":\"Ă\",\"abreve\":\"ă\",\"ac\":\"∾\",\"acd\":\"∿\",\"acE\":\"∾̳\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"Acy\":\"А\",\"acy\":\"а\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"af\":\"⁡\",\"Afr\":\"𝔄\",\"afr\":\"𝔞\",\"Agrave\":\"À\",\"agrave\":\"à\",\"alefsym\":\"ℵ\",\"aleph\":\"ℵ\",\"Alpha\":\"Α\",\"alpha\":\"α\",\"Amacr\":\"Ā\",\"amacr\":\"ā\",\"amalg\":\"⨿\",\"amp\":\"&\",\"AMP\":\"&\",\"andand\":\"⩕\",\"And\":\"⩓\",\"and\":\"∧\",\"andd\":\"⩜\",\"andslope\":\"⩘\",\"andv\":\"⩚\",\"ang\":\"∠\",\"ange\":\"⦤\",\"angle\":\"∠\",\"angmsdaa\":\"⦨\",\"angmsdab\":\"⦩\",\"angmsdac\":\"⦪\",\"angmsdad\":\"⦫\",\"angmsdae\":\"⦬\",\"angmsdaf\":\"⦭\",\"angmsdag\":\"⦮\",\"angmsdah\":\"⦯\",\"angmsd\":\"∡\",\"angrt\":\"∟\",\"angrtvb\":\"⊾\",\"angrtvbd\":\"⦝\",\"angsph\":\"∢\",\"angst\":\"Å\",\"angzarr\":\"⍼\",\"Aogon\":\"Ą\",\"aogon\":\"ą\",\"Aopf\":\"𝔸\",\"aopf\":\"𝕒\",\"apacir\":\"⩯\",\"ap\":\"≈\",\"apE\":\"⩰\",\"ape\":\"≊\",\"apid\":\"≋\",\"apos\":\"'\",\"ApplyFunction\":\"⁡\",\"approx\":\"≈\",\"approxeq\":\"≊\",\"Aring\":\"Å\",\"aring\":\"å\",\"Ascr\":\"𝒜\",\"ascr\":\"𝒶\",\"Assign\":\"≔\",\"ast\":\"*\",\"asymp\":\"≈\",\"asympeq\":\"≍\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"awconint\":\"∳\",\"awint\":\"⨑\",\"backcong\":\"≌\",\"backepsilon\":\"϶\",\"backprime\":\"‵\",\"backsim\":\"∽\",\"backsimeq\":\"⋍\",\"Backslash\":\"∖\",\"Barv\":\"⫧\",\"barvee\":\"⊽\",\"barwed\":\"⌅\",\"Barwed\":\"⌆\",\"barwedge\":\"⌅\",\"bbrk\":\"⎵\",\"bbrktbrk\":\"⎶\",\"bcong\":\"≌\",\"Bcy\":\"Б\",\"bcy\":\"б\",\"bdquo\":\"„\",\"becaus\":\"∵\",\"because\":\"∵\",\"Because\":\"∵\",\"bemptyv\":\"⦰\",\"bepsi\":\"϶\",\"bernou\":\"ℬ\",\"Bernoullis\":\"ℬ\",\"Beta\":\"Β\",\"beta\":\"β\",\"beth\":\"ℶ\",\"between\":\"≬\",\"Bfr\":\"𝔅\",\"bfr\":\"𝔟\",\"bigcap\":\"⋂\",\"bigcirc\":\"◯\",\"bigcup\":\"⋃\",\"bigodot\":\"⨀\",\"bigoplus\":\"⨁\",\"bigotimes\":\"⨂\",\"bigsqcup\":\"⨆\",\"bigstar\":\"★\",\"bigtriangledown\":\"▽\",\"bigtriangleup\":\"△\",\"biguplus\":\"⨄\",\"bigvee\":\"⋁\",\"bigwedge\":\"⋀\",\"bkarow\":\"⤍\",\"blacklozenge\":\"⧫\",\"blacksquare\":\"▪\",\"blacktriangle\":\"▴\",\"blacktriangledown\":\"▾\",\"blacktriangleleft\":\"◂\",\"blacktriangleright\":\"▸\",\"blank\":\"␣\",\"blk12\":\"▒\",\"blk14\":\"░\",\"blk34\":\"▓\",\"block\":\"█\",\"bne\":\"=⃥\",\"bnequiv\":\"≡⃥\",\"bNot\":\"⫭\",\"bnot\":\"⌐\",\"Bopf\":\"𝔹\",\"bopf\":\"𝕓\",\"bot\":\"⊥\",\"bottom\":\"⊥\",\"bowtie\":\"⋈\",\"boxbox\":\"⧉\",\"boxdl\":\"┐\",\"boxdL\":\"╕\",\"boxDl\":\"╖\",\"boxDL\":\"╗\",\"boxdr\":\"┌\",\"boxdR\":\"╒\",\"boxDr\":\"╓\",\"boxDR\":\"╔\",\"boxh\":\"─\",\"boxH\":\"═\",\"boxhd\":\"┬\",\"boxHd\":\"╤\",\"boxhD\":\"╥\",\"boxHD\":\"╦\",\"boxhu\":\"┴\",\"boxHu\":\"╧\",\"boxhU\":\"╨\",\"boxHU\":\"╩\",\"boxminus\":\"⊟\",\"boxplus\":\"⊞\",\"boxtimes\":\"⊠\",\"boxul\":\"┘\",\"boxuL\":\"╛\",\"boxUl\":\"╜\",\"boxUL\":\"╝\",\"boxur\":\"└\",\"boxuR\":\"╘\",\"boxUr\":\"╙\",\"boxUR\":\"╚\",\"boxv\":\"│\",\"boxV\":\"║\",\"boxvh\":\"┼\",\"boxvH\":\"╪\",\"boxVh\":\"╫\",\"boxVH\":\"╬\",\"boxvl\":\"┤\",\"boxvL\":\"╡\",\"boxVl\":\"╢\",\"boxVL\":\"╣\",\"boxvr\":\"├\",\"boxvR\":\"╞\",\"boxVr\":\"╟\",\"boxVR\":\"╠\",\"bprime\":\"‵\",\"breve\":\"˘\",\"Breve\":\"˘\",\"brvbar\":\"¦\",\"bscr\":\"𝒷\",\"Bscr\":\"ℬ\",\"bsemi\":\"⁏\",\"bsim\":\"∽\",\"bsime\":\"⋍\",\"bsolb\":\"⧅\",\"bsol\":\"\\\\\",\"bsolhsub\":\"⟈\",\"bull\":\"•\",\"bullet\":\"•\",\"bump\":\"≎\",\"bumpE\":\"⪮\",\"bumpe\":\"≏\",\"Bumpeq\":\"≎\",\"bumpeq\":\"≏\",\"Cacute\":\"Ć\",\"cacute\":\"ć\",\"capand\":\"⩄\",\"capbrcup\":\"⩉\",\"capcap\":\"⩋\",\"cap\":\"∩\",\"Cap\":\"⋒\",\"capcup\":\"⩇\",\"capdot\":\"⩀\",\"CapitalDifferentialD\":\"ⅅ\",\"caps\":\"∩︀\",\"caret\":\"⁁\",\"caron\":\"ˇ\",\"Cayleys\":\"ℭ\",\"ccaps\":\"⩍\",\"Ccaron\":\"Č\",\"ccaron\":\"č\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"Ccirc\":\"Ĉ\",\"ccirc\":\"ĉ\",\"Cconint\":\"∰\",\"ccups\":\"⩌\",\"ccupssm\":\"⩐\",\"Cdot\":\"Ċ\",\"cdot\":\"ċ\",\"cedil\":\"¸\",\"Cedilla\":\"¸\",\"cemptyv\":\"⦲\",\"cent\":\"¢\",\"centerdot\":\"·\",\"CenterDot\":\"·\",\"cfr\":\"𝔠\",\"Cfr\":\"ℭ\",\"CHcy\":\"Ч\",\"chcy\":\"ч\",\"check\":\"✓\",\"checkmark\":\"✓\",\"Chi\":\"Χ\",\"chi\":\"χ\",\"circ\":\"ˆ\",\"circeq\":\"≗\",\"circlearrowleft\":\"↺\",\"circlearrowright\":\"↻\",\"circledast\":\"⊛\",\"circledcirc\":\"⊚\",\"circleddash\":\"⊝\",\"CircleDot\":\"⊙\",\"circledR\":\"®\",\"circledS\":\"Ⓢ\",\"CircleMinus\":\"⊖\",\"CirclePlus\":\"⊕\",\"CircleTimes\":\"⊗\",\"cir\":\"○\",\"cirE\":\"⧃\",\"cire\":\"≗\",\"cirfnint\":\"⨐\",\"cirmid\":\"⫯\",\"cirscir\":\"⧂\",\"ClockwiseContourIntegral\":\"∲\",\"CloseCurlyDoubleQuote\":\"”\",\"CloseCurlyQuote\":\"’\",\"clubs\":\"♣\",\"clubsuit\":\"♣\",\"colon\":\":\",\"Colon\":\"∷\",\"Colone\":\"⩴\",\"colone\":\"≔\",\"coloneq\":\"≔\",\"comma\":\",\",\"commat\":\"@\",\"comp\":\"∁\",\"compfn\":\"∘\",\"complement\":\"∁\",\"complexes\":\"ℂ\",\"cong\":\"≅\",\"congdot\":\"⩭\",\"Congruent\":\"≡\",\"conint\":\"∮\",\"Conint\":\"∯\",\"ContourIntegral\":\"∮\",\"copf\":\"𝕔\",\"Copf\":\"ℂ\",\"coprod\":\"∐\",\"Coproduct\":\"∐\",\"copy\":\"©\",\"COPY\":\"©\",\"copysr\":\"℗\",\"CounterClockwiseContourIntegral\":\"∳\",\"crarr\":\"↵\",\"cross\":\"✗\",\"Cross\":\"⨯\",\"Cscr\":\"𝒞\",\"cscr\":\"𝒸\",\"csub\":\"⫏\",\"csube\":\"⫑\",\"csup\":\"⫐\",\"csupe\":\"⫒\",\"ctdot\":\"⋯\",\"cudarrl\":\"⤸\",\"cudarrr\":\"⤵\",\"cuepr\":\"⋞\",\"cuesc\":\"⋟\",\"cularr\":\"↶\",\"cularrp\":\"⤽\",\"cupbrcap\":\"⩈\",\"cupcap\":\"⩆\",\"CupCap\":\"≍\",\"cup\":\"∪\",\"Cup\":\"⋓\",\"cupcup\":\"⩊\",\"cupdot\":\"⊍\",\"cupor\":\"⩅\",\"cups\":\"∪︀\",\"curarr\":\"↷\",\"curarrm\":\"⤼\",\"curlyeqprec\":\"⋞\",\"curlyeqsucc\":\"⋟\",\"curlyvee\":\"⋎\",\"curlywedge\":\"⋏\",\"curren\":\"¤\",\"curvearrowleft\":\"↶\",\"curvearrowright\":\"↷\",\"cuvee\":\"⋎\",\"cuwed\":\"⋏\",\"cwconint\":\"∲\",\"cwint\":\"∱\",\"cylcty\":\"⌭\",\"dagger\":\"†\",\"Dagger\":\"‡\",\"daleth\":\"ℸ\",\"darr\":\"↓\",\"Darr\":\"↡\",\"dArr\":\"⇓\",\"dash\":\"‐\",\"Dashv\":\"⫤\",\"dashv\":\"⊣\",\"dbkarow\":\"⤏\",\"dblac\":\"˝\",\"Dcaron\":\"Ď\",\"dcaron\":\"ď\",\"Dcy\":\"Д\",\"dcy\":\"д\",\"ddagger\":\"‡\",\"ddarr\":\"⇊\",\"DD\":\"ⅅ\",\"dd\":\"ⅆ\",\"DDotrahd\":\"⤑\",\"ddotseq\":\"⩷\",\"deg\":\"°\",\"Del\":\"∇\",\"Delta\":\"Δ\",\"delta\":\"δ\",\"demptyv\":\"⦱\",\"dfisht\":\"⥿\",\"Dfr\":\"𝔇\",\"dfr\":\"𝔡\",\"dHar\":\"⥥\",\"dharl\":\"⇃\",\"dharr\":\"⇂\",\"DiacriticalAcute\":\"´\",\"DiacriticalDot\":\"˙\",\"DiacriticalDoubleAcute\":\"˝\",\"DiacriticalGrave\":\"`\",\"DiacriticalTilde\":\"˜\",\"diam\":\"⋄\",\"diamond\":\"⋄\",\"Diamond\":\"⋄\",\"diamondsuit\":\"♦\",\"diams\":\"♦\",\"die\":\"¨\",\"DifferentialD\":\"ⅆ\",\"digamma\":\"ϝ\",\"disin\":\"⋲\",\"div\":\"÷\",\"divide\":\"÷\",\"divideontimes\":\"⋇\",\"divonx\":\"⋇\",\"DJcy\":\"Ђ\",\"djcy\":\"ђ\",\"dlcorn\":\"⌞\",\"dlcrop\":\"⌍\",\"dollar\":\"$\",\"Dopf\":\"𝔻\",\"dopf\":\"𝕕\",\"Dot\":\"¨\",\"dot\":\"˙\",\"DotDot\":\"⃜\",\"doteq\":\"≐\",\"doteqdot\":\"≑\",\"DotEqual\":\"≐\",\"dotminus\":\"∸\",\"dotplus\":\"∔\",\"dotsquare\":\"⊡\",\"doublebarwedge\":\"⌆\",\"DoubleContourIntegral\":\"∯\",\"DoubleDot\":\"¨\",\"DoubleDownArrow\":\"⇓\",\"DoubleLeftArrow\":\"⇐\",\"DoubleLeftRightArrow\":\"⇔\",\"DoubleLeftTee\":\"⫤\",\"DoubleLongLeftArrow\":\"⟸\",\"DoubleLongLeftRightArrow\":\"⟺\",\"DoubleLongRightArrow\":\"⟹\",\"DoubleRightArrow\":\"⇒\",\"DoubleRightTee\":\"⊨\",\"DoubleUpArrow\":\"⇑\",\"DoubleUpDownArrow\":\"⇕\",\"DoubleVerticalBar\":\"∥\",\"DownArrowBar\":\"⤓\",\"downarrow\":\"↓\",\"DownArrow\":\"↓\",\"Downarrow\":\"⇓\",\"DownArrowUpArrow\":\"⇵\",\"DownBreve\":\"̑\",\"downdownarrows\":\"⇊\",\"downharpoonleft\":\"⇃\",\"downharpoonright\":\"⇂\",\"DownLeftRightVector\":\"⥐\",\"DownLeftTeeVector\":\"⥞\",\"DownLeftVectorBar\":\"⥖\",\"DownLeftVector\":\"↽\",\"DownRightTeeVector\":\"⥟\",\"DownRightVectorBar\":\"⥗\",\"DownRightVector\":\"⇁\",\"DownTeeArrow\":\"↧\",\"DownTee\":\"⊤\",\"drbkarow\":\"⤐\",\"drcorn\":\"⌟\",\"drcrop\":\"⌌\",\"Dscr\":\"𝒟\",\"dscr\":\"𝒹\",\"DScy\":\"Ѕ\",\"dscy\":\"ѕ\",\"dsol\":\"⧶\",\"Dstrok\":\"Đ\",\"dstrok\":\"đ\",\"dtdot\":\"⋱\",\"dtri\":\"▿\",\"dtrif\":\"▾\",\"duarr\":\"⇵\",\"duhar\":\"⥯\",\"dwangle\":\"⦦\",\"DZcy\":\"Џ\",\"dzcy\":\"џ\",\"dzigrarr\":\"⟿\",\"Eacute\":\"É\",\"eacute\":\"é\",\"easter\":\"⩮\",\"Ecaron\":\"Ě\",\"ecaron\":\"ě\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"ecir\":\"≖\",\"ecolon\":\"≕\",\"Ecy\":\"Э\",\"ecy\":\"э\",\"eDDot\":\"⩷\",\"Edot\":\"Ė\",\"edot\":\"ė\",\"eDot\":\"≑\",\"ee\":\"ⅇ\",\"efDot\":\"≒\",\"Efr\":\"𝔈\",\"efr\":\"𝔢\",\"eg\":\"⪚\",\"Egrave\":\"È\",\"egrave\":\"è\",\"egs\":\"⪖\",\"egsdot\":\"⪘\",\"el\":\"⪙\",\"Element\":\"∈\",\"elinters\":\"⏧\",\"ell\":\"ℓ\",\"els\":\"⪕\",\"elsdot\":\"⪗\",\"Emacr\":\"Ē\",\"emacr\":\"ē\",\"empty\":\"∅\",\"emptyset\":\"∅\",\"EmptySmallSquare\":\"◻\",\"emptyv\":\"∅\",\"EmptyVerySmallSquare\":\"▫\",\"emsp13\":\" \",\"emsp14\":\" \",\"emsp\":\" \",\"ENG\":\"Ŋ\",\"eng\":\"ŋ\",\"ensp\":\" \",\"Eogon\":\"Ę\",\"eogon\":\"ę\",\"Eopf\":\"𝔼\",\"eopf\":\"𝕖\",\"epar\":\"⋕\",\"eparsl\":\"⧣\",\"eplus\":\"⩱\",\"epsi\":\"ε\",\"Epsilon\":\"Ε\",\"epsilon\":\"ε\",\"epsiv\":\"ϵ\",\"eqcirc\":\"≖\",\"eqcolon\":\"≕\",\"eqsim\":\"≂\",\"eqslantgtr\":\"⪖\",\"eqslantless\":\"⪕\",\"Equal\":\"⩵\",\"equals\":\"=\",\"EqualTilde\":\"≂\",\"equest\":\"≟\",\"Equilibrium\":\"⇌\",\"equiv\":\"≡\",\"equivDD\":\"⩸\",\"eqvparsl\":\"⧥\",\"erarr\":\"⥱\",\"erDot\":\"≓\",\"escr\":\"ℯ\",\"Escr\":\"ℰ\",\"esdot\":\"≐\",\"Esim\":\"⩳\",\"esim\":\"≂\",\"Eta\":\"Η\",\"eta\":\"η\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"euro\":\"€\",\"excl\":\"!\",\"exist\":\"∃\",\"Exists\":\"∃\",\"expectation\":\"ℰ\",\"exponentiale\":\"ⅇ\",\"ExponentialE\":\"ⅇ\",\"fallingdotseq\":\"≒\",\"Fcy\":\"Ф\",\"fcy\":\"ф\",\"female\":\"♀\",\"ffilig\":\"ﬃ\",\"fflig\":\"ﬀ\",\"ffllig\":\"ﬄ\",\"Ffr\":\"𝔉\",\"ffr\":\"𝔣\",\"filig\":\"ﬁ\",\"FilledSmallSquare\":\"◼\",\"FilledVerySmallSquare\":\"▪\",\"fjlig\":\"fj\",\"flat\":\"♭\",\"fllig\":\"ﬂ\",\"fltns\":\"▱\",\"fnof\":\"ƒ\",\"Fopf\":\"𝔽\",\"fopf\":\"𝕗\",\"forall\":\"∀\",\"ForAll\":\"∀\",\"fork\":\"⋔\",\"forkv\":\"⫙\",\"Fouriertrf\":\"ℱ\",\"fpartint\":\"⨍\",\"frac12\":\"½\",\"frac13\":\"⅓\",\"frac14\":\"¼\",\"frac15\":\"⅕\",\"frac16\":\"⅙\",\"frac18\":\"⅛\",\"frac23\":\"⅔\",\"frac25\":\"⅖\",\"frac34\":\"¾\",\"frac35\":\"⅗\",\"frac38\":\"⅜\",\"frac45\":\"⅘\",\"frac56\":\"⅚\",\"frac58\":\"⅝\",\"frac78\":\"⅞\",\"frasl\":\"⁄\",\"frown\":\"⌢\",\"fscr\":\"𝒻\",\"Fscr\":\"ℱ\",\"gacute\":\"ǵ\",\"Gamma\":\"Γ\",\"gamma\":\"γ\",\"Gammad\":\"Ϝ\",\"gammad\":\"ϝ\",\"gap\":\"⪆\",\"Gbreve\":\"Ğ\",\"gbreve\":\"ğ\",\"Gcedil\":\"Ģ\",\"Gcirc\":\"Ĝ\",\"gcirc\":\"ĝ\",\"Gcy\":\"Г\",\"gcy\":\"г\",\"Gdot\":\"Ġ\",\"gdot\":\"ġ\",\"ge\":\"≥\",\"gE\":\"≧\",\"gEl\":\"⪌\",\"gel\":\"⋛\",\"geq\":\"≥\",\"geqq\":\"≧\",\"geqslant\":\"⩾\",\"gescc\":\"⪩\",\"ges\":\"⩾\",\"gesdot\":\"⪀\",\"gesdoto\":\"⪂\",\"gesdotol\":\"⪄\",\"gesl\":\"⋛︀\",\"gesles\":\"⪔\",\"Gfr\":\"𝔊\",\"gfr\":\"𝔤\",\"gg\":\"≫\",\"Gg\":\"⋙\",\"ggg\":\"⋙\",\"gimel\":\"ℷ\",\"GJcy\":\"Ѓ\",\"gjcy\":\"ѓ\",\"gla\":\"⪥\",\"gl\":\"≷\",\"glE\":\"⪒\",\"glj\":\"⪤\",\"gnap\":\"⪊\",\"gnapprox\":\"⪊\",\"gne\":\"⪈\",\"gnE\":\"≩\",\"gneq\":\"⪈\",\"gneqq\":\"≩\",\"gnsim\":\"⋧\",\"Gopf\":\"𝔾\",\"gopf\":\"𝕘\",\"grave\":\"`\",\"GreaterEqual\":\"≥\",\"GreaterEqualLess\":\"⋛\",\"GreaterFullEqual\":\"≧\",\"GreaterGreater\":\"⪢\",\"GreaterLess\":\"≷\",\"GreaterSlantEqual\":\"⩾\",\"GreaterTilde\":\"≳\",\"Gscr\":\"𝒢\",\"gscr\":\"ℊ\",\"gsim\":\"≳\",\"gsime\":\"⪎\",\"gsiml\":\"⪐\",\"gtcc\":\"⪧\",\"gtcir\":\"⩺\",\"gt\":\">\",\"GT\":\">\",\"Gt\":\"≫\",\"gtdot\":\"⋗\",\"gtlPar\":\"⦕\",\"gtquest\":\"⩼\",\"gtrapprox\":\"⪆\",\"gtrarr\":\"⥸\",\"gtrdot\":\"⋗\",\"gtreqless\":\"⋛\",\"gtreqqless\":\"⪌\",\"gtrless\":\"≷\",\"gtrsim\":\"≳\",\"gvertneqq\":\"≩︀\",\"gvnE\":\"≩︀\",\"Hacek\":\"ˇ\",\"hairsp\":\" \",\"half\":\"½\",\"hamilt\":\"ℋ\",\"HARDcy\":\"Ъ\",\"hardcy\":\"ъ\",\"harrcir\":\"⥈\",\"harr\":\"↔\",\"hArr\":\"⇔\",\"harrw\":\"↭\",\"Hat\":\"^\",\"hbar\":\"ℏ\",\"Hcirc\":\"Ĥ\",\"hcirc\":\"ĥ\",\"hearts\":\"♥\",\"heartsuit\":\"♥\",\"hellip\":\"…\",\"hercon\":\"⊹\",\"hfr\":\"𝔥\",\"Hfr\":\"ℌ\",\"HilbertSpace\":\"ℋ\",\"hksearow\":\"⤥\",\"hkswarow\":\"⤦\",\"hoarr\":\"⇿\",\"homtht\":\"∻\",\"hookleftarrow\":\"↩\",\"hookrightarrow\":\"↪\",\"hopf\":\"𝕙\",\"Hopf\":\"ℍ\",\"horbar\":\"―\",\"HorizontalLine\":\"─\",\"hscr\":\"𝒽\",\"Hscr\":\"ℋ\",\"hslash\":\"ℏ\",\"Hstrok\":\"Ħ\",\"hstrok\":\"ħ\",\"HumpDownHump\":\"≎\",\"HumpEqual\":\"≏\",\"hybull\":\"⁃\",\"hyphen\":\"‐\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"ic\":\"⁣\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"Icy\":\"И\",\"icy\":\"и\",\"Idot\":\"İ\",\"IEcy\":\"Е\",\"iecy\":\"е\",\"iexcl\":\"¡\",\"iff\":\"⇔\",\"ifr\":\"𝔦\",\"Ifr\":\"ℑ\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"ii\":\"ⅈ\",\"iiiint\":\"⨌\",\"iiint\":\"∭\",\"iinfin\":\"⧜\",\"iiota\":\"℩\",\"IJlig\":\"Ĳ\",\"ijlig\":\"ĳ\",\"Imacr\":\"Ī\",\"imacr\":\"ī\",\"image\":\"ℑ\",\"ImaginaryI\":\"ⅈ\",\"imagline\":\"ℐ\",\"imagpart\":\"ℑ\",\"imath\":\"ı\",\"Im\":\"ℑ\",\"imof\":\"⊷\",\"imped\":\"Ƶ\",\"Implies\":\"⇒\",\"incare\":\"℅\",\"in\":\"∈\",\"infin\":\"∞\",\"infintie\":\"⧝\",\"inodot\":\"ı\",\"intcal\":\"⊺\",\"int\":\"∫\",\"Int\":\"∬\",\"integers\":\"ℤ\",\"Integral\":\"∫\",\"intercal\":\"⊺\",\"Intersection\":\"⋂\",\"intlarhk\":\"⨗\",\"intprod\":\"⨼\",\"InvisibleComma\":\"⁣\",\"InvisibleTimes\":\"⁢\",\"IOcy\":\"Ё\",\"iocy\":\"ё\",\"Iogon\":\"Į\",\"iogon\":\"į\",\"Iopf\":\"𝕀\",\"iopf\":\"𝕚\",\"Iota\":\"Ι\",\"iota\":\"ι\",\"iprod\":\"⨼\",\"iquest\":\"¿\",\"iscr\":\"𝒾\",\"Iscr\":\"ℐ\",\"isin\":\"∈\",\"isindot\":\"⋵\",\"isinE\":\"⋹\",\"isins\":\"⋴\",\"isinsv\":\"⋳\",\"isinv\":\"∈\",\"it\":\"⁢\",\"Itilde\":\"Ĩ\",\"itilde\":\"ĩ\",\"Iukcy\":\"І\",\"iukcy\":\"і\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"Jcirc\":\"Ĵ\",\"jcirc\":\"ĵ\",\"Jcy\":\"Й\",\"jcy\":\"й\",\"Jfr\":\"𝔍\",\"jfr\":\"𝔧\",\"jmath\":\"ȷ\",\"Jopf\":\"𝕁\",\"jopf\":\"𝕛\",\"Jscr\":\"𝒥\",\"jscr\":\"𝒿\",\"Jsercy\":\"Ј\",\"jsercy\":\"ј\",\"Jukcy\":\"Є\",\"jukcy\":\"є\",\"Kappa\":\"Κ\",\"kappa\":\"κ\",\"kappav\":\"ϰ\",\"Kcedil\":\"Ķ\",\"kcedil\":\"ķ\",\"Kcy\":\"К\",\"kcy\":\"к\",\"Kfr\":\"𝔎\",\"kfr\":\"𝔨\",\"kgreen\":\"ĸ\",\"KHcy\":\"Х\",\"khcy\":\"х\",\"KJcy\":\"Ќ\",\"kjcy\":\"ќ\",\"Kopf\":\"𝕂\",\"kopf\":\"𝕜\",\"Kscr\":\"𝒦\",\"kscr\":\"𝓀\",\"lAarr\":\"⇚\",\"Lacute\":\"Ĺ\",\"lacute\":\"ĺ\",\"laemptyv\":\"⦴\",\"lagran\":\"ℒ\",\"Lambda\":\"Λ\",\"lambda\":\"λ\",\"lang\":\"⟨\",\"Lang\":\"⟪\",\"langd\":\"⦑\",\"langle\":\"⟨\",\"lap\":\"⪅\",\"Laplacetrf\":\"ℒ\",\"laquo\":\"«\",\"larrb\":\"⇤\",\"larrbfs\":\"⤟\",\"larr\":\"←\",\"Larr\":\"↞\",\"lArr\":\"⇐\",\"larrfs\":\"⤝\",\"larrhk\":\"↩\",\"larrlp\":\"↫\",\"larrpl\":\"⤹\",\"larrsim\":\"⥳\",\"larrtl\":\"↢\",\"latail\":\"⤙\",\"lAtail\":\"⤛\",\"lat\":\"⪫\",\"late\":\"⪭\",\"lates\":\"⪭︀\",\"lbarr\":\"⤌\",\"lBarr\":\"⤎\",\"lbbrk\":\"❲\",\"lbrace\":\"{\",\"lbrack\":\"[\",\"lbrke\":\"⦋\",\"lbrksld\":\"⦏\",\"lbrkslu\":\"⦍\",\"Lcaron\":\"Ľ\",\"lcaron\":\"ľ\",\"Lcedil\":\"Ļ\",\"lcedil\":\"ļ\",\"lceil\":\"⌈\",\"lcub\":\"{\",\"Lcy\":\"Л\",\"lcy\":\"л\",\"ldca\":\"⤶\",\"ldquo\":\"“\",\"ldquor\":\"„\",\"ldrdhar\":\"⥧\",\"ldrushar\":\"⥋\",\"ldsh\":\"↲\",\"le\":\"≤\",\"lE\":\"≦\",\"LeftAngleBracket\":\"⟨\",\"LeftArrowBar\":\"⇤\",\"leftarrow\":\"←\",\"LeftArrow\":\"←\",\"Leftarrow\":\"⇐\",\"LeftArrowRightArrow\":\"⇆\",\"leftarrowtail\":\"↢\",\"LeftCeiling\":\"⌈\",\"LeftDoubleBracket\":\"⟦\",\"LeftDownTeeVector\":\"⥡\",\"LeftDownVectorBar\":\"⥙\",\"LeftDownVector\":\"⇃\",\"LeftFloor\":\"⌊\",\"leftharpoondown\":\"↽\",\"leftharpoonup\":\"↼\",\"leftleftarrows\":\"⇇\",\"leftrightarrow\":\"↔\",\"LeftRightArrow\":\"↔\",\"Leftrightarrow\":\"⇔\",\"leftrightarrows\":\"⇆\",\"leftrightharpoons\":\"⇋\",\"leftrightsquigarrow\":\"↭\",\"LeftRightVector\":\"⥎\",\"LeftTeeArrow\":\"↤\",\"LeftTee\":\"⊣\",\"LeftTeeVector\":\"⥚\",\"leftthreetimes\":\"⋋\",\"LeftTriangleBar\":\"⧏\",\"LeftTriangle\":\"⊲\",\"LeftTriangleEqual\":\"⊴\",\"LeftUpDownVector\":\"⥑\",\"LeftUpTeeVector\":\"⥠\",\"LeftUpVectorBar\":\"⥘\",\"LeftUpVector\":\"↿\",\"LeftVectorBar\":\"⥒\",\"LeftVector\":\"↼\",\"lEg\":\"⪋\",\"leg\":\"⋚\",\"leq\":\"≤\",\"leqq\":\"≦\",\"leqslant\":\"⩽\",\"lescc\":\"⪨\",\"les\":\"⩽\",\"lesdot\":\"⩿\",\"lesdoto\":\"⪁\",\"lesdotor\":\"⪃\",\"lesg\":\"⋚︀\",\"lesges\":\"⪓\",\"lessapprox\":\"⪅\",\"lessdot\":\"⋖\",\"lesseqgtr\":\"⋚\",\"lesseqqgtr\":\"⪋\",\"LessEqualGreater\":\"⋚\",\"LessFullEqual\":\"≦\",\"LessGreater\":\"≶\",\"lessgtr\":\"≶\",\"LessLess\":\"⪡\",\"lesssim\":\"≲\",\"LessSlantEqual\":\"⩽\",\"LessTilde\":\"≲\",\"lfisht\":\"⥼\",\"lfloor\":\"⌊\",\"Lfr\":\"𝔏\",\"lfr\":\"𝔩\",\"lg\":\"≶\",\"lgE\":\"⪑\",\"lHar\":\"⥢\",\"lhard\":\"↽\",\"lharu\":\"↼\",\"lharul\":\"⥪\",\"lhblk\":\"▄\",\"LJcy\":\"Љ\",\"ljcy\":\"љ\",\"llarr\":\"⇇\",\"ll\":\"≪\",\"Ll\":\"⋘\",\"llcorner\":\"⌞\",\"Lleftarrow\":\"⇚\",\"llhard\":\"⥫\",\"lltri\":\"◺\",\"Lmidot\":\"Ŀ\",\"lmidot\":\"ŀ\",\"lmoustache\":\"⎰\",\"lmoust\":\"⎰\",\"lnap\":\"⪉\",\"lnapprox\":\"⪉\",\"lne\":\"⪇\",\"lnE\":\"≨\",\"lneq\":\"⪇\",\"lneqq\":\"≨\",\"lnsim\":\"⋦\",\"loang\":\"⟬\",\"loarr\":\"⇽\",\"lobrk\":\"⟦\",\"longleftarrow\":\"⟵\",\"LongLeftArrow\":\"⟵\",\"Longleftarrow\":\"⟸\",\"longleftrightarrow\":\"⟷\",\"LongLeftRightArrow\":\"⟷\",\"Longleftrightarrow\":\"⟺\",\"longmapsto\":\"⟼\",\"longrightarrow\":\"⟶\",\"LongRightArrow\":\"⟶\",\"Longrightarrow\":\"⟹\",\"looparrowleft\":\"↫\",\"looparrowright\":\"↬\",\"lopar\":\"⦅\",\"Lopf\":\"𝕃\",\"lopf\":\"𝕝\",\"loplus\":\"⨭\",\"lotimes\":\"⨴\",\"lowast\":\"∗\",\"lowbar\":\"_\",\"LowerLeftArrow\":\"↙\",\"LowerRightArrow\":\"↘\",\"loz\":\"◊\",\"lozenge\":\"◊\",\"lozf\":\"⧫\",\"lpar\":\"(\",\"lparlt\":\"⦓\",\"lrarr\":\"⇆\",\"lrcorner\":\"⌟\",\"lrhar\":\"⇋\",\"lrhard\":\"⥭\",\"lrm\":\"‎\",\"lrtri\":\"⊿\",\"lsaquo\":\"‹\",\"lscr\":\"𝓁\",\"Lscr\":\"ℒ\",\"lsh\":\"↰\",\"Lsh\":\"↰\",\"lsim\":\"≲\",\"lsime\":\"⪍\",\"lsimg\":\"⪏\",\"lsqb\":\"[\",\"lsquo\":\"‘\",\"lsquor\":\"‚\",\"Lstrok\":\"Ł\",\"lstrok\":\"ł\",\"ltcc\":\"⪦\",\"ltcir\":\"⩹\",\"lt\":\"<\",\"LT\":\"<\",\"Lt\":\"≪\",\"ltdot\":\"⋖\",\"lthree\":\"⋋\",\"ltimes\":\"⋉\",\"ltlarr\":\"⥶\",\"ltquest\":\"⩻\",\"ltri\":\"◃\",\"ltrie\":\"⊴\",\"ltrif\":\"◂\",\"ltrPar\":\"⦖\",\"lurdshar\":\"⥊\",\"luruhar\":\"⥦\",\"lvertneqq\":\"≨︀\",\"lvnE\":\"≨︀\",\"macr\":\"¯\",\"male\":\"♂\",\"malt\":\"✠\",\"maltese\":\"✠\",\"Map\":\"⤅\",\"map\":\"↦\",\"mapsto\":\"↦\",\"mapstodown\":\"↧\",\"mapstoleft\":\"↤\",\"mapstoup\":\"↥\",\"marker\":\"▮\",\"mcomma\":\"⨩\",\"Mcy\":\"М\",\"mcy\":\"м\",\"mdash\":\"—\",\"mDDot\":\"∺\",\"measuredangle\":\"∡\",\"MediumSpace\":\" \",\"Mellintrf\":\"ℳ\",\"Mfr\":\"𝔐\",\"mfr\":\"𝔪\",\"mho\":\"℧\",\"micro\":\"µ\",\"midast\":\"*\",\"midcir\":\"⫰\",\"mid\":\"∣\",\"middot\":\"·\",\"minusb\":\"⊟\",\"minus\":\"−\",\"minusd\":\"∸\",\"minusdu\":\"⨪\",\"MinusPlus\":\"∓\",\"mlcp\":\"⫛\",\"mldr\":\"…\",\"mnplus\":\"∓\",\"models\":\"⊧\",\"Mopf\":\"𝕄\",\"mopf\":\"𝕞\",\"mp\":\"∓\",\"mscr\":\"𝓂\",\"Mscr\":\"ℳ\",\"mstpos\":\"∾\",\"Mu\":\"Μ\",\"mu\":\"μ\",\"multimap\":\"⊸\",\"mumap\":\"⊸\",\"nabla\":\"∇\",\"Nacute\":\"Ń\",\"nacute\":\"ń\",\"nang\":\"∠⃒\",\"nap\":\"≉\",\"napE\":\"⩰̸\",\"napid\":\"≋̸\",\"napos\":\"ŉ\",\"napprox\":\"≉\",\"natural\":\"♮\",\"naturals\":\"ℕ\",\"natur\":\"♮\",\"nbsp\":\" \",\"nbump\":\"≎̸\",\"nbumpe\":\"≏̸\",\"ncap\":\"⩃\",\"Ncaron\":\"Ň\",\"ncaron\":\"ň\",\"Ncedil\":\"Ņ\",\"ncedil\":\"ņ\",\"ncong\":\"≇\",\"ncongdot\":\"⩭̸\",\"ncup\":\"⩂\",\"Ncy\":\"Н\",\"ncy\":\"н\",\"ndash\":\"–\",\"nearhk\":\"⤤\",\"nearr\":\"↗\",\"neArr\":\"⇗\",\"nearrow\":\"↗\",\"ne\":\"≠\",\"nedot\":\"≐̸\",\"NegativeMediumSpace\":\"​\",\"NegativeThickSpace\":\"​\",\"NegativeThinSpace\":\"​\",\"NegativeVeryThinSpace\":\"​\",\"nequiv\":\"≢\",\"nesear\":\"⤨\",\"nesim\":\"≂̸\",\"NestedGreaterGreater\":\"≫\",\"NestedLessLess\":\"≪\",\"NewLine\":\"\\n\",\"nexist\":\"∄\",\"nexists\":\"∄\",\"Nfr\":\"𝔑\",\"nfr\":\"𝔫\",\"ngE\":\"≧̸\",\"nge\":\"≱\",\"ngeq\":\"≱\",\"ngeqq\":\"≧̸\",\"ngeqslant\":\"⩾̸\",\"nges\":\"⩾̸\",\"nGg\":\"⋙̸\",\"ngsim\":\"≵\",\"nGt\":\"≫⃒\",\"ngt\":\"≯\",\"ngtr\":\"≯\",\"nGtv\":\"≫̸\",\"nharr\":\"↮\",\"nhArr\":\"⇎\",\"nhpar\":\"⫲\",\"ni\":\"∋\",\"nis\":\"⋼\",\"nisd\":\"⋺\",\"niv\":\"∋\",\"NJcy\":\"Њ\",\"njcy\":\"њ\",\"nlarr\":\"↚\",\"nlArr\":\"⇍\",\"nldr\":\"‥\",\"nlE\":\"≦̸\",\"nle\":\"≰\",\"nleftarrow\":\"↚\",\"nLeftarrow\":\"⇍\",\"nleftrightarrow\":\"↮\",\"nLeftrightarrow\":\"⇎\",\"nleq\":\"≰\",\"nleqq\":\"≦̸\",\"nleqslant\":\"⩽̸\",\"nles\":\"⩽̸\",\"nless\":\"≮\",\"nLl\":\"⋘̸\",\"nlsim\":\"≴\",\"nLt\":\"≪⃒\",\"nlt\":\"≮\",\"nltri\":\"⋪\",\"nltrie\":\"⋬\",\"nLtv\":\"≪̸\",\"nmid\":\"∤\",\"NoBreak\":\"⁠\",\"NonBreakingSpace\":\" \",\"nopf\":\"𝕟\",\"Nopf\":\"ℕ\",\"Not\":\"⫬\",\"not\":\"¬\",\"NotCongruent\":\"≢\",\"NotCupCap\":\"≭\",\"NotDoubleVerticalBar\":\"∦\",\"NotElement\":\"∉\",\"NotEqual\":\"≠\",\"NotEqualTilde\":\"≂̸\",\"NotExists\":\"∄\",\"NotGreater\":\"≯\",\"NotGreaterEqual\":\"≱\",\"NotGreaterFullEqual\":\"≧̸\",\"NotGreaterGreater\":\"≫̸\",\"NotGreaterLess\":\"≹\",\"NotGreaterSlantEqual\":\"⩾̸\",\"NotGreaterTilde\":\"≵\",\"NotHumpDownHump\":\"≎̸\",\"NotHumpEqual\":\"≏̸\",\"notin\":\"∉\",\"notindot\":\"⋵̸\",\"notinE\":\"⋹̸\",\"notinva\":\"∉\",\"notinvb\":\"⋷\",\"notinvc\":\"⋶\",\"NotLeftTriangleBar\":\"⧏̸\",\"NotLeftTriangle\":\"⋪\",\"NotLeftTriangleEqual\":\"⋬\",\"NotLess\":\"≮\",\"NotLessEqual\":\"≰\",\"NotLessGreater\":\"≸\",\"NotLessLess\":\"≪̸\",\"NotLessSlantEqual\":\"⩽̸\",\"NotLessTilde\":\"≴\",\"NotNestedGreaterGreater\":\"⪢̸\",\"NotNestedLessLess\":\"⪡̸\",\"notni\":\"∌\",\"notniva\":\"∌\",\"notnivb\":\"⋾\",\"notnivc\":\"⋽\",\"NotPrecedes\":\"⊀\",\"NotPrecedesEqual\":\"⪯̸\",\"NotPrecedesSlantEqual\":\"⋠\",\"NotReverseElement\":\"∌\",\"NotRightTriangleBar\":\"⧐̸\",\"NotRightTriangle\":\"⋫\",\"NotRightTriangleEqual\":\"⋭\",\"NotSquareSubset\":\"⊏̸\",\"NotSquareSubsetEqual\":\"⋢\",\"NotSquareSuperset\":\"⊐̸\",\"NotSquareSupersetEqual\":\"⋣\",\"NotSubset\":\"⊂⃒\",\"NotSubsetEqual\":\"⊈\",\"NotSucceeds\":\"⊁\",\"NotSucceedsEqual\":\"⪰̸\",\"NotSucceedsSlantEqual\":\"⋡\",\"NotSucceedsTilde\":\"≿̸\",\"NotSuperset\":\"⊃⃒\",\"NotSupersetEqual\":\"⊉\",\"NotTilde\":\"≁\",\"NotTildeEqual\":\"≄\",\"NotTildeFullEqual\":\"≇\",\"NotTildeTilde\":\"≉\",\"NotVerticalBar\":\"∤\",\"nparallel\":\"∦\",\"npar\":\"∦\",\"nparsl\":\"⫽⃥\",\"npart\":\"∂̸\",\"npolint\":\"⨔\",\"npr\":\"⊀\",\"nprcue\":\"⋠\",\"nprec\":\"⊀\",\"npreceq\":\"⪯̸\",\"npre\":\"⪯̸\",\"nrarrc\":\"⤳̸\",\"nrarr\":\"↛\",\"nrArr\":\"⇏\",\"nrarrw\":\"↝̸\",\"nrightarrow\":\"↛\",\"nRightarrow\":\"⇏\",\"nrtri\":\"⋫\",\"nrtrie\":\"⋭\",\"nsc\":\"⊁\",\"nsccue\":\"⋡\",\"nsce\":\"⪰̸\",\"Nscr\":\"𝒩\",\"nscr\":\"𝓃\",\"nshortmid\":\"∤\",\"nshortparallel\":\"∦\",\"nsim\":\"≁\",\"nsime\":\"≄\",\"nsimeq\":\"≄\",\"nsmid\":\"∤\",\"nspar\":\"∦\",\"nsqsube\":\"⋢\",\"nsqsupe\":\"⋣\",\"nsub\":\"⊄\",\"nsubE\":\"⫅̸\",\"nsube\":\"⊈\",\"nsubset\":\"⊂⃒\",\"nsubseteq\":\"⊈\",\"nsubseteqq\":\"⫅̸\",\"nsucc\":\"⊁\",\"nsucceq\":\"⪰̸\",\"nsup\":\"⊅\",\"nsupE\":\"⫆̸\",\"nsupe\":\"⊉\",\"nsupset\":\"⊃⃒\",\"nsupseteq\":\"⊉\",\"nsupseteqq\":\"⫆̸\",\"ntgl\":\"≹\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"ntlg\":\"≸\",\"ntriangleleft\":\"⋪\",\"ntrianglelefteq\":\"⋬\",\"ntriangleright\":\"⋫\",\"ntrianglerighteq\":\"⋭\",\"Nu\":\"Ν\",\"nu\":\"ν\",\"num\":\"#\",\"numero\":\"№\",\"numsp\":\" \",\"nvap\":\"≍⃒\",\"nvdash\":\"⊬\",\"nvDash\":\"⊭\",\"nVdash\":\"⊮\",\"nVDash\":\"⊯\",\"nvge\":\"≥⃒\",\"nvgt\":\">⃒\",\"nvHarr\":\"⤄\",\"nvinfin\":\"⧞\",\"nvlArr\":\"⤂\",\"nvle\":\"≤⃒\",\"nvlt\":\"<⃒\",\"nvltrie\":\"⊴⃒\",\"nvrArr\":\"⤃\",\"nvrtrie\":\"⊵⃒\",\"nvsim\":\"∼⃒\",\"nwarhk\":\"⤣\",\"nwarr\":\"↖\",\"nwArr\":\"⇖\",\"nwarrow\":\"↖\",\"nwnear\":\"⤧\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"oast\":\"⊛\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"ocir\":\"⊚\",\"Ocy\":\"О\",\"ocy\":\"о\",\"odash\":\"⊝\",\"Odblac\":\"Ő\",\"odblac\":\"ő\",\"odiv\":\"⨸\",\"odot\":\"⊙\",\"odsold\":\"⦼\",\"OElig\":\"Œ\",\"oelig\":\"œ\",\"ofcir\":\"⦿\",\"Ofr\":\"𝔒\",\"ofr\":\"𝔬\",\"ogon\":\"˛\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ogt\":\"⧁\",\"ohbar\":\"⦵\",\"ohm\":\"Ω\",\"oint\":\"∮\",\"olarr\":\"↺\",\"olcir\":\"⦾\",\"olcross\":\"⦻\",\"oline\":\"‾\",\"olt\":\"⧀\",\"Omacr\":\"Ō\",\"omacr\":\"ō\",\"Omega\":\"Ω\",\"omega\":\"ω\",\"Omicron\":\"Ο\",\"omicron\":\"ο\",\"omid\":\"⦶\",\"ominus\":\"⊖\",\"Oopf\":\"𝕆\",\"oopf\":\"𝕠\",\"opar\":\"⦷\",\"OpenCurlyDoubleQuote\":\"“\",\"OpenCurlyQuote\":\"‘\",\"operp\":\"⦹\",\"oplus\":\"⊕\",\"orarr\":\"↻\",\"Or\":\"⩔\",\"or\":\"∨\",\"ord\":\"⩝\",\"order\":\"ℴ\",\"orderof\":\"ℴ\",\"ordf\":\"ª\",\"ordm\":\"º\",\"origof\":\"⊶\",\"oror\":\"⩖\",\"orslope\":\"⩗\",\"orv\":\"⩛\",\"oS\":\"Ⓢ\",\"Oscr\":\"𝒪\",\"oscr\":\"ℴ\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"osol\":\"⊘\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"otimesas\":\"⨶\",\"Otimes\":\"⨷\",\"otimes\":\"⊗\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"ovbar\":\"⌽\",\"OverBar\":\"‾\",\"OverBrace\":\"⏞\",\"OverBracket\":\"⎴\",\"OverParenthesis\":\"⏜\",\"para\":\"¶\",\"parallel\":\"∥\",\"par\":\"∥\",\"parsim\":\"⫳\",\"parsl\":\"⫽\",\"part\":\"∂\",\"PartialD\":\"∂\",\"Pcy\":\"П\",\"pcy\":\"п\",\"percnt\":\"%\",\"period\":\".\",\"permil\":\"‰\",\"perp\":\"⊥\",\"pertenk\":\"‱\",\"Pfr\":\"𝔓\",\"pfr\":\"𝔭\",\"Phi\":\"Φ\",\"phi\":\"φ\",\"phiv\":\"ϕ\",\"phmmat\":\"ℳ\",\"phone\":\"☎\",\"Pi\":\"Π\",\"pi\":\"π\",\"pitchfork\":\"⋔\",\"piv\":\"ϖ\",\"planck\":\"ℏ\",\"planckh\":\"ℎ\",\"plankv\":\"ℏ\",\"plusacir\":\"⨣\",\"plusb\":\"⊞\",\"pluscir\":\"⨢\",\"plus\":\"+\",\"plusdo\":\"∔\",\"plusdu\":\"⨥\",\"pluse\":\"⩲\",\"PlusMinus\":\"±\",\"plusmn\":\"±\",\"plussim\":\"⨦\",\"plustwo\":\"⨧\",\"pm\":\"±\",\"Poincareplane\":\"ℌ\",\"pointint\":\"⨕\",\"popf\":\"𝕡\",\"Popf\":\"ℙ\",\"pound\":\"£\",\"prap\":\"⪷\",\"Pr\":\"⪻\",\"pr\":\"≺\",\"prcue\":\"≼\",\"precapprox\":\"⪷\",\"prec\":\"≺\",\"preccurlyeq\":\"≼\",\"Precedes\":\"≺\",\"PrecedesEqual\":\"⪯\",\"PrecedesSlantEqual\":\"≼\",\"PrecedesTilde\":\"≾\",\"preceq\":\"⪯\",\"precnapprox\":\"⪹\",\"precneqq\":\"⪵\",\"precnsim\":\"⋨\",\"pre\":\"⪯\",\"prE\":\"⪳\",\"precsim\":\"≾\",\"prime\":\"′\",\"Prime\":\"″\",\"primes\":\"ℙ\",\"prnap\":\"⪹\",\"prnE\":\"⪵\",\"prnsim\":\"⋨\",\"prod\":\"∏\",\"Product\":\"∏\",\"profalar\":\"⌮\",\"profline\":\"⌒\",\"profsurf\":\"⌓\",\"prop\":\"∝\",\"Proportional\":\"∝\",\"Proportion\":\"∷\",\"propto\":\"∝\",\"prsim\":\"≾\",\"prurel\":\"⊰\",\"Pscr\":\"𝒫\",\"pscr\":\"𝓅\",\"Psi\":\"Ψ\",\"psi\":\"ψ\",\"puncsp\":\" \",\"Qfr\":\"𝔔\",\"qfr\":\"𝔮\",\"qint\":\"⨌\",\"qopf\":\"𝕢\",\"Qopf\":\"ℚ\",\"qprime\":\"⁗\",\"Qscr\":\"𝒬\",\"qscr\":\"𝓆\",\"quaternions\":\"ℍ\",\"quatint\":\"⨖\",\"quest\":\"?\",\"questeq\":\"≟\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"rAarr\":\"⇛\",\"race\":\"∽̱\",\"Racute\":\"Ŕ\",\"racute\":\"ŕ\",\"radic\":\"√\",\"raemptyv\":\"⦳\",\"rang\":\"⟩\",\"Rang\":\"⟫\",\"rangd\":\"⦒\",\"range\":\"⦥\",\"rangle\":\"⟩\",\"raquo\":\"»\",\"rarrap\":\"⥵\",\"rarrb\":\"⇥\",\"rarrbfs\":\"⤠\",\"rarrc\":\"⤳\",\"rarr\":\"→\",\"Rarr\":\"↠\",\"rArr\":\"⇒\",\"rarrfs\":\"⤞\",\"rarrhk\":\"↪\",\"rarrlp\":\"↬\",\"rarrpl\":\"⥅\",\"rarrsim\":\"⥴\",\"Rarrtl\":\"⤖\",\"rarrtl\":\"↣\",\"rarrw\":\"↝\",\"ratail\":\"⤚\",\"rAtail\":\"⤜\",\"ratio\":\"∶\",\"rationals\":\"ℚ\",\"rbarr\":\"⤍\",\"rBarr\":\"⤏\",\"RBarr\":\"⤐\",\"rbbrk\":\"❳\",\"rbrace\":\"}\",\"rbrack\":\"]\",\"rbrke\":\"⦌\",\"rbrksld\":\"⦎\",\"rbrkslu\":\"⦐\",\"Rcaron\":\"Ř\",\"rcaron\":\"ř\",\"Rcedil\":\"Ŗ\",\"rcedil\":\"ŗ\",\"rceil\":\"⌉\",\"rcub\":\"}\",\"Rcy\":\"Р\",\"rcy\":\"р\",\"rdca\":\"⤷\",\"rdldhar\":\"⥩\",\"rdquo\":\"”\",\"rdquor\":\"”\",\"rdsh\":\"↳\",\"real\":\"ℜ\",\"realine\":\"ℛ\",\"realpart\":\"ℜ\",\"reals\":\"ℝ\",\"Re\":\"ℜ\",\"rect\":\"▭\",\"reg\":\"®\",\"REG\":\"®\",\"ReverseElement\":\"∋\",\"ReverseEquilibrium\":\"⇋\",\"ReverseUpEquilibrium\":\"⥯\",\"rfisht\":\"⥽\",\"rfloor\":\"⌋\",\"rfr\":\"𝔯\",\"Rfr\":\"ℜ\",\"rHar\":\"⥤\",\"rhard\":\"⇁\",\"rharu\":\"⇀\",\"rharul\":\"⥬\",\"Rho\":\"Ρ\",\"rho\":\"ρ\",\"rhov\":\"ϱ\",\"RightAngleBracket\":\"⟩\",\"RightArrowBar\":\"⇥\",\"rightarrow\":\"→\",\"RightArrow\":\"→\",\"Rightarrow\":\"⇒\",\"RightArrowLeftArrow\":\"⇄\",\"rightarrowtail\":\"↣\",\"RightCeiling\":\"⌉\",\"RightDoubleBracket\":\"⟧\",\"RightDownTeeVector\":\"⥝\",\"RightDownVectorBar\":\"⥕\",\"RightDownVector\":\"⇂\",\"RightFloor\":\"⌋\",\"rightharpoondown\":\"⇁\",\"rightharpoonup\":\"⇀\",\"rightleftarrows\":\"⇄\",\"rightleftharpoons\":\"⇌\",\"rightrightarrows\":\"⇉\",\"rightsquigarrow\":\"↝\",\"RightTeeArrow\":\"↦\",\"RightTee\":\"⊢\",\"RightTeeVector\":\"⥛\",\"rightthreetimes\":\"⋌\",\"RightTriangleBar\":\"⧐\",\"RightTriangle\":\"⊳\",\"RightTriangleEqual\":\"⊵\",\"RightUpDownVector\":\"⥏\",\"RightUpTeeVector\":\"⥜\",\"RightUpVectorBar\":\"⥔\",\"RightUpVector\":\"↾\",\"RightVectorBar\":\"⥓\",\"RightVector\":\"⇀\",\"ring\":\"˚\",\"risingdotseq\":\"≓\",\"rlarr\":\"⇄\",\"rlhar\":\"⇌\",\"rlm\":\"‏\",\"rmoustache\":\"⎱\",\"rmoust\":\"⎱\",\"rnmid\":\"⫮\",\"roang\":\"⟭\",\"roarr\":\"⇾\",\"robrk\":\"⟧\",\"ropar\":\"⦆\",\"ropf\":\"𝕣\",\"Ropf\":\"ℝ\",\"roplus\":\"⨮\",\"rotimes\":\"⨵\",\"RoundImplies\":\"⥰\",\"rpar\":\")\",\"rpargt\":\"⦔\",\"rppolint\":\"⨒\",\"rrarr\":\"⇉\",\"Rrightarrow\":\"⇛\",\"rsaquo\":\"›\",\"rscr\":\"𝓇\",\"Rscr\":\"ℛ\",\"rsh\":\"↱\",\"Rsh\":\"↱\",\"rsqb\":\"]\",\"rsquo\":\"’\",\"rsquor\":\"’\",\"rthree\":\"⋌\",\"rtimes\":\"⋊\",\"rtri\":\"▹\",\"rtrie\":\"⊵\",\"rtrif\":\"▸\",\"rtriltri\":\"⧎\",\"RuleDelayed\":\"⧴\",\"ruluhar\":\"⥨\",\"rx\":\"℞\",\"Sacute\":\"Ś\",\"sacute\":\"ś\",\"sbquo\":\"‚\",\"scap\":\"⪸\",\"Scaron\":\"Š\",\"scaron\":\"š\",\"Sc\":\"⪼\",\"sc\":\"≻\",\"sccue\":\"≽\",\"sce\":\"⪰\",\"scE\":\"⪴\",\"Scedil\":\"Ş\",\"scedil\":\"ş\",\"Scirc\":\"Ŝ\",\"scirc\":\"ŝ\",\"scnap\":\"⪺\",\"scnE\":\"⪶\",\"scnsim\":\"⋩\",\"scpolint\":\"⨓\",\"scsim\":\"≿\",\"Scy\":\"С\",\"scy\":\"с\",\"sdotb\":\"⊡\",\"sdot\":\"⋅\",\"sdote\":\"⩦\",\"searhk\":\"⤥\",\"searr\":\"↘\",\"seArr\":\"⇘\",\"searrow\":\"↘\",\"sect\":\"§\",\"semi\":\";\",\"seswar\":\"⤩\",\"setminus\":\"∖\",\"setmn\":\"∖\",\"sext\":\"✶\",\"Sfr\":\"𝔖\",\"sfr\":\"𝔰\",\"sfrown\":\"⌢\",\"sharp\":\"♯\",\"SHCHcy\":\"Щ\",\"shchcy\":\"щ\",\"SHcy\":\"Ш\",\"shcy\":\"ш\",\"ShortDownArrow\":\"↓\",\"ShortLeftArrow\":\"←\",\"shortmid\":\"∣\",\"shortparallel\":\"∥\",\"ShortRightArrow\":\"→\",\"ShortUpArrow\":\"↑\",\"shy\":\"­\",\"Sigma\":\"Σ\",\"sigma\":\"σ\",\"sigmaf\":\"ς\",\"sigmav\":\"ς\",\"sim\":\"∼\",\"simdot\":\"⩪\",\"sime\":\"≃\",\"simeq\":\"≃\",\"simg\":\"⪞\",\"simgE\":\"⪠\",\"siml\":\"⪝\",\"simlE\":\"⪟\",\"simne\":\"≆\",\"simplus\":\"⨤\",\"simrarr\":\"⥲\",\"slarr\":\"←\",\"SmallCircle\":\"∘\",\"smallsetminus\":\"∖\",\"smashp\":\"⨳\",\"smeparsl\":\"⧤\",\"smid\":\"∣\",\"smile\":\"⌣\",\"smt\":\"⪪\",\"smte\":\"⪬\",\"smtes\":\"⪬︀\",\"SOFTcy\":\"Ь\",\"softcy\":\"ь\",\"solbar\":\"⌿\",\"solb\":\"⧄\",\"sol\":\"/\",\"Sopf\":\"𝕊\",\"sopf\":\"𝕤\",\"spades\":\"♠\",\"spadesuit\":\"♠\",\"spar\":\"∥\",\"sqcap\":\"⊓\",\"sqcaps\":\"⊓︀\",\"sqcup\":\"⊔\",\"sqcups\":\"⊔︀\",\"Sqrt\":\"√\",\"sqsub\":\"⊏\",\"sqsube\":\"⊑\",\"sqsubset\":\"⊏\",\"sqsubseteq\":\"⊑\",\"sqsup\":\"⊐\",\"sqsupe\":\"⊒\",\"sqsupset\":\"⊐\",\"sqsupseteq\":\"⊒\",\"square\":\"□\",\"Square\":\"□\",\"SquareIntersection\":\"⊓\",\"SquareSubset\":\"⊏\",\"SquareSubsetEqual\":\"⊑\",\"SquareSuperset\":\"⊐\",\"SquareSupersetEqual\":\"⊒\",\"SquareUnion\":\"⊔\",\"squarf\":\"▪\",\"squ\":\"□\",\"squf\":\"▪\",\"srarr\":\"→\",\"Sscr\":\"𝒮\",\"sscr\":\"𝓈\",\"ssetmn\":\"∖\",\"ssmile\":\"⌣\",\"sstarf\":\"⋆\",\"Star\":\"⋆\",\"star\":\"☆\",\"starf\":\"★\",\"straightepsilon\":\"ϵ\",\"straightphi\":\"ϕ\",\"strns\":\"¯\",\"sub\":\"⊂\",\"Sub\":\"⋐\",\"subdot\":\"⪽\",\"subE\":\"⫅\",\"sube\":\"⊆\",\"subedot\":\"⫃\",\"submult\":\"⫁\",\"subnE\":\"⫋\",\"subne\":\"⊊\",\"subplus\":\"⪿\",\"subrarr\":\"⥹\",\"subset\":\"⊂\",\"Subset\":\"⋐\",\"subseteq\":\"⊆\",\"subseteqq\":\"⫅\",\"SubsetEqual\":\"⊆\",\"subsetneq\":\"⊊\",\"subsetneqq\":\"⫋\",\"subsim\":\"⫇\",\"subsub\":\"⫕\",\"subsup\":\"⫓\",\"succapprox\":\"⪸\",\"succ\":\"≻\",\"succcurlyeq\":\"≽\",\"Succeeds\":\"≻\",\"SucceedsEqual\":\"⪰\",\"SucceedsSlantEqual\":\"≽\",\"SucceedsTilde\":\"≿\",\"succeq\":\"⪰\",\"succnapprox\":\"⪺\",\"succneqq\":\"⪶\",\"succnsim\":\"⋩\",\"succsim\":\"≿\",\"SuchThat\":\"∋\",\"sum\":\"∑\",\"Sum\":\"∑\",\"sung\":\"♪\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"sup\":\"⊃\",\"Sup\":\"⋑\",\"supdot\":\"⪾\",\"supdsub\":\"⫘\",\"supE\":\"⫆\",\"supe\":\"⊇\",\"supedot\":\"⫄\",\"Superset\":\"⊃\",\"SupersetEqual\":\"⊇\",\"suphsol\":\"⟉\",\"suphsub\":\"⫗\",\"suplarr\":\"⥻\",\"supmult\":\"⫂\",\"supnE\":\"⫌\",\"supne\":\"⊋\",\"supplus\":\"⫀\",\"supset\":\"⊃\",\"Supset\":\"⋑\",\"supseteq\":\"⊇\",\"supseteqq\":\"⫆\",\"supsetneq\":\"⊋\",\"supsetneqq\":\"⫌\",\"supsim\":\"⫈\",\"supsub\":\"⫔\",\"supsup\":\"⫖\",\"swarhk\":\"⤦\",\"swarr\":\"↙\",\"swArr\":\"⇙\",\"swarrow\":\"↙\",\"swnwar\":\"⤪\",\"szlig\":\"ß\",\"Tab\":\"\\t\",\"target\":\"⌖\",\"Tau\":\"Τ\",\"tau\":\"τ\",\"tbrk\":\"⎴\",\"Tcaron\":\"Ť\",\"tcaron\":\"ť\",\"Tcedil\":\"Ţ\",\"tcedil\":\"ţ\",\"Tcy\":\"Т\",\"tcy\":\"т\",\"tdot\":\"⃛\",\"telrec\":\"⌕\",\"Tfr\":\"𝔗\",\"tfr\":\"𝔱\",\"there4\":\"∴\",\"therefore\":\"∴\",\"Therefore\":\"∴\",\"Theta\":\"Θ\",\"theta\":\"θ\",\"thetasym\":\"ϑ\",\"thetav\":\"ϑ\",\"thickapprox\":\"≈\",\"thicksim\":\"∼\",\"ThickSpace\":\"  \",\"ThinSpace\":\" \",\"thinsp\":\" \",\"thkap\":\"≈\",\"thksim\":\"∼\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"tilde\":\"˜\",\"Tilde\":\"∼\",\"TildeEqual\":\"≃\",\"TildeFullEqual\":\"≅\",\"TildeTilde\":\"≈\",\"timesbar\":\"⨱\",\"timesb\":\"⊠\",\"times\":\"×\",\"timesd\":\"⨰\",\"tint\":\"∭\",\"toea\":\"⤨\",\"topbot\":\"⌶\",\"topcir\":\"⫱\",\"top\":\"⊤\",\"Topf\":\"𝕋\",\"topf\":\"𝕥\",\"topfork\":\"⫚\",\"tosa\":\"⤩\",\"tprime\":\"‴\",\"trade\":\"™\",\"TRADE\":\"™\",\"triangle\":\"▵\",\"triangledown\":\"▿\",\"triangleleft\":\"◃\",\"trianglelefteq\":\"⊴\",\"triangleq\":\"≜\",\"triangleright\":\"▹\",\"trianglerighteq\":\"⊵\",\"tridot\":\"◬\",\"trie\":\"≜\",\"triminus\":\"⨺\",\"TripleDot\":\"⃛\",\"triplus\":\"⨹\",\"trisb\":\"⧍\",\"tritime\":\"⨻\",\"trpezium\":\"⏢\",\"Tscr\":\"𝒯\",\"tscr\":\"𝓉\",\"TScy\":\"Ц\",\"tscy\":\"ц\",\"TSHcy\":\"Ћ\",\"tshcy\":\"ћ\",\"Tstrok\":\"Ŧ\",\"tstrok\":\"ŧ\",\"twixt\":\"≬\",\"twoheadleftarrow\":\"↞\",\"twoheadrightarrow\":\"↠\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"uarr\":\"↑\",\"Uarr\":\"↟\",\"uArr\":\"⇑\",\"Uarrocir\":\"⥉\",\"Ubrcy\":\"Ў\",\"ubrcy\":\"ў\",\"Ubreve\":\"Ŭ\",\"ubreve\":\"ŭ\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ucy\":\"У\",\"ucy\":\"у\",\"udarr\":\"⇅\",\"Udblac\":\"Ű\",\"udblac\":\"ű\",\"udhar\":\"⥮\",\"ufisht\":\"⥾\",\"Ufr\":\"𝔘\",\"ufr\":\"𝔲\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uHar\":\"⥣\",\"uharl\":\"↿\",\"uharr\":\"↾\",\"uhblk\":\"▀\",\"ulcorn\":\"⌜\",\"ulcorner\":\"⌜\",\"ulcrop\":\"⌏\",\"ultri\":\"◸\",\"Umacr\":\"Ū\",\"umacr\":\"ū\",\"uml\":\"¨\",\"UnderBar\":\"_\",\"UnderBrace\":\"⏟\",\"UnderBracket\":\"⎵\",\"UnderParenthesis\":\"⏝\",\"Union\":\"⋃\",\"UnionPlus\":\"⊎\",\"Uogon\":\"Ų\",\"uogon\":\"ų\",\"Uopf\":\"𝕌\",\"uopf\":\"𝕦\",\"UpArrowBar\":\"⤒\",\"uparrow\":\"↑\",\"UpArrow\":\"↑\",\"Uparrow\":\"⇑\",\"UpArrowDownArrow\":\"⇅\",\"updownarrow\":\"↕\",\"UpDownArrow\":\"↕\",\"Updownarrow\":\"⇕\",\"UpEquilibrium\":\"⥮\",\"upharpoonleft\":\"↿\",\"upharpoonright\":\"↾\",\"uplus\":\"⊎\",\"UpperLeftArrow\":\"↖\",\"UpperRightArrow\":\"↗\",\"upsi\":\"υ\",\"Upsi\":\"ϒ\",\"upsih\":\"ϒ\",\"Upsilon\":\"Υ\",\"upsilon\":\"υ\",\"UpTeeArrow\":\"↥\",\"UpTee\":\"⊥\",\"upuparrows\":\"⇈\",\"urcorn\":\"⌝\",\"urcorner\":\"⌝\",\"urcrop\":\"⌎\",\"Uring\":\"Ů\",\"uring\":\"ů\",\"urtri\":\"◹\",\"Uscr\":\"𝒰\",\"uscr\":\"𝓊\",\"utdot\":\"⋰\",\"Utilde\":\"Ũ\",\"utilde\":\"ũ\",\"utri\":\"▵\",\"utrif\":\"▴\",\"uuarr\":\"⇈\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"uwangle\":\"⦧\",\"vangrt\":\"⦜\",\"varepsilon\":\"ϵ\",\"varkappa\":\"ϰ\",\"varnothing\":\"∅\",\"varphi\":\"ϕ\",\"varpi\":\"ϖ\",\"varpropto\":\"∝\",\"varr\":\"↕\",\"vArr\":\"⇕\",\"varrho\":\"ϱ\",\"varsigma\":\"ς\",\"varsubsetneq\":\"⊊︀\",\"varsubsetneqq\":\"⫋︀\",\"varsupsetneq\":\"⊋︀\",\"varsupsetneqq\":\"⫌︀\",\"vartheta\":\"ϑ\",\"vartriangleleft\":\"⊲\",\"vartriangleright\":\"⊳\",\"vBar\":\"⫨\",\"Vbar\":\"⫫\",\"vBarv\":\"⫩\",\"Vcy\":\"В\",\"vcy\":\"в\",\"vdash\":\"⊢\",\"vDash\":\"⊨\",\"Vdash\":\"⊩\",\"VDash\":\"⊫\",\"Vdashl\":\"⫦\",\"veebar\":\"⊻\",\"vee\":\"∨\",\"Vee\":\"⋁\",\"veeeq\":\"≚\",\"vellip\":\"⋮\",\"verbar\":\"|\",\"Verbar\":\"‖\",\"vert\":\"|\",\"Vert\":\"‖\",\"VerticalBar\":\"∣\",\"VerticalLine\":\"|\",\"VerticalSeparator\":\"❘\",\"VerticalTilde\":\"≀\",\"VeryThinSpace\":\" \",\"Vfr\":\"𝔙\",\"vfr\":\"𝔳\",\"vltri\":\"⊲\",\"vnsub\":\"⊂⃒\",\"vnsup\":\"⊃⃒\",\"Vopf\":\"𝕍\",\"vopf\":\"𝕧\",\"vprop\":\"∝\",\"vrtri\":\"⊳\",\"Vscr\":\"𝒱\",\"vscr\":\"𝓋\",\"vsubnE\":\"⫋︀\",\"vsubne\":\"⊊︀\",\"vsupnE\":\"⫌︀\",\"vsupne\":\"⊋︀\",\"Vvdash\":\"⊪\",\"vzigzag\":\"⦚\",\"Wcirc\":\"Ŵ\",\"wcirc\":\"ŵ\",\"wedbar\":\"⩟\",\"wedge\":\"∧\",\"Wedge\":\"⋀\",\"wedgeq\":\"≙\",\"weierp\":\"℘\",\"Wfr\":\"𝔚\",\"wfr\":\"𝔴\",\"Wopf\":\"𝕎\",\"wopf\":\"𝕨\",\"wp\":\"℘\",\"wr\":\"≀\",\"wreath\":\"≀\",\"Wscr\":\"𝒲\",\"wscr\":\"𝓌\",\"xcap\":\"⋂\",\"xcirc\":\"◯\",\"xcup\":\"⋃\",\"xdtri\":\"▽\",\"Xfr\":\"𝔛\",\"xfr\":\"𝔵\",\"xharr\":\"⟷\",\"xhArr\":\"⟺\",\"Xi\":\"Ξ\",\"xi\":\"ξ\",\"xlarr\":\"⟵\",\"xlArr\":\"⟸\",\"xmap\":\"⟼\",\"xnis\":\"⋻\",\"xodot\":\"⨀\",\"Xopf\":\"𝕏\",\"xopf\":\"𝕩\",\"xoplus\":\"⨁\",\"xotime\":\"⨂\",\"xrarr\":\"⟶\",\"xrArr\":\"⟹\",\"Xscr\":\"𝒳\",\"xscr\":\"𝓍\",\"xsqcup\":\"⨆\",\"xuplus\":\"⨄\",\"xutri\":\"△\",\"xvee\":\"⋁\",\"xwedge\":\"⋀\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"YAcy\":\"Я\",\"yacy\":\"я\",\"Ycirc\":\"Ŷ\",\"ycirc\":\"ŷ\",\"Ycy\":\"Ы\",\"ycy\":\"ы\",\"yen\":\"¥\",\"Yfr\":\"𝔜\",\"yfr\":\"𝔶\",\"YIcy\":\"Ї\",\"yicy\":\"ї\",\"Yopf\":\"𝕐\",\"yopf\":\"𝕪\",\"Yscr\":\"𝒴\",\"yscr\":\"𝓎\",\"YUcy\":\"Ю\",\"yucy\":\"ю\",\"yuml\":\"ÿ\",\"Yuml\":\"Ÿ\",\"Zacute\":\"Ź\",\"zacute\":\"ź\",\"Zcaron\":\"Ž\",\"zcaron\":\"ž\",\"Zcy\":\"З\",\"zcy\":\"з\",\"Zdot\":\"Ż\",\"zdot\":\"ż\",\"zeetrf\":\"ℨ\",\"ZeroWidthSpace\":\"​\",\"Zeta\":\"Ζ\",\"zeta\":\"ζ\",\"zfr\":\"𝔷\",\"Zfr\":\"ℨ\",\"ZHcy\":\"Ж\",\"zhcy\":\"ж\",\"zigrarr\":\"⇝\",\"zopf\":\"𝕫\",\"Zopf\":\"ℤ\",\"Zscr\":\"𝒵\",\"zscr\":\"𝓏\",\"zwj\":\"‍\",\"zwnj\":\"‌\"}");

/***/ }),

/***/ "8soX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isSymbol2 = __webpack_require__("a88S");

var _isSymbol3 = _interopRequireDefault(_isSymbol2);

var _isString2 = __webpack_require__("nDih");

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = __webpack_require__("Kkar");

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFSA(action) {
  return (0, _isPlainObject3.default)(action) && ((0, _isString3.default)(action.type) || (0, _isSymbol3.default)(action.type)) && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return action.error === true;
}

function isValidKey(key) {
  return ['type', 'payload', 'error', 'meta'].indexOf(key) > -1;
}

/***/ }),

/***/ "9BmX":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("dw5g");

/**
 * Converts `string`, as a whole, to upper case just like
 * [String#toUpperCase](https://mdn.io/toUpperCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.toUpper('--foo-bar--');
 * // => '--FOO-BAR--'
 *
 * _.toUpper('fooBar');
 * // => 'FOOBAR'
 *
 * _.toUpper('__foo_bar__');
 * // => '__FOO_BAR__'
 */
function toUpper(value) {
  return toString(value).toUpperCase();
}

module.exports = toUpper;


/***/ }),

/***/ "9QcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACETING_CHILDCARE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FACETING_CLEAR_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FACETING_CLEAR_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FACETING_PRICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FACETING_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FACETING_LOAD_PRODUCTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FACETING_LOAD_OFFSET_SELL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FACETING_SET_CUSTOM_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FACETING_SET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FACETING_SET_SEARCH_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FACETING_SET_INITIAL_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FACETING_SET_IS_DATE_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FACETING_SET_IS_SEARCH_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FACETING_SET_KIDS_VALIDATION_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FACETING_SET_ORDER_BY_PRICE; });
/* unused harmony export FACETING_SET_SCROLL_TO_RESULTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FACETING_SET_SEARCH_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FACETING_RESET_CUSTOM_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FACETING_RESET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FACETING_RESET_REDIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FACETING_RESET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FACETING_TOGGLE_FACET_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FACETING_UPDATE_CUSTOM_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FACETING_UPDATE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS; });
var FACETING_CHILDCARE_REQUEST = 'FACETING_CHILDCARE_REQUEST';
var FACETING_CLEAR_FACETS = 'FACETING_CLEAR_FACETS';
var FACETING_CLEAR_ALL = 'FACETING_CLEAR_ALL';
var FACETING_PRICES_REQUEST = 'FACETING_PRICES_REQUEST';
var FACETING_SEARCH_REQUEST = 'FACETING_SEARCH_REQUEST';
var FACETING_LOAD_PRODUCTS_REQUEST = 'FACETING_LOAD_PRODUCTS_REQUEST';
var FACETING_LOAD_OFFSET_SELL_REQUEST = 'FACETING_LOAD_OFFSET_SELL_REQUEST';
var FACETING_SET_CUSTOM_FILTERS = 'FACETING_SET_CUSTOM_FILTERS';
var FACETING_SET_FILTERS = 'FACETING_SET_FILTERS';
var FACETING_SET_SEARCH_FILTERS = 'FACETING_SET_SEARCH_FILTERS';
var FACETING_SET_INITIAL_PRICES = 'FACETING_SET_INITIAL_PRICES';
var FACETING_SET_IS_DATE_REQUIRED = 'FACETING_SET_IS_DATE_REQUIRED';
var FACETING_SET_IS_SEARCH_ENABLED = 'FACETING_SET_IS_SEARCH_ENABLED';
var FACETING_SET_KIDS_VALIDATION_STATE = 'FACETING_SET_KIDS_VALIDATION_STATE';
var FACETING_SET_ORDER_BY_PRICE = 'FACETING_SET_ORDER_BY_PRICE';
var FACETING_SET_SCROLL_TO_RESULTS = 'FACETING_SCROLL_TO_RESULTS';
var FACETING_SET_SEARCH_QUERY = 'FACETING_SET_SEARCH_QUERY';
var FACETING_RESET_CUSTOM_FILTERS = 'FACETING_RESET_CUSTOM_FILTERS';
var FACETING_RESET_FILTERS = 'FACETING_RESET_FILTERS';
var FACETING_RESET_REDIRECTION = 'FACETING_RESET_REDIRECTION';
var FACETING_RESET_SEARCH = 'FACETING_RESET_SEARCH';
var FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_FACET_SELECTED = 'FACETING_TOGGLE_FACET_SELECTED';
var FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON = 'FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON';
var FACETING_UPDATE_CUSTOM_FILTERS = 'FACETING_UPDATE_CUSTOM_FILTERS';
var FACETING_UPDATE_FILTERS = 'FACETING_UPDATE_FILTERS';
var FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING = 'FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING';
var FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS = 'FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS';

/***/ }),

/***/ "9TP6":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("OBn4"),
    noop = __webpack_require__("nnm9"),
    setToArray = __webpack_require__("XlL0");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ "9au6":
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ "Akr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useSyncDepartureCity; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("uDfI");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("loSl");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kNiU");





var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["constants"].NO_TRANSPORT_VALUE;
function useSyncDepartureCity(_ref) {
  var departureCitiesOptions = _ref.departureCitiesOptions,
      departureCity = _ref.departureCity,
      initialTransport = _ref.initialTransport,
      onChange = _ref.onChange,
      withValidDepartureCity = _ref.withValidDepartureCity;
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useDispatch */ "d"])();
  var isDepartureCityAvailable = Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* hasDepartureCityAvailable */ "l"])(departureCitiesOptions, departureCity);

  var _departureCity = withValidDepartureCity && departureCity && !isDepartureCityAvailable ? null : departureCity;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(_departureCity || initialTransport || NO_TRANSPORT_VALUE),
      inputDepartureCity = _useState[0],
      setInputDepartureCity = _useState[1]; // Store update effect


  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var newDepartureCity = departureCity;

    if (withValidDepartureCity && newDepartureCity && !isDepartureCityAvailable) {
      newDepartureCity = initialTransport || NO_TRANSPORT_VALUE;
      dispatch(Object(_client_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_3__[/* changeDepartureCity */ "a"])(newDepartureCity));
    } // 1. Sync local state with store updates


    if (inputDepartureCity !== newDepartureCity) {
      setInputDepartureCity(newDepartureCity);
    } // 2. Sync criteria validation with store updates


    if (onChange) {
      onChange(newDepartureCity);
    }
  }, [departureCity]);
  return {
    inputDepartureCity: inputDepartureCity,
    setInputDepartureCity: setInputDepartureCity
  };
}

/***/ }),

/***/ "B3yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keywordsSelector; });
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hByQ");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_2__);




var searchSelector = function searchSelector(_ref) {
  var search = _ref.search;
  return search || {};
};

var querySelector = Object(reselect__WEBPACK_IMPORTED_MODULE_2__["createSelector"])(searchSelector, function (_ref2) {
  var query = _ref2.query;
  return query || {};
});
var keywordsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_2__["createSelector"])(querySelector, function (_ref3) {
  var keywords = _ref3.keywords;
  return keywords;
});


/***/ }),

/***/ "BRr/":
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__("ZLJe")),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__("8PLQ")),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),

/***/ "C5R2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDuration; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _duration_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("RBvG");


function setDuration(value) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_duration_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DURATION */ "c"], {
    value: value
  });
}

/***/ }),

/***/ "CZlo":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),

/***/ "Cmkl":
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__("2M3I");

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ "DwNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormFeedback; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("RUiN");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var BEACON_SELECTOR = 'FormFeedbackBeacon';
var FormFeedback = function FormFeedback(_ref) {
  var className = _ref.className,
      hasAutoScroll = _ref.hasAutoScroll,
      isError = _ref.isError,
      message = _ref.message;
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (hasAutoScroll) {
      Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__[/* scrollToElement */ "a"])("[data-testid=\"".concat(BEACON_SELECTOR, "\"]"));
    }
  }, []);
  return __jsx("p", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('flex font-bold gap-10 items-center leading-1 my-10 text-14', "".concat(isError ? 'text-red' : 'text-success'), className),
    "data-testid": BEACON_SELECTOR
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('shrink-0', {
      'pt-5 px-5': !isError
    }),
    name: isError ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].WARNING : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].CHECK,
    width: "1.25rem"
  }), __jsx("span", {
    "data-testid": "FormFeedback-message"
  }, message));
};

/***/ }),

/***/ "E8Xq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return capitalizeFromUppercase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return capitalizeWordFirstCaracter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return capitalize; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("EnZy");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("TYRa");
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5__);







function capitalize(string) {
  if (!string) {
    return '';
  }

  return string[0].toUpperCase() + string.slice(1);
}

var capitalizeFromUppercase = function capitalizeFromUppercase(str) {
  return lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default()(str.toLowerCase());
};
var capitalizeWordFirstCaracter = function capitalizeWordFirstCaracter(str) {
  return str === null || str === void 0 ? void 0 : str.toLowerCase().split(' ').map(function (w) {
    return lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default()(w);
  }).join(' ');
};


/***/ }),

/***/ "EWLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickOutside; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ClickOutside = function ClickOutside(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$shard = _ref.shard,
      shard = _ref$shard === void 0 ? {} : _ref$shard,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "onClick", "shard"]);

  var ref = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var current = ref.current;
      var shardElement = shard.current;
      var clickedElement = e.target;

      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: className,
    ref: ref
  }), children);
};

/***/ }),

/***/ "Eu1I":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("dw5g");

/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */
function toLower(value) {
  return toString(value).toLowerCase();
}

module.exports = toLower;


/***/ }),

/***/ "EvYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Modal_Modal; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("oVuX");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.themes.js
var MAX_HEIGHT = '70vh';
var sizes = {
  auto: 'auto',
  small: '23.75rem',
  // 380px
  medium: '40rem',
  // 640px
  large: '50rem' // 800px

};
var themes = function themes(_ref) {
  var size = _ref.size;
  return {
    "default": {
      thRoot: 'animate-fadeIn animate-scaleIn animation-duration-500 flex isolate relative ',
      thRootStyles: {
        width: sizes[size],
        maxWidth: '100%',
        maxHeight: MAX_HEIGHT,
        minHeight: 100
      },
      thCloseButton: 'absolute bg-white border-1 cursor-pointer leading-0 top-0 mb-10 end-0 p-5 rounded-full z-2',
      thCloseButtonLabel: 'sr-only',
      thCloseButtonStyles: {
        top: 'auto',
        bottom: '100%',
        width: 40,
        height: 40
      },
      thBody: 'bg-white max-h-full relative z-1 overflow-hidden rounded-12 shadow w-full flex flex-col',
      thBodyStyles: {
        maxHeight: MAX_HEIGHT
      },
      // ⚠️ relative is only needed to prevent a weird bug of reflow on chrome
      thContent: 'isolate max-h-full overflow-auto relative w-full',
      thAddendum: 'max-h-full fixed bottom-0 inset-x-0 overflow-hidden rounded-4 md:rounded-2 shadow w-full',
      thAddendumStyles: {
        maxHeight: MAX_HEIGHT
      },
      thAddendumContent: 'max-h-full overflow-auto relative w-full'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.jsx

var __jsx = react_default.a.createElement;






var Modal_Modal = function Modal(_ref) {
  var addendum = _ref.addendum,
      ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      backdropColor = _ref.backdropColor,
      backdropOpacity = _ref.backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? true : _ref$hasCloseButton,
      header = _ref.header,
      id = _ref.id,
      onClose = _ref.onClose,
      portalName = _ref.portalName,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'Modal' : _ref$dataTestId,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var modalButtonRef = Object(react["useRef"])();
  var closeBtnModal = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  Object(react["useEffect"])(function () {
    modalButtonRef.current && modalButtonRef.current.focus();
  }, []);
  var _themes$theme = themes({
    size: size
  })[theme],
      thAddendum = _themes$theme.thAddendum,
      thAddendumStyles = _themes$theme.thAddendumStyles,
      thAddendumContent = _themes$theme.thAddendumContent,
      thBody = _themes$theme.thBody,
      thBodyStyles = _themes$theme.thBodyStyles,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thCloseButtonStyles = _themes$theme.thCloseButtonStyles,
      thCloseIconWidth = _themes$theme.thCloseIconWidth,
      thContent = _themes$theme.thContent,
      thRoot = _themes$theme.thRoot,
      thRootStyles = _themes$theme.thRootStyles;
  return __jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: ariaLabel,
    ariaLabelledby: ariaLabelledby,
    bgColor: backdropColor,
    onClose: onClose,
    opacity: backdropOpacity,
    portalName: portalName
  }, __jsx("aside", {
    className: thRoot,
    id: id,
    style: thRootStyles,
    "data-testid": dataTestId
  }, hasCloseButton && __jsx("button", {
    className: thCloseButton,
    "data-testid": "Modal-close",
    onClick: onClose,
    ref: modalButtonRef,
    style: thCloseButtonStyles,
    type: "button"
  }, closeBtnModal && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnModal), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), __jsx("div", {
    className: thBody,
    style: thBodyStyles
  }, header, __jsx("div", {
    className: classnames_default()(thContent, className)
  }, children)), addendum && __jsx("div", {
    className: thAddendum,
    style: thAddendumStyles
  }, __jsx("div", {
    className: classnames_default()(thAddendumContent, className)
  }, addendum))));
};

/***/ }),

/***/ "GFPz":
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__("1aYn"),
    findLastIndex = __webpack_require__("ehGJ");

/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = createFind(findLastIndex);

module.exports = findLast;


/***/ }),

/***/ "Gf56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterButton; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;




var FilterButton = function FilterButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      isIconButton = _ref.isIconButton,
      onClick = _ref.onClick,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "isActive", "isDisabled", "isIconButton", "onClick"]);

  return __jsx("button", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('border-1 border-solid animate-fadeIn animation-duration-500 font-bold flex gap-15 items-center justify-center min-h-40 text-14 transition-colors duration-250 ease-in whitespace-nowrap', {
      'leading-0 p-2 rounded-4': isIconButton,
      'leading-1 py-10 px-15 rounded-pill': !isIconButton,
      'bg-white hocus:border-black': !isActive && !isDisabled,
      'border-white': !isActive && !isDisabled && isIconButton,
      'border-grey': !isActive && !isDisabled && !isIconButton,
      'bg-pearl border-grey cursor-not-allowed text-grey': isDisabled,
      'bg-saffron border-saffron text-black': isActive && !isDisabled && !isIconButton,
      'bg-white border-saffron text-black': isActive && !isDisabled && isIconButton
    }, className),
    disabled: isDisabled,
    onClick: onClick,
    type: "button"
  }), children, !isDisabled && isActive && !isIconButton && __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    className: "animate-fadeIn animation-duration-500 leading-0",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CHECK,
    width: "0.75rem"
  }));
};

/***/ }),

/***/ "Go22":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CriteriaWhen_CriteriaWhen; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("oVuX");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("rB9j");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("UxlC");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/range.js
var range = __webpack_require__("Cmkl");
var range_default = /*#__PURE__*/__webpack_require__.n(range);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/constants.js
var constants = __webpack_require__("393O");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/FilterWhen.jsx
var FilterWhen = __webpack_require__("qLhN");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaContext.jsx
var CriteriaContext = __webpack_require__("XiOS");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaTrigger.jsx
var CriteriaTrigger = __webpack_require__("+Rc+");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeasonPopin.jsx
var DayPriceDoubleSeasonPopin = __webpack_require__("uMuQ");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.action.js
var calendar_action = __webpack_require__("rueY");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.selector.js + 1 modules
var calendar_selector = __webpack_require__("05PS");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/hooks/use-unmount-delay/useUnmountDelay.js
var useUnmountDelay = __webpack_require__("5C2K");

// EXTERNAL MODULE: ./src/hooks/use-block-input-departure-date/useBlockInputDepartureDate.js
var useBlockInputDepartureDate = __webpack_require__("VQ9C");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.action.js
var departureDate_action = __webpack_require__("fflk");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.constants.js
var flexibility_constants = __webpack_require__("45Yg");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.action.js


function setFlexibility(value) {
  return Object(createAction["b" /* default */])(flexibility_constants["a" /* TRIP_INFORMATION_SET_FLEXIBILITY */], {
    value: value
  });
}
// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var date_apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-when/FlexibilityBlock.jsx

var __jsx = react_default.a.createElement;






var FlexibilityBlock_FlexibilityBlock = function FlexibilityBlock(_ref) {
  var shouldDisplayFlexibility = _ref.shouldDisplayFlexibility,
      flexibility = _ref.flexibility,
      onFlexibilityChange = _ref.onFlexibilityChange;
  return __jsx("div", {
    className: "animation-duration-500 flex flex-wrap justify-center ".concat(shouldDisplayFlexibility ? 'animate-fadeIn' : 'animate-fadeOut')
  }, [1, 3, 7].map(function (flexibilityOption) {
    return __jsx(Button["a" /* Button */], {
      className: classnames_default()('mx-5 mb-5 md:mb-0', {
        'border-2': flexibility === flexibilityOption
      }),
      color: colors["a" /* COLORS */].BLACK,
      colorBg: colors["a" /* COLORS */].TRANSPARENT,
      colorBorder: flexibility === flexibilityOption ? colors["a" /* COLORS */].GREEN : colors["a" /* COLORS */].BLACK,
      dataTestId: "flex-".concat(flexibilityOption),
      iconRight: flexibility === flexibilityOption ? {
        name: icons["a" /* ICONS */].CHECK,
        color: colors["a" /* COLORS */].GREEN,
        width: '0.625rem'
      } : undefined,
      key: flexibilityOption,
      minWidth: "5.875rem",
      onClick: function onClick() {
        return onFlexibilityChange(flexibilityOption);
      }
    }, "\xB1".concat(Object(i18n["h" /* t */])("faceting.flexibility.duration_".concat(flexibilityOption))));
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/CriteriaWhenReassuranceDropdown.jsx
var CriteriaWhenReassuranceDropdown = __webpack_require__("s6y/");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-when/CriteriaWhen.jsx


















var CriteriaWhen_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
































var selector = function selector(state) {
  return {
    departureDate: state.tripCriteria.departureDate,
    duration: state.tripCriteria.duration
  };
};

var CriteriaWhen_CriteriaWhen = function CriteriaWhen(props) {
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useContext = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0],
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var _useSelector = Object(es["e" /* useSelector */])(selector),
      departureDate = _useSelector.departureDate,
      duration = _useSelector.duration;

  var intialDuration = Object(es["e" /* useSelector */])(calendar_selector["k" /* getInitialDuration */]);
  var checkIfDepartureDateIsBookable = props.checkIfDepartureDateIsBookable,
      _props$isDropDownRela = props.isDropDownRelative,
      isDropDownRelative = _props$isDropDownRela === void 0 ? false : _props$isDropDownRela,
      prices = props.prices,
      product = props.product,
      withFlexibility = props.withFlexibility,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      useQueryParams = props.useQueryParams;

  var _useBlockInputDepartu = Object(useBlockInputDepartureDate["a" /* useBlockInputDepartureDate */])(checkIfDepartureDateIsBookable),
      blockInputDepartureDate = _useBlockInputDepartu.blockInputDepartureDate,
      setBlockInputDepartureDate = _useBlockInputDepartu.setBlockInputDepartureDate;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var _useRouter = Object(router["useRouter"])(),
      asPath = _useRouter.asPath,
      replace = _useRouter.replace;

  var seasonLabel = (product === null || product === void 0 ? void 0 : product.isSummer) || (product === null || product === void 0 ? void 0 : product.isWinter) ? "booking.priceCalendar.priceStatus.".concat((product === null || product === void 0 ? void 0 : product.isWinter) ? 'siblingSummer' : 'siblingWinter') : '';

  var _useState = Object(react["useState"])(!blockInputDepartureDate ? departureDate : null),
      inputDepartureDate = _useState[0],
      setInputDepartureDate = _useState[1];

  var flexibility = Object(es["e" /* useSelector */])(tripCriteria_selector["d" /* getTripFlexibility */]);

  var _useState2 = Object(react["useState"])(duration),
      inputDuration = _useState2[0],
      setInputDuration = _useState2[1];

  var dispatch = Object(es["d" /* useDispatch */])();
  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: criteriaContext.trackingActionName
  });

  var _useState3 = Object(react["useState"])(false),
      isDoubleSeasonPopinVisible = _useState3[0],
      setIsDoubleSeasonPopinVisible = _useState3[1];

  var onFlexibilityChange = function onFlexibilityChange(value) {
    var flexibilityValue = value !== flexibility ? value : 0;
    track({
      actionGA: 'smartCriterias',
      labelGA: "flexibility_".concat(flexibilityValue || 'none')
    });
    dispatch(setFlexibility(flexibilityValue));
  };

  var showFlexibility = withFlexibility && !!inputDepartureDate && !!inputDuration;

  var _useState4 = Object(react["useState"])(showFlexibility),
      shouldDisplayFlexibility = _useState4[0],
      setShouldDisplayFlexibility = _useState4[1];

  Object(react["useEffect"])(function () {
    if (!shouldDisplayFlexibility && showFlexibility) {
      setShouldDisplayFlexibility(true);
    } else if (shouldDisplayFlexibility && !showFlexibility) {
      setShouldDisplayFlexibility(false);
    }
  }, [showFlexibility]);
  var shouldRenderFlexibility = Object(useUnmountDelay["a" /* useDelayUnmount */])(!!shouldDisplayFlexibility, 300);

  var flexibilityBlock = CriteriaWhen_jsx(FlexibilityBlock_FlexibilityBlock, {
    shouldDisplayFlexibility: shouldDisplayFlexibility,
    flexibility: flexibility,
    onFlexibilityChange: onFlexibilityChange
  });

  Object(react["useEffect"])(function () {
    var formattedDepartureDate = departureDate ? moment_default()(departureDate).format('DDMM') : departureDate;
    var formattedInputDepartureDate = inputDepartureDate ? moment_default()(inputDepartureDate).format('DDMM') : inputDepartureDate;

    if (formattedDepartureDate !== formattedInputDepartureDate && !blockInputDepartureDate) {
      setInputDepartureDate(departureDate);
    }
  }, [departureDate]);
  Object(react["useEffect"])(function () {
    if (duration !== inputDuration) {
      setInputDuration(duration);
    }
  }, [duration]);
  Object(react["useEffect"])(function () {
    setCriteriaContext({
      criteriaWhenIsSet: Boolean(departureDate && duration && !blockInputDepartureDate)
    });
  }, [departureDate, duration, blockInputDepartureDate]);
  Object(react["useEffect"])(function () {
    setInputDepartureDate(blockInputDepartureDate ? null : departureDate);
  }, [blockInputDepartureDate]);

  var openCriteriaEventHandler = function openCriteriaEventHandler() {
    dispatchCriteriaDisplayContext({
      type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
      payload: 'criteriaWhen'
    });
  };

  Object(react["useEffect"])(function () {
    document.addEventListener(constants["a" /* OPEN_CRITERIA_WHEN_EVENT */], openCriteriaEventHandler);
    return function () {
      return document.removeEventListener(constants["a" /* OPEN_CRITERIA_WHEN_EVENT */], openCriteriaEventHandler);
    };
  }, []);
  var hasPrices = !isEmpty_default()(prices);
  var apiDate = Object(date_apiDate["k" /* timestampToApiDate */])(departureDate); // $FlowFixMe

  var price = hasPrices && !!apiDate ? prices[apiDate] : undefined;
  var priceAvailability = price ? price === null || price === void 0 ? void 0 : price.availability : '';

  var setUrlQueries = function setUrlQueries(queries) {
    var uri = new URI_default.a(asPath);
    var searchPageUrl = uri.clone().setQuery(queries);
    replace(searchPageUrl.toString(), undefined, {
      shallow: true,
      scroll: false
    });
  };

  var saveDateAndDuration = function saveDateAndDuration() {
    if (inputDepartureDate !== departureDate) {
      criteriaContext.setFacetHasSeeMore(false);
    }

    if (!inputDepartureDate) {
      if (useQueryParams) {
        var _setUrlQueries;

        setUrlQueries((_setUrlQueries = {}, Object(defineProperty["a" /* default */])(_setUrlQueries, uri_constants["g" /* QUERY_DEPARTURE_DATE */], undefined), Object(defineProperty["a" /* default */])(_setUrlQueries, uri_constants["h" /* QUERY_DURATION */], undefined), _setUrlQueries));
      }

      dispatch(Object(facetingSearch_action["f" /* clearDepartureDate */])());
      dispatch(Object(facetingSearch_action["h" /* clearTripDuration */])());
    } else if (departureDate) {
      if (hasPrices) {
        setIsDoubleSeasonPopinVisible(price === null || price === void 0 ? void 0 : price.siblingOpen);
      }

      var currentDuration = inputDuration || props.defaultDuration || duration_constants["b" /* DEFAULT_TRIP_DURATION */];

      if (currentDuration !== duration) {
        if (useQueryParams) {
          var _setUrlQueries2;

          setUrlQueries((_setUrlQueries2 = {}, Object(defineProperty["a" /* default */])(_setUrlQueries2, uri_constants["g" /* QUERY_DEPARTURE_DATE */], moment_default()(departureDate).format(uri_constants["f" /* QUERY_DATE_FORMAT */])), Object(defineProperty["a" /* default */])(_setUrlQueries2, uri_constants["h" /* QUERY_DURATION */], currentDuration), _setUrlQueries2));
        }

        dispatch(Object(facetingSearch_action["d" /* changeTripDuration */])(currentDuration));
      }
    }

    dispatchCriteriaDisplayContext({
      type: CriteriaDisplayContext["a" /* ACTIONS */].CLOSE_CRITERIA,
      payload: 'criteriaWhen'
    });
  };

  var labelPartsMobile = [];

  if (departureDate && duration && !blockInputDepartureDate) {
    labelPartsMobile.push(moment_default()(departureDate).format('DD/MM'));
    var arrival = moment_default()(departureDate).add({
      days: duration
    });
    labelPartsMobile.push(arrival.format('DD/MM'));
  }

  var labelParts = [Object(i18n["h" /* t */])('faceting.when.arrivalDateTitle'), Object(i18n["h" /* t */])('faceting.when.departureDateTitle')];

  if (departureDate && (!duration || !blockInputDepartureDate)) {
    labelParts[0] = moment_default()(departureDate).format('DD MMM');
  }

  if (departureDate && duration && !blockInputDepartureDate) {
    labelParts[1] = moment_default()(departureDate).add({
      days: duration
    }).format('DD MMM');

    if (flexibility && withFlexibility) {
      labelParts[1] = "".concat(labelParts[1], " (").concat(Object(i18n["h" /* t */])("faceting.flexibility.duration_".concat(flexibility, "short")), ")");
    }
  }

  var durationOptions = appContext.isSeller ? range_default()(1, 31) : props.durationOptions;
  var showDuration = !!inputDepartureDate && !!duration && !withFlexibility;

  var buttonLabel = CriteriaWhen_jsx(react["Fragment"], null, CriteriaWhen_jsx("span", {
    className: "flex-1 hidden lg:inline truncate"
  }, labelParts.join(' - '), ' ', showDuration && "(".concat(Object(i18n["h" /* t */])('booking.form.selectDuration', {
    duration: duration
  }), ")")), labelPartsMobile.length > 1 && CriteriaWhen_jsx(react["Fragment"], null, CriteriaWhen_jsx("div", {
    className: "flex flex-col h-full lg:hidden justify-center leading-tight text-12"
  }, labelPartsMobile.map(function (labelSplited, key) {
    return CriteriaWhen_jsx("span", {
      key: "".concat(labelSplited, "_").concat(key)
    }, labelSplited);
  })), !!flexibility && withFlexibility && CriteriaWhen_jsx("span", {
    className: "lg:hidden"
  }, Object(i18n["h" /* t */])("faceting.flexibility.duration_".concat(flexibility, "short")))));

  var trackDepartureDateChange = function trackDepartureDateChange(value) {
    if (criteriaContext.trackingActionName) {
      track({
        labelGA: "when_".concat(value.format('DD/MM/YYYY'))
      });
    }
  };

  var trackDurationChange = function trackDurationChange(value) {
    if (criteriaContext.trackingActionName) {
      var labelGA = "duration_".concat(value);
      track({
        labelGA: labelGA
      });
    }
  };

  var closeModal = function closeModal() {
    setIsDoubleSeasonPopinVisible(false);
  };

  var offsetCalendar = appContext.isSeller ? 0 : props.offsetSell;
  var onOpen = Object(react["useCallback"])(function () {
    dispatchCriteriaDisplayContext({
      type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
      payload: 'criteriaWhen'
    });
  }, []);
  var onClear = Object(react["useCallback"])(function () {
    if (useQueryParams) {
      var _setUrlQueries3;

      setUrlQueries((_setUrlQueries3 = {}, Object(defineProperty["a" /* default */])(_setUrlQueries3, uri_constants["g" /* QUERY_DEPARTURE_DATE */], undefined), Object(defineProperty["a" /* default */])(_setUrlQueries3, uri_constants["h" /* QUERY_DURATION */], undefined), _setUrlQueries3));
    }

    dispatch(Object(facetingSearch_action["h" /* clearTripDuration */])());
    dispatch(Object(facetingSearch_action["f" /* clearDepartureDate */])());
  }, []);
  var dateFormat = Object(i18n["h" /* t */])('booking.form.dateFormat');
  var from = inputDepartureDate ? moment_default()(inputDepartureDate) : null;
  var to = from && inputDuration ? moment_default()(from).add({
    days: inputDuration
  }) : null;

  var layerHeader = CriteriaWhen_jsx("span", {
    className: "font-bold"
  }, from ? from.format(dateFormat) : Object(i18n["h" /* t */])('faceting.when.arrivalDateTitle'), ' — ', to ? to.format(dateFormat) : Object(i18n["h" /* t */])('faceting.when.departureDateTitle'));

  var changeDepartureDate = Object(react["useCallback"])(function (value) {
    if (!value) {
      setInputDepartureDate();
      setInputDuration();
      return;
    }

    dispatch(Object(calendar_action["h" /* setIsPriceCalendarSelection */])(false));
    var newDepartureDate = moment_default()(value);
    var timestamp = newDepartureDate.valueOf();

    if (inputDepartureDate !== timestamp) {
      if (blockInputDepartureDate) {
        setBlockInputDepartureDate(false);
      }

      dispatch(Object(departureDate_action["a" /* setDepartureDate */])(timestamp));
      dispatch(Object(facetingSearch_action["h" /* clearTripDuration */])());
      setInputDepartureDate(timestamp);
      setInputDuration();
      setCriteriaContext({
        defaultValueForCalendar: newDepartureDate
      });
      trackDepartureDateChange(newDepartureDate);
    }
  }, [inputDepartureDate]);
  return CriteriaWhen_jsx(react["Fragment"], null, CriteriaWhen_jsx(CriteriaTrigger["a" /* CriteriaTrigger */], {
    buttonLabel: buttonLabel,
    buttonIcon: icons["a" /* ICONS */].DATE,
    buttonIsFilled: criteriaContext.criteriaWhenIsSet,
    dropDownStyle: _objectSpread({
      width: 'auto',
      minWidth: 'calc(780rem / 16)',
      transform: 'none'
    }, isRTL ? {
      right: '0',
      left: 'auto'
    } : {
      left: '0',
      right: 'auto'
    }),
    isDropDownRelative: isDropDownRelative,
    isOpen: criteriaDisplayContext.criteriaWhenIsOpen,
    isJoyview: props.isJoyview,
    trackingLabel: "when",
    onOpen: onOpen,
    onClose: saveDateAndDuration,
    onClear: onClear,
    layerHeader: layerHeader,
    layerHeaderSlot: hasPrices && CriteriaWhen_jsx(CriteriaWhenReassuranceDropdown["a" /* CriteriaWhenReassuranceDropdown */], {
      nbNightsProps: {
        from: from,
        to: to,
        duration: inputDuration
      }
    }),
    buttons: [{
      children: Object(i18n["h" /* t */])('faceting.reset'),
      className: 'pe-10',
      dataTestId: 'criteria-when-reset',
      onClick: function onClick() {
        setInputDuration();
        setInputDepartureDate();

        if (flexibility) {
          dispatch(setFlexibility(0));
        }
      },
      theme: 'link'
    }, {
      children: Object(i18n["h" /* t */])('faceting.validate'),
      dataTestId: 'criteria-when-validate',
      onClick: function onClick() {
        saveDateAndDuration();
        dispatchCriteriaDisplayContext({
          type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_NEXT_CRITERIA,
          payload: {
            currentCriteria: 'criteriaWhen',
            criteriaContext: criteriaContext
          }
        });
      }
    }],
    buttonsSlot: shouldRenderFlexibility && flexibilityBlock
  }, CriteriaWhen_jsx(FilterWhen["a" /* FilterWhen */], {
    defaultDuration: intialDuration || props.defaultDuration,
    optionsDuration: durationOptions,
    prices: prices,
    changeTripDuration: function changeTripDuration(time) {
      if (time) {
        setInputDuration(time);
        trackDurationChange(time);
      }
    },
    changeDepartureDate: changeDepartureDate,
    duration: inputDuration,
    departureDate: inputDepartureDate,
    openCalendarToDate: criteriaContext.defaultValueForCalendar,
    offsetCalendar: offsetCalendar,
    dateFormat: dateFormat,
    seasonLabel: seasonLabel,
    theme: theme
  })), isDoubleSeasonPopinVisible && !!product && CriteriaWhen_jsx(Modal["a" /* Modal */], {
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: closeModal,
    size: "small"
  }, CriteriaWhen_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: priceAvailability,
    product: product,
    statusMessageKey: "booking.priceCalendar.priceStatus.".concat(priceAvailability),
    trackingData: {
      actionGA: 'priceBar'
    }
  })));
};

/***/ }),

/***/ "HAu2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useRouterEvents; });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);


function useRouterEvents() {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      transitioning = _useState[0],
      setTransitioning = _useState[1];

  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_0__["useRouter"])();
  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    var routeChangeStartHandler = function routeChangeStartHandler() {
      setTransitioning(true);
    };

    var routeChangeCompleteHandler = function routeChangeCompleteHandler() {
      setTransitioning(false);
    };

    router.events.on('routeChangeStart', routeChangeStartHandler);
    router.events.on('routeChangeComplete', routeChangeCompleteHandler);
    return function () {
      router.events.off('routeChangeStart', routeChangeStartHandler);
      router.events.off('routeChangeComplete', routeChangeCompleteHandler);
    };
  }, []);
  return {
    transitioning: transitioning
  };
}

/***/ }),

/***/ "HFnK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__("bWFh");
var collectionStrong = __webpack_require__("ZWaQ");

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "I2LH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnmountClosed = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _Collapse = __webpack_require__("gz38");

var _excluded = ["isOpened"],
    _excluded2 = ["isOpened"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UnmountClosed = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(UnmountClosed, _React$PureComponent);

  var _super = _createSuper(UnmountClosed);

  function UnmountClosed(props) {
    var _this;

    _classCallCheck(this, UnmountClosed);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onWork", function (_ref) {
      var isOpened = _ref.isOpened,
          rest = _objectWithoutProperties(_ref, _excluded);

      _this.setState({
        isResting: false,
        isOpened: isOpened
      });

      var onWork = _this.props.onWork;

      if (onWork) {
        onWork(_objectSpread({
          isOpened: isOpened
        }, rest));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRest", function (_ref2) {
      var isOpened = _ref2.isOpened,
          rest = _objectWithoutProperties(_ref2, _excluded2);

      _this.setState({
        isResting: true,
        isOpened: isOpened,
        isInitialRender: false
      });

      var onRest = _this.props.onRest;

      if (onRest) {
        onRest(_objectSpread({
          isOpened: isOpened
        }, rest));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialStyle", function () {
      var _this$state = _this.state,
          isOpened = _this$state.isOpened,
          isInitialRender = _this$state.isInitialRender;

      if (isInitialRender) {
        return isOpened ? {
          height: 'auto',
          overflow: 'initial'
        } : {
          height: '0px',
          overflow: 'hidden'
        };
      }

      return {
        height: '0px',
        overflow: 'hidden'
      };
    });

    _this.state = {
      isResting: true,
      isOpened: props.isOpened,
      isInitialRender: true
    };
    return _this;
  }

  _createClass(UnmountClosed, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpened = this.props.isOpened;

      if (prevProps.isOpened !== isOpened) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isResting: false,
          isOpened: isOpened,
          isInitialRender: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          isResting = _this$state2.isResting,
          isOpened = _this$state2.isOpened;
      return isResting && !isOpened ? null : /*#__PURE__*/_react["default"].createElement(_Collapse.Collapse, _extends({}, this.props, {
        initialStyle: this.getInitialStyle(),
        onWork: this.onWork,
        onRest: this.onRest
      }));
    }
  }]);

  return UnmountClosed;
}(_react["default"].PureComponent);

exports.UnmountClosed = UnmountClosed;

_defineProperty(UnmountClosed, "defaultProps", {
  onWork: undefined,
  onRest: undefined
});

/***/ }),

/***/ "Itgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ECBadge; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var ECBadge = function ECBadge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE : _ref$color,
      size = _ref.size;
  return __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"], {
    alt: alt,
    className: className,
    color: color,
    dataTestid: "ECBadge",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].EXCLUSIVE_COLLECTION,
    width: size
  });
};

/***/ }),

/***/ "J8B4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NbNights; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _trip_date_picker_TripDatePicker_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("RqHf");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var NbNights = function NbNights(_ref) {
  var from = _ref.from,
      to = _ref.to,
      hovered = _ref.hovered,
      duration = _ref.duration;

  var computeDisplayedDuration = function computeDisplayedDuration() {
    var displayedDuration = from && (to || hovered) ? Object(_trip_date_picker_TripDatePicker_utils__WEBPACK_IMPORTED_MODULE_2__[/* dateDiff */ "c"])(from, to || hovered || from) || duration : 0;
    return displayedDuration || duration || 0;
  };

  var displayedDuration = computeDisplayedDuration();
  var durationLabel = Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["messageFormat"])({
    n: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('faceting.when.durationPlural'),
    _0: '-',
    _1: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('faceting.when.durationSingular')
  }).format({
    n: displayedDuration,
    count: displayedDuration
  });
  return __jsx("p", {
    "data-testid": "nbNights",
    className: "text-center  text-14 font-bold pb-10 text-black"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('faceting.when.pricesBasedOn'), " ", durationLabel);
};

/***/ }),

/***/ "J9nQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderLayerContent; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("VHif");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var HeaderLayerContent = function HeaderLayerContent(_ref) {
  var activeCount = _ref.activeCount,
      title = _ref.title;
  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, !!title && title, activeCount ? __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_1__[/* Badge */ "a"], {
    className: "ms-10 text-14",
    colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].SAFFRON,
    colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].SAFFRON,
    label: __jsx("span", {
      className: "font-bold me-1 mt-1 text-black"
    }, activeCount),
    size: 32,
    variant: "pill"
  }) : null);
};

/***/ }),

/***/ "Jcrg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FormControl_FormControl; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Label.jsx
var Label = __webpack_require__("vJSV");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/dedupe.js
var dedupe = __webpack_require__("MoqE");
var dedupe_default = /*#__PURE__*/__webpack_require__.n(dedupe);

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.themes.js



var themes = {
  "default": function _default(props) {
    var hasValidationIcon = props.hasValidationIcon,
        isActive = props.isActive,
        isDisabled = props.isDisabled,
        isFilled = props.isFilled,
        isReadOnly = props.isReadOnly,
        _props$validationStat = props.validationState,
        validationState = _props$validationStat === void 0 ? 'NOT_VALIDATED' : _props$validationStat;
    var hasDefaultStyle = validationState === 'NOT_VALIDATED' && !isActive && !isFilled && !isDisabled;
    var hasValidStyle = validationState === 'IS_VALID' && !isFilled && !isDisabled && !isReadOnly;
    var hasInvalidStyle = validationState === 'IS_INVALID' && !isFilled && !isDisabled && !isReadOnly;
    var validationIconName = null;

    if (hasValidationIcon && (hasValidStyle || hasInvalidStyle)) {
      validationIconName = hasValidStyle ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS;
    }

    return {
      thField: dedupe_default()('flex items-center gap-10', Object(form_util["a" /* getCursorClass */])(props), 'appearance-none border h-48 leading-normal outline-none px-20 py-10 rounded-pill text-14 text-black transition-all duration-250 ease-in w-full', {
        'border-lightGrey hocus:border-black': hasDefaultStyle,
        'border-success': hasValidStyle,
        'border-red formik-errored': hasInvalidStyle,
        'border-grey bg-pearl cursor-not-allowed text-grey': isDisabled || isReadOnly
      }),
      thSpinnerColor: 'current',
      thClearButton: 'leading-0 transition-color',
      thClearIconSize: '0.625rem',
      thValidationIcon: hasValidStyle ? 'text-success' : 'text-red',
      thValidationIconSize: '0.8125rem',
      thValidationIconName: validationIconName
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx
var __jsx = react_default.a.createElement;






var FormControl_FormControl = function FormControl(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dir = _ref.dir,
      hasClear = _ref.hasClear,
      _ref$hasValidationIco = _ref.hasValidationIcon,
      hasValidationIcon = _ref$hasValidationIco === void 0 ? true : _ref$hasValidationIco,
      iconLeft = _ref.iconLeft,
      id = _ref.id,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly,
      isRequired = _ref.isRequired,
      label = _ref.label,
      notes = _ref.notes,
      onClear = _ref.onClear,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      validationState = _ref.validationState;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme]({
    hasValidationIcon: hasValidationIcon,
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isReadOnly: isReadOnly,
    validationState: validationState
  }),
      thClearButton = _themes$theme.thClearButton,
      thClearIconSize = _themes$theme.thClearIconSize,
      thField = _themes$theme.thField,
      thSpinnerColor = _themes$theme.thSpinnerColor,
      thValidationIcon = _themes$theme.thValidationIcon,
      thValidationIconName = _themes$theme.thValidationIconName,
      thValidationIconSize = _themes$theme.thValidationIconSize;

  return __jsx("div", {
    className: className,
    dir: dir
  }, !!label && __jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: id,
    isRequired: isRequired,
    label: label,
    labelAdditionalInfo: notes
  }), __jsx("div", {
    className: thField
  }, iconLeft && __jsx(Icon["a" /* Icon */], {
    name: iconLeft,
    width: "1.25rem"
  }), children, isLoading && !isDisabled && !isReadOnly && __jsx(Spinner["a" /* Spinner */], {
    color: thSpinnerColor,
    size: "small"
  }), hasClear && !isDisabled && !isLoading && !isReadOnly && __jsx("button", {
    className: thClearButton,
    "data-testid": "FormControlClear",
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearIconSize
  })), thValidationIconName && __jsx(Icon["a" /* Icon */], {
    className: thValidationIcon,
    name: thValidationIconName,
    width: thValidationIconSize
  })));
};

/***/ }),

/***/ "JevA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("I+eb");
var parseInt = __webpack_require__("wg0c");

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseInt !== parseInt }, {
  parseInt: parseInt
});


/***/ }),

/***/ "Jsmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tripInformationSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdultsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getKids; });
/* unused harmony export getMainContactOptins */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);

var tripInformationSelector = function tripInformationSelector(state) {
  return (state === null || state === void 0 ? void 0 : state.tripInformation) || {};
};

var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var getAdults = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref2) {
  var adults = _ref2.adults;
  return adults || [];
});
var getAdultsNumber = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref3) {
  var adults = _ref3.adults;
  return (adults || []).length;
});
var getKids = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref4) {
  var kids = _ref4.kids;
  return kids || [];
});
var getMainContactOptins = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref5) {
  var mainContact = _ref5.mainContact;
  return mainContact;
});


/***/ }),

/***/ "M3jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterTransport; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("1JJ2");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("7amT");





var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

/* eslint-disable clubmed/no-fake-component */








var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["constants"].NO_TRANSPORT_VALUE;
var FilterTransport = function FilterTransport(_ref) {
  var changeDepartureCity = _ref.changeDepartureCity,
      className = _ref.className,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'FilterTransport' : _ref$dataTestId,
      departureCity = _ref.departureCity,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      optionsDepartureCities = _ref.optionsDepartureCities,
      toggleCriteriaExpansion = _ref.toggleCriteriaExpansion,
      validateDepartureCity = _ref.validateDepartureCity,
      withNoTransport = _ref.withNoTransport,
      _ref$shouldShowNoTran = _ref.shouldShowNoTransportButtonMobile,
      shouldShowNoTransportButtonMobile = _ref$shouldShowNoTran === void 0 ? true : _ref$shouldShowNoTran;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var value = departureCity || '';
  var loading = isLoading || optionsDepartureCities.length === 0;
  var otherDepartureCities = withNoTransport ? optionsDepartureCities : optionsDepartureCities.filter(function (_ref2) {
    var departureCityCode = _ref2.value;
    return departureCityCode !== NO_TRANSPORT_VALUE;
  });
  var mainCities = Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* getListValue */ "e"])('faceting.transport.departureCities.mainCitiesList') || [];
  var optionsMainDepartureCities = optionsDepartureCities.filter(function (_ref3) {
    var cityCode = _ref3.value;
    return mainCities.includes(cityCode);
  });

  var renderTitle = function renderTitle(shouldShowNoTransportButton) {
    if (!isDesktop) {
      return __jsx("div", {
        className: "flex flex-col"
      }, shouldShowNoTransportButton && __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('py-15 px-20', {
          'font-bold text-success': value === NO_TRANSPORT_VALUE
        })
      }, __jsx("label", {
        className: "rounded-2 hocus:bg-lightGrey cursor-pointer flex items-baseline justify-between",
        htmlFor: NO_TRANSPORT_VALUE
      }, __jsx("input", {
        checked: value === NO_TRANSPORT_VALUE,
        className: "hidden",
        "data-testid": "".concat(dataTestId, "-").concat(NO_TRANSPORT_VALUE),
        disabled: isDisabled,
        id: NO_TRANSPORT_VALUE,
        name: "TransportSelectFilter",
        onChange: function onChange(e) {
          return changeDepartureCity(e.target.value, toggleCriteriaExpansion);
        },
        onClick: function onClick(e) {
          return validateDepartureCity(e.target.value);
        },
        type: "radio",
        value: NO_TRANSPORT_VALUE
      }), Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.noTransportNeededMobile'), value === NO_TRANSPORT_VALUE && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].CHECK,
        width: "0.625rem"
      }))), __jsx("div", {
        className: "border-b-1 border-lightGrey p-20 py-15"
      }, __jsx("p", {
        className: "font-bold  text-16"
      }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.transportNeededMobile'))));
    }

    return __jsx("div", {
      className: "border-b-1 border-lightGrey p-20 py-15"
    }, __jsx("p", {
      className: "font-bold  text-16"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.when.from')));
  };

  var renderDepartureCitiesOptions = function renderDepartureCitiesOptions(departureCities) {
    return departureCities.map(function (o) {
      return __jsx("li", {
        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()({
          'font-bold text-success': o.value === value
        }),
        key: o.value
      }, __jsx("label", {
        className: "-mx-20 px-20 rounded-2 hocus:bg-lightGrey cursor-pointer flex items-baseline justify-between py-5",
        htmlFor: o.value
      }, __jsx("input", {
        checked: o.value === value,
        className: "hidden",
        "data-testid": "".concat(dataTestId, "-").concat(o.value),
        disabled: o.isDisabled || isDisabled,
        id: o.value,
        name: "TransportSelectFilter",
        onChange: function onChange(e) {
          return changeDepartureCity(e.target.value, toggleCriteriaExpansion);
        },
        type: "radio",
        value: o.value
      }), o.label, o.value === value && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].CHECK,
        width: "0.625rem"
      })));
    });
  };

  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('flex flex-col', className),
    "data-testid": "FilterTransport"
  }, renderTitle(shouldShowNoTransportButtonMobile), loading ? __jsx("div", {
    className: "flex-1 flex items-center justify-center leading-0 p-20"
  }, __jsx(_frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__[/* Spinner */ "a"], {
    size: "small"
  })) : __jsx("div", {
    className: "max-h-none overflow-y-auto text-14 px-20",
    style: isDesktop ? {
      maxHeight: 'calc(240rem / 16)'
    } : {}
  }, optionsMainDepartureCities.length > 0 && __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx("p", {
    className: "border-b-1 border-grey text-mediumGrey border-dashed py-5"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.departureCities.mainCities')), __jsx("ul", {
    className: "flex-1 lg:flex-none  pb-5 mb-10"
  }, renderDepartureCitiesOptions(optionsMainDepartureCities)), __jsx("p", {
    className: "border-b-1 border-grey text-mediumGrey border-dashed py-5"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.departureCities.allCities'))), __jsx("ul", {
    className: "flex-1 lg:flex-none "
  }, renderDepartureCitiesOptions(otherDepartureCities))));
};

/***/ }),

/***/ "MX/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_TRANSPORT_EVENT; });
var OPEN_CRITERIA_TRANSPORT_EVENT = 'openCriteriaTransport';

/***/ }),

/***/ "Mn1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripDateCriteriaSelector = function tripDateCriteriaSelector(_ref) {
  var tripDateCriteria = _ref.tripDateCriteria;
  return tripDateCriteria || {};
};

var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref2) {
  var arrivalDate = _ref2.arrivalDate;
  return arrivalDate;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref3) {
  var departureDate = _ref3.departureDate;
  return departureDate;
});


/***/ }),

/***/ "MoqE":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var classNames = (function () {
		// don't inherit from Object so we can skip hasOwnProperty check later
		// http://stackoverflow.com/questions/15518328/creating-js-object-with-object-createnull#answer-21079232
		function StorageObject() {}
		StorageObject.prototype = Object.create(null);

		function _parseArray (resultSet, array) {
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				_parse(resultSet, array[i]);
			}
		}

		var hasOwn = {}.hasOwnProperty;

		function _parseNumber (resultSet, num) {
			resultSet[num] = true;
		}

		function _parseObject (resultSet, object) {
			for (var k in object) {
				if (hasOwn.call(object, k)) {
					// set value to false instead of deleting it to avoid changing object structure
					// https://www.smashingmagazine.com/2012/11/writing-fast-memory-efficient-javascript/#de-referencing-misconceptions
					resultSet[k] = !!object[k];
				}
			}
		}

		var SPACE = /\s+/;
		function _parseString (resultSet, str) {
			var array = str.split(SPACE);
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				resultSet[array[i]] = true;
			}
		}

		function _parse (resultSet, arg) {
			if (!arg) return;
			var argType = typeof arg;

			// 'foo bar'
			if (argType === 'string') {
				_parseString(resultSet, arg);

			// ['foo', 'bar', ...]
			} else if (Array.isArray(arg)) {
				_parseArray(resultSet, arg);

			// { 'foo': true, ... }
			} else if (argType === 'object') {
				_parseObject(resultSet, arg);

			// '130'
			} else if (argType === 'number') {
				_parseNumber(resultSet, arg);
			}
		}

		function _classNames () {
			// don't leak arguments
			// https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
			var len = arguments.length;
			var args = Array(len);
			for (var i = 0; i < len; i++) {
				args[i] = arguments[i];
			}

			var classSet = new StorageObject();
			_parseArray(classSet, args);

			var list = [];

			for (var k in classSet) {
				if (classSet[k]) {
					list.push(k)
				}
			}

			return list.join(' ');
		}

		return _classNames;
	})();

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "NLwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return graphqlify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return graphqlifyString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return buildProductArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildCruiseArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildArgs; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("T63A");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("zygG");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_isBoolean__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("p6M4");
/* harmony import */ var lodash_isBoolean__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_isBoolean__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("mGvo");
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_isUndefined__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("CZlo");
/* harmony import */ var lodash_isUndefined__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_isUndefined__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_isNull__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("R7V3");
/* harmony import */ var lodash_isNull__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_isNull__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var lodash_isArray__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("wxYD");
/* harmony import */ var lodash_isArray__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_isArray__WEBPACK_IMPORTED_MODULE_19__);





















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var EMPTY_STRING = '""';

function graphqlify(jsonObject) {
  if (jsonObject) {
    return JSON.stringify(jsonObject).replace(/\"([^(\")"]+)\":/g, '$1:').replace(/(null)/g, EMPTY_STRING);
  }

  return '';
}

function graphqlifyString(str) {
  if (lodash_isString__WEBPACK_IMPORTED_MODULE_14___default()(str)) {
    return JSON.stringify(str);
  }

  return EMPTY_STRING;
}

function buildArgs() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var initialArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Object.entries(args).reduce(function (acc, _ref) {
    var _ref2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (lodash_isNull__WEBPACK_IMPORTED_MODULE_18___default()(value) || lodash_isUndefined__WEBPACK_IMPORTED_MODULE_17___default()(value)) {
      return acc;
    }

    if (lodash_isNumber__WEBPACK_IMPORTED_MODULE_16___default()(value) || lodash_isBoolean__WEBPACK_IMPORTED_MODULE_15___default()(value)) {
      return "".concat(acc, " ").concat(key, ": ").concat(value);
    }

    if (lodash_isArray__WEBPACK_IMPORTED_MODULE_19___default()(value)) {
      return "".concat(acc, " ").concat(key, ": ").concat(graphqlify(value));
    }

    return "".concat(acc, " ").concat(key, ": \"").concat(value, "\"");
  }, initialArgs);
}

function getCruiseArgs() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$departureDate = params.departureDate,
      departureDate = _params$departureDate === void 0 ? '' : _params$departureDate,
      _params$arrivalDate = params.arrivalDate,
      arrivalDate = _params$arrivalDate === void 0 ? '' : _params$arrivalDate;
  return {
    cruiseDepartureDate: departureDate,
    cruiseArrivalDate: arrivalDate
  };
}

function buildCruiseArgs() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var optionalArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var args = _objectSpread(_objectSpread({}, optionalArguments), getCruiseArgs(params));

  return buildArgs(args);
}

var CRUISE_RESORT_ID = 'CM2C';

function buildProductArgs(productId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var optionalArguments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!productId) {
    throw new Error('You must provide a productId');
  }

  var productArg;

  if (productId !== CRUISE_RESORT_ID) {
    productArg = "productId: \"".concat(productId, "\"");
  } else {
    var _getCruiseArgs = getCruiseArgs(params),
        cruiseDepartureDate = _getCruiseArgs.cruiseDepartureDate,
        cruiseArrivalDate = _getCruiseArgs.cruiseArrivalDate;

    productArg = "productId: \"".concat(productId, "_").concat(cruiseDepartureDate, "_").concat(cruiseArrivalDate, "\"");
  }

  return buildArgs(optionalArguments, productArg);
}



/***/ }),

/***/ "NWzG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaTransport; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zygG");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("uDfI");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("SPKZ");
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("XiOS");
/* harmony import */ var _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("TYzI");
/* harmony import */ var _CriteriaTrigger__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+Rc+");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("MX/n");
/* harmony import */ var _filter_transport_FilterTransport__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("M3jp");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("Ub5k");
/* harmony import */ var _hooks_use_sync_departure_city_useSyncDepartureCity__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Akr5");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("kiXb");
/* harmony import */ var _store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("loSl");
/* harmony import */ var _store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("vIa8");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("RBO1");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("L7OA");




var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;




















var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_6__["constants"].NO_TRANSPORT_VALUE;
var CriteriaTransport = function CriteriaTransport(_ref) {
  var departureCitiesOptions = _ref.departureCitiesOptions,
      initialTransport = _ref.initialTransport,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$transportIcon = _ref.transportIcon,
      transportIcon = _ref$transportIcon === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_9__[/* ICONS */ "a"].TRANSPORT : _ref$transportIcon,
      withValidDepartureCity = _ref.withValidDepartureCity;
  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_15__[/* useAppContext */ "c"])();
  var isInitialMount = Object(react__WEBPACK_IMPORTED_MODULE_4__["useRef"])(true);

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_4__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_10__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(_CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_11__[/* useCriteriaDisplayContext */ "c"])(),
      _useCriteriaDisplayCo2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_useCriteriaDisplayCo, 2),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0],
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useDispatch */ "d"])();
  var departureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useSelector */ "e"])(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_20__[/* getDepartureCity */ "a"]);
  var facetingCustomFilters = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useSelector */ "e"])(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_19__[/* customFiltersSelector */ "d"]);
  var facetingFilters = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useSelector */ "e"])(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_19__[/* filtersSelector */ "j"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_21__[/* useTracking */ "a"])({
    actionGA: criteriaContext.trackingActionName
  }); // Store update effect

  var _useSyncDepartureCity = Object(_hooks_use_sync_departure_city_useSyncDepartureCity__WEBPACK_IMPORTED_MODULE_16__[/* useSyncDepartureCity */ "a"])({
    departureCitiesOptions: departureCitiesOptions,
    departureCity: departureCity,
    initialTransport: initialTransport,
    onChange: function onChange(newDepartureCity) {
      setCriteriaContext({
        criteriaTransportIsSet: Boolean(newDepartureCity)
      });
    },
    withValidDepartureCity: withValidDepartureCity
  }),
      inputDepartureCity = _useSyncDepartureCity.inputDepartureCity,
      setInputDepartureCity = _useSyncDepartureCity.setInputDepartureCity;

  Object(react__WEBPACK_IMPORTED_MODULE_4__["useEffect"])(function () {
    if (!isInitialMount.current && inputDepartureCity) {
      saveTransport();
    }

    isInitialMount.current = false;
  }, [inputDepartureCity]);
  var noDepartureCitiesOptions = [{
    isDisabled: true,
    isSelected: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('booking.priceCalendar.priceStatus.noFlight'),
    value: ''
  }];

  var openCriteriaEventHandler = function openCriteriaEventHandler() {
    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_11__[/* ACTIONS */ "a"].OPEN_CRITERIA,
      payload: 'criteriaTransport'
    });
  }; // Open/Close effect


  Object(react__WEBPACK_IMPORTED_MODULE_4__["useEffect"])(function () {
    document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__[/* OPEN_CRITERIA_TRANSPORT_EVENT */ "a"], openCriteriaEventHandler);
    return function () {
      return document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_13__[/* OPEN_CRITERIA_TRANSPORT_EVENT */ "a"], openCriteriaEventHandler);
    };
  }, []);

  var resetFlightDurationActiveFacetOptions = function resetFlightDurationActiveFacetOptions() {
    return dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_18__[/* updateCustomFilters */ "u"])(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(facetingCustomFilters).filter(function (_ref2) {
      var id = _ref2.id;
      return id !== _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* FLIGHT_DURATION_FACET_ID */ "C"];
    })));
  };

  var saveTransport = function saveTransport() {
    if (inputDepartureCity !== departureCity || !inputDepartureCity) {
      criteriaContext.setFacetHasSeeMore(false);
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_18__[/* changeDepartureCity */ "a"])(inputDepartureCity || NO_TRANSPORT_VALUE));

      if (!inputDepartureCity) {
        resetFlightDurationActiveFacetOptions();
      }
    }

    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_11__[/* ACTIONS */ "a"].CLOSE_CRITERIA,
      payload: 'criteriaTransport'
    });
  };

  var getIcon = function getIcon() {
    if (departureCity === NO_TRANSPORT_VALUE) {
      return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_9__[/* ICONS */ "a"].NO_TRANSPORT;
    }

    return transportIcon;
  };

  var getLabel = function getLabel() {
    if (!criteriaContext.criteriaTransportIsSet) {
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('faceting.transport.departingFrom');
    }

    var selectedOption = departureCitiesOptions.find(function (item) {
      return item.value === departureCity;
    });

    if (!selectedOption) {
      var departureCityFilter = facetingFilters.find(function (_ref3) {
        var id = _ref3.id;
        return id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* DEPARTURE_CITY_FACET_ID */ "r"];
      });
      return departureCityFilter ? departureCityFilter.label : '';
    }

    return selectedOption.label;
  };

  var buttonIsLoading = !departureCitiesOptions.length && isLoading && criteriaContext.criteriaTransportIsSet;

  var buttonLabel = __jsx("span", {
    className: "flex-1 hidden lg:block truncate"
  }, getLabel());

  var trackDepartureCityChange = function trackDepartureCityChange(newDepartureCity) {
    if (newDepartureCity) {
      var labelGA = "departureCity_".concat(newDepartureCity);

      if (criteriaContext.trackingActionName) {
        track({
          labelGA: labelGA
        });
      }
    }
  };

  var buttonsSlot = __jsx("div", {
    className: "text-12"
  }, __jsx("div", {
    className: "text-16 font-bold flex gap-15 mb-15"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_9__[/* ICONS */ "a"].ALL_INCLUSIVE,
    className: "shrink-0",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_8__[/* COLORS */ "a"].SIENNA
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('faceting.transport.departureCities.reinsurance')), __jsx("div", {
    className: "mb-10"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('faceting.transport.departureCities.guarantee')), __jsx("div", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('faceting.transport.departureCities.schedule')));

  var onOpen = Object(react__WEBPACK_IMPORTED_MODULE_4__["useCallback"])(function () {
    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_11__[/* ACTIONS */ "a"].OPEN_CRITERIA,
      payload: 'criteriaTransport'
    });
  }, []);
  var onClear = Object(react__WEBPACK_IMPORTED_MODULE_4__["useCallback"])(function () {
    dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_18__[/* changeDepartureCity */ "a"])(NO_TRANSPORT_VALUE));
    resetFlightDurationActiveFacetOptions();
  }, []);
  return !Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('faceting.hideCriteriaTransport') ? __jsx(_CriteriaTrigger__WEBPACK_IMPORTED_MODULE_12__[/* CriteriaTrigger */ "a"], {
    dataTestId: "CriteriaTransport-trigger",
    buttonLabel: buttonLabel,
    buttonIcon: getIcon(),
    buttonIsFilled: criteriaContext.criteriaTransportIsSet && departureCity !== NO_TRANSPORT_VALUE,
    buttons: [{
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('faceting.reset'),
      onClick: function onClick() {
        setInputDepartureCity('');
      },
      theme: 'link'
    }, {
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('faceting.validate'),
      onClick: saveTransport
    }],
    buttonsSlot: buttonsSlot,
    hasSwitch: true,
    isJoyview: isJoyview,
    isLoading: buttonIsLoading,
    isOpen: criteriaDisplayContext.criteriaTransportIsOpen,
    onClear: onClear,
    onClose: saveTransport,
    onOpen: onOpen,
    trackingLabel: "departureCity"
  }, __jsx(_filter_transport_FilterTransport__WEBPACK_IMPORTED_MODULE_14__[/* FilterTransport */ "a"], {
    changeDepartureCity: function changeDepartureCity(newDepartureCity) {
      setInputDepartureCity(newDepartureCity);
      trackDepartureCityChange(newDepartureCity);
    },
    className: "h-full",
    dataTestId: "CriteriaTransport-input",
    departureCity: !departureCitiesOptions.length ? '' : inputDepartureCity,
    isDisabled: !isLoading && !departureCitiesOptions.length,
    isLoading: isLoading,
    labelDepartingFrom: Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('faceting.transport.departingFrom'),
    optionsDepartureCities: !isLoading && !departureCitiesOptions.length ? noDepartureCitiesOptions : departureCitiesOptions,
    placeholderFrom: Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('faceting.transport.titleFrom'),
    selectPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_17__[/* t */ "h"])('faceting.transport.selectPlaceholder'),
    validateDepartureCity: saveTransport
  })) : null;
};

/***/ }),

/***/ "NXDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInstallmentPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrencySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTotalPriceWithDonation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasAtLeastOnePrice; });
/* unused harmony export hasPrice */
/* unused harmony export isLongFormat */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("SYor");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("wz9x");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("kiXb");















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var MAX_LENGTH = 10;

function getCurrencySymbol(locale, currency) {
  return 0 .toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\d/g, '').trim();
}

function hasPrice(price) {
  return !!(price === null || price === void 0 ? void 0 : price.value);
}

var hasDiscount = function hasDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      initialPrice = _ref.initialPrice;
  return hasPrice(initialPrice) && hasPrice(bestPrice) && (initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.value) !== (bestPrice === null || bestPrice === void 0 ? void 0 : bestPrice.value);
};

function hasAtLeastOnePrice() {
  var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref2 = price || {},
      initialPrice = _ref2.initialPrice,
      bestPrice = _ref2.bestPrice;

  return hasPrice(initialPrice) || hasPrice(bestPrice);
}

var isLongFormat = function isLongFormat(amount) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_LENGTH;
  return amount ? amount.toString().length > limit : false;
};

var getTotalPriceWithDonation = function getTotalPriceWithDonation(price, locale) {
  var donation = price.donation,
      total = price.total,
      totalWithoutDiscount = price.totalWithoutDiscount;

  var totalWithDonation = lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(donation, 'value', 0) + lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(total, 'value', 0);

  var totalWithoutDiscountWithDonation = lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(donation, 'value', 0) + lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(totalWithoutDiscount, 'value', 0);

  var currencyOptions = {
    precision: Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__["getBookingPrecision"])(locale)
  };
  return _objectSpread(_objectSpread({}, price), {}, {
    withDonation: {
      total: {
        value: totalWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(totalWithDonation, locale, price.currency, currencyOptions)
      },
      totalWithoutDiscount: {
        value: totalWithoutDiscountWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(totalWithoutDiscountWithDonation, locale, price.currency, currencyOptions)
      },
      hasFlexRates: price.hasFlexRates,
      selectedRate: price.selectedRate
    }
  });
};

var getInstallmentPrice = function getInstallmentPrice(price, locale) {
  if (!price || !price.value) {
    return '';
  }

  if (Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])('common.price.displayInstalmentsPrice')) {
    var instalmentValue = Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])('common.price.instalmentValue');
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.price.instalmentPrice', {
      instalmentValue: instalmentValue,
      dividedPrice: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(Math.ceil(price.value / instalmentValue), locale, price.currency, {
        precision: 0
      })
    });
  }

  return price.formattedValue;
};


/***/ }),

/***/ "NrqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackSearchResults; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("uDfI");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _FacetSearch_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("hPQF");
/* harmony import */ var _global_search_GlobalSearchSuggestionsList__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("RWDY");
/* harmony import */ var _store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("vIa8");
/* harmony import */ var _store_search_search_selector__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("B3yO");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("RBO1");
/* harmony import */ var _store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("Jsmy");
/* harmony import */ var _store_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("apzf");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_tracking_resort__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("zCbR");











function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}















var useTrackSearchResults = function useTrackSearchResults() {
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_21__[/* useTracking */ "a"])();
  var adults = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_18__[/* getAdults */ "a"])(state) || [];
  });
  var departureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_17__[/* getDepartureCity */ "a"])(state);
  });
  var departureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_17__[/* getDepartureDate */ "b"])(state);
  });
  var duration = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_17__[/* getTripDuration */ "c"])(state);
  });

  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_15__[/* facetingCriteriaSelector */ "e"])(state);
  }),
      _useSelector$filters = _useSelector.filters,
      filters = _useSelector$filters === void 0 ? [] : _useSelector$filters;

  var keywords = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_search_search_selector__WEBPACK_IMPORTED_MODULE_16__[/* keywordsSelector */ "a"])(state);
  });
  var kids = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_18__[/* getKids */ "c"])(state) || [];
  });
  var products = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_15__[/* filteredProductsSelector */ "i"])(state) || [];
  });
  var productsCount = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_15__[/* filteredProductsCountSelector */ "g"])(state) || 0;
  });
  var facetingQuery = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (_ref) {
    var faceting = _ref.faceting;
    return faceting.query || {};
  });
  var redirection = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (_ref2) {
    var faceting = _ref2.faceting;
    return faceting.redirection;
  });
  var profile = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(_store_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_19__[/* userInfoSelector */ "a"]);
  var isFromAutoComplete = Boolean(facetingQuery.type);
  var nbAdults = adults.length;
  var nbKids = kids.length;
  var nbParticipants = nbAdults + nbKids;
  var searchTerms = isFromAutoComplete || facetingQuery.label ? facetingQuery.label : keywords;
  var withFilter = Boolean(nbKids > 0 || duration || departureDate || departureCity || filters.length > 0);

  var executeTracking = function executeTracking(payload, query) {
    var trackingData = {};

    if (!query || query.type !== _global_search_GlobalSearchSuggestionsList__WEBPACK_IMPORTED_MODULE_14__[/* SUGGESTION_TYPES */ "b"].EDITO) {
      var _profile$loyaltyProgr;

      trackingData.fidelityStatus = (profile === null || profile === void 0 ? void 0 : (_profile$loyaltyProgr = profile.loyaltyProgram) === null || _profile$loyaltyProgr === void 0 ? void 0 : _profile$loyaltyProgr.status) || '';
      trackingData.resortAdult = nbAdults;
      trackingData.resortChildren = nbKids;
      trackingData.resortDepartureCityCode = departureCity;
      trackingData.resortNightNumber = duration;
      trackingData.resortTotalParticipant = nbParticipants;
      trackingData.resortTransport = departureCity ? 'with Transport' : null;
      trackingData.searchDepartureDate = departureDate ? moment__WEBPACK_IMPORTED_MODULE_12___default()(departureDate).format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* DATE_FORMAT */ "o"]) : null;
      trackingData.searchDestinationArea = Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_13__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* DESTINATIONS_FACET_ID */ "w"]);
      trackingData.searchDestinationCountry = Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_13__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* COUNTRIES_FACET_ID */ "m"]);
      trackingData.searchFilter = withFilter ? 'withFilter' : 'withoutFilter';
      trackingData.searchResorts = products.map(function (product) {
        return {
          resortCode: product.id,
          resortName: product.name,
          resortTrident: product.comfort,
          resortCountry: product.destination ? product.destination.country : null,
          resortRegion: product.destination ? product.destination.area : null,
          resortAdult: nbAdults,
          resortChildren: nbKids,
          resortDepartureCityCode: departureCity,
          resortSeasonType: product.seasonName || 'Summer',
          resortUrlImage: product.image,
          versionBooking: 'responsive',
          resortSeason: departureDate && Object(_utils_tracking_resort__WEBPACK_IMPORTED_MODULE_23__[/* isSummer */ "e"])(new Date(departureDate)) ? 'Summer' : 'Winter',
          resortYearSeason: moment__WEBPACK_IMPORTED_MODULE_12___default()(departureDate).format('YYYY')
        };
      });
    } // $FlowFixMe


    track(_objectSpread(_objectSpread({
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_20__[/* VIRTUAL_PAGE_LOAD */ "A"],
      internalSearchEngineNbResults: redirection ? 'redirection' : productsCount,
      pageName: 'shopping_home_search',
      searchDate: moment__WEBPACK_IMPORTED_MODULE_12___default()().format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* DATE_FORMAT */ "o"]),
      searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
      searchTerms: searchTerms || ''
    }, trackingData), payload)); // Reset searchReferrer after each pageView is sent.
    // If searchReferrer === "null", GTM will set it to "search"

    track({
      event: 'PUSH',
      searchReferrer: 'null'
    });
  };

  return executeTracking;
};

/***/ }),

/***/ "OBn4":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("vxC8"),
    root = __webpack_require__("IBsm");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "ORYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_SET_ADULTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIP_INFORMATION_UPDATE_ADULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ADULTS_NB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ADULT_VALUE; });
var TRIP_INFORMATION_SET_ADULTS_NUMBER = 'TRIP_INFORMATION_SET_ADULTS_NUMBER';
var TRIP_INFORMATION_UPDATE_ADULT = 'TRIP_INFORMATION_UPDATE_ADULT';
var SET_ATTENDEES = 'SET_ATTENDEES';
var SET_ADULTS = 'SET_ADULTS';
var DEFAULT_ADULTS_NB = 2;
var DEFAULT_ADULT_VALUE = {
  birthdate: undefined,
  civility: undefined,
  firstName: undefined,
  lastName: undefined,
  unicodeFirstName: undefined,
  unicodeLastName: undefined,
  neolid: undefined
};

/***/ }),

/***/ "OWFg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return facetingSearchRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return facetingLoadOffsetSellRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return facetingLoadProductsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pricesRequestAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return childcareRequestAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("fflk");
/* harmony import */ var _trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("RBO1");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_searchHelper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("4+vj");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("kNiU");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("9QcM");
/* harmony import */ var _faceting_selector__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("vIa8");









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}








function facetingSearchRequest(_ref) {
  var appContext = _ref.appContext,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  return function (dispatch, getState) {
    var state = getState();
    var departureDate = Object(_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_9__[/* getDepartureDate */ "b"])(state);

    if (departureDate && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_12__[/* isDateInThePast */ "m"])(departureDate)) {
      dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_8__[/* setDepartureDate */ "a"])(null));
    }

    var boutique = options.boutique,
        defaultDepartureCity = options.defaultDepartureCity,
        offerId = options.offerId,
        productIds = options.productIds,
        screenSize = options.screenSize;

    var _searchQuerySelector = Object(_faceting_selector__WEBPACK_IMPORTED_MODULE_14__[/* searchQuerySelector */ "q"])(state),
        query = _searchQuerySelector.label;

    var facetingCriteria = Object(_faceting_selector__WEBPACK_IMPORTED_MODULE_14__[/* facetingCriteriaSelector */ "e"])(state);
    var flexibility = Object(_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_9__[/* getTripFlexibility */ "d"])(state);

    var criteria = _objectSpread(_objectSpread({}, facetingCriteria), {}, {
      boutique: boutique,
      defaultDepartureCity: defaultDepartureCity,
      flexibility: flexibility,
      offerId: offerId,
      productIds: productIds,
      query: query,
      screenSize: screenSize
    });

    var promise = Object(_utils_searchHelper__WEBPACK_IMPORTED_MODULE_11__[/* searchWithFacets */ "f"])({
      criteria: criteria,
      options: options,
      appContext: appContext
    });
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_10__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_13__[/* FACETING_SEARCH_REQUEST */ "k"], {}, {
      optimist: true,
      promise: promise
    }));
  };
}
function facetingLoadOffsetSellRequest(_ref2) {
  var appContext = _ref2.appContext;
  return function (dispatch) {
    var promise = Object(_utils_searchHelper__WEBPACK_IMPORTED_MODULE_11__[/* loadOffsetSell */ "c"])({
      appContext: appContext
    });
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_10__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_13__[/* FACETING_LOAD_OFFSET_SELL_REQUEST */ "d"], {}, {
      optimist: true,
      promise: promise
    }));
  };
}
function facetingLoadProductsRequest(_ref3) {
  var appContext = _ref3.appContext,
      _ref3$productIds = _ref3.productIds,
      productIds = _ref3$productIds === void 0 ? [] : _ref3$productIds;
  return function (dispatch) {
    var promise = Object(_utils_searchHelper__WEBPACK_IMPORTED_MODULE_11__[/* loadProductsWithIds */ "e"])({
      appContext: appContext,
      productIds: productIds
    });
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_10__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_13__[/* FACETING_LOAD_PRODUCTS_REQUEST */ "e"], {}, {
      optimist: true,
      promise: promise
    }));
  };
}
function pricesRequestAction(_ref4) {
  var appContext = _ref4.appContext,
      criteria = _ref4.criteria,
      withFlexibility = _ref4.withFlexibility;
  var promise = Object(_utils_searchHelper__WEBPACK_IMPORTED_MODULE_11__[/* loadPrices */ "d"])({
    appContext: appContext,
    criteria: criteria,
    withFlexibility: withFlexibility
  });
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_10__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_13__[/* FACETING_PRICES_REQUEST */ "f"], {}, {
    optimist: true,
    promise: promise
  });
}
function childcareRequestAction(_ref5) {
  var appContext = _ref5.appContext,
      _ref5$criteria = _ref5.criteria,
      criteria = _ref5$criteria === void 0 ? {} : _ref5$criteria;
  var promise = Object(_utils_searchHelper__WEBPACK_IMPORTED_MODULE_11__[/* loadChildcareAvailabilities */ "b"])({
    appContext: appContext,
    criteria: criteria
  });
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_10__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_13__[/* FACETING_CHILDCARE_REQUEST */ "a"], {}, {
    optimist: true,
    promise: promise
  });
}

/***/ }),

/***/ "PFCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_DEPARTURE_CITY; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cvSI");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _constants__WEBPACK_IMPORTED_MODULE_0__["w"]; });


var DEFAULT_DEPARTURE_CITY = 'NO';

/***/ }),

/***/ "PFSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_WHO_EVENT; });
var OPEN_CRITERIA_WHO_EVENT = 'openCriteriaWho';

/***/ }),

/***/ "Q4oW":
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__("zKkv"),
    createBaseEach = __webpack_require__("bz5b");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "Q8Qh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);

var themes = function themes(_ref) {
  var _ref$hasArrow = _ref.hasArrow,
      hasArrow = _ref$hasArrow === void 0 ? true : _ref$hasArrow;
  return {
    "default": {
      thBody: classnames__WEBPACK_IMPORTED_MODULE_0___default()('bg-white border-1 border-lightGrey mt-15 p-10 shadow-lg', {
        'arrow-up arrow-white arrow-bg arrow-bg-grey': hasArrow
      })
    },
    hollow: {
      thBody: classnames__WEBPACK_IMPORTED_MODULE_0___default()('bg-white border-1 border-lightGrey rounded-12 shadow-lg', {
        'arrow-up arrow-white arrow-bg arrow-bg-lightGrey': hasArrow
      })
    }
  };
};

/***/ }),

/***/ "Qmkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESORT_PRODUCT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResultItem; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4Brf");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("0oug");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("pjDv");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("4mDm");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("YGK4");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("PKPk");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_match_all__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("ofBz");
/* harmony import */ var core_js_modules_es_string_match_all__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_all__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("EnZy");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("3bBZ");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("fGyu");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("47go");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("UCZK");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("SPKZ");




























function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}






var COMFORT_EXCLUSIVE = 5;
var REGEXP_DYNAMIC_CRUISE = /^CM2C_\d{8}_\d{8}$/;
var REGEXP_SPAN_MATCH = /<span class="match">([^<]*)<\/span>/g;
var RESORT_PRODUCT_TYPE = 'resort';

function getType(item) {
  return item.product_id ? RESORT_PRODUCT_TYPE : item.type || item.section || '';
}

function isItemResort(item) {
  return getType(item) === RESORT_PRODUCT_TYPE;
}

function getLabel(item) {
  var label = striptags__WEBPACK_IMPORTED_MODULE_27___default()(item.value || '', '<span>');
  return isItemResort(item) && item.sibling_id ? "".concat(label, " - ").concat(item.season || '') : label;
}

function isCruise(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["constants"].PRODUCT_TYPES.CRUISE;
}

function isDynamicCruise(item) {
  return isCruise(item) && REGEXP_DYNAMIC_CRUISE.test(item.product_id || '');
}

function isJoyview(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["constants"].PRODUCT_TYPES.JOYVIEW;
}

function isTour(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["constants"].PRODUCT_TYPES.TOUR;
}

function isVilla(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["constants"].PRODUCT_TYPES.VILLA;
}

function isExclusiveComfort(item) {
  return Number(item.comfort_level) >= COMFORT_EXCLUSIVE;
}

function isExclusiveCollection(item) {
  return isVilla(item) || isCruise(item) || isExclusiveComfort(item);
}

function getDescription(item) {
  return striptags__WEBPACK_IMPORTED_MODULE_27___default()(item.description || '', '<span>');
}

function getQueryMatches(item) {
  var queryMatches = [];
  var valueMatches = item.value ? item.value.matchAll(REGEXP_SPAN_MATCH) : [];

  var _iterator = _createForOfIteratorHelper(valueMatches),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var valueMatch = _step.value;
      queryMatches.push(valueMatch[1].toLowerCase());
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var descriptionMatches = item.description ? item.description.matchAll(REGEXP_SPAN_MATCH) : [];

  var _iterator2 = _createForOfIteratorHelper(descriptionMatches),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var descriptionMatch = _step2.value;
      queryMatches.push(descriptionMatch[1].toLowerCase());
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set(queryMatches));
}

function getProductId(item) {
  return isItemResort(item) ? item.product_id : null;
}

function getProductSeason(item) {
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["resortAction"].getSeasonInfos(item.sibling_id ? item.season_id : _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["constants"].ALL_YEAR);
}

function getProductUrl(item) {
  var productUrl = new urijs__WEBPACK_IMPORTED_MODULE_28___default.a('/');

  if (isDynamicCruise(item)) {
    productUrl.segment('c').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["url"].normalizePath((item.product_id || '').split('_').join('/')));
  } else if (isTour(item)) {
    productUrl.segment('i').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["url"].normalizeSlug(item.title)).segment(getProductSeason(item));
  } else {
    productUrl.segment('r').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["url"].normalizeSlug(item.title)).segment(getProductSeason(item));
  }

  return productUrl.toString();
}

function getLink(item) {
  return isItemResort(item) ? getProductUrl(item) : item.url;
}
/**
 * Sort by 
 - Products (pageType: resort, cruise or tour)
 - Facets - destinations, activités etc.
 - destinations Pages (pagetype: destination and destination-travel and URL that started by /d o /v)
 - landing Pages (pageType: landing and URL that started by /l) 
 * @param {*} item
 * @returns {number} The display position
 */


var getDisplayPosition = function getDisplayPosition(item) {
  // Resort in first
  if (isItemResort(item)) {
    return 1;
  }

  if (item.url) {
    var _item$url$split = item.url.split('/'),
        _item$url$split2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_25__[/* default */ "a"])(_item$url$split, 2),
        pageType = _item$url$split2[1]; // Destination


    if (pageType === 'd' || pageType === 'v') {
      return 3;
    } // Landing


    if (pageType === 'l') {
      return 4;
    }
  }

  return 2;
};

function getHeadlines(item) {
  return isItemResort(item) ? {
    subLabel1: Array.isArray(item.destination_country) ? item.destination_country.join(', ') : item.destination_country,
    subLabel2: item.destination_area,
    productId: item.product_id,
    productType: item.type,
    comfortLevel: item.comfort_level,
    season: Array.isArray(item.season) ? '' : item.season
  } : {};
}

function getIcon(item) {
  var comfortLevel = item.comfort_level || 1;

  switch (item.type) {
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["constants"].PRODUCT_TYPES.CRUISE:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_31__[/* ICONS */ "a"].CRUISE;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["constants"].PRODUCT_TYPES.JOYVIEW:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_31__[/* ICONS */ "a"].TRIDENT_JOYVIEW;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["constants"].PRODUCT_TYPES.TOUR:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_31__[/* ICONS */ "a"].TOUR;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["constants"].PRODUCT_TYPES.RESORT:
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["constants"].PRODUCT_TYPES.VILLA:
      return comfortLevel === String(COMFORT_EXCLUSIVE) ? null : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_31__[/* ICONS */ "a"]["TRIDENT".concat(comfortLevel)];

    default:
      return item.type === 'activity' ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_31__[/* ICONS */ "a"].ACTIVITIES : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_31__[/* ICONS */ "a"].ADDRESS;
  }
}

function getImage(item) {
  return isItemResort(item) ? item.immersive_image : item.backgroundurl || '';
}

function getColor(item) {
  if (isExclusiveCollection(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_30__[/* COLORS */ "a"].ULTRAMARINE;
  }

  if (isJoyview(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_30__[/* COLORS */ "a"].BLUE_WAVE;
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_30__[/* COLORS */ "a"].SAFFRON;
}

var getTagsColor = function getTagsColor(item) {
  var seasonName = Array.isArray(item.seasons_id) ? '' : item.seasons_id;

  if (seasonName === _clubmed_utils__WEBPACK_IMPORTED_MODULE_29__["constants"].SEASONS.SUMMER) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_30__[/* COLORS */ "a"].ORANGE;
  }

  if (isTour(item) || isCruise(item)) {
    return getColor(item);
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_30__[/* COLORS */ "a"].SAFFRON;
};

function getResultItem(item) {
  return _objectSpread({
    description: getDescription(item),
    displayPosition: getDisplayPosition(item),
    icon: getIcon(item),
    id: getProductId(item) || getLabel(item),
    image: getImage(item),
    isExclusiveCollection: isExclusiveCollection(item),
    label: getLabel(item),
    link: getLink(item),
    productColor: getColor(item),
    product_id: getProductId(item),
    queryMatches: getQueryMatches(item),
    tagsColor: getTagsColor(item),
    type: getType(item)
  }, getHeadlines(item));
}

/***/ }),

/***/ "R2jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endLoading; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var START_LOADING = 'START_LOADING';
var END_LOADING = 'END_LOADING';

function endLoading() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(END_LOADING, {});
}

function startLoading(globalLoaderLabel, isNavigation) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(START_LOADING, {
    globalLoaderLabel: globalLoaderLabel,
    isNavigation: isNavigation
  });
}



/***/ }),

/***/ "R7V3":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),

/***/ "RBO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getArrivalDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* unused harmony export getMainContactOptinEmail */
/* unused harmony export getMainContactOptinSms */
/* unused harmony export getMainContactOptinFosun */
/* unused harmony export getMainContactOptinMail */
/* unused harmony export getMainContactOptinPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTripFlexibility; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var mainContactSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref2) {
  var mainContact = _ref2.mainContact;
  return mainContact || {};
});
var getDepartureCity = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref3) {
  var departureCity = _ref3.departureCity;
  return departureCity;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref4) {
  var departureDate = _ref4.departureDate;
  return departureDate;
});
var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref5) {
  var arrivalDate = _ref5.arrivalDate;
  return arrivalDate;
});
var getMainContactOptinEmail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref6) {
  var optinEmail = _ref6.optinEmail;
  return optinEmail;
});
var getMainContactOptinSms = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref7) {
  var optinSms = _ref7.optinSms;
  return optinSms;
});
var getMainContactOptinMail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref8) {
  var optinMail = _ref8.optinMail;
  return optinMail;
});
var getMainContactOptinPhone = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref9) {
  var optinPhone = _ref9.optinPhone;
  return optinPhone;
});
var getMainContactOptinFosun = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref10) {
  var optinFosun = _ref10.optinFosun;
  return optinFosun;
});
var getTripDuration = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref11) {
  var duration = _ref11.duration;
  return duration;
});
var getTripFlexibility = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref12) {
  var flexibility = _ref12.flexibility;
  return flexibility;
});


/***/ }),

/***/ "RBvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TRIP_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_NO_DURATION; });
var TRIP_INFORMATION_SET_DURATION = 'TRIP_INFORMATION_SET_DURATION';
var DEFAULT_TRIP_DURATION = 7;
var DEFAULT_NO_DURATION = null;

/***/ }),

/***/ "RWDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUGGESTION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalSearchSuggestionsList; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4Brf");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("TWNs");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("mRH6");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("TYRa");
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_upperFirst__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("47go");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("0IQ5");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("MWZw");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("kiXb");












var __jsx = react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement;







var SUGGESTION_TYPES = {
  ACTIVITY: 'activity',
  AREA: 'area',
  COUNTRY: 'country',
  EDITO: 'edito',
  RESORT: 'resort'
};
var GlobalSearchSuggestionsList = function GlobalSearchSuggestionsList(_ref) {
  var blockSuggestions = _ref.blockSuggestions,
      blockType = _ref.blockType,
      isDesktop = _ref.isDesktop,
      onClick = _ref.onClick;
  var maxNumberOfSuggestions = !isDesktop || blockType === SUGGESTION_TYPES.EDITO ? 3 : 5;

  var onPress = function onPress(suggestion) {
    onClick(suggestion);
  };

  return __jsx("ul", null, blockSuggestions.slice(0, maxNumberOfSuggestions).map(function (suggestion) {
    var description = suggestion.description,
        image = suggestion.image,
        label = suggestion.label,
        link = suggestion.link,
        queryMatches = suggestion.queryMatches,
        type = suggestion.type;
    return {
      description: description,
      image: image,
      label: striptags__WEBPACK_IMPORTED_MODULE_14___default()(label),
      link: link,
      queryMatches: queryMatches,
      type: type
    };
  }).map(function (suggestion, index) {
    var description = suggestion.description,
        image = suggestion.image,
        label = suggestion.label,
        _suggestion$queryMatc = suggestion.queryMatches,
        queryMatches = _suggestion$queryMatc === void 0 ? [] : _suggestion$queryMatc,
        type = suggestion.type;

    if (type === SUGGESTION_TYPES.EDITO) {
      var defaultPicture = {
        alt: label,
        src: image
      };
      var stripedDescription = striptags__WEBPACK_IMPORTED_MODULE_14___default()(description || '');
      var truncatedDescription = stripedDescription.length > 65 ? "".concat(stripedDescription.substring(0, 62), "...") : stripedDescription;
      var decoratedDescription = truncatedDescription;
      queryMatches.forEach(function (queryMatch) {
        decoratedDescription = decoratedDescription.replace(new RegExp("(".concat(queryMatch, ")"), 'ig'), "<span class='match'>$1</span>");
      });
      return __jsx("li", {
        key: label,
        className: "flex mb-30 cursor-pointer",
        "data-testid": "".concat(type, "-link"),
        onClick: function onClick() {
          return onPress(suggestion);
        },
        onKeyUp: function onKeyUp(event) {
          /* Space & Enter */
          if (event.keyCode === 32 || event.keyCode === 13) {
            onPress(suggestion);
          }
        }
      }, isDesktop && __jsx("div", {
        className: "me-20 overflow-hidden relative rounded-12 self-start w-1/3"
      }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_15__[/* default */ "b"], {
        altMsg: defaultPicture.alt,
        imageUrl: defaultPicture.src,
        key: defaultPicture.src,
        groupKey: "thumbnails",
        ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_16__[/* default */ "c"].XL,
        ratioDisplay: 1 / 3,
        hasLazyLoading: false
      })), __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_12___default()('flex flex-col flex-start overflow-hidden', {
          'w-1/2': isDesktop,
          'w-full': !isDesktop
        }),
        role: "button",
        tabIndex: index
      }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_17__[/* Title */ "a"], {
        className: "leading-tight font-bold text-18",
        hLevel: 3,
        theme: "none"
      }, label), __jsx("div", {
        className: "leading-tight text-14 text-black decorator-match pt-10 flex-1" // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: decoratedDescription
        }
      }), __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_12___default()('font-bold text-12 text-black underline', {
          'pt-10': !isDesktop
        })
      }, lodash_upperFirst__WEBPACK_IMPORTED_MODULE_11___default()(Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('common.readMoreLabel')))));
    }

    return __jsx("li", {
      key: label,
      className: "flex mb-10",
      "data-testid": "".concat(type, "-link")
    }, __jsx("span", {
      role: "button",
      tabIndex: index,
      className: "cursor-pointer font-bold leading-tight text-black text-20 lg:text-24",
      onClick: function onClick() {
        return onPress(suggestion);
      },
      onKeyUp: function onKeyUp(event) {
        /* Space & Enter */
        if (event.keyCode === 32 || event.keyCode === 13) {
          onPress(suggestion);
        }
      }
    }, label));
  }));
};

/***/ }),

/***/ "RYcy":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("m2YG");

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),

/***/ "RqHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRICE_COLOR_CLASS_NAMES; });
/* unused harmony export mixedToMoment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dateDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return stringToDateFormatted; });
/* unused harmony export momentToInt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return maxDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return minDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closedDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return firstSiblingOpenDayOfSelectedMonthFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return siblingOpenDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDisabledDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPriceColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return flattenPrices; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JevA");
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("VtPb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("sW3P");
















var PRICE_COLOR_CLASS_NAMES = {
  DARK_GREY: 'text-black hocus:text-black-active',
  GREEN: 'text-green',
  GREEN_OPACITY_45: 'text-green bestPrice',
  GREY: 'text-grey hocus:text-black-active',
  ORANGE: 'text-orange',
  ORANGE_OPACITY_45: 'text-orange lastAvailability',
  WHITE: 'text-white',
  TURQUOISE: 'text-turquoise'
};
var mixedToMoment = function mixedToMoment(mixedDate) {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()(mixedDate);
};
var dateToInt = function dateToInt(d) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"];
  return parseInt(mixedToMoment(d).format(format), 10);
};
var dateDiff = function dateDiff(day1, day2) {
  return Math.abs(moment__WEBPACK_IMPORTED_MODULE_12___default()(day2).diff(moment__WEBPACK_IMPORTED_MODULE_12___default()(day1), 'days'));
};
var stringToDateFormatted = function stringToDateFormatted(date, format) {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()(date).format(format);
};
var momentToInt = function momentToInt(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"];
  return parseInt(date.format(format), 10);
};
var maxDatepickerDate = function maxDatepickerDate() {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()().add(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_DATE_MAX_DATE */ "t"]).toDate();
};
var minDatepickerDate = function minDatepickerDate() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return moment__WEBPACK_IMPORTED_MODULE_12___default()().add({
    days: offset
  }).toDate();
};

function daysWithoutDepartureFactory(resolver, fromDate, toDate) {
  return function (day) {
    var _resolver = resolver(dateToInt(day)),
        _resolver$exclusivity = _resolver.exclusivity,
        exclusivity = _resolver$exclusivity === void 0 ? false : _resolver$exclusivity,
        _resolver$noFlight = _resolver.noFlight,
        noFlight = _resolver$noFlight === void 0 ? false : _resolver$noFlight,
        _resolver$full = _resolver.full,
        full = _resolver$full === void 0 ? false : _resolver$full;

    var available = !exclusivity && !noFlight && !full;

    if (!fromDate && !toDate) {
      return !available;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && !available;
  };
}

var daysWithNoAvailabilityFactory = function daysWithNoAvailabilityFactory(resolver) {
  return function (day) {
    var data = resolver(dateToInt(day));
    return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(data) || data.noAvailability;
  };
};

var closedDaysFactory = function closedDaysFactory(resolver, fromDate, toDate, shouldAllowSelectingSiblingOpenDays) {
  return function (day) {
    var _resolver2 = resolver(dateToInt(day)),
        _resolver2$closed = _resolver2.closed,
        closed = _resolver2$closed === void 0 ? false : _resolver2$closed,
        _resolver2$siblingOpe = _resolver2.siblingOpen,
        siblingOpen = _resolver2$siblingOpe === void 0 ? false : _resolver2$siblingOpe;

    if (!fromDate && !toDate) {
      return closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && (closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  };
};
var firstSiblingOpenDayOfSelectedMonthFactory = function firstSiblingOpenDayOfSelectedMonthFactory(resolver, selectedMonth) {
  var firstSiblingOpenDayFound;
  return function (day) {
    var _resolver3;

    if (!selectedMonth) {
      return false;
    }

    var firstDayOfSelectedMonth = "".concat(selectedMonth.toString(), "01");
    var firstDayOfSelectedMonthAsDate = moment__WEBPACK_IMPORTED_MODULE_12___default()(firstDayOfSelectedMonth, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]);
    var firstDisplayedDayOfSelectedMonthAsInt = firstDayOfSelectedMonthAsDate.weekday() > 0 ? momentToInt(firstDayOfSelectedMonthAsDate.subtract(firstDayOfSelectedMonthAsDate.weekday(), 'days')) : momentToInt(firstDayOfSelectedMonthAsDate);
    var lastDisplayedDayOfSelectedMonthAsInt = momentToInt(moment__WEBPACK_IMPORTED_MODULE_12___default()(firstDayOfSelectedMonthAsDate).add(41, 'days'));
    var currentDayDateAsInt = dateToInt(day);

    if (firstSiblingOpenDayFound && firstSiblingOpenDayFound !== dateToInt(day) || currentDayDateAsInt < firstDisplayedDayOfSelectedMonthAsInt || currentDayDateAsInt > lastDisplayedDayOfSelectedMonthAsInt) {
      return false;
    }

    var hasSiblingOpen = ((_resolver3 = resolver(currentDayDateAsInt)) === null || _resolver3 === void 0 ? void 0 : _resolver3.siblingOpen) || false;

    if (hasSiblingOpen) {
      firstSiblingOpenDayFound = dateToInt(day);
    }

    return hasSiblingOpen;
  };
};
var siblingOpenDaysFactory = function siblingOpenDaysFactory(resolver) {
  return function (day) {
    var _resolver4;

    return ((_resolver4 = resolver(dateToInt(day))) === null || _resolver4 === void 0 ? void 0 : _resolver4.siblingOpen) || false;
  };
};

var unavailableReturnDaysFactory = function unavailableReturnDaysFactory(fromDate) {
  var durations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (day) {
    if (day < fromDate) {
      return false;
    }

    var duration = dateDiff(day, fromDate); // rule of max 30 days of reservation

    if (duration > 30) {
      return true;
    }

    return !!duration && !durations.includes(duration);
  };
};

function getDisabledDays(_ref) {
  var from = _ref.from,
      isSeller = _ref.isSeller,
      optionsDuration = _ref.optionsDuration,
      openingDates = _ref.openingDates,
      prices = _ref.prices,
      resolvePrice = _ref.resolvePrice,
      shouldAllowSelectingSiblingOpenDays = _ref.shouldAllowSelectingSiblingOpenDays,
      to = _ref.to;
  var disabledDays = [];
  var pricesIds = Object.keys(prices || {});
  var hasPrices = pricesIds.length > 0;
  var allClosedDays = pricesIds.filter(function (priceKey) {
    return prices && (prices[priceKey].closed || prices[priceKey].siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  }).map(function (priceKey) {
    return parseInt(priceKey, 10);
  });

  if (hasPrices) {
    var dayIsWithoutDeparture = daysWithoutDepartureFactory(resolvePrice, from, to);
    var dayIsClosed = closedDaysFactory(resolvePrice, from, to, shouldAllowSelectingSiblingOpenDays);
    var dayIsSiblingOpen = siblingOpenDaysFactory(resolvePrice);
    var dayIsWithoutData = daysWithNoAvailabilityFactory(resolvePrice);
    disabledDays.push(dayIsWithoutDeparture);
    disabledDays.push(dayIsClosed);

    if (!shouldAllowSelectingSiblingOpenDays) {
      disabledDays.push(dayIsSiblingOpen);
    }

    disabledDays.push(dayIsWithoutData);
  }

  if (from && !to) {
    var fromDay = dateToInt(from);
    var closedDaysAfterFromDay = allClosedDays.filter(function (closedDay) {
      return closedDay > fromDay;
    });
    var firstClosedDay = hasPrices && closedDaysAfterFromDay.length > 0 && Math.min.apply(null, closedDaysAfterFromDay);
    disabledDays.push({
      before: moment__WEBPACK_IMPORTED_MODULE_12___default()(from).toDate(),
      after: firstClosedDay ? moment__WEBPACK_IMPORTED_MODULE_12___default()(firstClosedDay.toString()).toDate() : moment__WEBPACK_IMPORTED_MODULE_12___default()(from).add(30, 'days').toDate()
    });
  }

  if (from && !to && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(optionsDuration) && !isSeller) {
    disabledDays.push(unavailableReturnDaysFactory(from, optionsDuration));
  }

  if (openingDates === null || openingDates === void 0 ? void 0 : openingDates.length) {
    disabledDays.push.apply(disabledDays, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Object(_store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_13__[/* getClosingDatesRanges */ "b"])(openingDates)));
  }

  return disabledDays;
}
function getPriceColor(_ref2) {
  var classColor = _ref2.classColor,
      from = _ref2.from,
      hasPrices = _ref2.hasPrices,
      resolvePrice = _ref2.resolvePrice,
      selectedMonth = _ref2.selectedMonth,
      to = _ref2.to;
  return function (day) {
    var dayAsInt = dateToInt(day);

    if (selectedMonth) {
      var firstDayOfCurrentMonth = Number.parseInt("".concat(selectedMonth, "01"), 10);
      var lastDayOfCurrentMonth = Number.parseInt("".concat(selectedMonth, "31"), 10); // Handle dates outside current month & without prices

      var isDayBeforeSelectedMonth = Boolean(dayAsInt < firstDayOfCurrentMonth);
      var isDayAfterSelectedMonth = Boolean(dayAsInt > lastDayOfCurrentMonth);

      if (isDayBeforeSelectedMonth || !from && isDayAfterSelectedMonth || !hasPrices) {
        return classColor === PRICE_COLOR_CLASS_NAMES.GREY;
      }
    }

    if (from) {
      var fromDateAsInt = dateToInt(from);

      if (to) {
        var toDateAsInt = dateToInt(to); // Handle dates between from and to dates

        if (dayAsInt >= fromDateAsInt && dayAsInt <= toDateAsInt) {
          return classColor === PRICE_COLOR_CLASS_NAMES.WHITE;
        }
      } else {
        if (dayAsInt === fromDateAsInt) {
          return classColor === PRICE_COLOR_CLASS_NAMES.WHITE;
        } // Handle dates before and after from date


        switch (classColor) {
          case PRICE_COLOR_CLASS_NAMES.WHITE:
            return false;

          case PRICE_COLOR_CLASS_NAMES.GREEN_OPACITY_45:
          case PRICE_COLOR_CLASS_NAMES.GREY:
          case PRICE_COLOR_CLASS_NAMES.ORANGE_OPACITY_45:
            if (dayAsInt >= fromDateAsInt) {
              return false;
            }

            break;

          default:
            if (dayAsInt < fromDateAsInt) {
              return false;
            }

            break;
        }
      }
    } // Get the correct color based on price


    if (resolvePrice) {
      var dayWithPrice = resolvePrice(dateToInt(day)) || {
        isBestPrice: false,
        lastAvailability: false,
        price: ''
      };
      var isBestPrice = dayWithPrice.isBestPrice,
          lastAvailability = dayWithPrice.lastAvailability,
          price = dayWithPrice.price,
          siblingOpen = dayWithPrice.siblingOpen;

      if (siblingOpen) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE || classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE : classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE;
      }

      if (lastAvailability) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.ORANGE || classColor === PRICE_COLOR_CLASS_NAMES.ORANGE_OPACITY_45 : classColor === PRICE_COLOR_CLASS_NAMES.ORANGE;
      }

      if (isBestPrice) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.GREEN || classColor === PRICE_COLOR_CLASS_NAMES.GREEN_OPACITY_45 : classColor === PRICE_COLOR_CLASS_NAMES.GREEN;
      }

      if (price) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.DARK_GREY || classColor === PRICE_COLOR_CLASS_NAMES.GREY : classColor === PRICE_COLOR_CLASS_NAMES.DARK_GREY;
      }
    }

    return false;
  };
}
function flattenPrices(prices) {
  var pricesIds = Object.keys(prices);
  return pricesIds.map(function (priceId) {
    return prices[priceId].oldPrice;
  }).join();
}

/***/ }),

/***/ "SqqE":
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__("s+R0");

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

module.exports = uniqWith;


/***/ }),

/***/ "TYzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* unused harmony export CriteriaDisplayContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useCriteriaDisplayContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaDisplayProvider; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("3KgV");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var ACTIONS = Object.freeze({
  CLOSE_CRITERIA: 'CLOSE_CRITERIA',
  OPEN_CRITERIA: 'OPEN_CRITERIA',
  OPEN_NEXT_CRITERIA: 'OPEN_NEXT_CRITERIA'
});
var initialState = {
  criteriaWhenIsOpen: false,
  criteriaWhoIsOpen: false,
  criteriaTransportIsOpen: false
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  switch (action.type) {
    case ACTIONS.OPEN_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), true));

    case ACTIONS.CLOSE_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), false));

    case ACTIONS.OPEN_NEXT_CRITERIA:
      var _action$payload = action.payload,
          currentCriteria = _action$payload.currentCriteria,
          criteriaContext = _action$payload.criteriaContext;

      if (currentCriteria === 'criteriaTransport') {
        return state;
      }

      if (currentCriteria === 'criteriaWho' && !criteriaContext.criteriaTransportIsSet) {
        return _objectSpread(_objectSpread({}, state), {}, {
          criteriaTransportIsOpen: true
        });
      }

      if (currentCriteria === 'criteriaWhen') {
        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      if (currentCriteria === 'criteriaQuery') {
        if (!criteriaContext.criteriaWhenIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhenIsOpen: true
          });
        }

        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      return state;

    default:
      return state;
  }
};

var CriteriaDisplayContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_9__["createContext"])([initialState, function () {}]);
var useCriteriaDisplayContext = function useCriteriaDisplayContext() {
  return Object(react__WEBPACK_IMPORTED_MODULE_9__["useContext"])(CriteriaDisplayContext);
};
var CriteriaDisplayProvider = function CriteriaDisplayProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_9__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var reducer = Object(react__WEBPACK_IMPORTED_MODULE_9__["useMemo"])(function () {
    return [state, dispatch];
  }, [state, dispatch]);
  return __jsx(CriteriaDisplayContext.Provider, {
    value: reducer
  }, children);
};

/***/ }),

/***/ "U2fG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LAYER_HEADER_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Layer; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SYor");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Bcqe");
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_focus_on__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Qt1m");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("UCZK");
/* harmony import */ var _context_ToastContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("waz2");
/* harmony import */ var _body_locker_BodyLocker__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("DHMe");
/* harmony import */ var _portal_Portal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("3uBn");
/* harmony import */ var _layer_header_LayerHeader__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("csq+");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;









var LAYER_HEADER_HEIGHT = 60;

var onScroll = lodash_throttle__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  Object(react_lazyload__WEBPACK_IMPORTED_MODULE_9__["forceCheck"])();
}, 250);

var LayerComponent = function LayerComponent(_ref, layerRef) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_11__[/* COLORS */ "a"].WHITE : _ref$bgColor,
      buttonLeft = _ref.buttonLeft,
      buttonRight = _ref.buttonRight,
      customHeader = _ref.customHeader,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'Layer' : _ref$dataTestId,
      _ref$enterAnimation = _ref.enterAnimation,
      enterAnimation = _ref$enterAnimation === void 0 ? 'ltr:animate-slideInRight rtl:animate-slideInLeft' : _ref$enterAnimation,
      _ref$externalFocusTra = _ref.externalFocusTrapRefs,
      externalFocusTrapRefs = _ref$externalFocusTra === void 0 ? [] : _ref$externalFocusTra,
      hasAnimateEnter = _ref.hasAnimateEnter,
      hasContainer = _ref.hasContainer,
      hasContainerHeader = _ref.hasContainerHeader,
      hasNoFocusTrap = _ref.hasNoFocusTrap,
      header = _ref.header,
      onClose = _ref.onClose,
      portalName = _ref.portalName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_7__["useContext"])(_context_ToastContext__WEBPACK_IMPORTED_MODULE_12__[/* ToastContext */ "a"]),
      ref = _useContext.ref;

  var layerBody = Object(react__WEBPACK_IMPORTED_MODULE_7__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_7__["useImperativeHandle"])(layerRef, function () {
    return layerBody.current;
  }, [layerBody]);
  Object(react__WEBPACK_IMPORTED_MODULE_7__["useEffect"])(function () {
    var _layerBody$current;

    (_layerBody$current = layerBody.current) === null || _layerBody$current === void 0 ? void 0 : _layerBody$current.addEventListener('scroll', onScroll);
    return function () {
      var _layerBody$current2;

      (_layerBody$current2 = layerBody.current) === null || _layerBody$current2 === void 0 ? void 0 : _layerBody$current2.removeEventListener('scroll', onScroll);
    };
  }, []);

  if (!react__WEBPACK_IMPORTED_MODULE_7__["Children"].count(children)) {
    return null;
  }

  var hasHeader = buttonLeft || buttonRight || header;

  var getStyle = function getStyle() {
    return hasHeader || !hasHeader && customHeader ? {
      paddingTop: customHeader ? customHeader.height : LAYER_HEADER_HEIGHT
    } : {};
  };

  var shards = ref ? [ref].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(externalFocusTrapRefs)) : externalFocusTrapRefs;
  return __jsx(_portal_Portal__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"], {
    name: portalName
  }, __jsx(react_focus_on__WEBPACK_IMPORTED_MODULE_10__[/* FocusOn */ "a"], {
    allowPinchZoom: true,
    enabled: !hasNoFocusTrap,
    onEscapeKey: onClose,
    shards: shards.filter(Boolean)
  }, __jsx(_body_locker_BodyLocker__WEBPACK_IMPORTED_MODULE_13__[/* BodyLocker */ "a"], {
    isLocked: true
  }, __jsx("aside", {
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_8___default()("animation-duration-500 bg-".concat(bgColor), 'fixed inset-0 w-full', Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])({}, enterAnimation, hasAnimateEnter), className),
    "data-testid": dataTestId,
    role: "document"
  }, hasHeader && __jsx(_layer_header_LayerHeader__WEBPACK_IMPORTED_MODULE_15__[/* LayerHeader */ "a"], {
    buttonLeft: buttonLeft,
    buttonRight: buttonRight,
    closeLabel: [closeLabel, ariaLabel].join(' ').trim(),
    hasContainer: hasContainerHeader,
    height: LAYER_HEADER_HEIGHT,
    onClose: onClose,
    theme: theme
  }, header), !hasHeader && customHeader && customHeader.content, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_8___default()('h-full scroll-y duration-250 ease-in transition-all z-0', {
      'px-20': hasContainer
    }),
    "data-testid": "Layer-body",
    ref: layerBody,
    style: getStyle()
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_8___default()('h-full min-h-full', {
      'mx-auto max-w-site w-full': hasContainer
    }),
    "data-testid": "Layer-content"
  }, children)))))));
}; // $FlowFixMe


var Layer = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_7__["forwardRef"])(LayerComponent);

/***/ }),

/***/ "U6GL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropDown; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SuFq");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("05v4");
/* harmony import */ var _DropDown_themes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Q8Qh");











var __jsx = react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





var DropDown = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(DropDown, _Component);

  var _super = _createSuper(DropDown);

  function DropDown(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, DropDown);

    _this = _super.call(this, props);

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "rootRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_11__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "contentRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_11__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "expand", function () {
      _this.setState({
        isExpanded: true
      }, _this.toggleEventListeners);
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "collapse", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      if (!_this.props.unmountsOnClose) {
        _this.setState({
          isExpanded: false
        }, _this.toggleEventListeners);
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onKeyDown", function (e) {
      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__[/* ESCAPE */ "g"]) {
        _this.collapse();
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onClickOutside", function (e) {
      if (!_this.contentRef || // $FlowFixMe
      _this.contentRef.current.contains(e.target) || // $FlowFixMe
      _this.rootRef.current.contains(e.target) || // $FlowFixMe
      lodash_get__WEBPACK_IMPORTED_MODULE_10___default()(_this.props, 'rootRef.current') && _this.props.rootRef.current.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      _this.collapse();
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "toggle", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      }, _this.toggleEventListeners);
    });

    _this.state = {
      isExpanded: props.isExpanded || false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isExpanded) {
        this.removeEventListeners();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isExpanded !== this.props.isExpanded) {
        this.setState({
          isExpanded: nextProps.isExpanded
        }, this.toggleEventListeners);
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      if (true) {
        document.addEventListener('mouseup', this.onClickOutside, false);
        document.addEventListener('touchstart', this.onClickOutside, false);
        document.addEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      if (true) {
        document.removeEventListener('mouseup', this.onClickOutside, false);
        document.removeEventListener('touchstart', this.onClickOutside, false);
        document.removeEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "toggleEventListeners",
    value: function toggleEventListeners() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      } else {
        this.removeEventListeners();
      }
    } // TODO: cleanup !!
    // eslint-disable-next-line react/no-unused-class-component-methods

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          contentStyle = _this$props.contentStyle,
          contentClassName = _this$props.contentClassName,
          hasArrow = _this$props.hasArrow,
          hasCloseOnClick = _this$props.hasCloseOnClick,
          relative = _this$props.relative,
          noLayout = _this$props.noLayout,
          renderTrigger = _this$props.renderTrigger,
          theme = _this$props.theme;
      var thBody = Object(_DropDown_themes__WEBPACK_IMPORTED_MODULE_14__[/* themes */ "a"])({
        hasArrow: hasArrow
      })[theme].thBody;
      return __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_12___default()('inline-block', {
          relative: relative
        }, className),
        ref: this.rootRef
      }, renderTrigger && renderTrigger(this.toggle, this.state.isExpanded), this.state.isExpanded && __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_12___default()({
          'absolute left-1/2 min-w-full w-full transform -translate-x-1/2 z-4': !noLayout
        }, contentClassName, thBody),
        "data-testid": "DropDown-body",
        onClick: hasCloseOnClick ? this.collapse : null,
        ref: this.contentRef,
        style: contentStyle
      }, children(this.toggle, this.state.isExpanded)));
    }
  }]);

  return DropDown;
}(react__WEBPACK_IMPORTED_MODULE_11__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(DropDown, "defaultProps", {
  hasArrow: true,
  isExpanded: false,
  relative: true,
  noLayout: false,
  theme: 'default',
  unmountsOnClose: false
});

/***/ }),

/***/ "VHif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Badge_Badge; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.themes.js


var variants = {
  diamond: {
    root: ' transform rotate-45',
    item: ' transform -rotate-45'
  },
  pill: {
    root: ' rounded-full',
    item: ''
  }
};
var themes = {
  "default": function _default(_ref) {
    var _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$colorBg,
        _ref$colorBorder = _ref.colorBorder,
        colorBorder = _ref$colorBorder === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$colorBorder,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
        hasShadow = _ref.hasShadow,
        relative = _ref.relative,
        variant = _ref.variant;
    return {
      thRoot: "bg-".concat(colorBg, " border-").concat(colorBorder, " text-").concat(color, " border-2 flex-none inline-flex items-center justify-center leading-0 overflow-hidden ").concat(relative ? 'relative' : '', " ").concat(hasShadow ? 'shadow' : '').concat(variant ? variants[variant].root : ''),
      thImage: "absolute inset-0 ".concat(variant ? variants[variant].item : ''),
      thIcon: "absolute flex items-center justify-center inset-0".concat(variant ? variants[variant].item : ''),
      thIconSize: '65%',
      thLabel: "absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-center ".concat(variant ? variants[variant].item : ''),
      thLabelStyle: {
        fontSize: '1em'
      }
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.jsx
var __jsx = react_default.a.createElement;





var Badge_Badge = function Badge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder,
      color = _ref.color,
      hasShadow = _ref.hasShadow,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      imageSrc = _ref.imageSrc,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 50 : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$relative = _ref.relative,
      relative = _ref$relative === void 0 ? true : _ref$relative,
      variant = _ref.variant;

  if (!iconName && !imageSrc && !label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    colorBg: colorBg,
    colorBorder: colorBorder,
    color: color,
    hasShadow: hasShadow,
    relative: relative,
    variant: variant
  }),
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thImage = _themes$theme.thImage,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thRoot = _themes$theme.thRoot;

  var styles = {
    width: size,
    height: size
  };
  var imageSize = {
    w: size,
    h: size
  };
  return __jsx("span", {
    className: classnames_default()(thRoot, className),
    style: styles
  }, !!imageSrc && __jsx("span", {
    className: thImage
  }, __jsx(Image["b" /* default */], {
    altMsg: alt,
    imageUrl: imageSrc,
    dimensions: imageSize
  })), !!iconName && __jsx("span", {
    className: thIcon
  }, __jsx(Icon["a" /* Icon */], {
    alt: alt,
    name: iconName,
    width: iconSize || thIconSize
  })), !!label && __jsx("span", {
    className: thLabel,
    style: thLabelStyle
  }, label));
};

/***/ }),

/***/ "VO7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setAdultsNumber; });
/* unused harmony export updateAdult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setAttendees; });
/* unused harmony export setAdults */
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ORYz");



function setAdultsNumber(adultsNumber) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_ADULTS_NUMBER */ "e"], {
    adultsNumber: adultsNumber
  });
}

function updateAdult(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_ADULT */ "f"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}

function setAttendees(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ATTENDEES */ "d"], payload);
}

function setAdults(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ADULTS */ "c"], payload);
}



/***/ }),

/***/ "VQ9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useBlockInputDepartureDate; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("uDfI");
/* harmony import */ var _client_store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rueY");
/* harmony import */ var _client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("05PS");




function useBlockInputDepartureDate() {
  var checkIfDepartureDateIsBookable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var departureDateIsBookable = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__[/* getDepartureDateBookable */ "j"]);
  var blockInputDepartureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__[/* getBlockInputDepartureDate */ "b"]);
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useDispatch */ "d"])();

  var setBlockInputDepartureDate = function setBlockInputDepartureDate(value) {
    if (value !== blockInputDepartureDate) {
      dispatch(Object(_client_store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_2__[/* setCalendarBlockInputDepartureDate */ "f"])(value));
    }
  };

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (departureDateIsBookable) {
      setBlockInputDepartureDate(false);
    }
  }, [departureDateIsBookable]);
  return {
    blockInputDepartureDate: checkIfDepartureDateIsBookable && blockInputDepartureDate,
    departureDateIsBookable: departureDateIsBookable,
    setBlockInputDepartureDate: setBlockInputDepartureDate
  };
}

/***/ }),

/***/ "VtPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MONTH; });
/* unused harmony export calendarQuery */
/* unused harmony export bookableDatesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return queryFetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return queryFetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPricesByDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClosingDatesRanges; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ToJy");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("nv//");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ldK3");














var NO_TRANSPORT_VALUE = 'NO';
var DATE_FORMAT = 'YYYYMM';
var INITIAL_MONTH = 0;
function calendarQuery(args) {
  var resortId = args.resortId,
      duration = args.duration,
      departureCity = args.departureCity,
      urgentisationRate = args.urgentisationRate;
  return "\n      calendar(resortId: \"".concat(resortId, "\", duration: \"").concat(duration, "\", departureCity: \"").concat(departureCity, "\") {\n        blocks {\n          hasPrice\n          id\n          name\n          price {\n            value\n            currency\n            formattedValue\n          }\n          shortName\n          year\n        }\n        firstAvailableMonthIndex\n        months {\n          id\n          days {\n            dayContent {\n              arrivalDate\n              availability\n              canGoToBooking\n              id\n              isCurrentMonth\n              name\n              number\n              offer(urgentisationRate: ").concat(urgentisationRate, ")\n              shortName\n              siblingId\n            }\n            priceConfig {\n              bestPrice(forceAdultPerTrip: true, isCalendarCase: true) { value formattedValue }\n              currency\n              initialPrice(forceAdultPerTrip: true, isCalendarCase: true) { value formattedValue }\n              isBestPriceMonth\n              termsAndConditions {\n                accommodationComfortLabel\n                departureCity {\n                  value\n                  name\n                }\n                departureDate\n                duration\n                numberOfAdults\n                offerId\n              }\n              rawUnit\n              unit\n            }\n          }\n        }\n        weekDays\n      }\n    ");
}
function bookableDatesQuery(_ref) {
  var departureCity = _ref.departureCity,
      productId = _ref.productId;
  return "\n    bookableDates(productId: \"".concat(productId, "\", departureCity: \"").concat(departureCity, "\") {\n      months {\n        id\n        days {\n          id\n          availabilities {\n            status\n            durations\n          }\n        }\n      }\n    }\n  ");
}
function queryFetchCalendar(appContext, options) {
  var locale = appContext.locale;
  var _options$resortId = options.resortId,
      resortId = _options$resortId === void 0 ? '' : _options$resortId,
      _options$transport = options.transport,
      transport = _options$transport === void 0 ? '' : _options$transport,
      duration = options.duration,
      urgentisationRate = options.urgentisationRate;
  var calendarQueryArgs = {
    locale: locale,
    resortId: resortId,
    departureCity: transport || NO_TRANSPORT_VALUE,
    duration: duration,
    urgentisationRate: urgentisationRate
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(calendarQuery(calendarQueryArgs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_CALENDAR */ "nd"]
  }).then(function (_ref2) {
    var calendar = _ref2.calendar;
    return {
      calendar: calendar
    };
  });
}
function queryFetchBookableDates(appContext, options) {
  var _options$productId = options.productId,
      productId = _options$productId === void 0 ? '' : _options$productId,
      _options$departureCit = options.departureCity,
      departureCity = _options$departureCit === void 0 ? '' : _options$departureCit;
  var bookableDatesQueryArs = {
    productId: productId,
    departureCity: departureCity
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(bookableDatesQuery(bookableDatesQueryArs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_BOOKABLE_DATES */ "md"]
  }).then(function (_ref3) {
    var bookableDates = _ref3.bookableDates;
    return {
      bookableDates: bookableDates
    };
  });
}
function getDefaultSelectedMonth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var momentDate = value ? moment__WEBPACK_IMPORTED_MODULE_7___default()(value, format) : moment__WEBPACK_IMPORTED_MODULE_7___default()();
  return parseInt(momentDate.format(DATE_FORMAT), 10);
}
function getSelectedMonth(calendar, previousSelectedMonth) {
  var _calendar$months; // The query date param prevails


  var dateQueryParam = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__[/* getSpecificQueryParam */ "l"])(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__[/* QUERY_DEPARTURE_DATE */ "g"]);

  if (dateQueryParam) {
    return getDefaultSelectedMonth(dateQueryParam);
  }

  var firstCalendarMonth = ((_calendar$months = calendar.months) === null || _calendar$months === void 0 ? void 0 : _calendar$months[0].id) || getDefaultSelectedMonth();
  var firstAvailableMonthIndex = calendar.firstAvailableMonthIndex || INITIAL_MONTH;
  var firstAvailableMonth = parseInt(moment__WEBPACK_IMPORTED_MODULE_7___default()(firstCalendarMonth, DATE_FORMAT).add(firstAvailableMonthIndex, 'months').format(DATE_FORMAT), 10); // The previously selected month remains selected unless the first available dates are later

  if (previousSelectedMonth > firstAvailableMonth) {
    return previousSelectedMonth;
  }

  return firstAvailableMonth;
}
function getPricesByDays(calendar) {
  var prices = {};

  if (calendar.months) {
    calendar.months.forEach(function (_ref4) {
      var days = _ref4.days;

      if (days) {
        days.forEach(function (_ref5) {
          var _priceConfig$termsAnd, _priceConfig$termsAnd2;

          var dayContent = _ref5.dayContent,
              priceConfig = _ref5.priceConfig;

          var _ref6 = dayContent || {},
              availability = _ref6.availability,
              id = _ref6.id,
              offer = _ref6.offer,
              siblingId = _ref6.siblingId;

          var isBestPrice = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.isBestPriceMonth;
          var unit = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.unit;
          var departureCityValue = (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd === void 0 ? void 0 : (_priceConfig$termsAnd2 = _priceConfig$termsAnd.departureCity) === null || _priceConfig$termsAnd2 === void 0 ? void 0 : _priceConfig$termsAnd2.value) || NO_TRANSPORT_VALUE;

          if (id) {
            var _priceConfig$termsAnd3, _priceConfig$termsAnd4, _priceConfig$initialP, _priceConfig$bestPric, _priceConfig$bestPric2, _priceConfig$termsAnd5;

            var available = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_OPEN */ "g"];
            var closed = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_CLOSED */ "a"];
            var exclusivity = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_EXCLUSIVITY */ "b"];
            var full = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_FULL */ "c"];
            var lastAvailability = offer === 'urgentisation';
            var noAvailability = availability === '';
            var noDeparture = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_DEPARTURE */ "e"];
            var noFlight = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_FLIGHT */ "f"];
            var siblingOpen = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_SUMMER */ "h"] || availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_WINTER */ "i"];
            prices[id] = {
              availability: availability,
              available: available,
              closed: closed,
              currency: priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.currency,
              departureCity: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd3 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd3 === void 0 ? void 0 : (_priceConfig$termsAnd4 = _priceConfig$termsAnd3.departureCity) === null || _priceConfig$termsAnd4 === void 0 ? void 0 : _priceConfig$termsAnd4.name) || '',
              exclusivity: exclusivity,
              full: full,
              hasTransport: departureCityValue !== NO_TRANSPORT_VALUE,
              isBestPrice: isBestPrice,
              lastAvailability: lastAvailability,
              noAvailability: noAvailability,
              noDeparture: noDeparture,
              noFlight: noFlight,
              oldPrice: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$initialP = priceConfig.initialPrice) === null || _priceConfig$initialP === void 0 ? void 0 : _priceConfig$initialP.formattedValue) || null,
              price: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric = priceConfig.bestPrice) === null || _priceConfig$bestPric === void 0 ? void 0 : _priceConfig$bestPric.formattedValue) || null,
              priceValue: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric2 = priceConfig.bestPrice) === null || _priceConfig$bestPric2 === void 0 ? void 0 : _priceConfig$bestPric2.value) || null,
              rate: priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd5 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd5 === void 0 ? void 0 : _priceConfig$termsAnd5.offerId,
              siblingId: siblingId,
              siblingOpen: siblingOpen,
              unit: unit
            };
          }
        });
      }
    });
  }

  return prices;
}
var getClosingDatesRanges = function getClosingDatesRanges(openingDatesRanges) {
  return openingDatesRanges.sort(function (date1, date2) {
    return Number(date1.opening) - Number(date2.opening);
  }).map(function (openingDate, index, openingDates) {
    var _openingDates;

    return {
      after: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "h"])(openingDate.closing).toDate(),
      before: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "h"])(((_openingDates = openingDates[index + 1]) === null || _openingDates === void 0 ? void 0 : _openingDates.opening) || openingDates[0].opening).toDate()
    };
  });
};

/***/ }),

/***/ "W+NJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputButton_InputButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var InputButton_themes_defaultTheme = function defaultTheme(_ref) {
  var isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled;
  var hasDefaultStyle = !isActive && !isFilled && !isDisabled;
  var hasFilledStyle = isFilled && !isDisabled;
  var hasActiveStyle = isActive && !isDisabled && !isFilled;
  return {
    thRoot: classnames_default()('border flex items-center leading-normal rounded-pill text-14 text-black transition-all duration-250 ease-in w-full', {
      'border-lightGrey hocus:border-black': hasDefaultStyle,
      'border-black': hasActiveStyle,
      'border-success text-black': hasFilledStyle,
      'border-grey bg-pearl cursor-not-allowed text-grey': isDisabled
    }),
    thButton: 'flex gap-10 items-center flex-1 h-48 px-20 py-10',
    thIcon: classnames_default()('flex-none shrink-0', {
      'text-success': isFilled
    }),
    thIconSize: '1.25em',
    thChildren: 'flex-1 text-initial',
    thBadgeColor: colors["a" /* COLORS */].SAFFRON,
    thBadgeColorText: colors["a" /* COLORS */].BLACK,
    thIconRight: 'leading-0 pe-20 py-10 shrink-0',
    thSpinner: 'shrink-0',
    thSpinnerColor: 'current',
    thIconCaret: 'transition-all duration-250 ease-in',
    thClear: 'leading-0 pe-20 py-10 shrink-0',
    thClearSize: '0.625rem',
    thSwitchButton: 'leading-0 pe-20 py-10 shrink-0',
    thSwitch: classnames_default()('bg-current border-current flex leading-0 overflow-hidden rounded-pill duration-250 ease-in transition-all', {
      'text-lightGrey': !isFilled,
      'text-success': isFilled
    }),
    thSwitchStyle: {
      width: 'calc(40rem / 16)',
      height: 'calc(24rem / 16)',
      padding: 'calc(2rem / 16)'
    },
    thSwitchToggler: classnames_default()('bg-white flex font-bold items-center justify-center leading-0 rounded-pill text-center text-10 shadow', {
      'text-lightGrey': !isFilled,
      'text-success transform ltr:translate-x-[16px] rtl:-translate-x-[16px]': isFilled
    }),
    thSwitchTogglerStyle: {
      width: 'calc(20rem / 16)',
      height: 'calc(20rem / 16)'
    }
  };
};

var themes = function themes(props) {
  var d = InputButton_themes_defaultTheme(props);
  return {
    "default": d,
    remote: _objectSpread(_objectSpread({}, d), {}, {
      thButton: 'flex gap-5 items-center justify-center flex-1 h-48 p-10',
      thChildren: 'text-initial',
      thBadge: 'hidden',
      thClear: 'hidden',
      thIconRight: 'hidden',
      thSwitchButton: 'hidden'
    })
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.jsx
var __jsx = react_default.a.createElement;

/* eslint-disable react/jsx-no-useless-fragment */







var InputButton_InputButton = function InputButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      badgeCount = _ref.badgeCount,
      _ref$badgeSize = _ref.badgeSize,
      badgeSize = _ref$badgeSize === void 0 ? 24 : _ref$badgeSize,
      _ref$hasSwitch = _ref.hasSwitch,
      hasSwitch = _ref$hasSwitch === void 0 ? false : _ref$hasSwitch,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;
  var _themes$theme = themes({
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isLoading: isLoading
  })[theme],
      thBadge = _themes$theme.thBadge,
      thBadgeColor = _themes$theme.thBadgeColor,
      thBadgeColorText = _themes$theme.thBadgeColorText,
      thButton = _themes$theme.thButton,
      thChildren = _themes$theme.thChildren,
      thClear = _themes$theme.thClear,
      thClearSize = _themes$theme.thClearSize,
      thIcon = _themes$theme.thIcon,
      thIconRight = _themes$theme.thIconRight,
      thIconCaret = _themes$theme.thIconCaret,
      thIconSize = _themes$theme.thIconSize,
      thSpinner = _themes$theme.thSpinner,
      thRoot = _themes$theme.thRoot,
      thSpinnerColor = _themes$theme.thSpinnerColor,
      thSwitch = _themes$theme.thSwitch,
      thSwitchButton = _themes$theme.thSwitchButton,
      thSwitchStyle = _themes$theme.thSwitchStyle,
      thSwitchToggler = _themes$theme.thSwitchToggler,
      thSwitchTogglerStyle = _themes$theme.thSwitchTogglerStyle;

  if (!iconName && !children) {
    return null;
  }

  var hasClear = onClear && isFilled && !isLoading && !isDisabled;
  return __jsx("div", {
    className: classnames_default()(thRoot, className)
  }, __jsx("button", {
    className: thButton,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: onClick,
    title: title,
    type: "button"
  }, !!iconName && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    color: "none",
    name: iconName,
    width: thIconSize
  }), __jsx("span", {
    className: thChildren
  }, children), !!badgeCount && __jsx(Badge["a" /* Badge */], {
    className: thBadge,
    color: thBadgeColorText,
    colorBg: thBadgeColor,
    colorBorder: thBadgeColor,
    label: __jsx("span", {
      className: "-me-1 mt-1"
    }, badgeCount),
    size: badgeSize,
    variant: "pill"
  })), !hasSwitch && __jsx(react["Fragment"], null, hasClear ? __jsx("button", {
    "data-testid": "InputButtonClear",
    className: thClear,
    disabled: isDisabled,
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearSize
  })) : __jsx("button", {
    className: thIconRight,
    onClick: onClick,
    type: "button"
  }, isLoading ? __jsx(Spinner["a" /* Spinner */], {
    className: thSpinner,
    color: thSpinnerColor,
    size: "small"
  }) : __jsx(Icon["a" /* Icon */], {
    className: thIconCaret,
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: "0.625rem"
  }))), hasSwitch && __jsx("button", {
    className: thSwitchButton,
    "data-testid": "InputButtonClear",
    onClick: hasClear ? onClear : onClick,
    type: "button"
  }, __jsx("span", {
    className: thSwitch,
    style: thSwitchStyle
  }, __jsx("span", {
    "aria-hidden": true,
    className: thSwitchToggler,
    style: thSwitchTogglerStyle
  }, __jsx(Icon["a" /* Icon */], {
    name: isFilled ? icons["a" /* ICONS */].ON : icons["a" /* ICONS */].OFF,
    width: "calc(8rem / 16)"
  })))));
};

/***/ }),

/***/ "XiOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaContextProvider; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);








var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var initialState = {
  criteriaWhenIsSet: false,
  criteriaWhoIsSet: false,
  criteriaTransportIsSet: false,
  defaultValueForCalendar: null,
  isJoyview: false,
  layerButtonLabel: '',
  layerHeader: '',
  trackingActionName: '',
  setFacetHasSeeMore: function setFacetHasSeeMore() {},
  displayActivityFilter: true,
  displayChildcareFilter: true,
  displayDestinationFilter: true,
  displaySeasonFilter: true,
  displayTypeOfStayFilter: true,
  displayFlightDurationFilter: true
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  return _objectSpread(_objectSpread({}, state), action);
};

var CriteriaContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_8__["createContext"])([initialState, function () {}]);
var CriteriaContextProvider = function CriteriaContextProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_8__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var reducer = Object(react__WEBPACK_IMPORTED_MODULE_8__["useMemo"])(function () {
    return [state, dispatch];
  }, [state, dispatch]);
  return __jsx(CriteriaContext.Provider, {
    value: reducer
  }, children);
};

/***/ }),

/***/ "Xzib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PopOver_PopOver; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.themes.js
var themes = {
  "default": {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-large arrow-white bg-white after:drop-shadow-md mb-20 rounded-2 shadow-md',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  infoBanner: {
    thTrigger: 'w-full',
    thContainer: 'absolute top-full animate-fadeIn animation-duration-500 mt-5 rounded-2',
    thContent: ' arrow-white bg-white',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.875rem'
  },
  priceOfStayTooltip: {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-white bg-white after:drop-shadow-md mb-20 rounded-2',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  fancy: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-bg arrow-bg-black arrow-downLeft arrow-large arrow-white bg-white border-1 border-black after:drop-shadow-md mb-20 rounded-12 shadow-md',
    thCloseButton: 'absolute leading-0 p-10 end-0 top-0 text-grey',
    thCloseIconWidth: '0.625rem'
  },
  favorite: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-40 flex justify-end',
    thContent: 'arrow-downRight arrow-white bg-white after:drop-shadow-md text-12 mb-10 text-center rounded-2',
    thCloseButton: 'absolute leading-none p-10 end-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  'favorite-centered': {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-40 flex justify-center',
    thContent: 'arrow-down arrow-white bg-white after:drop-shadow-md text-12 mb-10 text-center rounded-2',
    thCloseButton: 'absolute leading-none p-10 end-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  typesOfStaySearchFilter: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 -mb-5 w-screen',
    thContent: 'flex w-full leading-1',
    thCloseButton: '',
    thTrigger: 'leading-0',
    thCloseIconWidth: ''
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx

var __jsx = react_default.a.createElement;









var PopOver_PopOver = function PopOver(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      _ref$contentClassName = _ref.contentClassName,
      contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
      containerStyle = _ref.containerStyle,
      content = _ref.content,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? false : _ref$hasCloseButton,
      _ref$isInitiallyVisib = _ref.isInitiallyVisible,
      isInitiallyVisible = _ref$isInitiallyVisib === void 0 ? false : _ref$isInitiallyVisib,
      _ref$isModalOnly = _ref.isModalOnly,
      isModalOnly = _ref$isModalOnly === void 0 ? false : _ref$isModalOnly,
      _onClick = _ref.onClick,
      onRender = _ref.onRender,
      onTimeout = _ref.onTimeout,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      timeoutInMs = _ref.timeoutInMs,
      triggerOnHover = _ref.triggerOnHover;

  var _useState = Object(react["useState"])(isInitiallyVisible),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  Object(react["useEffect"])(function () {
    onRender && onRender();

    if (timeoutInMs && timeoutInMs > 0) {
      setTimeout(function () {
        setIsVisible(false);
        onTimeout && onTimeout();
      }, timeoutInMs);
    }

    return function () {
      onTimeout && onTimeout();
    };
  }, []);
  var shouldTriggerOnHover = triggerOnHover && isDesktop;
  Object(react["useEffect"])(function () {
    var timeoutId;

    if (shouldTriggerOnHover && isVisible && _onClick) {
      timeoutId = setTimeout(_onClick, 300);
      return function () {
        clearTimeout(timeoutId);
      };
    }
  }, [isVisible, shouldTriggerOnHover]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thTrigger = _themes$theme.thTrigger,
      thContainer = _themes$theme.thContainer,
      thContent = _themes$theme.thContent,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseIconWidth = _themes$theme.thCloseIconWidth;
  return __jsx("div", Object(esm_extends["a" /* default */])({
    className: classnames_default()('isolate relative', className)
  }, shouldTriggerOnHover && {
    onMouseEnter: function onMouseEnter(e) {
      setIsVisible(true);

      if (!shouldTriggerOnHover) {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      }
    },
    onMouseLeave: function onMouseLeave() {
      setIsVisible(false);
    }
  }), __jsx("button", {
    className: thTrigger,
    "data-testid": "PopOver-button",
    onClick: function onClick(e) {
      e.preventDefault();

      if (!timeoutInMs) {
        setIsVisible(!isVisible);
      }

      if (!isVisible && !shouldTriggerOnHover && _onClick) {
        _onClick(e);
      }
    },
    type: "button"
  }, children), isVisible && (isDesktop && !isModalOnly ? __jsx(ClickOutside["a" /* ClickOutside */], Object(esm_extends["a" /* default */])({
    className: classnames_default()(thContainer, containerClassName),
    onClick: function onClick() {
      setIsVisible(false);
    }
  }, containerStyle ? {
    style: containerStyle
  } : {}), __jsx("div", {
    className: classnames_default()(thContent, contentClassName)
  }, hasCloseButton && __jsx("button", {
    className: thCloseButton,
    onClick: function onClick() {
      return setIsVisible(false);
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), content)) : __jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: function onClose(e) {
      e.preventDefault();
      setIsVisible(false);
    },
    size: "small"
  }, content)));
};

/***/ }),

/***/ "YGK4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("HFnK");


/***/ }),

/***/ "YMTf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FacetList_FacetList; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/choice-list/ChoiceList.jsx
var ChoiceList = __webpack_require__("c18e");

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/choice-lists/ChoiceLists.jsx


var __jsx = react_default.a.createElement;



var ChoiceLists_ChoiceLists = function ChoiceLists(_ref) {
  var _ref$choiceLists = _ref.choiceLists,
      choiceLists = _ref$choiceLists === void 0 ? [] : _ref$choiceLists,
      className = _ref.className,
      name = _ref.name,
      onChange = _ref.onChange,
      title = _ref.title;
  return __jsx("fieldset", {
    className: classnames_default()('p-0 m-0 border-0', className)
  }, title && __jsx("legend", {
    className: "font-bold leading-tight mb-10 p-0 text-16"
  }, title), choiceLists.map(function (choiceList) {
    return __jsx(ChoiceList["a" /* ChoiceList */], {
      choices: choiceList.choices,
      className: classnames_default()('FacetList mb-20', className),
      key: choiceList.value,
      name: name,
      onChange: onChange,
      title: choiceList.label
    });
  }));
};
// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetList.utils.js + 1 modules
var FacetList_utils = __webpack_require__("3y23");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetList.jsx










var FacetList_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var FacetList_getChoiceLists = function getChoiceLists(props) {
  var _props$facets;

  // Safeguard: API can return facets with null names, that must be ignored.
  return (_props$facets = props.facets) === null || _props$facets === void 0 ? void 0 : _props$facets.filter(function (_ref) {
    var badgeIconProps = _ref.badgeIconProps,
        label = _ref.label;
    return Boolean((badgeIconProps === null || badgeIconProps === void 0 ? void 0 : badgeIconProps.iconName) || label);
  }).map(function (facet) {
    var label = facet.label,
        value = facet.value;
    return {
      choices: facet.list && facet.list.length > 0 ? Object(FacetList_utils["a" /* getChoices */])(_objectSpread(_objectSpread({}, props), {}, {
        facets: facet.list
      })) : [],
      label: label,
      value: value
    };
  });
};

var FacetList_FacetList = function FacetList(props) {
  var name = props.name,
      isTopFacets = props.isTopFacets;
  return !isTopFacets && name === constants["m" /* COUNTRIES_FACET_ID */] ? FacetList_jsx(ChoiceLists_ChoiceLists, {
    choiceLists: FacetList_getChoiceLists(props),
    className: props.className,
    name: name,
    onChange: props.onChange,
    title: props.title
  }) : FacetList_jsx(ChoiceList["a" /* ChoiceList */], {
    choices: Object(FacetList_utils["a" /* getChoices */])(props),
    className: props.className,
    name: name,
    onChange: props.onChange,
    title: props.title
  });
};

/***/ }),

/***/ "YZTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP; });
/* unused harmony export ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ID_LAYER_HEADER__CA__ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ID_LAYER_HEADER__CA__CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ID_LAYER_HEADER__CA__ESF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ID_LAYER_HEADER__CA__INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ID_LAYER_HEADER__CA__MORE_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ID_LAYER_HEADER__CA__PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ID_LAYER_HEADER__CA__RENTALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ID_LAYER_HEADER__CA__STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ID_LAYER_HEADER__CA__TRANSFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ID_LAYER_HEADER__CA__VOUCHERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ID_MODAL_HEADER__BE__OPTION; });
/* unused harmony export ID_MODAL_HEADER__BE__CXO_OPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ID_MODAL_HEADER__BE__PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ID_MODAL_HEADER__BE__SHARE_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ID_MODAL_HEADER__BE__MISMATCH_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ID_MODAL_HEADER__PLE__LOGIN; });
/* unused harmony export ID_MODAL_HEADER__BE__CUSTOMER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ID_MODAL_HEADER__EASY_ARRIVAL_INFO; });
/* unused harmony export ID_MODAL_HEADER__BE__HOUSEHOLD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ID_MODAL_HEADER__PLE__NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ID_MODAL_HEADER__FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ID_MODAL_HEADER__BE_REFRESH_PROPOSAL; });
// Layers header IDs
var ID_LAYER_HEADER__BE__ACCOMMODATIONS = 'AccommodationsLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP = 'TransportsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE = 'TransportsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE = 'OtherProposalsMobileLayerHeaderId';
var ID_LAYER_HEADER__CA__ACTIVITIES = 'ActivitiesLayerHeaderId';
var ID_LAYER_HEADER__CA__CHILDCARES = 'ChildcaresLayerHeaderId';
var ID_LAYER_HEADER__CA__ESF = 'ESFLayerHeaderId';
var ID_LAYER_HEADER__CA__INSURANCES = 'InsurancesLayerHeaderId';
var ID_LAYER_HEADER__CA__MORE_ROOMS = 'MoreRoomsLayerHeaderId';
var ID_LAYER_HEADER__CA__PACKAGES = 'PackagesLayerHeaderId';
var ID_LAYER_HEADER__CA__RENTALS = 'RentalsLayerHeaderId';
var ID_LAYER_HEADER__CA__STAFF = 'StaffLayerHeaderId';
var ID_LAYER_HEADER__CA__TRANSFERS = 'TransfersLayerHeaderId';
var ID_LAYER_HEADER__CA__VOUCHERS = 'VouchersLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES = 'CookiePreferencesLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL = 'CriteriaModalLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER = 'CriteriaTriggerLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS = 'PriceRemoteDetailsLayerHeaderId'; // Modals header IDs

var ID_MODAL_HEADER__BE__OPTION = 'OptionModalHeaderId';
var ID_MODAL_HEADER__BE__CXO_OPTION = 'CxoOptionModalHeaderId';
var ID_MODAL_HEADER__BE__PROMO_CODE = 'PromoCodeModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION = 'SaveCriteriaConfirmationModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN = 'SaveCriteriaLoginModalHeaderId';
var ID_MODAL_HEADER__BE__SHARE_CONTEXT = 'ShareContextModalHeaderId';
var ID_MODAL_HEADER__BE__MISMATCH_COUNTRY = 'MismatchCountryModalHeaderId';
var ID_MODAL_HEADER__PLE__LOGIN = 'ParticipantsLoginToPleModalHeaderId';
var ID_MODAL_HEADER__BE__CUSTOMER = 'ParticipantsCustomerModalHeaderId';
var ID_MODAL_HEADER__EASY_ARRIVAL_INFO = 'EasyArrivalModalHeaderId';
var ID_MODAL_HEADER__BE__HOUSEHOLD = 'ParticipantsHouseholdModalHeaderId';
var ID_MODAL_HEADER__PLE__NEWSLETTER = 'NewsletterModalHeaderId';
var ID_MODAL_HEADER__FILTERS = 'FiltersModalHeaderId';
var ID_MODAL_HEADER__BE_REFRESH_PROPOSAL = 'RefreshProposalModalHeaderId';

/***/ }),

/***/ "YjXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputSwitch_InputSwitch; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isString.js
var isString = __webpack_require__("nDih");
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.themes.js










function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var themes = {
  "default": function _default(props) {
    var color = props.color,
        isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        isRequired = props.isRequired,
        validationState = props.validationState;
    var hasValidStyle = validationState === 'IS_VALID' && !isDisabled && !isReadOnly;
    var hasInvalidStyle = validationState === 'IS_INVALID' && !isDisabled && !isReadOnly;
    return {
      thRoot: 'flex gap-10 items-center',
      thLabel: classnames_default()('font-bold inline-block leading-tight mt-1 text-14 text-black', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props))),
      thChecked: classnames_default()('border flex h-[1.5rem] items-center justify-center p-2 outline-custom-sibling rounded-8 shrink-0 text-14 w-[1.5rem]', {
        'border-black': !isDisabled,
        'bg-pearl border-grey text-grey': isDisabled,
        'border-success text-success': hasValidStyle && isRequired,
        'border-red text-red formik-errored': hasInvalidStyle && isRequired
      }),
      thSwitch: classnames_default()('border-1 flex h-[32px] items-center p-[4px] rounded-pill transition-all duration-250 ease-in w-[56px]', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), Object(defineProperty["a" /* default */])({
        'bg-lightGrey border-lightGrey text-lightGrey': !isChecked || isDisabled
      }, "bg-".concat(color, " border-").concat(color), isChecked && !isDisabled)),
      thSwitchToggler: classnames_default()('bg-white block leading-0 flex h-[24px] items-center justify-center rounded-full text-lightGrey transition-all duration-250 ease-in w-[24px]', Object(defineProperty["a" /* default */])({
        'transform ltr:translate-x-full rtl:-translate-x-full': isChecked
      }, "text-".concat(color), isChecked && !isDisabled))
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx




















var __jsx = react_default.a.createElement;

function InputSwitch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InputSwitch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InputSwitch_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InputSwitch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }










var defaultProps = {
  color: colors["a" /* COLORS */].SAFFRON,
  iconChecked: icons["a" /* ICONS */].CHECK,
  iconUnChecked: null,
  isDisabled: false,
  isLoading: false,
  theme: 'default',
  validationState: 'NOT_VALIDATED'
};
var InputSwitch_InputSwitch = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputSwitch, _Component);

  var _super = _createSuper(InputSwitch);

  function InputSwitch(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputSwitch);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function () {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? noop_default.a : _this$props$onChange,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? '' : _this$props$value;

      if (!isReadOnly && !isDisabled && !isLoading) {
        var isChecked = !_this.state.isChecked;

        _this.setState({
          isChecked: isChecked
        }, function () {
          return onChange(name, isChecked, value);
        });
      }
    });

    _this.state = {
      isChecked: props.isChecked || false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputSwitch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isChecked !== this.props.isChecked) {
        this.setState({
          isChecked: this.props.isChecked
        });
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props2 = this.props,
          _this$props2$iconChec = _this$props2.iconChecked,
          iconChecked = _this$props2$iconChec === void 0 ? null : _this$props2$iconChec,
          _this$props2$iconUnCh = _this$props2.iconUnChecked,
          iconUnChecked = _this$props2$iconUnCh === void 0 ? null : _this$props2$iconUnCh;
      return this.state.isChecked ? iconChecked : iconUnChecked;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          ariaDescribedby = _this$props3.ariaDescribedby,
          ariaLabelledby = _this$props3.ariaLabelledby,
          className = _this$props3.className,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? "InputSwitch_".concat(shortid_default.a.generate()) : _this$props3$id,
          inputTestId = _this$props3.inputTestId,
          isDisabled = _this$props3.isDisabled,
          isLoading = _this$props3.isLoading,
          isReadOnly = _this$props3.isReadOnly,
          isRequired = _this$props3.isRequired,
          isSwitch = _this$props3.isSwitch,
          label = _this$props3.label,
          name = _this$props3.name,
          onClick = _this$props3.onClick,
          theme = _this$props3.theme,
          value = _this$props3.value,
          dataTestId = _this$props3.dataTestId;
      var isChecked = this.state.isChecked;

      var _themes$theme = themes[theme](InputSwitch_objectSpread({
        isChecked: isChecked
      }, this.props)),
          thChecked = _themes$theme.thChecked,
          thLabel = _themes$theme.thLabel,
          thRoot = _themes$theme.thRoot,
          thSwitch = _themes$theme.thSwitch,
          thSwitchToggler = _themes$theme.thSwitchToggler;

      return __jsx("div", {
        "data-testid": dataTestId,
        className: classnames_default()(thRoot, className)
      }, isSwitch ? __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: thSwitch,
        "data-testid": id,
        onClick: this.onChange,
        role: "checkbox",
        type: "button"
      }, __jsx("span", {
        className: thSwitchToggler
      }, __jsx(Icon["a" /* Icon */], {
        className: classnames_default()({
          'opacity-0 transition-opacity': isChecked
        }),
        name: icons["a" /* ICONS */].FAT_DOT,
        width: "0.5rem"
      }))) : __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: thChecked,
        "data-testid": id,
        disabled: isDisabled,
        onClick: this.onChange,
        role: "checkbox",
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: this.getIcon(),
        width: "1em"
      })), __jsx("input", {
        checked: isChecked,
        className: "hidden",
        disabled: isDisabled,
        id: id,
        "data-testid": inputTestId,
        label: label,
        name: name,
        onChange: this.onChange,
        onClick: onClick,
        required: isRequired,
        type: "checkbox",
        value: value
      }), isLoading && !isDisabled && !isReadOnly && __jsx(Spinner["a" /* Spinner */], {
        size: "small"
      }), !!label && __jsx("label", {
        className: thLabel,
        htmlFor: id
      }, isString_default()(label) ? Object(form_util["b" /* getFormattedLabel */])(label, isRequired) : label));
    }
  }]);

  return InputSwitch;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputSwitch_InputSwitch, "defaultProps", defaultProps);

/***/ }),

/***/ "ZLJe":
/***/ (function(module) {

module.exports = JSON.parse("{\"amp\":\"&\",\"apos\":\"'\",\"gt\":\">\",\"lt\":\"<\",\"quot\":\"\\\"\"}");

/***/ }),

/***/ "ZS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductPriceInfo; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qqKu");
/* harmony import */ var _rate_messages_RateMessages_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tuzA");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("EkOT");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;










var ProductPriceInfo = function ProductPriceInfo(_ref) {
  var city = _ref.city,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      onClick = _ref.onClick,
      _ref$rate = _ref.rate,
      rate = _ref$rate === void 0 ? '' : _ref$rate,
      startDate = _ref.startDate,
      unit = _ref.unit;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_10__[/* usePageContext */ "b"])(),
      pageType = _usePageContext.pageType;

  var isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["b2cPagesService"].isMicePage(pageType);
  var isAllInclusive = !isJoyview && !isTour; // eslint-disable-next-line no-nested-ternary

  var buttonLabel = isTour ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.buttonTourLabel') : isCruise ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.buttonCruiseLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.buttonLabel');

  var _getRateMessagesPrope = Object(_rate_messages_RateMessages_utils__WEBPACK_IMPORTED_MODULE_9__[/* getRateMessagesProperties */ "a"])(rate),
      rateContent = _getRateMessagesPrope.rateContent,
      rateTitle = _getRateMessagesPrope.rateTitle; // Display text only in product Thumbnails popin


  var rateObject = onClick ? {
    rateContent: rateContent,
    rateTitle: rateTitle
  } : {};
  return __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
    className: "p-20",
    text: isMice ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionForME', {
      unit: unit
    }) : [hasTransport ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithTransport', {
      unit: unit,
      city: city,
      endDate: endDate,
      startDate: startDate
    }) : Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithoutTransport', {
      endDate: endDate,
      startDate: startDate,
      unit: unit
    }), Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.roomAvailability'), rateObject === null || rateObject === void 0 ? void 0 : rateObject.rateTitle, rateObject === null || rateObject === void 0 ? void 0 : rateObject.rateContent].join(' '),
    theme: "text-sans-n2"
  }), (isAllInclusive || isJoyview || onClick) && __jsx("div", {
    className: "flex flex-col items-center border-t-1 border-lightGrey p-20"
  }, isAllInclusive && __jsx("p", {
    className: "flex flex-col sm:flex-row sm:flex-wrap gap-5 sm:items-center sm:justify-center max-w-full text-center text-black text-12"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.priceIsLabel'), ' ', __jsx("span", {
    className: "flex font-brand gap-5 items-center text-16 text-sienna"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].SIENNA,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].ALL_INCLUSIVE,
    width: "1.2rem"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.startingPrice.allInclusive'))), isJoyview && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "-mt-5",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLUE_WAVE,
    isNotSquare: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CLUBMED_JOYVIEW,
    width: "10rem"
  }), onClick && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], {
    className: "mt-10",
    dataTestId: "ProductPriceInfo-button",
    onClick: onClick
  }, buttonLabel)));
};

/***/ }),

/***/ "aUQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAutocomplete; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ToJy");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ub5k");
/* harmony import */ var _use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ngAq");
/* harmony import */ var _client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Qmkj");
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("y316");










function useAutocomplete() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var appContext = Object(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__[/* useAppContext */ "c"])();

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_5__["useState"])(keywords),
      autocompleteQuery = _useState[0],
      setAutocompleteQuery = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_5__["useState"])([]),
      autocompleteResults = _useState2[0],
      setAutocompleteResults = _useState2[1];

  var _useDebounce = Object(_use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_7__[/* useDebounce */ "a"])([autocompleteQuery], 300),
      _useDebounce2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_useDebounce, 1),
      debouncedAutocompleteQuery = _useDebounce2[0]; // This effect is used to fetch autocomplete suggestions when the query changes (with a 300ms debounce)


  Object(react__WEBPACK_IMPORTED_MODULE_5__["useEffect"])(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.mark(function _callee() {
        var _yield$fetchAutocompl, _yield$fetchAutocompl2, answers, results;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_4___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_9__[/* suggest */ "d"])({
                  criteria: {
                    keywords: debouncedAutocompleteQuery
                  },
                  appContext: appContext
                });

              case 3:
                _yield$fetchAutocompl = _context.sent;
                _yield$fetchAutocompl2 = _yield$fetchAutocompl.answers;
                answers = _yield$fetchAutocompl2 === void 0 ? [] : _yield$fetchAutocompl2;
                results = answers.map(_client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_8__[/* getResultItem */ "b"]).sort(function (_ref2, _ref3) {
                  var displayPositionA = _ref2.displayPosition;
                  var displayPositionB = _ref3.displayPosition;
                  return displayPositionA - displayPositionB;
                });
                setAutocompleteResults(results);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                setAutocompleteResults([]);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    if (debouncedAutocompleteQuery) {
      fetchData();
    } else {
      setAutocompleteResults([]);
    }
  }, [debouncedAutocompleteQuery]);
  return {
    autocompleteQuery: autocompleteQuery,
    setAutocompleteQuery: setAutocompleteQuery,
    autocompleteResults: autocompleteResults,
    setAutocompleteResults: setAutocompleteResults
  };
}

/***/ }),

/***/ "apzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userInfoSelector; });
var userInfoSelector = function userInfoSelector(state) {
  return state.userInfo;
};

/***/ }),

/***/ "b0q8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.resolve = resolve;
exports.reject = reject;
exports.unresolve = unresolve;
exports.unreject = unreject;
exports.isResolvedAction = isResolvedAction;
exports.isRejectedAction = isRejectedAction;
exports.isThenAction = isThenAction;
exports.default = optimistPromiseMiddleware;

var _fluxStandardAction = __webpack_require__("8soX");

function isPromise(val) {
  return val && typeof val.then === 'function';
}

var RESOLVED_NAME = '_RESOLVED',
    REJECTED_NAME = '_REJECTED';

var BEGIN = 'BEGIN';
var COMMIT = 'COMMIT';
var REVERT = 'REVERT';

function resolve(actionName) {
  return actionName + RESOLVED_NAME;
}

function reject(actionName) {
  return actionName + REJECTED_NAME;
}

function unresolve(resolvedActionName) {
  return resolvedActionName.split(RESOLVED_NAME)[0];
}

function unreject(rejectedActionName) {
  return rejectedActionName.split(REJECTED_NAME)[0];
}

function isResolvedAction(resolvedActionName) {
  return unresolve(resolvedActionName) !== resolvedActionName;
}

function isRejectedAction(rejectedActionName) {
  return unreject(rejectedActionName) !== rejectedActionName;
}

function isThenAction(thenActionName) {
  return isResolvedAction(thenActionName) || isRejectedAction(thenActionName);
}

function optimistPromiseMiddleware() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$throwOnReject = _ref.throwOnReject,
      throwOnReject = _ref$throwOnReject === undefined ? true : _ref$throwOnReject,
      _ref$resolvedName = _ref.resolvedName,
      resolvedName = _ref$resolvedName === undefined ? RESOLVED_NAME : _ref$resolvedName,
      _ref$rejectedName = _ref.rejectedName,
      rejectedName = _ref$rejectedName === undefined ? REJECTED_NAME : _ref$rejectedName;

  RESOLVED_NAME = resolvedName;
  REJECTED_NAME = rejectedName;

  var nextTransactionID = 0;
  return function (_ref2) {
    var dispatch = _ref2.dispatch;
    return function (next) {
      return function (action) {
        if (!(0, _fluxStandardAction.isFSA)(action) || !action.meta || !isPromise(action.meta.promise)) {
          return next(action);
        }

        var isOptimist = action.meta.optimist;

        var transactionID = void 0;

        if (isOptimist) {
          transactionID = nextTransactionID++;
        }

        // (1) Dispatch actionName with meta with arguments apart from promise

        // Clone original action
        var newAction = _extends({}, action, {
          meta: _extends({}, action.meta)
        });

        if (isOptimist) {
          // Adding optimistic meta
          newAction.optimist = { type: BEGIN, id: transactionID };
          delete newAction.meta.optimist;
        }

        if (Object.keys(newAction.meta).length === 1) {
          delete newAction.meta;
        } else {
          // Other arguments, delete promise and optimist only
          delete newAction.meta.promise;
        }

        var skipOptimist = action.meta.skipOptimist;

        if (!skipOptimist) {
          next(newAction);
        }

        // Create a base for the next action containing the metadata.
        var nextActionBase = {
          meta: _extends({}, newAction.meta, {
            payload: newAction.payload
          })
        };

        if (!nextActionBase.meta.payload) {
          // No payload, no need to include them in the meta.
          delete nextActionBase.meta.payload;
        }
        if (Object.keys(nextActionBase.meta).length === 0) {
          // No meta was included either, remove all meta.
          delete nextActionBase.meta;
        }

        // (2) Listen to promise and dispatch payload with new actionName
        return action.meta.promise.then(function (result) {
          var actionToDispatch = _extends({
            type: resolve(action.type),
            payload: result
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: COMMIT, id: transactionID };
          }
          dispatch(actionToDispatch);
          return result;
        }).catch(function (error) {
          var actionToDispatch = _extends({
            type: reject(action.type),
            payload: error
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: REVERT, id: transactionID };
          }
          dispatch(actionToDispatch);
          if (throwOnReject) {
            throw error;
          }
        });
      };
    };
  };
}

/***/ }),

/***/ "b3ii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toggleProductComparisonSelectionMode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toggleProductSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setProductComparisonSelectionMode; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9QcM");



function toggleProductComparisonSelectionMode() {
  return function (dispatch) {
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE */ "y"]));
  };
}

function setProductComparisonSelectionMode(enable) {
  return function (dispatch) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE */ "u"], {
      enable: enable
    }));
  };
}

function toggleProductSelected(productId) {
  return function (dispatch) {
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON */ "z"], {
      productId: productId
    }));
  };
}



/***/ }),

/***/ "bFjY":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("Q4oW"),
    isArrayLike = __webpack_require__("9y2L");

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ "bq+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterProductsByFlightDuration; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);

var filterProductsByFlightDuration = function filterProductsByFlightDuration(_ref) {
  var facet = _ref.facet,
      productList = _ref.productList;

  switch (facet) {
    case '2h':
      return productList.filter(function (product) {
        var _product$price, _product$price$termsA, _product$price2, _product$price2$terms;

        return typeof (product === null || product === void 0 ? void 0 : (_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$termsA = _product$price.termsAndConditions) === null || _product$price$termsA === void 0 ? void 0 : _product$price$termsA.flightDuration) === 'number' && (product === null || product === void 0 ? void 0 : (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : (_product$price2$terms = _product$price2.termsAndConditions) === null || _product$price2$terms === void 0 ? void 0 : _product$price2$terms.flightDuration) <= 120;
      });

    case '4h':
      return productList.filter(function (product) {
        var _product$price3, _product$price3$terms, _product$price4, _product$price4$terms, _product$price5, _product$price5$terms;

        return typeof (product === null || product === void 0 ? void 0 : (_product$price3 = product.price) === null || _product$price3 === void 0 ? void 0 : (_product$price3$terms = _product$price3.termsAndConditions) === null || _product$price3$terms === void 0 ? void 0 : _product$price3$terms.flightDuration) === 'number' && (product === null || product === void 0 ? void 0 : (_product$price4 = product.price) === null || _product$price4 === void 0 ? void 0 : (_product$price4$terms = _product$price4.termsAndConditions) === null || _product$price4$terms === void 0 ? void 0 : _product$price4$terms.flightDuration) > 120 && (product === null || product === void 0 ? void 0 : (_product$price5 = product.price) === null || _product$price5 === void 0 ? void 0 : (_product$price5$terms = _product$price5.termsAndConditions) === null || _product$price5$terms === void 0 ? void 0 : _product$price5$terms.flightDuration) <= 240;
      });

    case '8h':
      return productList.filter(function (product) {
        var _product$price6, _product$price6$terms, _product$price7, _product$price7$terms, _product$price8, _product$price8$terms;

        return typeof (product === null || product === void 0 ? void 0 : (_product$price6 = product.price) === null || _product$price6 === void 0 ? void 0 : (_product$price6$terms = _product$price6.termsAndConditions) === null || _product$price6$terms === void 0 ? void 0 : _product$price6$terms.flightDuration) === 'number' && (product === null || product === void 0 ? void 0 : (_product$price7 = product.price) === null || _product$price7 === void 0 ? void 0 : (_product$price7$terms = _product$price7.termsAndConditions) === null || _product$price7$terms === void 0 ? void 0 : _product$price7$terms.flightDuration) > 240 && (product === null || product === void 0 ? void 0 : (_product$price8 = product.price) === null || _product$price8 === void 0 ? void 0 : (_product$price8$terms = _product$price8.termsAndConditions) === null || _product$price8$terms === void 0 ? void 0 : _product$price8$terms.flightDuration) <= 480;
      });

    case '8hmore':
      return productList.filter(function (product) {
        var _product$price9, _product$price9$terms, _product$price10, _product$price10$term;

        return typeof (product === null || product === void 0 ? void 0 : (_product$price9 = product.price) === null || _product$price9 === void 0 ? void 0 : (_product$price9$terms = _product$price9.termsAndConditions) === null || _product$price9$terms === void 0 ? void 0 : _product$price9$terms.flightDuration) === 'number' && (product === null || product === void 0 ? void 0 : (_product$price10 = product.price) === null || _product$price10 === void 0 ? void 0 : (_product$price10$term = _product$price10.termsAndConditions) === null || _product$price10$term === void 0 ? void 0 : _product$price10$term.flightDuration) > 480;
      });

    default:
      return [];
  }
};

/***/ }),

/***/ "bz5b":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("9y2L");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "c18e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChoiceList; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _filter_button_FilterButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Gf56");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;





var ChoiceList = function ChoiceList(_ref) {
  var _ref$choices = _ref.choices,
      choices = _ref$choices === void 0 ? [] : _ref$choices,
      className = _ref.className,
      name = _ref.name,
      onChange = _ref.onChange,
      title = _ref.title;
  return __jsx("fieldset", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('border-0 p-0 m-0 flex flex-col gap-y-20', className)
  }, title && __jsx("legend", {
    className: "p-0 text-16 leading-normal font-bold mb-10"
  }, title), choices.length > 0 && __jsx("ul", {
    className: "flex flex-wrap gap-20"
  }, choices.map(function (choice) {
    return __jsx("li", {
      className: "flex items-center gap-10",
      key: choice.value
    }, choice.icon && __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].SIENNA,
      name: choice.icon,
      width: "1.5rem"
    }), __jsx(_filter_button_FilterButton__WEBPACK_IMPORTED_MODULE_5__[/* FilterButton */ "a"], {
      isActive: !!choice.isSelected,
      isIconButton: choice.isIconOnly,
      isDisabled: choice.isDisabled,
      onClick: function onClick() {
        onChange(name, !choice.isSelected, choice.value);
      }
    }, choice.label));
  })));
};

/***/ }),

/***/ "cGFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidationStateFromKid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidationStateFromKids; });
/* unused harmony export updateValidationStateForKid */
/* unused harmony export addOrRemoveKidFromValidationState */
/* unused harmony export addOrRemoveKidFromKidsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasKidWithoutAValidBirthdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasOnlyValidKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return invalidateNotValidatedKids; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("piMb");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("yyme");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("fGyu");
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wQ38");
/* harmony import */ var _facetingUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kNiU");
/* harmony import */ var _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("45yR");











var getValidationStateFromKid = function getValidationStateFromKid(kid, isKidBirthdateRequired) {
  if (typeof kid !== 'object') {
    return _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"];
  }

  if (!kid.birthdate) {
    return isKidBirthdateRequired ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* NOT_VALIDATED */ "c"];
  }

  return typeof kid === 'object' && Object(_facetingUtils__WEBPACK_IMPORTED_MODULE_9__[/* isKidMinor */ "n"])(kid.birthdate) ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_VALID */ "b"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"];
};
var getValidationStateFromKids = function getValidationStateFromKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return kids.map(function (kid) {
    return getValidationStateFromKid(kid);
  });
};
var updateValidationStateForKid = function updateValidationStateForKid(_ref) {
  var index = _ref.index,
      kid = _ref.kid,
      _ref$kidsValidationSt = _ref.kidsValidationState,
      kidsValidationState = _ref$kidsValidationSt === void 0 ? [] : _ref$kidsValidationSt;
  var validationState = getValidationStateFromKid(kid);
  return kidsValidationState.map(function (kidValidation, indexKid) {
    var isNewKid = kidValidation === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* NOT_VALIDATED */ "c"];
    var kidNeedsValidation = !!kid.birthdate || !isNewKid;
    return indexKid === index && kidNeedsValidation ? validationState : kidValidation;
  });
};
var addOrRemoveKidFromValidationState = function addOrRemoveKidFromValidationState(_ref2) {
  var _ref2$currentState = _ref2.currentState,
      currentState = _ref2$currentState === void 0 ? [] : _ref2$currentState,
      kidsNumber = _ref2.kidsNumber;

  if (kidsNumber > currentState.length) {
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(currentState), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Array(kidsNumber - currentState.length).fill(_client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_8__[/* VALIDATION_STATE_ENUM */ "f"].notvalidated)));
  }

  if (kidsNumber < currentState.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(currentState.slice(0, kidsNumber));
  }

  return currentState;
};
var addOrRemoveKidFromKidsList = function addOrRemoveKidFromKidsList(args) {
  var _args$kids = args.kids,
      kids = _args$kids === void 0 ? [] : _args$kids,
      kidsNumber = args.kidsNumber;

  if (kidsNumber > kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(kids).concat(Array(kidsNumber - kids.length).fill().map(function () {
      return _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_8__[/* DEFAULT_KID_VALUE */ "a"];
    }));
  }

  if (kidsNumber < kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(kids.slice(0, kidsNumber));
  }

  return kids;
};
var hasKidWithoutAValidBirthdate = function hasKidWithoutAValidBirthdate(kidsValidationState) {
  return Boolean(kidsValidationState && kidsValidationState.find(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"];
  }));
};
var hasOnlyValidKids = function hasOnlyValidKids(kidsValidationState) {
  return kidsValidationState.every(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_VALID */ "b"];
  });
};
var invalidateNotValidatedKids = function invalidateNotValidatedKids(kidsValidationState) {
  return kidsValidationState.reduce(function (acc, current) {
    if (current === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* NOT_VALIDATED */ "c"]) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(acc), [_client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"]]);
    }

    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(acc), [current]);
  }, []);
};

/***/ }),

/***/ "cHMM":
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__("tRRp");

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),

/***/ "cdI6":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, INFINITY) : [];
}

module.exports = flattenDeep;


/***/ }),

/***/ "csq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ LayerHeader_LayerHeader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/layer-header-button/LayerHeaderButton.themes.js
var themes = function themes(_ref) {
  var isActive = _ref.isActive,
      hasIcon = _ref.hasIcon;
  return {
    "default": {
      thRoot: "cursor-pointer flex flex-col sm:flex-row items-center p-5 rounded-4 text-12 text-black transition-colors duration-250 ease-in".concat(isActive ? ' bg-saffron hocus:bg-saffron-active' : ' hocus:text-black-active'),
      thIcon: 'm-5 shrink-0',
      thIconWidth: '1.25rem',
      thLabel: hasIcon ? 'sr-only' : ''
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/layer-header-button/LayerHeaderButton.jsx

var __jsx = react_default.a.createElement;




var LayerHeaderButton_LayerHeaderButton = function LayerHeaderButton(_ref) {
  var ariaHidden = _ref.ariaHidden,
      ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      iconClassName = _ref.iconClassName,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      label = _ref.label,
      onClick = _ref.onClick,
      tabIndex = _ref.tabIndex,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!label && !iconName) {
    return null;
  }

  var hasIcon = !!iconName;
  var _themes$theme = themes({
    isActive: isActive,
    hasIcon: hasIcon
  })[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;
  return __jsx("button", Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    className: classnames_default()(thRoot, className),
    "data-testid": dataTestId,
    onClick: onClick
  }, tabIndex === -1 ? {
    tabIndex: tabIndex
  } : null, {
    type: "button"
  }), !!iconName && __jsx(Icon["a" /* Icon */], {
    className: classnames_default()(thIcon, iconClassName),
    hasRtl: true,
    name: iconName,
    width: thIconWidth
  }), !!label && __jsx("span", {
    className: thLabel
  }, label));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/LayerHeader.themes.js
var LayerHeader_themes_themes = {
  "default": {
    thRoot: 'bg-white border-b-1 fixed overflow-hidden px-20 transition-heights duration-250 ease-in w-full z-3',
    thInner: 'flex h-full items-center w-full',
    thChild: 'w-full',
    thClose: 'leading-0 ms-auto order-1 p-10 text-black hocus:text-black-active transition-color',
    thCloseIconWidth: '1rem',
    thCloseLabel: 'sr-only'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/LayerHeader.jsx

var LayerHeader_jsx = react_default.a.createElement;






var LayerHeader_LayerHeader = function LayerHeader(_ref) {
  var buttonLeft = _ref.buttonLeft,
      buttonRight = _ref.buttonRight,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      hasContainer = _ref.hasContainer,
      height = _ref.height,
      onClose = _ref.onClose,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var layerButtonRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    layerButtonRef.current && layerButtonRef.current.focus();
  }, []);
  var _themes$theme = LayerHeader_themes_themes[theme],
      thChild = _themes$theme.thChild,
      thClose = _themes$theme.thClose,
      thCloseIconWidth = _themes$theme.thCloseIconWidth,
      thCloseLabel = _themes$theme.thCloseLabel,
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;
  return LayerHeader_jsx("header", {
    className: classnames_default()(thRoot, className),
    style: {
      height: height,
      maxHeight: height
    }
  }, LayerHeader_jsx("div", {
    className: classnames_default()(thInner, {
      'm-auto max-w-site w-full': hasContainer
    }),
    "data-testid": "LayerHeader-body"
  }, LayerHeader_jsx("button", {
    className: thClose,
    "data-testid": "Layer-close",
    onClick: onClose,
    ref: layerButtonRef,
    type: "button"
  }, !!closeLabel && LayerHeader_jsx("span", {
    className: thCloseLabel
  }, closeLabel), LayerHeader_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), LayerHeader_jsx(LayerHeaderButton_LayerHeaderButton, Object(esm_extends["a" /* default */])({
    dataTestId: "layer-header-button-left"
  }, buttonLeft, {
    theme: theme
  })), !!react["Children"].count(children) && LayerHeader_jsx("div", {
    className: thChild
  }, children), LayerHeader_jsx(LayerHeaderButton_LayerHeaderButton, Object(esm_extends["a" /* default */])({
    dataTestId: "layer-header-button-right"
  }, buttonRight, {
    theme: theme
  }))));
};

/***/ }),

/***/ "cvSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SYNC_WITH_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SEARCH_SET_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TRIP_INFORMATION_SET_DEPARTURE_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TRIP_INFORMATION_SET_DEPARTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_USER_PAST_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RESET_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_USER_FUTURE_TRIPS_FETCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_USER_FUTURE_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RESET_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_USER_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_USER_SEARCHES_RESOLVED; });
/* unused harmony export SET_PARTICIPANTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_CALENDAR_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_CALENDAR_TRIP_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_CALENDAR_TRIP_PRICE_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_BOOKABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_BOOKABLE_DATES_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALENDAR_CHANGE_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CALENDAR_SET_INITIAL_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION; });
/* unused harmony export QUOTATION_FORM_UPDATE */
/* unused harmony export QUOTATION_FORM_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UPDATE_TRIP_DATE_CRITERIA; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);

var SYNC_WITH_LOCATION = 'SYNC_WITH_LOCATION';
var SEARCH_SET_KEYWORDS = 'SEARCH_SET_KEYWORDS';
var TRIP_INFORMATION_SET_DEPARTURE_CITY = 'TRIP_INFORMATION_SET_DEPARTURE_CITY';
var TRIP_INFORMATION_SET_DEPARTURE_DATE = 'TRIP_INFORMATION_SET_DEPARTURE_DATE';
var FETCH_USER_PAST_TRIPS = 'FETCH_USER_PAST_TRIPS';
var FETCH_USER_PAST_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_PAST_TRIPS);
var RESET_USER_PAST_TRIPS = 'RESET_USER_PAST_TRIPS';
var FETCH_USER_FUTURE_TRIPS = 'FETCH_USER_FUTURE_TRIPS';
var FETCH_USER_FUTURE_TRIPS_FETCHED = 'FETCH_USER_FUTURE_TRIPS_FETCHED';
var FETCH_USER_FUTURE_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_FUTURE_TRIPS);
var RESET_USER_FUTURE_TRIPS = 'RESET_USER_FUTURE_TRIPS';
var FETCH_USER_SEARCHES = 'FETCH_USER_SEARCHES';
var FETCH_USER_SEARCHES_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_SEARCHES);
var SET_PARTICIPANTS = 'SET_PARTICIPANTS';
var FETCH_CALENDAR = 'FETCH_CALENDAR';
var FETCH_CALENDAR_ABORT = 'FETCH_CALENDAR_ABORT';
var FETCH_CALENDAR_TRIP_PRICE = 'FETCH_CALENDAR_TRIP_PRICE';
var FETCH_CALENDAR_TRIP_PRICE_ABORT = 'FETCH_CALENDAR_TRIP_PRICE_ABORT';
var FETCH_BOOKABLE_DATES = 'FETCH_BOOKABLE_DATES';
var FETCH_BOOKABLE_DATES_ABORT = 'FETCH_BOOKABLE_DATES_ABORT';
var CALENDAR_CHANGE_MONTH = 'CALENDAR_CHANGE_MONTH';
var CLEAR_CALENDAR = 'CLEAR_CALENDAR';
var CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE = 'CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE';
var CALENDAR_SET_INITIAL_DURATION = 'CALENDAR_SET_INITIAL_DURATION';
var CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION = 'CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION';
var QUOTATION_FORM_UPDATE = 'QUOTATION_FORM_UPDATE';
var QUOTATION_FORM_REQUEST = 'QUOTATION_FORM_REQUEST';
var UPDATE_TRIP_DATE_CRITERIA = 'UPDATE_TRIP_DATE_CRITERIA';

/***/ }),

/***/ "dnX/":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("a88S");

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ "eHpp":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseGet = __webpack_require__("w2Tz"),
    baseIteratee = __webpack_require__("S3pA"),
    baseMap = __webpack_require__("bFjY"),
    baseSortBy = __webpack_require__("4jPf"),
    baseUnary = __webpack_require__("SU8Q"),
    compareMultiple = __webpack_require__("5WP5"),
    identity = __webpack_require__("zWgn"),
    isArray = __webpack_require__("wxYD");

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ "ehGJ":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("DuXo"),
    baseIteratee = __webpack_require__("S3pA"),
    toInteger = __webpack_require__("m2YG");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),

/***/ "fYnN":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "fflk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureDate; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function setDepartureDate(departureDate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_DATE */ "x"], {
    departureDate: departureDate
  });
}



/***/ }),

/***/ "gz38":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Collapse = /*#__PURE__*/function (_React$Component) {
  _inherits(Collapse, _React$Component);

  var _super = _createSuper(Collapse);

  function Collapse(props) {
    var _this;

    _classCallCheck(this, Collapse);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "timeout", undefined);

    _defineProperty(_assertThisInitialized(_this), "container", undefined);

    _defineProperty(_assertThisInitialized(_this), "content", undefined);

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      clearTimeout(_this.timeout);

      if (!_this.container || !_this.content) {
        return;
      }

      var _this$props = _this.props,
          isOpened = _this$props.isOpened,
          checkTimeout = _this$props.checkTimeout;
      var containerHeight = Math.floor(_this.container.clientHeight);
      var contentHeight = Math.floor(_this.content.clientHeight);
      var isFullyOpened = isOpened && Math.abs(contentHeight - containerHeight) <= 1;
      var isFullyClosed = !isOpened && Math.abs(containerHeight) <= 1;

      if (isFullyOpened || isFullyClosed) {
        _this.onRest({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });
      } else {
        _this.onWork({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });

        _this.timeout = setTimeout(function () {
          return _this.onResize();
        }, checkTimeout);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRest", function (_ref) {
      var isFullyOpened = _ref.isFullyOpened,
          isFullyClosed = _ref.isFullyClosed,
          isOpened = _ref.isOpened,
          containerHeight = _ref.containerHeight,
          contentHeight = _ref.contentHeight;

      if (!_this.container || !_this.content) {
        return;
      }

      var hasOpened = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
      var hasClosed = !isOpened && _this.container.style.height === '0px';

      if (hasOpened || hasClosed) {
        _this.container.style.overflow = isOpened ? 'initial' : 'hidden';
        _this.container.style.height = isOpened ? 'auto' : '0px';
        var onRest = _this.props.onRest;

        if (onRest) {
          onRest({
            isFullyOpened: isFullyOpened,
            isFullyClosed: isFullyClosed,
            isOpened: isOpened,
            containerHeight: containerHeight,
            contentHeight: contentHeight
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onWork", function (_ref2) {
      var isFullyOpened = _ref2.isFullyOpened,
          isFullyClosed = _ref2.isFullyClosed,
          isOpened = _ref2.isOpened,
          containerHeight = _ref2.containerHeight,
          contentHeight = _ref2.contentHeight;

      if (!_this.container || !_this.content) {
        return;
      }

      var isOpenining = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
      var isClosing = !isOpened && _this.container.style.height === '0px';

      if (isOpenining || isClosing) {
        // No need to do any work
        return;
      }

      _this.container.style.overflow = 'hidden';
      _this.container.style.height = isOpened ? "".concat(contentHeight, "px") : '0px';
      var onWork = _this.props.onWork;

      if (onWork) {
        onWork({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRefContainer", function (container) {
      _this.container = container;
    });

    _defineProperty(_assertThisInitialized(_this), "onRefContent", function (content) {
      _this.content = content;
    });

    if (props.initialStyle) {
      _this.initialStyle = props.initialStyle;
    } else {
      _this.initialStyle = props.isOpened ? {
        height: 'auto',
        overflow: 'initial'
      } : {
        height: '0px',
        overflow: 'hidden'
      };
    }

    return _this;
  }

  _createClass(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onResize();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props2 = this.props,
          theme = _this$props2.theme,
          isOpened = _this$props2.isOpened,
          children = _this$props2.children;
      return children !== nextProps.children || isOpened !== nextProps.isOpened || Object.keys(theme).some(function (c) {
        return theme[c] !== nextProps.theme[c];
      });
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      if (!this.container || !this.content) {
        return null;
      }

      if (this.container.style.height === 'auto') {
        var contentHeight = this.content.clientHeight;
        this.container.style.height = "".concat(contentHeight, "px");
      }

      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          theme = _this$props3.theme,
          children = _this$props3.children,
          isOpened = _this$props3.isOpened;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.onRefContainer,
        className: theme.collapse,
        style: this.initialStyle,
        "aria-hidden": !isOpened
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.onRefContent,
        className: theme.content
      }, children));
    }
  }]);

  return Collapse;
}(_react["default"].Component);

exports.Collapse = Collapse;

_defineProperty(Collapse, "defaultProps", {
  theme: {
    collapse: 'ReactCollapse--collapse',
    content: 'ReactCollapse--content'
  },
  initialStyle: undefined,
  onRest: undefined,
  onWork: undefined,
  checkTimeout: 50
});

/***/ }),

/***/ "hA0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductLogo_ProductLogo; });

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.theme.js

var themes = {
  "default": function _default(_ref) {
    var isExclusiveCollection = _ref.isExclusiveCollection;
    return {
      thRoot: 'text-center',
      thIcon: classnames_default()('mb-15', {
        'bg-lightSand rounded-full text-black p-15': !isExclusiveCollection
      }, {
        'border-5 border-ultramarine rounded-12 text-ultramarine p-10': isExclusiveCollection
      }),
      thIconWidth: 'calc(100rem / 16)',
      thIsNotSquare: false,
      thProductInfo: 'flex flex-col-reverse text-initial',
      thProductCountry: 'font-bold text-14 text-sienna truncate w-full',
      thProductName: 'font-bold leading-tight text-18'
    };
  },
  calendar: function calendar() {
    return {
      thRoot: 'font-brand leading-tight text-black text-center text-16',
      thIconWidth: '5rem',
      thIsNotSquare: true
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.jsx
var __jsx = react_default.a.createElement;




var ProductLogo_ProductLogo = function ProductLogo(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      iconName = _ref.iconName,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _themes$theme = themes[theme]({
    isExclusiveCollection: isExclusiveCollection
  }),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot,
      thIsNotSquare = _themes$theme.thIsNotSquare,
      thProductInfo = _themes$theme.thProductInfo,
      thProductName = _themes$theme.thProductName,
      thProductCountry = _themes$theme.thProductCountry;

  return __jsx("div", {
    className: classnames_default()(thRoot, className)
  }, __jsx(Icon["a" /* Icon */], {
    alt: productName,
    className: thIcon,
    isNotSquare: thIsNotSquare,
    name: iconName,
    width: thIconWidth
  }), __jsx("div", {
    className: thProductInfo
  }, productName && __jsx("p", {
    className: thProductName,
    "data-testid": "product-logo-name"
  }, productName), productCountry && __jsx("p", {
    className: thProductCountry,
    "data-testid": "product-logo-country"
  }, productCountry)));
};

/***/ }),

/***/ "hPQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACET_QUERY_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return navigateToSearchPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return navigateToResortPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentUrlContainsSearchQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return currentUrlHasNoQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFacetsAsString; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("piMb");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("mRH6");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("U2CP");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("Sj1w");





















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var FACET_QUERY_PARAMS = [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_DEPARTURE_DATE */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_DURATION */ "h"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_KIDS */ "j"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* QUERY_QUERY_PARAM */ "Q"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_TRANSPORT */ "m"], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* customFacetsQueryParamMapping */ "a"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* FLIGHT_DURATION_FACET_ID */ "C"]], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* facetsQueryParamMapping */ "b"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* ACTIVITIES_FACET_ID */ "a"]], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* facetsQueryParamMapping */ "b"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* CHILDCARE_FILTER_FACET_ID */ "f"]], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* facetsQueryParamMapping */ "b"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* COUNTRIES_FACET_ID */ "m"]], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* facetsQueryParamMapping */ "b"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* DESTINATIONS_FACET_ID */ "w"]], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* facetsQueryParamMapping */ "b"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* SEASON_FACET_ID */ "S"]], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* facetsQueryParamMapping */ "b"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* TYPES_OF_STAY_FACET_ID */ "ab"]], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* SORT_BY_PRICE_QUERY_PARAM */ "X"]];

var getChildcareFacetFilterQueryParams = function getChildcareFacetFilterQueryParams(args) {
  var activeFacetsQueries = args.activeFacetsQueries,
      criteriaKeysToPersist = args.criteriaKeysToPersist,
      currentQueryParams = args.currentQueryParams,
      searchCriteria = args.searchCriteria;

  if (criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_KIDS */ "j"]) && searchCriteria.departureDate) {
    var _currentQueryParams$Q, _currentQueryParams$Q2, _activeFacetsQueries$;

    var departureDateQPCurrentValue = (_currentQueryParams$Q = currentQueryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_DEPARTURE_DATE */ "g"]]) !== null && _currentQueryParams$Q !== void 0 ? _currentQueryParams$Q : '';
    var kidsQPCurrentValue = (_currentQueryParams$Q2 = currentQueryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_KIDS */ "j"]]) !== null && _currentQueryParams$Q2 !== void 0 ? _currentQueryParams$Q2 : '';
    return Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* synchronizeChildcareQPWithKidsQP */ "p"])({
      childcareFacetQueryParam: (_activeFacetsQueries$ = activeFacetsQueries === null || activeFacetsQueries === void 0 ? void 0 : activeFacetsQueries[_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* facetsQueryParamMapping */ "b"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* CHILDCARE_FILTER_FACET_ID */ "f"]]]) !== null && _activeFacetsQueries$ !== void 0 ? _activeFacetsQueries$ : '',
      departureDate: searchCriteria.departureDate,
      departureDateQueryParam: Array.isArray(departureDateQPCurrentValue) ? departureDateQPCurrentValue.join('') : departureDateQPCurrentValue,
      kids: searchCriteria.kids,
      kidsQueryParam: Array.isArray(kidsQPCurrentValue) ? kidsQPCurrentValue.join(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_KIDS_DELIMITER */ "k"]) : kidsQPCurrentValue
    });
  }

  return undefined;
};

var computeQueryParamsForUrl = function computeQueryParamsForUrl(args) {
  var _ref;

  var criteriaKeysToPersist = args.criteriaKeysToPersist,
      searchCriteria = args.searchCriteria;
  var formattedDate = searchCriteria.departureDate && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* getDepartureDateDisplayValue */ "i"])(Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* formatDepartureDateForStore */ "d"])(searchCriteria.departureDate, ''));
  var searchQuery = searchCriteria.query ? searchCriteria.query.label : '';
  return _ref = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_DEPARTURE_DATE */ "g"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_DEPARTURE_DATE */ "g"]) && formattedDate || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_DURATION */ "h"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_DURATION */ "h"]) && searchCriteria.duration || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_TRANSPORT */ "m"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_TRANSPORT */ "m"]) && searchCriteria.departureCity || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(_ref, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* QUERY_QUERY_PARAM */ "Q"], criteriaKeysToPersist.includes(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* QUERY_QUERY_PARAM */ "Q"]) && (searchCriteria.keywords || searchQuery) || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_KIDS */ "j"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_KIDS */ "j"]) && searchCriteria.kids.length > 0 && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* serializeKidsToQueryParam */ "o"])({
    kids: searchCriteria.kids,
    kidsValidationState: searchCriteria.kidsValidationState
  }) || undefined), _ref;
};

var navigateToSearchPage = function navigateToSearchPage(args) {
  var activeCustomFacetsQueries = args.activeCustomFacetsQueries,
      activeFacetsQueries = args.activeFacetsQueries,
      criteriaKeysToPersist = args.criteriaKeysToPersist,
      router = args.router,
      searchCriteria = args.searchCriteria,
      searchPageRouteName = args.searchPageRouteName;
  var queryParams = computeQueryParamsForUrl({
    criteriaKeysToPersist: criteriaKeysToPersist,
    searchCriteria: searchCriteria
  });
  var childcareFacetFilterQueryParams = getChildcareFacetFilterQueryParams({
    activeFacetsQueries: activeFacetsQueries,
    criteriaKeysToPersist: criteriaKeysToPersist,
    currentQueryParams: router.query,
    searchCriteria: searchCriteria
  });
  queryParams = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, queryParams), activeCustomFacetsQueries), activeFacetsQueries), childcareFacetFilterQueryParams && Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])({}, _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* facetsQueryParamMapping */ "b"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* CHILDCARE_FILTER_FACET_ID */ "f"]], childcareFacetFilterQueryParams)), childcareFacetFilterQueryParams === '' && Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])({}, _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_23__[/* facetsQueryParamMapping */ "b"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* CHILDCARE_FILTER_FACET_ID */ "f"]], undefined)); // NOTE: URI.setQuery() does not remove existing queries

  var searchPageUrl = new urijs__WEBPACK_IMPORTED_MODULE_21___default.a(router.asPath).setQuery(queryParams);
  var previousPathname = searchPageUrl.pathname();
  var pathname = searchPageRouteName ? _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_20__[/* urlPattern */ "b"](searchPageRouteName) : null;

  if (pathname) {
    searchPageUrl.pathname(pathname);
  }

  var isShallow = searchPageUrl.pathname() === previousPathname;
  router.replace(searchPageUrl.toString(), undefined, {
    shallow: isShallow
  });
};
var navigateToResortPage = function navigateToResortPage(args) {
  var query = args.query,
      router = args.router,
      searchCriteria = args.searchCriteria;
  var queryParams = computeQueryParamsForUrl({
    criteriaKeysToPersist: [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_DEPARTURE_DATE */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_DURATION */ "h"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_TRANSPORT */ "m"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_24__[/* QUERY_KIDS */ "j"]],
    searchCriteria: searchCriteria
  });
  var resortPageUrl = new urijs__WEBPACK_IMPORTED_MODULE_21___default.a(router.asPath).pathname(query.link).setQuery(queryParams);
  router.push(resortPageUrl.toString());
};
var currentUrlContainsSearchQueryParam = function currentUrlContainsSearchQueryParam(queryParams) {
  return !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_19___default()(queryParams[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_22__[/* QUERY_QUERY_PARAM */ "Q"]]);
};
var currentUrlHasNoQueryParams = function currentUrlHasNoQueryParams(queryParams) {
  return FACET_QUERY_PARAMS.every(function (queryKey) {
    return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_19___default()(queryParams[queryKey]);
  });
};
var getFacetsAsString = function getFacetsAsString(filters, facetCategoryId) {
  var facetsInCategory = filters.filter(function (filter) {
    return filter.id === facetCategoryId;
  });

  if (facetsInCategory.length === 0) {
    return null;
  }

  return facetsInCategory.map(function (filter) {
    return filter.name;
  }).join('|');
};

/***/ }),

/***/ "hqKg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ "i6QF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("I+eb");
var isIntegralNumber = __webpack_require__("6sUC");

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isIntegralNumber
});


/***/ }),

/***/ "jw1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPriceFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanupArgs; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_4__);






var generateCmsArgs = function generateCmsArgs(content, release) {
  return "content : \"".concat(content, "\" release : \"").concat(release, "\"");
};

var getPriceArgs = function getPriceArgs(args) {
  return ['offerId', 'offerName', 'date', 'dateStart', 'dateEnd', 'duration', 'departureCity', 'forceWithoutTransport', 'optimizedPriceCalls'].filter(function (key) {
    return args[key];
  }).map(function (key) {
    var value = lodash_isString__WEBPACK_IMPORTED_MODULE_4___default()(args[key]) ? "\"".concat(args[key], "\"") : args[key];
    return [key, value];
  });
};

var buildPriceGraphqlArgs = function buildPriceGraphqlArgs(args) {
  return args.length ? "(".concat(args.map(function (priceArg) {
    return priceArg.join(' : ');
  }).join(' '), ")") : '';
};

function getPriceFields(args) {
  var content = args.content,
      release = args.release,
      isMice = args.isMice;
  var cmsArgs = generateCmsArgs(content, release);
  var priceArgs = buildPriceGraphqlArgs(getPriceArgs(args));

  if (isMice) {
    return "\n    mice {\n      bestPrice {\n        value\n        formattedValue\n      }\n      unit(".concat(cmsArgs, ")\n    }\n    ");
  }

  return "\n    price ".concat(priceArgs, " {\n      bestPrice {\n        value\n        formattedValue\n      }\n      initialPrice {\n        value\n        formattedValue\n      }\n      unit(").concat(cmsArgs, ")\n      currency\n      termsAndConditions {\n        accommodationComfortLabel\n        departureCity {\n          name\n          value\n        }\n        departureDate\n        duration\n        durationFormatted(").concat(cmsArgs, ")\n        flightDuration\n        numberOfAdults\n        offerId\n      }\n    }");
}

function getThumbnailBaseFields(args) {
  var isMice = args.isMice,
      offerName = args.offerName,
      tourDurationPlaceholder = args.tourDurationPlaceholder,
      cruiseTimingPlaceholder = args.cruiseTimingPlaceholder,
      cruiseDurationPlaceholder = args.cruiseDurationPlaceholder,
      dateFormat = args.dateFormat,
      content = args.content,
      release = args.release; // use typeof string since we cannot be sure that there are no empty strings on the CMS

  var durationArgs = typeof tourDurationPlaceholder === 'string' && typeof cruiseDurationPlaceholder === 'string' ? "(message : \"".concat(tourDurationPlaceholder, "\", cruiseMessage : \"").concat(cruiseDurationPlaceholder, "\")") : '';
  var timingDescriptionArgs = typeof cruiseTimingPlaceholder === 'string' && typeof dateFormat === 'string' ? "(message : \"".concat(cruiseTimingPlaceholder, "\" dateFormat : \"").concat(dateFormat, "\")") : '';
  return "\n    accommodationsIntroduction {\n      roomsCount\n    }\n    badgeIcon\n    childcareDetails {\n      ageInMonths {\n        min\n        max\n      }\n      id\n      included\n    }\n    color\n    comfort\n    comfortLabel\n    coordinates {\n      latitude\n      longitude\n    }\n    destination {\n      area\n      country\n    }\n    duration".concat(durationArgs, "\n    hasECSpace\n    href(offerName : \"").concat(offerName, "\")\n    id\n    images\n    isCruise\n    isDoubleSeason\n    isExclusiveCollection\n    isExplicitEC\n    isJoyview\n    isResort\n    isSummer\n    isTour\n    isVilla\n    isWinter\n    minAuthorizedAge {\n      value\n    }\n    ").concat(isMice ? "productMeetingRooms {\n      meetingRooms {\n        shapes {\n          maxCapacity\n        }\n      }\n    }" : '', "\n    name\n    openingStatus\n    rangeId\n    rangeLabel\n    resortId\n    seasonName\n    seasonTrad(").concat(generateCmsArgs(content, release), ")\n    tags {\n      backgroundColor\n      textColor\n      title\n    }\n    thematics {\n      label\n    }\n    timingDescription").concat(timingDescriptionArgs, "\n    title\n    transportType\n    type");
}

function cleanupArgs(args) {
  return {
    content: args.content || '',
    isMice: args.isMice,
    release: args.release || '',
    cruiseTimingPlaceholder: args.cruiseTimingPlaceholder,
    cruiseDurationPlaceholder: args.cruiseDurationPlaceholder,
    date: args.date || '',
    dateFormat: args.dateFormat,
    departureCity: args.departureCity || '',
    duration: args.duration || null,
    dateStart: args.dateStart || '',
    dateEnd: args.dateEnd || '',
    forceWithoutTransport: !!args.forceWithoutTransport,
    offerId: args.offerId || '',
    offerName: args.offerName || '',
    optimizedPriceCalls: args.optimizedPriceCalls || false,
    tourDurationPlaceholder: args.tourDurationPlaceholder
  };
}

function makeResortThumbnailQuery(args, options) {
  var _ref = options || {},
      _ref$withoutPrice = _ref.withoutPrice,
      withoutPrice = _ref$withoutPrice === void 0 ? false : _ref$withoutPrice;

  var priceFields = !withoutPrice ? getPriceFields(cleanupArgs(args)) : '';
  return "".concat(getThumbnailBaseFields(cleanupArgs(args))).concat(priceFields);
}

/* harmony default export */ __webpack_exports__["b"] = (makeResortThumbnailQuery);

/***/ }),

/***/ "kNiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return serializeKidsToQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return synchronizeChildcareQPWithKidsQP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getKidAgeInMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customFacetsQueryParamMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return facetsQueryParamMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getActiveFacetsFromQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return generateActiveFacetsQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasDepartureCityAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return filterFacetsToHide; });
/* unused harmony export findFacetCategoryById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatDepartureDateForStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getChildcareFacets; });
/* unused harmony export getChildren */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDepartureCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDepartureDateDisplayValue; });
/* unused harmony export getFormattedDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getInactiveFacetValues; });
/* unused harmony export getSelectedDepartureCity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isDateInThePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isKidMinor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return unserializeKidsFromQueryParam; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("yyme");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("4mDm");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Rfxz");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("i6QF");
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("YGK4");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("PKPk");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("EnZy");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("3bBZ");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("zygG");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("15pl");
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(lodash_times__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("wQ38");
/* harmony import */ var _uri_constants__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("Sj1w");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("sW3P");
































var _facetsQueryParamMapp;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






function findFacetCategoryById(facets, facetCategoryId) {
  return facets.find(function (facetCategory) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(facetCategory, 'id') === facetCategoryId;
  });
}

function _getFacetValues(facets, categoryId) {
  var category = findFacetCategoryById(facets, categoryId);
  return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(category, 'list', []);
}

function getChildcareFacets(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_CRITERIA_FACET_ID */ "d"]);
}

function getDepartureCities(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DEPARTURE_CITY_FACET_ID */ "r"]);
}

function getInactiveFacetValues(facets, activeFacets, facetId) {
  var _matchingFacet$list$m, _matchingFacet$list, _activeFacets$facetId;

  var _facets$filter = facets.filter(function (_ref) {
    var id = _ref.id;
    return id === facetId;
  }),
      _facets$filter2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_facets$filter, 1),
      matchingFacet = _facets$filter2[0];

  var matchingFacetValues = (_matchingFacet$list$m = matchingFacet === null || matchingFacet === void 0 ? void 0 : (_matchingFacet$list = matchingFacet.list) === null || _matchingFacet$list === void 0 ? void 0 : _matchingFacet$list.map(function (_ref2) {
    var value = _ref2.value;
    return value;
  })) !== null && _matchingFacet$list$m !== void 0 ? _matchingFacet$list$m : [];
  var matchingActiveFacetValues = Object.keys((_activeFacets$facetId = activeFacets[facetId]) !== null && _activeFacets$facetId !== void 0 ? _activeFacets$facetId : {});
  return matchingFacetValues.filter(function (option) {
    return !matchingActiveFacetValues.includes(option);
  });
}

function filterFacetsToHide(facets, facetsToHide) {
  var facetIdsWithOptionsToHide = Object.keys(facetsToHide !== null && facetsToHide !== void 0 ? facetsToHide : {});
  return facets.map(function (facet) {
    if (facetIdsWithOptionsToHide.includes(facet.id)) {
      return _objectSpread(_objectSpread({}, facet), {}, {
        list: facet.list.filter(function (_ref3) {
          var value = _ref3.value;
          return !facetsToHide[facet.id].includes(value);
        })
      });
    }

    return facet;
  });
}

function getSelectedDepartureCity(facets) {
  var selectedCity = getDepartureCities(facets).find(function (facet) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(facet, 'selected');
  });
  return selectedCity ? lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(selectedCity, 'name') : null;
}

function formatDepartureDateForStore(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"];
  return date !== null ? moment__WEBPACK_IMPORTED_MODULE_31___default()(date, format).valueOf() : null;
}

function getDepartureDateDisplayValue() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_31___default()(date);
  return momentDate.isValid() ? momentDate.format(_constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"]) : '';
}

function isDateInThePast(timestampDate) {
  return timestampDate ? moment__WEBPACK_IMPORTED_MODULE_31___default()(timestampDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_31___default()(), 'day') : false;
}

function getFormattedDepartureDate(date, dateFormat) {
  return date ? moment__WEBPACK_IMPORTED_MODULE_31___default()(date).format(dateFormat) : '';
}

function isKidMinor(birthdate) {
  if (!birthdate) {
    return false;
  }

  var minBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()().subtract(18, 'years');
  var momentBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate);
  return momentBirthdate.isValid() && momentBirthdate.isBetween(minBirthdate, moment__WEBPACK_IMPORTED_MODULE_31___default()());
}

function getChildren(numberOfChildren, childrenBirthdates) {
  if (Number.isInteger(numberOfChildren) && numberOfChildren >= 0 && numberOfChildren <= _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX */ "G"]) {
    return lodash_times__WEBPACK_IMPORTED_MODULE_30___default()(numberOfChildren, function (idx) {
      return childrenBirthdates && childrenBirthdates.length > idx ? {
        birthdate: moment__WEBPACK_IMPORTED_MODULE_31___default()(childrenBirthdates[idx], 'YYYYMMDD', true).valueOf(),
        childcareIncluded: false
      } : {
        childcareIncluded: false
      };
    });
  }

  return null;
}

function convertQueryParamToKids(value) {
  if (!value) {
    return [];
  }

  return value.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_KIDS_DELIMITER */ "k"]).map(function (serializedKidString) {
    var hasChildcareFlag = serializedKidString.substr(-1) === _uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"];
    var strBirthdate = serializedKidString.replace(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"], '');
    var birthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(strBirthdate, _uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DATE_FORMAT */ "f"], true);
    var childcareIncluded = birthdate.isValid() ? hasChildcareFlag : _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"].childcareIncluded;
    return _objectSpread(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"]), {}, {
      childcareIncluded: childcareIncluded,
      birthdate: birthdate.isValid() ? birthdate.valueOf() : undefined
    });
  });
}

function convertKidsToChildcareQueryParam(_ref4) {
  var departureDate = _ref4.departureDate,
      kids = _ref4.kids;

  if (!departureDate) {
    return [];
  }

  return kids.reduce(function (acc, _ref5) {
    var birthdate = _ref5.birthdate;
    return birthdate ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(acc), [moment__WEBPACK_IMPORTED_MODULE_31___default()(departureDate).diff(moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate), 'months')]) : acc;
  }, []).map(function (diffInMonths) {
    if (diffInMonths >= 4 && diffInMonths < 24) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_0_TO_2 */ "i"];
    }

    if (diffInMonths >= 24 && diffInMonths < 48) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_2_TO_3 */ "k"];
    }

    if (diffInMonths >= 48 && diffInMonths < 132) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_4_TO_10 */ "l"];
    }

    if (diffInMonths >= 132 && diffInMonths < 216) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_11_TO_17 */ "j"];
    }

    return '';
  }).filter(Boolean);
}

function unserializeKidsFromQueryParam(value, isSeller) {
  var maxKidsNumber = isSeller ? _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX_SELLER */ "H"] : _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX */ "G"];

  if (!value) {
    return [];
  }

  var kidsNumber = Number(value); // NOTE: DO NOT USE parseInt() !!! parseInt('2010-12-10c') will return 2010 ...

  if (kidsNumber > maxKidsNumber) {
    return [];
  }

  if (Number.isInteger(kidsNumber)) {
    return new Array(kidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"]));
  }

  var kids = convertQueryParamToKids(value);
  return kids.length > maxKidsNumber ? [] : kids;
}
/**
 * Helper to serialize kids array as a URI query parameter.
 *
 * Example of returns:
 *
 * - `kids=1` (1 kid, no birthdate)
 * - `kids=2010-10-30` (1 kid, with birthdate)
 * - `kids=_` (2 kids)
 * - `kids=2010-10-30=_` (2 kids, 1 birthdate)
 * - `kids=2010-10-30c=___`
 * - `kids=2010-10-30c_2009-04-01!`
 */


var serializeKidsToQueryParam = function serializeKidsToQueryParam(params) {
  var kids = params.kids,
      kidsValidationState = params.kidsValidationState;
  var serializedKids = kids.map(function (_ref6, index) {
    var birthdate = _ref6.birthdate,
        childcareIncluded = _ref6.childcareIncluded;

    if (!birthdate || !kidsValidationState || (kidsValidationState === null || kidsValidationState === void 0 ? void 0 : kidsValidationState.length) > 0 && kidsValidationState[index] !== _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* VALIDATION_STATE_ENUM */ "f"].valid) {
      return '';
    }

    var formattedBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate).format(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DATE_FORMAT */ "f"]);
    return childcareIncluded ? "".concat(formattedBirthdate).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"]) : formattedBirthdate;
  }).filter(function (birthdate) {
    return birthdate !== '';
  }); // Special case when there is only one kid, as we can't make a join('_') with only one item

  var serializedOutput = '';

  if (serializedKids.length === 1) {
    if (serializedKids.filter(Boolean).length === 0) {
      serializedOutput = '1';
    } // Return kid's birthdate


    if (serializedOutput !== '1') {
      serializedOutput = serializedKids.shift();
    }

    var childcareIncluded = kids.some(function (kid) {
      return kid.childcareIncluded;
    });
    return childcareIncluded ? "".concat(serializedOutput).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"]) : serializedOutput;
  }

  return serializedKids.join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_KIDS_DELIMITER */ "k"]);
};
var synchronizeChildcareQPWithKidsQP = function synchronizeChildcareQPWithKidsQP(_ref7) {
  var childcareFacetQueryParam = _ref7.childcareFacetQueryParam,
      departureDate = _ref7.departureDate,
      departureDateQueryParam = _ref7.departureDateQueryParam,
      kids = _ref7.kids,
      _ref7$kidsQueryParam = _ref7.kidsQueryParam,
      kidsQueryParam = _ref7$kidsQueryParam === void 0 ? '' : _ref7$kidsQueryParam;
  var previousDepartureDate = formatDepartureDateForStore(departureDateQueryParam, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"]);
  var previousKids = convertQueryParamToKids(kidsQueryParam);
  var previousChildcareIncluded = previousKids.some(function (kid) {
    return kid.childcareIncluded;
  });
  var childcareIncluded = kids.some(function (kid) {
    return kid.childcareIncluded;
  });

  if (!childcareIncluded && !previousChildcareIncluded) {
    // childcareIncluded checkbox unchecked and unchanged => no override
    return undefined;
  }

  var childcareRemoved = previousChildcareIncluded && !childcareIncluded;
  var kidsRemoved = previousKids.length > 0 && kids.length === 0;

  if (childcareRemoved || kidsRemoved) {
    // childcareIncluded checkbox unchecked or kids removed from FilterWho => reset childcare filter
    return '';
  } // childcareIncluded checkbox checked => override childcare filter with matching kids age range and existing childcare options


  var childcareFilterOptionsFromPreviousKids = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set(convertKidsToChildcareQueryParam({
    departureDate: previousDepartureDate,
    kids: previousKids
  })));

  var childcareFilterOptionsFromKids = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set(convertKidsToChildcareQueryParam({
    departureDate: departureDate,
    kids: kids
  })));

  var childcareFilterOptionsToRemove = childcareFilterOptionsFromPreviousKids.filter(function (option) {
    return !childcareFilterOptionsFromKids.includes(option);
  });
  var chilcareFilterOptions = childcareFacetQueryParam.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]);
  return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set([].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(childcareFilterOptionsFromKids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(chilcareFilterOptions.filter(function (option) {
    return !childcareFilterOptionsToRemove.includes(option);
  }))))).filter(Boolean).join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]);
};
var getKidAgeInMonths = function getKidAgeInMonths(_ref8) {
  var birthdate = _ref8.birthdate,
      departureDate = _ref8.departureDate;
  var defaultDepartureDate = moment__WEBPACK_IMPORTED_MODULE_31___default()().add(_constants__WEBPACK_IMPORTED_MODULE_34__[/* DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH */ "s"], 'months').valueOf();
  var b = birthdate ? moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate) : moment__WEBPACK_IMPORTED_MODULE_31___default()().subtract(8, 'y');
  return moment__WEBPACK_IMPORTED_MODULE_31___default()(departureDate || defaultDepartureDate).diff(b, 'months');
};
var customFacetsQueryParamMapping = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, _constants__WEBPACK_IMPORTED_MODULE_34__[/* FLIGHT_DURATION_FACET_ID */ "C"], 'f');
var facetsQueryParamMapping = (_facetsQueryParamMapp = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* ACTIVITIES_FACET_ID */ "a"], 'a'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_ID */ "f"], 'ch'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* COUNTRIES_FACET_ID */ "m"], 'c'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DESTINATIONS_FACET_ID */ "w"], 'd'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "S"], 's'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* TYPES_OF_STAY_FACET_ID */ "ab"], 't'), _facetsQueryParamMapp);
var getActiveFacetsFromQueryParams = function getActiveFacetsFromQueryParams(queryParams, queryParamMapping) {
  return Object.keys(queryParamMapping).reduce(function (facets, facetId) {
    var _queryParams$queryPar;

    var activeFacets = ((_queryParams$queryPar = queryParams[queryParamMapping[facetId]]) === null || _queryParams$queryPar === void 0 ? void 0 : _queryParams$queryPar.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"])) || [];
    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, facetId, activeFacets.reduce(function (acc, activeFacet) {
      var facet = decodeURI(activeFacet);

      if (facetId === _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "S"]) {
        var _SEASON_FACET_QUERY_P;

        facet = (_SEASON_FACET_QUERY_P = _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_QUERY_PARAM_EN_TO_FR */ "V"][facet]) !== null && _SEASON_FACET_QUERY_P !== void 0 ? _SEASON_FACET_QUERY_P : facet;
      }

      acc[facet] = true;
      return acc;
    }, {})));
    return facets;
  }, {});
};
var generateActiveFacetsQueries = function generateActiveFacetsQueries(activeFacets, queryParamMapping) {
  return Object.keys(queryParamMapping).reduce(function (facets, facetId) {
    var facet = Object.keys(activeFacets[facetId] || {});

    if (facet.length && facetId === _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "S"]) {
      facet = facet.map(function (label) {
        var _SEASON_FACET_QUERY_P2;

        return (_SEASON_FACET_QUERY_P2 = _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_QUERY_PARAM_FR_TO_EN */ "W"][label]) !== null && _SEASON_FACET_QUERY_P2 !== void 0 ? _SEASON_FACET_QUERY_P2 : label;
      });
    }

    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, queryParamMapping[facetId], facet.length ? facet.join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]) : undefined));
    return facets;
  }, {});
};
var hasDepartureCityAvailable = function hasDepartureCityAvailable(departureCities, departureCity) {
  return departureCities === null || departureCities === void 0 ? void 0 : departureCities.some(function (_ref9) {
    var value = _ref9.value;
    return value === departureCity;
  });
};


/***/ }),

/***/ "kWb8":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"Agrave\":\"À\",\"agrave\":\"à\",\"amp\":\"&\",\"AMP\":\"&\",\"Aring\":\"Å\",\"aring\":\"å\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"brvbar\":\"¦\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"cedil\":\"¸\",\"cent\":\"¢\",\"copy\":\"©\",\"COPY\":\"©\",\"curren\":\"¤\",\"deg\":\"°\",\"divide\":\"÷\",\"Eacute\":\"É\",\"eacute\":\"é\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"Egrave\":\"È\",\"egrave\":\"è\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"frac12\":\"½\",\"frac14\":\"¼\",\"frac34\":\"¾\",\"gt\":\">\",\"GT\":\">\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"iexcl\":\"¡\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"iquest\":\"¿\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"laquo\":\"«\",\"lt\":\"<\",\"LT\":\"<\",\"macr\":\"¯\",\"micro\":\"µ\",\"middot\":\"·\",\"nbsp\":\" \",\"not\":\"¬\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ordf\":\"ª\",\"ordm\":\"º\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"para\":\"¶\",\"plusmn\":\"±\",\"pound\":\"£\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"raquo\":\"»\",\"reg\":\"®\",\"REG\":\"®\",\"sect\":\"§\",\"shy\":\"­\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"szlig\":\"ß\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"times\":\"×\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uml\":\"¨\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"yen\":\"¥\",\"yuml\":\"ÿ\"}");

/***/ }),

/***/ "kWbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackQueryChange; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("EkOT");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sRdV");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zwLB");









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





var useTrackQueryChange = function useTrackQueryChange() {
  var pageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_9__[/* usePageContext */ "b"])();
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__[/* useTracking */ "a"])();

  var executeTracking = function executeTracking(query, payload) {
    if (query) {
      var isFromAutoComplete = Boolean(query.type);
      track(_objectSpread({
        categoryGA: pageContext.pageId,
        actionGA: 'search',
        labelGA: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_11__[/* getSearchMappedTypeForLabelGA */ "d"])(query.type),
        internalSearchEngineNbResults: '',
        searchReferrer: pageContext.pageId,
        searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
        searchTerms: query.label || null
      }, payload));
    }
  };

  return executeTracking;
};

/***/ }),

/***/ "loSl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return toggleFacet; });
/* unused harmony export changeKids */
/* unused harmony export changeKidsNumberWith */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeKidsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeDepartureCity; });
/* unused harmony export changeDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return clearTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setInitialProductPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setKidsValidationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetRedirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setCustomFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return updateCustomFilters; });
/* unused harmony export resetCustomFilters */
/* unused harmony export setFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setSearchFilterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return updateFilters; });
/* unused harmony export resetFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resetCriteria; });
/* unused harmony export setIsDateRequired */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setProductsFilteredWithActiveCustomFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setProductsBeforeActiveCustomFacetsFiltering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setIsSearchEnabled; });
/* unused harmony export setOrderByPrice */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("15pl");
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_times__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("uDfI");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("rJ95");
/* harmony import */ var _search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("0ibg");
/* harmony import */ var _search_search_selector__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("B3yO");
/* harmony import */ var _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("wQ38");
/* harmony import */ var _trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("1bWg");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("fflk");
/* harmony import */ var _trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("+mhw");
/* harmony import */ var _trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("C5R2");
/* harmony import */ var _trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("RBvG");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("Jsmy");
/* harmony import */ var _faceting_selector__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("vIa8");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("9QcM");

















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}















function setActiveFacet(categoryId, value, isSelected) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_TOGGLE_FACET_SELECTED */ "x"], {
    categoryId: categoryId,
    value: value,
    isSelected: isSelected
  });
}

function toggleFacet(_ref) {
  var categoryId = _ref.categoryId,
      isSelected = _ref.isSelected,
      value = _ref.value;
  return setActiveFacet(categoryId, value, isSelected);
}
function changeKids(value) {
  return function (dispatch, getState) {
    var oldKids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_26__[/* getKids */ "c"])(getState());
    var newKids = value.map(function (kid, index) {
      return _objectSpread(_objectSpread({}, kid), {}, {
        neolid: lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(oldKids, "[".concat(index, "].neolid"))
      });
    });
    return dispatch(Object(_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_21__[/* setKids */ "b"])(newKids));
  };
}

function _changeKidsSize(kids, newSize) {
  var emptyKids = lodash_times__WEBPACK_IMPORTED_MODULE_14___default()(newSize - kids.length, function () {
    return _objectSpread({}, _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_20__[/* DEFAULT_KID_VALUE */ "a"]);
  });

  if (newSize < kids.length) {
    return kids.slice(0, newSize);
  }

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(kids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(emptyKids));
} // use this export when testing.


var changeKidsNumberWith = function changeKidsNumberWith(changeKidsFunc) {
  return function changeKidsNumber(value) {
    return function (dispatch, getState) {
      var kids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_26__[/* getKids */ "c"])(getState());

      var newKids = _changeKidsSize(kids, value);

      return dispatch(changeKidsFunc(newKids));
    };
  };
}; // use this export in app code.

var changeKidsNumber = changeKidsNumberWith(changeKids);
function changeDepartureCity(value) {
  return Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_23__[/* setDepartureCity */ "a"])({
    value: value
  });
}
function changeDepartureDate(_ref2) {
  var value = _ref2.value;
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureDate */ "a"])(value);
}
var clearDepartureDate = function clearDepartureDate() {
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureDate */ "a"])(null);
};
var setSearchQuery = function setSearchQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    label: ''
  };
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_SEARCH_QUERY */ "w"], {
    value: query
  });
};
function clearTripDuration() {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_25__[/* DEFAULT_NO_DURATION */ "a"]);
}
function changeSearchQuery(value) {
  return function (dispatch, getState) {
    var store = getState();
    var keywords = Object(_search_search_selector__WEBPACK_IMPORTED_MODULE_19__[/* keywordsSelector */ "a"])(store);
    var searchQuery = Object(_faceting_selector__WEBPACK_IMPORTED_MODULE_27__[/* searchQuerySelector */ "q"])(getState());
    Object(react_redux__WEBPACK_IMPORTED_MODULE_16__[/* batch */ "b"])(function () {
      if (keywords) {
        dispatch(Object(_search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_18__[/* setKeywords */ "a"])(''));
      }

      if (searchQuery.label !== value.label) {
        dispatch(setSearchQuery(value));
      }
    });
  };
}
function changeTripDuration(value) {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__[/* setDuration */ "a"])(value);
}
function setInitialProductPrices(initialProductPrices) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_INITIAL_PRICES */ "n"], {
    initialProductPrices: initialProductPrices
  });
}
function setKidsValidationState(kidsValidationState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_KIDS_VALIDATION_STATE */ "q"], {
    kidsValidationState: kidsValidationState
  });
}
function clearFacets(categoryId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_CLEAR_FACETS */ "c"], {
    categoryId: categoryId
  });
}
function clearAll() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_CLEAR_ALL */ "b"]);
}
function resetRedirection() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_REDIRECTION */ "i"]);
}
function resetSearch() {
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_SEARCH */ "j"])));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function setCustomFilters(customFilters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_CUSTOM_FILTERS */ "l"], {
    customFilters: customFilters
  });
}
function updateCustomFilters(customFilters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_UPDATE_CUSTOM_FILTERS */ "A"], {
    customFilters: customFilters
  });
}
function resetCustomFilters() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_CUSTOM_FILTERS */ "g"]);
}
function setFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_FILTERS */ "m"], {
    filters: filters
  });
}
function setSearchFilterList(searchFilterList) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_SEARCH_FILTERS */ "v"], {
    searchFilterList: searchFilterList
  });
}
function updateFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_UPDATE_FILTERS */ "B"], {
    filters: filters
  });
}
function resetFilters() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_FILTERS */ "h"]);
}
function resetCriteria() {
  return /*#__PURE__*/function () {
    var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee2(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_16__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_23__[/* setDepartureCity */ "a"])({
                  value: null
                }));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_25__[/* DEFAULT_NO_DURATION */ "a"]));
                dispatch(resetCustomFilters());
                dispatch(resetFilters());
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
}
function setIsDateRequired(isDateRequired) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_IS_DATE_REQUIRED */ "o"], {
    isDateRequired: isDateRequired
  });
}
function setProductsFilteredWithActiveCustomFacets(productsFilteredWithActiveCustomFacets) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS */ "t"], {
    productsFilteredWithActiveCustomFacets: productsFilteredWithActiveCustomFacets
  });
}
function setProductsBeforeActiveCustomFacetsFiltering(productsBeforeActiveCustomFacetsFiltering) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING */ "s"], {
    productsBeforeActiveCustomFacetsFiltering: productsBeforeActiveCustomFacetsFiltering
  });
}
function setIsSearchEnabled(isSearchEnabled) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_IS_SEARCH_ENABLED */ "p"], {
    isSearchEnabled: isSearchEnabled
  });
}
function setOrderByPrice(orderByPrice) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_ORDER_BY_PRICE */ "r"], {
    orderByPrice: orderByPrice
  });
}

/***/ }),

/***/ "mGvo":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("Dhk8"),
    isObjectLike = __webpack_require__("tLQN");

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ "n1ZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NUMBER_OF_TOP_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SearchFacets; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ToJy");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("yjkv");
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqBy__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var react_collapse__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("3OwS");
/* harmony import */ var react_collapse__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(react_collapse__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("uDfI");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("U2fG");
/* harmony import */ var _frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("EvYw");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("1JJ2");
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("RUiN");
/* harmony import */ var _FacetCategory__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("1xc2");
/* harmony import */ var _FacetList__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("YMTf");
/* harmony import */ var _SearchFacets_utils__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("zjU+");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("kiXb");
/* harmony import */ var _store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("loSl");
/* harmony import */ var _store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__("vIa8");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__("sW3P");
/* harmony import */ var _facet_search_results_search_results_SearchResults_utils__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__("bq+w");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__("E8Xq");
/* harmony import */ var _HeaderLayerContent__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__("J9nQ");



















var __jsx = react__WEBPACK_IMPORTED_MODULE_19___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























var NUMBER_OF_TOP_FACETS = 7;

var getTopFacets = function getTopFacets(facets, id, activeFacets) {
  var _facets$find, _facets$find2, _facets$find3, _facets$find4, _facets$find5, _facets$find6, _facets$find7;

  switch (id) {
    case _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* ACTIVITIES_FACET_ID */ "a"]:
      var selectedActivities = Object.keys(activeFacets[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* ACTIVITIES_FACET_ID */ "a"]] || {});
      return (_facets$find = facets.find(function (facet) {
        return facet.id === id;
      })) === null || _facets$find === void 0 ? void 0 : _facets$find.list.reduce(function (acc, cur) {
        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(acc), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(cur.list || []));
      }, []).sort(function (facetA, facetB) {
        return Number(facetB.count) - Number(facetA.count);
      }).sort(function (facetA, facetB) {
        return Number(selectedActivities.includes(facetB.value)) - Number(selectedActivities.includes(facetA.value));
      });

    case _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* CHILDCARE_FILTER_FACET_ID */ "f"]:
      return (_facets$find2 = facets.find(function (facet) {
        return facet.id === id;
      })) === null || _facets$find2 === void 0 ? void 0 : _facets$find2.list.map(function (facet) {
        var label = Object(_SearchFacets_utils__WEBPACK_IMPORTED_MODULE_32__[/* getFacetLocalizedLabel */ "b"])({
          facetValue: facet.value,
          facetLabels: _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* CHILDCARE_FILTER_FACET_LABELS */ "g"]
        });
        return _objectSpread(_objectSpread({}, facet), {}, {
          label: label
        });
      });

    case _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* DESTINATIONS_FACET_ID */ "w"]:
      var selectedCountries = Object.keys(activeFacets[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* COUNTRIES_FACET_ID */ "m"]] || {});
      return lodash_uniqBy__WEBPACK_IMPORTED_MODULE_18___default()((_facets$find3 = facets.find(function (facet) {
        return facet.id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* COUNTRIES_FACET_ID */ "m"];
      })) === null || _facets$find3 === void 0 ? void 0 : _facets$find3.list.reduce(function (acc, cur) {
        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(acc), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(cur.list || []));
      }, []).sort(function (facetA, facetB) {
        return Number(selectedCountries.includes(facetB.value)) - Number(selectedCountries.includes(facetA.value));
      }), function (facet) {
        return facet.value;
      });

    case _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* FLIGHT_DURATION_FACET_ID */ "C"]:
      return (_facets$find4 = facets.find(function (facet) {
        return facet.id === id;
      })) === null || _facets$find4 === void 0 ? void 0 : _facets$find4.list.map(function (facet) {
        var label = Object(_SearchFacets_utils__WEBPACK_IMPORTED_MODULE_32__[/* getFacetLocalizedLabel */ "b"])({
          facetValue: facet.value,
          facetLabels: _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* FLIGHT_DURATION_FACET_LABELS */ "D"]
        });
        return _objectSpread(_objectSpread({}, facet), {}, {
          label: label
        });
      });

    case _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* SEASON_FACET_ID */ "S"]:
      return (_facets$find5 = facets.find(function (facet) {
        return facet.id === id;
      })) === null || _facets$find5 === void 0 ? void 0 : _facets$find5.list.map(function (facet) {
        var label = Object(_SearchFacets_utils__WEBPACK_IMPORTED_MODULE_32__[/* getFacetLocalizedLabel */ "b"])({
          facetValue: facet.value,
          facetLabels: _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* SEASON_FACET_LABELS */ "T"]
        });
        return _objectSpread(_objectSpread({}, facet), {}, {
          label: label
        });
      }).sort(function (facetA) {
        return facetA.value === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* SEASON_FACET_FIRST_OPTION */ "R"] ? -1 : 1;
      });

    case _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* TYPES_OF_STAY_FACET_ID */ "ab"]:
      return (_facets$find6 = facets.find(function (facet) {
        return facet.id === id;
      })) === null || _facets$find6 === void 0 ? void 0 : _facets$find6.list.map(function (facet) {
        var label = Object(_SearchFacets_utils__WEBPACK_IMPORTED_MODULE_32__[/* getFacetLocalizedLabel */ "b"])({
          facetValue: facet.label,
          facetLabels: _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* TYPES_OF_STAY_FACET_LABELS */ "bb"]
        });
        return _objectSpread(_objectSpread({}, facet), {}, {
          badgeIconProps: Object(_SearchFacets_utils__WEBPACK_IMPORTED_MODULE_32__[/* getTypesOfStayFacetBadgeIconProps */ "d"])({
            facetBadgeIcons: _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* TYPES_OF_STAY_FACET_BADGE_ICON_PROPS */ "Z"],
            facetLabel: label,
            facetValue: facet.label
          }),
          label: label
        });
      });

    default:
      return (_facets$find7 = facets.find(function (facet) {
        return facet.id === id;
      })) === null || _facets$find7 === void 0 ? void 0 : _facets$find7.list;
  }
};

var SearchFacets = function SearchFacets(props) {
  var activeCustomFacets = props.activeCustomFacets,
      activeFacets = props.activeFacets,
      facets = props.facets,
      _props$facetTemplateC = props.facetTemplateConfig,
      facetTemplateConfig = _props$facetTemplateC === void 0 ? [] : _props$facetTemplateC;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_19__["useState"])(false),
      isLayerOpened = _useState[0],
      setIsLayerOpened = _useState[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_21__[/* useDispatch */ "d"])();

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_28__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var products = Object(react_redux__WEBPACK_IMPORTED_MODULE_21__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_35__[/* filteredProductsSelector */ "i"])(state) || [];
  });
  var productsBeforeActiveCustomFacetsFiltering = Object(react_redux__WEBPACK_IMPORTED_MODULE_21__[/* useSelector */ "e"])(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_35__[/* productsBeforeActiveCustomFacetsFilteringSelector */ "o"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_36__[/* useTracking */ "a"])();
  var productsWithoutCustomFacetFiltering = productsBeforeActiveCustomFacetsFiltering !== null ? productsBeforeActiveCustomFacetsFiltering : products;
  var inactiveFlightDurationFacets = Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_39__[/* getInactiveFacetValues */ "j"])(facets, activeCustomFacets, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* FLIGHT_DURATION_FACET_ID */ "C"]);
  var flightDurationFacetsToHide = inactiveFlightDurationFacets.filter(function (facet) {
    var remainingProducts = Object(_facet_search_results_search_results_SearchResults_utils__WEBPACK_IMPORTED_MODULE_38__[/* filterProductsByFlightDuration */ "a"])({
      facet: facet,
      productList: productsWithoutCustomFacetFiltering
    });
    return remainingProducts.length === 0;
  });
  var filteredFacets = Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_39__[/* filterFacetsToHide */ "c"])(facets, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])({}, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* FLIGHT_DURATION_FACET_ID */ "C"], flightDurationFacetsToHide));

  var setSearchFilter = function setSearchFilter() {
    var searchFilterList = {};
    facetTemplateConfig.forEach(function (templateConfig) {
      var _getTopFacets;

      var dataLabel = templateConfig.dataLabel,
          id = templateConfig.id,
          titleLabel = templateConfig.titleLabel;
      var topFacets = (_getTopFacets = getTopFacets(filteredFacets, id, activeFacets)) !== null && _getTopFacets !== void 0 ? _getTopFacets : [];

      if (topFacets.length > 0) {
        var _activeCustomFacets$t, _activeFacets$topFace;

        // $FlowFixMe
        var topFacetsId = id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* DESTINATIONS_FACET_ID */ "w"] ? _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* COUNTRIES_FACET_ID */ "m"] : id;
        var activeCount = _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* CUSTOM_FACETS_IDS */ "n"].includes(topFacetsId) ? Object.keys((_activeCustomFacets$t = activeCustomFacets === null || activeCustomFacets === void 0 ? void 0 : activeCustomFacets[topFacetsId]) !== null && _activeCustomFacets$t !== void 0 ? _activeCustomFacets$t : {}).length : Object.keys((_activeFacets$topFace = activeFacets === null || activeFacets === void 0 ? void 0 : activeFacets[topFacetsId]) !== null && _activeFacets$topFace !== void 0 ? _activeFacets$topFace : {}).length;
        searchFilterList[topFacetsId] = {
          activeCount: activeCount,
          dataLabel: dataLabel,
          title: titleLabel,
          topFacets: topFacets
        };
      }
    });
    dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_34__[/* setSearchFilterList */ "r"])(searchFilterList));
  };

  Object(react__WEBPACK_IMPORTED_MODULE_19__["useEffect"])(function () {
    setSearchFilter();
  }, [activeCustomFacets, activeFacets, JSON.stringify(facetTemplateConfig), JSON.stringify(filteredFacets)]);

  var changeFacet = function changeFacet(name, checked, value) {
    var labelGA = Object(_SearchFacets_utils__WEBPACK_IMPORTED_MODULE_32__[/* trackFacetChange */ "f"])(name, checked, value);

    if (labelGA) {
      track({
        actionGA: 'smartCriterias',
        labelGA: labelGA
      });
    }

    props.toggleFacet({
      categoryId: name,
      isSelected: checked,
      value: value
    });
    Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_29__[/* scrollToElement */ "a"])('.Line-ProductsFilters', 250, '.Navigation-bar');
  };

  var activeCustomFacetCount = activeCustomFacets ? Object.keys(activeCustomFacets).map(function (key) {
    return Object.keys(activeCustomFacets[key]).length;
  }).reduce(function (a, b) {
    return a + b;
  }, 0) : 0;
  var activeFacetCount = activeFacets ? Object.keys(activeFacets).map(function (key) {
    return Object.keys(activeFacets[key]).length;
  }).reduce(function (a, b) {
    return a + b;
  }, 0) : 0;
  var totalActiveCount = activeCustomFacetCount + activeFacetCount;

  var headerContent = __jsx(_HeaderLayerContent__WEBPACK_IMPORTED_MODULE_41__[/* HeaderLayerContent */ "a"], {
    activeCount: totalActiveCount,
    title: Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('faceting.filters.filtersTitle')
  });

  var resetButton = __jsx("button", {
    className: "font-sans ms-auto self-baseline text-14 hocus:text-black-active underline",
    onClick: props.clearAll,
    type: "button"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('common.comparator.resetCriteria'));

  var header = __jsx("div", {
    className: "border-b-1 border-lightGrey flex font-bold gap-5 items-center px-20 py-15 text-20"
  }, headerContent, resetButton);

  var getFacetBlocks = function getFacetBlocks() {
    return facetTemplateConfig.map(function (templateConfig) {
      var id = templateConfig.id,
          titleLabel = templateConfig.titleLabel;
      var title = Object(_utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_40__[/* capitalizeFromUppercase */ "b"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])(titleLabel));

      if (id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* FLIGHT_DURATION_FACET_ID */ "C"]) {
        var _flightDurationFacet$;

        var flightDurationFacet = filteredFacets.find(function (facet) {
          return facet.id === id;
        });
        var flightDurationFacetOptions = (_flightDurationFacet$ = flightDurationFacet === null || flightDurationFacet === void 0 ? void 0 : flightDurationFacet.list) !== null && _flightDurationFacet$ !== void 0 ? _flightDurationFacet$ : [];

        if (flightDurationFacetOptions.length === 0) {
          return null;
        }
      }

      return __jsx(FacetBlock, {
        key: id,
        title: title,
        templateConfig: templateConfig,
        id: id,
        onChange: changeFacet,
        facets: filteredFacets,
        activeCustomFacets: activeCustomFacets,
        activeFacets: activeFacets,
        headerContent: headerContent,
        clearFacetList: props.clearFacetList
      });
    }).filter(Boolean);
  };

  return isDesktop ? __jsx("div", {
    className: "border-e-1 border-lightGrey sm:w-1/3 lg:min-w-1/4"
  }, header, getFacetBlocks()) : __jsx(react__WEBPACK_IMPORTED_MODULE_19__["Fragment"], null, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__[/* Button */ "a"], {
    className: "w-full order-first",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_26__[/* COLORS */ "a"].DARK_GREY,
    colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_26__[/* COLORS */ "a"].WHITE,
    colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_26__[/* COLORS */ "a"].GREY,
    iconRight: {
      name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_27__[/* ICONS */ "a"].FILTERS
    },
    minWidth: "auto",
    onClick: function onClick() {
      setIsLayerOpened(true);
      track({
        actionGA: 'smartCriterias',
        labelGA: 'CTA_mobile'
      });
    }
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('faceting.filters.filtersButton')), isLayerOpened && __jsx(_frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_24__[/* Layer */ "b"], {
    ariaLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('faceting.filters.filtersTitle'),
    bgColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_26__[/* COLORS */ "a"].WHITE,
    buttonLeft: {
      iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_27__[/* ICONS */ "a"].ARROW_TAIL_LEFT,
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('common.backNavigation'),
      onClick: function onClick() {
        setIsLayerOpened(false);
      },
      className: 'flex-1'
    },
    buttonRight: {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('common.comparator.resetCriteria'),
      onClick: function onClick() {
        return props.clearAll();
      },
      className: 'text-14 underline'
    },
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('common.close'),
    header: __jsx("div", {
      className: "flex font-bold justify-center text-18"
    }, headerContent),
    hasAnimateEnter: true,
    hideCloseButton: true
  }, __jsx("div", {
    className: "flex flex-col h-full"
  }, __jsx("div", {
    className: "scroll-y"
  }, getFacetBlocks()), __jsx("div", {
    className: "p-10 border-t mt-auto"
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__[/* Button */ "a"], {
    className: "w-full",
    dataTestId: "apply-filters",
    onClick: function onClick() {
      setIsLayerOpened(false);
    },
    size: "medium"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('common.apply'))))));
};

var FacetBlock = function FacetBlock(_ref) {
  var _activeCustomFacets$i, _activeFacets$id, _getTopFacets2;

  var title = _ref.title,
      templateConfig = _ref.templateConfig,
      facets = _ref.facets,
      onChange = _ref.onChange,
      activeCustomFacets = _ref.activeCustomFacets,
      activeFacets = _ref.activeFacets,
      id = _ref.id,
      headerContent = _ref.headerContent,
      clearFacetList = _ref.clearFacetList;

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_19__["useState"])(false),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_19__["useState"])(false),
      isModalOpened = _useState3[0],
      setIsModalOpened = _useState3[1];

  var _useResponsive2 = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_28__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive2.isDesktop;

  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_36__[/* useTracking */ "a"])();
  var currentCustomFacetActiveFilterList = Object.keys((_activeCustomFacets$i = activeCustomFacets[id]) !== null && _activeCustomFacets$i !== void 0 ? _activeCustomFacets$i : {});
  var currentFacetActiveFilterList = Object.keys((_activeFacets$id = activeFacets[id]) !== null && _activeFacets$id !== void 0 ? _activeFacets$id : {});
  Object(react__WEBPACK_IMPORTED_MODULE_19__["useEffect"])(function () {
    var currentCustomFacetHasActiveFilters = currentCustomFacetActiveFilterList.length > 0;
    var currentFacetHasActiveFilters = currentFacetActiveFilterList.length > 0;
    setIsExpanded(currentCustomFacetHasActiveFilters || currentFacetHasActiveFilters);
  }, [currentCustomFacetActiveFilterList.length, currentFacetActiveFilterList.length, id]);

  var facetCategoryComponent = __jsx("div", {
    className: "p-20 flex flex-col gap-y-20"
  }, __jsx(_FacetCategory__WEBPACK_IMPORTED_MODULE_30__[/* FacetCategory */ "a"], {
    templateConfig: templateConfig,
    facetsFromSearch: facets,
    onChange: onChange,
    activeCustomFacets: activeCustomFacets,
    activeFacets: activeFacets,
    key: id,
    name: id
  }));

  var ModalTagName = isDesktop ? _frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_25__[/* Modal */ "a"] : _frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_24__[/* Layer */ "b"];
  var modalProps = isDesktop ? {
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('common.close'),
    onClose: function onClose(e) {
      e.preventDefault();
      setIsModalOpened(false);
    },
    header: __jsx("div", {
      className: "leading-1 p-20 text-20 font-bold border-b border-lightGrey"
    }, title),
    hasCloseButton: true,
    size: 'medium',
    children: facetCategoryComponent
  } : {
    ariaLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('faceting.filters.filtersTitle'),
    buttonLeft: {
      iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_27__[/* ICONS */ "a"].ARROW_TAIL_LEFT,
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('common.backNavigation'),
      onClick: function onClick() {
        setIsModalOpened(false);
      },
      className: 'flex-1'
    },
    hideCloseButton: true,
    buttonRight: {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('common.comparator.resetCriteria'),
      onClick: function onClick() {
        return Object(_SearchFacets_utils__WEBPACK_IMPORTED_MODULE_32__[/* onClearFacets */ "e"])(clearFacetList, id, templateConfig);
      },
      className: 'text-14 underline'
    },
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('common.close'),
    header: __jsx("div", {
      className: "flex justify-center text-18"
    }, headerContent),
    hasAnimateEnter: true,
    bgColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_26__[/* COLORS */ "a"].WHITE,
    children: __jsx("div", {
      className: "flex flex-col h-full"
    }, __jsx("div", {
      className: "scroll-y"
    }, facetCategoryComponent), __jsx("div", {
      className: "p-10 border-t mt-auto"
    }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__[/* Button */ "a"], {
      className: "w-full",
      dataTestId: "apply-filters",
      onClick: function onClick() {
        setIsModalOpened(false);
      },
      size: "medium"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('common.apply'))))
  };
  var topFacets = (_getTopFacets2 = getTopFacets(facets, id, activeFacets)) !== null && _getTopFacets2 !== void 0 ? _getTopFacets2 : [];
  var topFacetsId = id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* DESTINATIONS_FACET_ID */ "w"] ? _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_37__[/* COUNTRIES_FACET_ID */ "m"] : id;
  var capitalizeLabels = templateConfig.capitalizeLabels,
      dataLabel = templateConfig.dataLabel;
  return __jsx("div", {
    className: "border-b-1 border-lightGrey px-20 py-30"
  }, __jsx("button", {
    className: "font-bold flex gap-10 items-center justify-between text-20 w-full",
    "data-testid": "".concat(dataLabel, "Filter"),
    onClick: function onClick() {
      if (!isExpanded) {
        track(Object(_SearchFacets_utils__WEBPACK_IMPORTED_MODULE_32__[/* getActiveFacetTabTrackingData */ "a"])({
          facetId: dataLabel,
          isActive: isExpanded
        }));
      }

      setIsExpanded(!isExpanded);
    },
    type: "button"
  }, __jsx("span", null, title), __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_23__[/* Icon */ "a"], {
    className: "shrink-0",
    rotation: isExpanded ? 0 : 180,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_27__[/* ICONS */ "a"].ARROW_TOP,
    width: "calc(12rem / 16)"
  })), __jsx(react_collapse__WEBPACK_IMPORTED_MODULE_20__["Collapse"], {
    theme: {
      collapse: 'collapse-transition',
      content: 'flex flex-col gap-y-20'
    },
    isOpened: isExpanded
  }, __jsx(_FacetList__WEBPACK_IMPORTED_MODULE_31__[/* FacetList */ "a"], {
    activeCustomFacets: activeCustomFacets[topFacetsId],
    activeFacets: activeFacets[topFacetsId],
    capitalizeLabels: capitalizeLabels,
    className: "mt-20",
    facets: topFacets.slice(0, NUMBER_OF_TOP_FACETS),
    key: topFacetsId,
    name: topFacetsId,
    onChange: onChange,
    isTopFacets: true
  }), topFacets.length > NUMBER_OF_TOP_FACETS && __jsx("button", {
    type: "button",
    onClick: function onClick() {
      track({
        actionGA: 'smartCriterias',
        labelGA: "".concat(dataLabel, "_seeMore")
      });
      setIsModalOpened(true);
    },
    className: "text-14 text-initial underline hocus:text-black-active"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_33__[/* t */ "h"])('faceting.filters.viewMoreFilters'))), isModalOpened && __jsx(ModalTagName, modalProps));
};

/***/ }),

/***/ "ngAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useDebounce; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // Our hook

function useDebounce(values, delay) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(values),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(values);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, values);
  return debouncedValue;
}

/***/ }),

/***/ "oW49":
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__("8PLQ"),
    legacyMap = __webpack_require__("kWb8"),
    xmlMap    = __webpack_require__("ZLJe"),
    decodeCodePoint = __webpack_require__("cHMM");

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),

/***/ "oWz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputSelect_InputSelect; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.themes.js

var themes = {
  "default": function _default(props) {
    return {
      thInputWrapper: 'relative w-full',
      thInput: 'h-full relative w-full',
      thPlaceholder: '',
      thCaret: classnames_default()('absolute flex h-full items-center pointer-events-none end-0 top-0', {
        'text-current': !props.isDisabled,
        'text-black': props.isDisabled
      })
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.jsx















var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }








var defaultProps = {
  caretIcon: icons["a" /* ICONS */].ARROW_DOWN,
  options: [],
  theme: 'default'
};
var InputSelect_InputSelect = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputSelect, _Component);

  var _super = _createSuper(InputSelect);

  function InputSelect(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputSelect);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? noop_default.a : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = e.target.value;

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? noop_default.a : _this$props$onClear;

      _this.setState({
        value: ''
      }, function () {
        return onClear(e);
      });
    });

    _this.state = {
      value: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputSelect, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = this.props.options;

      if (isEmpty_default()(options)) {
        return null;
      }

      return options.map(function (_ref2) {
        var isDisabled = _ref2.isDisabled,
            isSelected = _ref2.isSelected,
            label = _ref2.label,
            value = _ref2.value;
        return label ? __jsx("option", {
          disabled: isDisabled,
          key: label,
          label: label,
          selected: isSelected,
          value: value
        }, label) : null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          caretIcon = _this$props2.caretIcon,
          className = _this$props2.className,
          hasClear = _this$props2.hasClear,
          iconLeft = _this$props2.iconLeft,
          _this$props2$id = _this$props2.id,
          id = _this$props2$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputSelect_') : _this$props2$id,
          isDisabled = _this$props2.isDisabled,
          isFilled = _this$props2.isFilled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          isRequired = _this$props2.isRequired,
          label = _this$props2.label,
          name = _this$props2.name,
          notes = _this$props2.notes,
          onBlur = _this$props2.onBlur,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          placeholder = _this$props2.placeholder,
          theme = _this$props2.theme,
          validationState = _this$props2.validationState,
          dataTestId = _this$props2.dataTestId,
          inputId = _this$props2.inputId;
      var value = this.state.value;
      var hasClearEnabled = Boolean(hasClear && this.state.value);
      var hasValue = Boolean(value);
      var placeholderFormatted = Object(form_util["b" /* getFormattedLabel */])(placeholder, isRequired);

      var _themes$theme = themes[theme](this.props),
          thCaret = _themes$theme.thCaret,
          thInput = _themes$theme.thInput,
          thInputWrapper = _themes$theme.thInputWrapper,
          thPlaceholder = _themes$theme.thPlaceholder;

      return __jsx(FormControl["a" /* FormControl */], {
        className: className,
        hasClear: hasClearEnabled,
        id: id,
        iconLeft: iconLeft,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        theme: theme,
        validationState: validationState
      }, __jsx("div", {
        className: thInputWrapper
      }, __jsx("select", Object(esm_extends["a" /* default */])({
        className: thInput,
        disabled: Boolean(isDisabled || isLoading || isReadOnly),
        id: inputId ? inputId : id
      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        required: isRequired,
        value: value,
        "data-testid": dataTestId
      }), !!placeholderFormatted && __jsx("option", {
        className: thPlaceholder,
        label: placeholderFormatted,
        disabled: true,
        value: ""
      }, placeholderFormatted), this.getOptions()), !(isDisabled || isLoading || isReadOnly) && __jsx("div", {
        className: thCaret,
        "data-testid": "InputSelectCaret"
      }, __jsx(Icon["a" /* Icon */], {
        name: caretIcon,
        width: "0.75rem",
        dataTestid: caretIcon ? "caret-".concat(caretIcon) : ''
      }))));
    }
  }]);

  return InputSelect;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputSelect_InputSelect, "defaultProps", defaultProps);

/***/ }),

/***/ "ofBz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-string-prototype-matchall -- safe */
var $ = __webpack_require__("I+eb");
var call = __webpack_require__("xluM");
var uncurryThis = __webpack_require__("RiVN");
var createIteratorConstructor = __webpack_require__("3MOf");
var createIterResultObject = __webpack_require__("R1RC");
var requireObjectCoercible = __webpack_require__("HYAF");
var toLength = __webpack_require__("UMSQ");
var toString = __webpack_require__("V37c");
var anObject = __webpack_require__("glrk");
var isNullOrUndefined = __webpack_require__("cjT7");
var classof = __webpack_require__("xrYK");
var isRegExp = __webpack_require__("ROdP");
var getRegExpFlags = __webpack_require__("kNi0");
var getMethod = __webpack_require__("3Eq5");
var defineBuiltIn = __webpack_require__("yy0I");
var fails = __webpack_require__("0Dky");
var wellKnownSymbol = __webpack_require__("tiKp");
var speciesConstructor = __webpack_require__("SEBh");
var advanceStringIndex = __webpack_require__("iqWW");
var regExpExec = __webpack_require__("FMNM");
var InternalStateModule = __webpack_require__("afO8");
var IS_PURE = __webpack_require__("xDBR");

var MATCH_ALL = wellKnownSymbol('matchAll');
var REGEXP_STRING = 'RegExp String';
var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;
var stringIndexOf = uncurryThis(''.indexOf);
var nativeMatchAll = uncurryThis(''.matchAll);

var WORKS_WITH_NON_GLOBAL_REGEX = !!nativeMatchAll && !fails(function () {
  nativeMatchAll('a', /./);
});

var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
  setInternalState(this, {
    type: REGEXP_STRING_ITERATOR,
    regexp: regexp,
    string: string,
    global: $global,
    unicode: fullUnicode,
    done: false
  });
}, REGEXP_STRING, function next() {
  var state = getInternalState(this);
  if (state.done) return createIterResultObject(undefined, true);
  var R = state.regexp;
  var S = state.string;
  var match = regExpExec(R, S);
  if (match === null) {
    state.done = true;
    return createIterResultObject(undefined, true);
  }
  if (state.global) {
    if (toString(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
    return createIterResultObject(match, false);
  }
  state.done = true;
  return createIterResultObject(match, false);
});

var $matchAll = function (string) {
  var R = anObject(this);
  var S = toString(string);
  var C = speciesConstructor(R, RegExp);
  var flags = toString(getRegExpFlags(R));
  var matcher, $global, fullUnicode;
  matcher = new C(C === RegExp ? R.source : R, flags);
  $global = !!~stringIndexOf(flags, 'g');
  fullUnicode = !!~stringIndexOf(flags, 'u');
  matcher.lastIndex = toLength(R.lastIndex);
  return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
};

// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$({ target: 'String', proto: true, forced: WORKS_WITH_NON_GLOBAL_REGEX }, {
  matchAll: function matchAll(regexp) {
    var O = requireObjectCoercible(this);
    var flags, S, matcher, rx;
    if (!isNullOrUndefined(regexp)) {
      if (isRegExp(regexp)) {
        flags = toString(requireObjectCoercible(getRegExpFlags(regexp)));
        if (!~stringIndexOf(flags, 'g')) throw new $TypeError('`.matchAll` does not allow non-global regexes');
      }
      if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
      matcher = getMethod(regexp, MATCH_ALL);
      if (matcher === undefined && IS_PURE && classof(regexp) === 'RegExp') matcher = $matchAll;
      if (matcher) return call(matcher, regexp, O);
    } else if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
    S = toString(O);
    rx = new RegExp(regexp, 'g');
    return IS_PURE ? call($matchAll, rx, S) : rx[MATCH_ALL](S);
  }
});

IS_PURE || MATCH_ALL in RegExpPrototype || defineBuiltIn(RegExpPrototype, MATCH_ALL, $matchAll);


/***/ }),

/***/ "ontP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "FacetSearch", function() { return /* binding */ FacetSearch_FacetSearch; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("oVuX");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("5s+n");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("rB9j");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("JTJg");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("UxlC");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/router/useRouterEvents.js
var useRouterEvents = __webpack_require__("HAu2");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaContext.jsx
var CriteriaContext = __webpack_require__("XiOS");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/FacetSearch.utils.js
var FacetSearch_utils = __webpack_require__("hPQF");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackQueryChange.js
var useTrackQueryChange = __webpack_require__("kWbI");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackSearchResults.js
var useTrackSearchResults = __webpack_require__("NrqW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("ToJy");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isFunction.js
var isFunction = __webpack_require__("2q8g");
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("LKBx");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("mRH6");

// EXTERNAL MODULE: /opt/webapp/node_modules/striptags/striptags.js
var striptags = __webpack_require__("47go");
var striptags_default = /*#__PURE__*/__webpack_require__.n(striptags);

// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/hooks/use-autocomplete/useAutocomplete.js
var useAutocomplete = __webpack_require__("aUQU");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/client/store/search/query/searchQuery.action.js
var searchQuery_action = __webpack_require__("0ibg");

// EXTERNAL MODULE: ./src/client/store/search/search.selector.js
var search_selector = __webpack_require__("B3yO");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.jsx + 2 modules
var InputDatalist = __webpack_require__("wRBU");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-query/CriteriaQuery.jsx






var __jsx = react_default.a.createElement;




















var ItemLayout = function ItemLayout(_ref) {
  var label = _ref.label;

  if (!label) {
    return null;
  }

  return __jsx("div", {
    className: "hocus:bg-black cursor-pointer flex items-center overflow-hidden py-15 hocus:text-white transition-colors duration-250 ease-in p-10"
  }, __jsx("span", {
    className: "decorator-match font-sans text-12 truncate"
  }, label));
};

var ItemTitle = function ItemTitle(_ref2) {
  var title = _ref2.title;
  return __jsx("div", {
    className: "text-sienna text-10 font-sans font-bold py-10"
  }, title);
};

var edito = 'edito';
var CriteriaQuery_CriteriaQuery = function CriteriaQuery(props) {
  var _suggestedRequests$it;

  var _onFocus = props.onFocus,
      onQueryChange = props.onQueryChange,
      suggestedRequests = props.suggestedRequests;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageId = _usePageContext.pageId;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isSeller = _useAppContext.isSeller;

  var _useContext = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext[0];

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var keywords = Object(es["e" /* useSelector */])(search_selector["a" /* keywordsSelector */]);
  var query = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.query;
  });
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  var locale = router.query.locale;
  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'search'
  });

  var _useAutocomplete = Object(useAutocomplete["a" /* useAutocomplete */])(keywords),
      setAutocompleteQuery = _useAutocomplete.setAutocompleteQuery,
      autocompleteResults = _useAutocomplete.autocompleteResults,
      setAutocompleteResults = _useAutocomplete.setAutocompleteResults;

  var value = query && query.label ? query.label : keywords;
  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var hasSuggestedRequests = !!(suggestedRequests === null || suggestedRequests === void 0 ? void 0 : (_suggestedRequests$it = suggestedRequests.items) === null || _suggestedRequests$it === void 0 ? void 0 : _suggestedRequests$it.length);
  return __jsx(InputDatalist["a" /* InputDatalist */], {
    dataList: value || isSeller ? autocompleteResults : ((suggestedRequests === null || suggestedRequests === void 0 ? void 0 : suggestedRequests.items) || []).map(function (_ref3) {
      var label = _ref3.label,
          link = _ref3.url;
      return {
        id: label,
        label: label,
        link: link
      };
    }),
    hasClear: true,
    hasValidationIcon: false,
    iconLeft: icons["a" /* ICONS */].SEARCH_GLASS,
    isAnimated: true,
    itemLayout: !value ? ItemLayout : undefined,
    itemTitle: !value && hasSuggestedRequests ? __jsx(ItemTitle, {
      title: suggestedRequests === null || suggestedRequests === void 0 ? void 0 : suggestedRequests.title
    }) : undefined,
    onChange: function onChange(_, v) {
      var cleanKeywords = striptags_default()(v);
      dispatch(Object(searchQuery_action["a" /* setKeywords */])(cleanKeywords));
      setAutocompleteQuery(cleanKeywords);
      onQueryChange({
        label: cleanKeywords
      });
    },
    onClear: function onClear() {
      setAutocompleteResults([]);
      var emptyQuery = {
        label: ''
      };

      if (!keywords) {
        // User is clearing the search query
        dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(emptyQuery));
      }

      onQueryChange(emptyQuery);
      dispatch(Object(searchQuery_action["a" /* setKeywords */])(''));
      setAutocompleteQuery('');
    },
    onFocus: function onFocus() {
      if (_onFocus) {
        _onFocus();
      }

      if (!isSeller && !value && hasSuggestedRequests) {
        track({
          labelGA: 'requestsDisplay'
        });
      }
    },
    onSelect: function onSelect(_ref4) {
      var label = _ref4.label,
          _ref4$item = _ref4.item,
          type = _ref4$item.type,
          productType = _ref4$item.productType,
          link = _ref4$item.link;
      var isEdito = type === edito;

      if (value && !isEdito) {
        var searchQuery = {
          label: label,
          link: link,
          productType: productType,
          type: type
        };
        dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(searchQuery));
        dispatchCriteriaDisplayContext({
          type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_NEXT_CRITERIA,
          payload: {
            currentCriteria: 'criteriaQuery',
            criteriaContext: criteriaContext
          }
        });
        onQueryChange(searchQuery);
      } else if (link) {
        var redirection = isEdito ? 'redirection_editorial' : 'redirection_suggestedRequest';
        var isSearchUrl = link.startsWith('/s');
        track({
          internalSearchEngineNbResults: isSearchUrl ? '' : redirection,
          labelGA: isEdito ? 'editorial' : 'suggestedRequest',
          searchReferrer: pageId,
          searchRequestType: 'Autocomplete',
          searchTerms: label
        });
        var url = locale ? new URI_default.a(link).addQuery({
          locale: locale
        }).toString() : link;
        router.push(url);

        if (!isSearchUrl) {
          trackSearchResults({
            internalSearchEngineNbResults: redirection,
            searchRequestType: 'Autocomplete',
            searchResorts: [],
            searchTerms: label
          });
        }
      }
    },
    placeholder: Object(i18n["h" /* t */])('faceting.searchTitle'),
    value: value,
    validationState: value ? validationStates["b" /* IS_VALID */] : validationStates["c" /* NOT_VALIDATED */]
  });
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/CriteriaTransport.jsx
var CriteriaTransport = __webpack_require__("NWzG");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/CriteriaWhen.jsx + 2 modules
var CriteriaWhen = __webpack_require__("Go22");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/CriteriaWho.jsx
var CriteriaWho = __webpack_require__("wKzQ");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/FilterWhen.jsx
var FilterWhen = __webpack_require__("qLhN");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria-modal/CriteriaModal.jsx
var CriteriaModal_jsx = react_default.a.createElement;

/* eslint-disable react/no-danger */









var CriteriaModal_CriteriaModal = function CriteriaModal(_ref) {
  var children = _ref.children,
      _onClose = _ref.onClose,
      onReset = _ref.onReset,
      onValidate = _ref.onValidate;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext[0];

  var buttons = CriteriaModal_jsx("div", {
    className: "bg-white flex items-center justify-between mt-auto p-10 px-25 lg:p-0 relative shadow lg:shadow-none w-full"
  }, CriteriaModal_jsx(Button["a" /* Button */], {
    onClick: function onClick() {
      onReset === null || onReset === void 0 ? void 0 : onReset();
    },
    theme: "link"
  }, Object(i18n["h" /* t */])('faceting.reset')), CriteriaModal_jsx(Button["a" /* Button */], {
    onClick: function onClick() {
      onValidate === null || onValidate === void 0 ? void 0 : onValidate();
    }
  }, Object(i18n["h" /* t */])('faceting.validate')));

  var ariaLabel = Object(i18n["h" /* t */])('faceting.when.duration');
  var closeLabel = Object(i18n["h" /* t */])('common.close');

  var onCloseModal = function onCloseModal() {
    _onClose === null || _onClose === void 0 ? void 0 : _onClose();
  };

  return isDesktop ? CriteriaModal_jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    className: "p-20 text-center",
    closeLabel: closeLabel,
    onClose: function onClose() {
      _onClose && _onClose();
    }
  }, children, buttons) : CriteriaModal_jsx(Layer["b" /* Layer */], {
    ariaLabel: ariaLabel,
    ariaLabelledby: constants["o" /* ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL */],
    buttonLeft: {
      iconName: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
      label: Object(i18n["h" /* t */])('common.backNavigation'),
      onClick: onCloseModal
    },
    closeLabel: closeLabel,
    hasAnimateEnter: true,
    header: CriteriaModal_jsx("div", {
      className: "font-normal text-20 text-black text-center",
      dangerouslySetInnerHTML: {
        __html: criteriaContext.layerHeader
      },
      id: constants["o" /* ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL */]
    }),
    onClose: onCloseModal
  }, CriteriaModal_jsx("div", {
    className: "scroll-y",
    style: {
      height: 'calc(100% - 70px)'
    }
  }, children), buttons);
};
// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.action.js
var departureDate_action = __webpack_require__("fflk");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria-modal/criteria-modal-when/CriteriaModalWhen.jsx
var CriteriaModalWhen_jsx = react_default.a.createElement;













var CriteriaModalWhen_CriteriaModalWhen = function CriteriaModalWhen(_ref) {
  var durationOptions = _ref.durationOptions,
      onClose = _ref.onClose;

  var _useContext = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);

  var _useState = Object(react["useState"])(departureDate),
      inputDepartureDate = _useState[0],
      setInputDepartureDate = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      inputDuration = _useState2[0],
      setInputDuration = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      validated = _useState3[0],
      setValidated = _useState3[1];

  var dispatch = Object(es["d" /* useDispatch */])();
  var track = Object(useTracking["a" /* useTracking */])();

  var persistDepartureDate = function persistDepartureDate() {
    var invalid = !(departureDate || moment_default.a.isMoment(inputDepartureDate) || moment_default()(inputDepartureDate).isValid());

    if (invalid) {
      return dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
    }

    dispatch(Object(departureDate_action["a" /* setDepartureDate */])(moment_default()(inputDepartureDate).valueOf()));
    setCriteriaContext({
      defaultValueForCalendar: departureDate
    });

    if (criteriaContext.trackingActionName) {
      track({
        actionGA: criteriaContext.trackingActionName,
        labelGA: "when_".concat(moment_default()(inputDepartureDate).format('DD/MM/YYYY'))
      });
    }
  };

  var persistDuration = function persistDuration() {
    var durationToPersist = inputDuration;

    if (!inputDuration && inputDepartureDate) {
      durationToPersist = duration_constants["b" /* DEFAULT_TRIP_DURATION */];
    }

    if (durationToPersist) {
      dispatch(Object(facetingSearch_action["d" /* changeTripDuration */])(durationToPersist));

      if (criteriaContext.trackingActionName) {
        var labelGA = "duration_".concat(durationToPersist);
        track({
          actionGA: criteriaContext.trackingActionName,
          labelGA: labelGA
        });
      }
    }
  };

  Object(react["useEffect"])(function () {
    if (validated) {
      onClose();
    }
  }, [validated]);
  var offsetCalendar = appContext.isSeller ? 0 : undefined;
  return CriteriaModalWhen_jsx(CriteriaModal_CriteriaModal, {
    onValidate: function onValidate() {
      if (inputDepartureDate && inputDuration) {
        persistDepartureDate();
        persistDuration();
        setValidated(true);
      }
    },
    onClose: onClose,
    onReset: function onReset() {
      setInputDuration(0);
      setInputDepartureDate(null);
    }
  }, CriteriaModalWhen_jsx(FilterWhen["a" /* FilterWhen */], {
    optionsDuration: durationOptions,
    changeTripDuration: function changeTripDuration(time) {
      setInputDuration(time);
    },
    changeDepartureDate: function changeDepartureDate(value) {
      setInputDepartureDate(value ? moment_default()(value, moment_default.a.defaultFormat) : null);
    },
    clearDepartureDate: function clearDepartureDate() {
      setInputDepartureDate(null);
    },
    clearTripDuration: function clearTripDuration() {
      setInputDuration(0);
    },
    duration: inputDuration,
    departureDate: inputDepartureDate,
    openCalendarToDate: criteriaContext.defaultValueForCalendar,
    dateFormat: Object(i18n["h" /* t */])('booking.form.dateFormat'),
    label: Object(i18n["h" /* t */])('faceting.compare.warningMessage'),
    isSubmittable: true,
    offsetCalendar: offsetCalendar,
    theme: "compact"
  }));
};
// EXTERNAL MODULE: ./src/client/store/faceting/faceting.selector.js + 1 modules
var faceting_selector = __webpack_require__("vIa8");

// EXTERNAL MODULE: ./src/client/store/faceting/productComparison.action.js
var productComparison_action = __webpack_require__("b3ii");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/utils/locale/localeUtils.js
var localeUtils = __webpack_require__("1tzK");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./node_modules/entities/index.js
var entities = __webpack_require__("4oK2");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/constants.js
var departure_city_constants = __webpack_require__("PFCZ");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/client/components/widgets/search-form/SearchForm.utils.js









var SearchForm_utils_getDepartureCitiesFromFacets = function getDepartureCitiesFromFacets(facets, placeholderLabel) {
  var departureCities = Object(facetingUtils["h" /* getDepartureCities */])(facets);

  if (departureCities.length === 0) {
    return [];
  }

  var options = placeholderLabel ? [{
    value: '',
    label: placeholderLabel
  }] : [];
  var noTransportOption = departureCities.find(function (city) {
    return city.value === departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */];
  });

  if (noTransportOption) {
    var value = noTransportOption.value,
        label = noTransportOption.label;
    options.push({
      value: value,
      label: Object(entities["decodeHTML"])(label)
    });
  }

  var citiesOptions = departureCities.filter(function (city) {
    return city.value !== departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */];
  }).map(function (_ref) {
    var label = _ref.label,
        value = _ref.value;
    return {
      value: value,
      label: Object(entities["decodeHTML"])(label)
    };
  }).sort(function (a, b) {
    return a.value.localeCompare(b.value);
  });
  return [].concat(options, Object(toConsumableArray["a" /* default */])(citiesOptions));
};
// CONCATENATED MODULE: ./src/client/components/widgets/search-form/SearchForm.jsx






var SearchForm_jsx = react_default.a.createElement;


























var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;

var SearchForm_SubmitButton = function SubmitButton(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId;
  return SearchForm_jsx("div", {
    className: className
  }, SearchForm_jsx(Button["a" /* Button */], {
    className: "leading-0 w-[3rem]",
    dataTestId: dataTestId,
    isSquare: true,
    type: "submit"
  }, SearchForm_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1.5rem"
  })));
};

var SearchForm_SearchForm = function SearchForm(props) {
  var _props$i18n, _props$i18n$faceting;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useContext = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 1),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0];

  var _useState = Object(react["useState"])(false),
      criteriaQueryIsJoyviewProduct = _useState[0],
      setCriteriaQueryIsJoyviewProduct = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      criteriaModalWhenIsOpen = _useState2[0],
      setCriteriaModalWhenIsOpen = _useState2[1];

  var trackQueryChange = Object(useTrackQueryChange["a" /* useTrackQueryChange */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var departureDate = Object(es["e" /* useSelector */])(function (state) {
    var _state$tripCriteria;

    return state === null || state === void 0 ? void 0 : (_state$tripCriteria = state.tripCriteria) === null || _state$tripCriteria === void 0 ? void 0 : _state$tripCriteria.departureDate;
  });
  var duration = Object(es["e" /* useSelector */])(function (state) {
    return get_default()(state, 'tripCriteria.duration', 0);
  });
  var facets = Object(es["e" /* useSelector */])(function (state) {
    return Object(faceting_selector["f" /* facetsSelector */])(state);
  });
  var resultsCount = Object(es["e" /* useSelector */])(function (state) {
    return Object(faceting_selector["g" /* filteredProductsCountSelector */])(state);
  });
  var isLoading = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.isLoading;
  });
  var isProductComparisonSelectionModeEnabled = Object(es["e" /* useSelector */])(function (state) {
    var _state$faceting;

    return state === null || state === void 0 ? void 0 : (_state$faceting = state.faceting) === null || _state$faceting === void 0 ? void 0 : _state$faceting.isSelectionModeEnabled;
  });
  var joyviewOffsetSell = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.joyviewOffsetSell;
  });
  var resortOffsetSell = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.resortOffsetSell;
  });
  var b2cOffsetSell = Object(localeUtils["a" /* isChineseLocale */])(appContext.locale) && criteriaQueryIsJoyviewProduct && joyviewOffsetSell > -1 ? joyviewOffsetSell : resortOffsetSell;
  var offsetSell = appContext.isSeller ? 0 : b2cOffsetSell;

  var getOptionsDuration = function getOptionsDuration() {
    var results = (facets.find(function (f) {
      return f.id === faceting_constants["x" /* DURATION_FACET */];
    }) || {
      list: []
    }).list;
    return results.map(function (opt) {
      return parseInt(opt.value, 10);
    }).sort(function (a, b) {
      return a < b ? -1 : 1;
    });
  };

  Object(react["useEffect"])(function () {
    setCriteriaContext({
      layerButtonLabel: props.layerButtonLabel,
      layerHeader: props.showNbResultsInLayer ? Object(i18n["h" /* t */])('faceting.viewResorts', {
        n: "<span class=\"font-bold text-sienna\">".concat(resultsCount || 0, "</span>")
      }) : ''
    });
  }, [props.showNbResultsInLayer, resultsCount, props.layerButtonLabel]);
  Object(react["useEffect"])(function () {
    if (criteriaDisplayContext.criteriaWhenIsOpen || criteriaDisplayContext.criteriaTransportIsOpen) {
      dispatch(Object(facetingSearch_action["n" /* setIsSearchEnabled */])(true));
    }
  }, [criteriaDisplayContext.criteriaTransportIsOpen, criteriaDisplayContext.criteriaWhenIsOpen]);

  var updateTranslationKeys = function updateTranslationKeys() {
    Object(i18n["a" /* addTranslationKeys */])({
      common: get_default()(props, 'i18n.common'),
      booking: get_default()(props, 'i18n.booking'),
      faceting: get_default()(props, 'i18n.faceting')
    });
  };

  updateTranslationKeys();
  Object(react["useEffect"])(function () {
    updateTranslationKeys();
  }, [props.i18n]);
  var isOpen = criteriaDisplayContext.criteriaWhenIsOpen || criteriaDisplayContext.criteriaWhoIsOpen || criteriaDisplayContext.criteriaTransportIsOpen;
  Object(react["useEffect"])(function () {
    if (isOpen) {
      Object(scrollToElement["a" /* scrollToElement */])('#search-form');
    }
  }, [isOpen]);
  Object(react["useEffect"])(function () {
    var dateIsMissing = !departureDate || !duration;

    if (isProductComparisonSelectionModeEnabled && dateIsMissing && !criteriaDisplayContext.criteriaWhenIsOpen && !criteriaModalWhenIsOpen) {
      setCriteriaModalWhenIsOpen(true);
    }
  }, [criteriaDisplayContext.criteriaWhenIsOpen, isProductComparisonSelectionModeEnabled, departureDate]);
  var departureCitiesOptions = SearchForm_utils_getDepartureCitiesFromFacets(facets, null);
  var hideCriteriaTransport = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('faceting.hideCriteriaTransport');

  var onSubmit = function onSubmit(event) {
    if (event) {
      event.preventDefault();
    }

    if (isFunction_default()(props.onSubmit)) {
      props.onSubmit(event);
    }
  };

  var onQueryChange = function onQueryChange(query) {
    setCriteriaQueryIsJoyviewProduct(query && query.productType === PRODUCT_TYPES.JOYVIEW);

    if (query && query.label && query.type) {
      return props.doTrackQueryChange && trackQueryChange(query);
    }
  };

  var onClose = function onClose() {
    setCriteriaModalWhenIsOpen(false);

    if (!departureDate && !duration) {
      dispatch(Object(productComparison_action["a" /* setProductComparisonSelectionMode */])(false));
    }
  };

  var durations = getOptionsDuration();

  var onCriteriaQueryFocus = function onCriteriaQueryFocus() {
    Object(scrollToElement["a" /* scrollToElement */])('#search-form');
  };

  return SearchForm_jsx("form", {
    className: classnames_default()('isolate relative', props.className),
    onSubmit: onSubmit
  }, SearchForm_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: props.fullScreen
  }, SearchForm_jsx("div", {
    className: classnames_default()('bg-white lg:flex p-5 border-b border-lightSand', {
      'border-1 mb-20 rounded-24 lg:rounded-pill shadow-lg': !props.fullScreen
    }),
    id: "search-form"
  }, props.withQuery && SearchForm_jsx("div", {
    className: "flex lg:flex-1 gap-10 p-5"
  }, SearchForm_jsx("div", {
    className: "flex-1 relative z-1",
    "data-testid": "search-form-criteria-query"
  }, SearchForm_jsx(CriteriaQuery_CriteriaQuery, {
    onFocus: onCriteriaQueryFocus,
    onQueryChange: onQueryChange,
    suggestedRequests: (_props$i18n = props.i18n) === null || _props$i18n === void 0 ? void 0 : (_props$i18n$faceting = _props$i18n.faceting) === null || _props$i18n$faceting === void 0 ? void 0 : _props$i18n$faceting.suggestedRequests
  })), SearchForm_jsx(SearchForm_SubmitButton, {
    className: "lg:hidden",
    dataTestId: "facet-search-button-mobile"
  })), SearchForm_jsx("div", {
    className: "flex lg:flex-2"
  }, SearchForm_jsx("div", {
    className: "flex-1 p-5",
    "data-testid": "search-form-criteria-when"
  }, SearchForm_jsx(CriteriaWhen["a" /* CriteriaWhen */], {
    durationOptions: durations,
    offsetSell: offsetSell > -1 ? offsetSell : null,
    isDropDownRelative: props.fullScreen,
    withFlexibility: true,
    theme: "compact"
  })), SearchForm_jsx("div", {
    className: "flex-1 p-5",
    "data-testid": "search-form-criteria-who"
  }, SearchForm_jsx(CriteriaWho["a" /* CriteriaWho */], null)), !hideCriteriaTransport && SearchForm_jsx("div", {
    className: "flex-1 p-5",
    "data-testid": "search-form-criteria-transport"
  }, SearchForm_jsx(CriteriaTransport["a" /* CriteriaTransport */], {
    departureCitiesOptions: departureCitiesOptions,
    isLoading: isLoading
  }))), SearchForm_jsx(SearchForm_SubmitButton, {
    className: "lg:block hidden m-5",
    dataTestId: "facet-search-button"
  }))), criteriaModalWhenIsOpen && SearchForm_jsx(CriteriaModalWhen_CriteriaModalWhen, {
    durationOptions: durations,
    onClose: onClose
  }));
};
// EXTERNAL MODULE: ./src/routes/constants.js
var routes_constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/client/store/faceting/searchRequest.action.js
var searchRequest_action = __webpack_require__("OWFg");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/store/utils/autocompleteItemHelper.js
var autocompleteItemHelper = __webpack_require__("Qmkj");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.jsx + 1 modules
var InputSelect = __webpack_require__("oWz2");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/SearchFacets.jsx
var SearchFacets = __webpack_require__("n1ZP");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-facets/CriteriaFacets.utils.js
var CriteriaFacets_utils = __webpack_require__("z3uz");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/CriteriaFacets.jsx





var CriteriaFacets_jsx = react_default.a.createElement;











var CriteriaFacets_CriteriaFacets = function CriteriaFacets() {
  var dispatch = Object(es["d" /* useDispatch */])();
  var activeCustomFacets = Object(es["e" /* useSelector */])(faceting_selector["a" /* activeCustomFacetsSelector */]);
  var activeFacets = Object(es["e" /* useSelector */])(faceting_selector["b" /* activeFacetsSelector */]);
  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var facets = Object(es["e" /* useSelector */])(faceting_selector["f" /* facetsSelector */]);
  var orderByPriceState = Object(es["e" /* useSelector */])(function (_ref) {
    var faceting = _ref.faceting;
    return faceting.orderByPrice;
  });
  var router = Object(next_router["useRouter"])();

  var _useContext = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext[0];

  var uri = new URI_default.a(router.asPath);
  return CriteriaFacets_jsx(SearchFacets["b" /* SearchFacets */], {
    activeCustomFacets: activeCustomFacets,
    activeFacets: activeFacets,
    clearFacetList: function clearFacetList(categoryId) {
      dispatch(Object(facetingSearch_action["g" /* clearFacets */])(categoryId));
    },
    clearAll: function clearAll() {
      dispatch(Object(facetingSearch_action["e" /* clearAll */])());
    },
    facets: facets,
    facetTemplateConfig: Object(CriteriaFacets_utils["a" /* getFacetTemplateConfig */])(criteriaContext, departureCity),
    orderByPrice: orderByPriceState,
    setOrderByPrice: function setOrderByPrice(orderByPrice) {
      var searchPageUrl = uri.clone().setQuery(Object(defineProperty["a" /* default */])({}, faceting_constants["X" /* SORT_BY_PRICE_QUERY_PARAM */], orderByPrice || undefined));
      router.replace(searchPageUrl.toString(), undefined, {
        shallow: true,
        scroll: false
      });
    },
    toggleFacet: function toggleFacet(_ref2) {
      var categoryId = _ref2.categoryId,
          isSelected = _ref2.isSelected,
          value = _ref2.value;
      criteriaContext.setFacetHasSeeMore(false);
      dispatch(Object(facetingSearch_action["t" /* toggleFacet */])({
        categoryId: categoryId,
        isSelected: isSelected,
        value: value
      }));
    }
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search/FacetSearch.jsx













var FacetSearch_jsx = react_default.a.createElement;



































var FacetSearchResults = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(28), __webpack_require__.e(127)]).then(__webpack_require__.bind(null, "4xIB")).then(function (x) {
    return x.FacetSearchResults;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("4xIB")];
    },
    modules: ["../facet-search-results/FacetSearchResults"]
  }
});
var FacetSearch_FacetSearch = function FacetSearch(props) {
  var className = props.className,
      _props$displayActivit = props.displayActivityFilter,
      displayActivityFilter = _props$displayActivit === void 0 ? true : _props$displayActivit,
      _props$displayChildca = props.displayChildcareFilter,
      displayChildcareFilter = _props$displayChildca === void 0 ? true : _props$displayChildca,
      _props$displayDestina = props.displayDestinationFilter,
      displayDestinationFilter = _props$displayDestina === void 0 ? true : _props$displayDestina,
      _props$displaySeasonF = props.displaySeasonFilter,
      displaySeasonFilter = _props$displaySeasonF === void 0 ? true : _props$displaySeasonF,
      _props$displayTypeOfS = props.displayTypeOfStayFilter,
      displayTypeOfStayFilter = _props$displayTypeOfS === void 0 ? true : _props$displayTypeOfS,
      _props$displayFlightD = props.displayFlightDurationFilter,
      displayFlightDurationFilter = _props$displayFlightD === void 0 ? true : _props$displayFlightD,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
      orderByPriceProp = props.orderByPrice,
      resultsHasSeeMore = props.resultsHasSeeMore,
      resortGridProps = props.resortGridProps,
      _props$shouldRedirect = props.shouldRedirectToResortPage,
      shouldRedirectToResortPage = _props$shouldRedirect === void 0 ? false : _props$shouldRedirect,
      _props$withSearchResu = props.withSearchResults,
      withSearchResults = _props$withSearchResu === void 0 ? false : _props$withSearchResu,
      _props$withWorldMap = props.withWorldMap,
      withWorldMap = _props$withWorldMap === void 0 ? false : _props$withWorldMap;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var pageContext = Object(PageContext["b" /* usePageContext */])();
  var router = Object(next_router["useRouter"])();
  var routerEvents = Object(useRouterEvents["a" /* useRouterEvents */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      currentBreakpoint = _useResponsive.currentBreakpoint,
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(false),
      searchDone = _useState[0],
      setSearchDone = _useState[1];

  var _useState2 = Object(react["useState"])(resultsHasSeeMore),
      facetHasSeeMore = _useState2[0],
      setFacetHasSeeMore = _useState2[1];

  var track = Object(useTracking["a" /* useTracking */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var activeCustomFacets = Object(es["e" /* useSelector */])(faceting_selector["a" /* activeCustomFacetsSelector */]);
  var activeFacets = Object(es["e" /* useSelector */])(faceting_selector["b" /* activeFacetsSelector */]);
  var facets = Object(es["e" /* useSelector */])(faceting_selector["f" /* facetsSelector */]);
  var facetingCriteria = Object(es["e" /* useSelector */])(faceting_selector["e" /* facetingCriteriaSelector */]);
  var isLoading = Object(es["e" /* useSelector */])(function (_ref) {
    var faceting = _ref.faceting;
    return faceting.isLoading;
  });
  var noResults = Object(es["e" /* useSelector */])(function (_ref2) {
    var faceting = _ref2.faceting;
    return faceting.noResults;
  });
  var isSearchEnabled = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.isSearchEnabled;
  });
  var keywords = Object(es["e" /* useSelector */])(search_selector["a" /* keywordsSelector */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var numberOfAdults = Object(es["e" /* useSelector */])(storeHelper["b" /* getAdultsNumber */]);
  var kidsValidationState = Object(es["e" /* useSelector */])(faceting_selector["m" /* getKidsValidationState */]);
  var products = Object(es["e" /* useSelector */])(function (state) {
    return Object(faceting_selector["i" /* filteredProductsSelector */])(state) || [];
  });
  var productIds = products.map(function (_ref3) {
    var resortId = _ref3.resortId;
    return resortId;
  }).join('|');
  var query = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.query || {};
  });
  var redirection = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.redirection;
  });
  var flexibility = Object(es["e" /* useSelector */])(tripCriteria_selector["d" /* getTripFlexibility */]);
  var orderByPriceState = Object(es["e" /* useSelector */])(function (_ref4) {
    var faceting = _ref4.faceting;
    return faceting.orderByPrice;
  });
  var trackQueryChange = Object(useTrackQueryChange["a" /* useTrackQueryChange */])();
  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var searchCriteria = {
    departureCity: departureCity,
    departureDate: departureDate,
    duration: duration,
    keywords: keywords,
    kids: kids,
    numberOfAdults: numberOfAdults,
    kidsValidationState: kidsValidationState,
    query: query
  };
  var searchOptions = Object(react["useMemo"])(function () {
    var _props$offer, _props$offer2;

    return {
      boutique: props.boutique,
      offerId: (_props$offer = props.offer) === null || _props$offer === void 0 ? void 0 : _props$offer.id,
      offerName: (_props$offer2 = props.offer) === null || _props$offer2 === void 0 ? void 0 : _props$offer2.seoName,
      productIds: (props.initialProducts || []).map(function (product) {
        return product.id;
      }),
      query: query.label || '',
      screenSize: currentBreakpoint
    };
  }, [props.boutique, props.initialProducts, props.offer, props.i18n, query, currentBreakpoint]);

  var navigateToSearch = function navigateToSearch() {
    if (isSearchEnabled) {
      if (props.shouldPersistCriteriaInUrl && !routerEvents.transitioning) {
        var activeCustomFacetsQueries = Object(facetingUtils["e" /* generateActiveFacetsQueries */])(activeCustomFacets, facetingUtils["a" /* customFacetsQueryParamMapping */]);
        var activeFacetsQueries = Object(facetingUtils["e" /* generateActiveFacetsQueries */])(activeFacets, facetingUtils["b" /* facetsQueryParamMapping */]);
        Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
          activeCustomFacetsQueries: activeCustomFacetsQueries,
          activeFacetsQueries: activeFacetsQueries,
          criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
          router: router,
          searchCriteria: searchCriteria,
          searchPageRouteName: props.searchPageRouteName
        });
      } // In Cmta, on FacetSearch, sellers need persistent data concerning attendees to be used later by the comparator


      if (appContext.isCmta) {
        js_cookie_default.a.set('persistentNumberOfAdults', numberOfAdults);
        js_cookie_default.a.set('persistentKids', kids);
      }
    }
  };

  var search = function search() {
    // We check routerReady to ensure that we do not update URL
    // or results while the router is transitioning between routes.
    if (isSearchEnabled) {
      navigateToSearch();
      dispatch(Object(searchRequest_action["d" /* facetingSearchRequest */])({
        appContext: appContext,
        options: searchOptions
      }));
      setSearchDone(true);
    }
  };

  Object(react["useEffect"])(function () {
    dispatch(Object(searchRequest_action["b" /* facetingLoadOffsetSellRequest */])({
      appContext: appContext
    }));
  }, []);
  Object(react["useEffect"])(function () {
    if (typeof products !== 'undefined' && pageContext.pageId === routes_constants["D" /* SEARCH_PAGE_ID */] && withSearchResults && isLoading === false && searchDone) {
      trackSearchResults();
    }
  }, [productIds, isLoading]);
  Object(react["useEffect"])(function () {
    var _props$i18n$remote, _props$i18n$remote$no, _props$i18n$remote$no2, _props$i18n$remote$no3;

    if (!isLoading && noResults && ((_props$i18n$remote = props.i18n.remote) === null || _props$i18n$remote === void 0 ? void 0 : (_props$i18n$remote$no = _props$i18n$remote.noResult) === null || _props$i18n$remote$no === void 0 ? void 0 : (_props$i18n$remote$no2 = _props$i18n$remote$no.recommendation) === null || _props$i18n$remote$no2 === void 0 ? void 0 : (_props$i18n$remote$no3 = _props$i18n$remote$no2.resortIds) === null || _props$i18n$remote$no3 === void 0 ? void 0 : _props$i18n$remote$no3.length) > 0) {
      dispatch(Object(searchRequest_action["c" /* facetingLoadProductsRequest */])({
        appContext: appContext,
        productIds: props.i18n.remote.noResult.recommendation.resortIds
      }));
    }
  }, [noResults]);

  var cleanSearch = /*#__PURE__*/function () {
    var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(Object(facetingSearch_action["k" /* resetSearch */])()));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function cleanSearch() {
      return _ref5.apply(this, arguments);
    };
  }();

  var cleanCriteria = /*#__PURE__*/function () {
    var _ref6 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", dispatch(Object(facetingSearch_action["i" /* resetCriteria */])()));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function cleanCriteria() {
      return _ref6.apply(this, arguments);
    };
  }();

  Object(react["useEffect"])(function () {
    dispatch(Object(productComparison_action["a" /* setProductComparisonSelectionMode */])(false));
    var _props$initialIsSearc = props.initialIsSearchEnabled,
        initialIsSearchEnabled = _props$initialIsSearc === void 0 ? false : _props$initialIsSearc;

    if (!Object(FacetSearch_utils["b" /* currentUrlContainsSearchQueryParam */])(router.query)) {
      // We always want to reset the search query, unless it's in the URL.
      dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])({
        label: ''
      }));
    } // useEffect cannot be async because it's supposed to return a cleaning callback.
    // This immediatly invoked function is a workaround to this.


    Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(Object(FacetSearch_utils["c" /* currentUrlHasNoQueryParams */])(router.query) && props.resetSearchAtMount)) {
                _context3.next = 5;
                break;
              }

              _context3.next = 3;
              return cleanSearch();

            case 3:
              _context3.next = 5;
              return cleanCriteria();

            case 5:
              if (departureCity) {
                // If transport is set in store, we need to trigger
                // the search request to get the departureCities facet from Pertimm.
                dispatch(Object(facetingSearch_action["n" /* setIsSearchEnabled */])(true));
              } else {
                dispatch(Object(facetingSearch_action["n" /* setIsSearchEnabled */])(initialIsSearchEnabled));
              }

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();

    return function () {
      cleanSearch();
    };
  }, []);
  Object(react["useEffect"])(function () {
    // In case PERTIMM response indicates a redirection, go to this page...
    if (redirection) {
      dispatch(Object(globalLoader_action["d" /* startLoading */])());
      router.replace(dist["url"].normalizeUrl(redirection));
      return function () {
        // clear search query to avoid infinite loop on back #14970
        dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])({
          label: ''
        }));
        dispatch(Object(facetingSearch_action["j" /* resetRedirection */])());
      };
    }
  }, [redirection]);
  var filtersKeysToIgnore = [faceting_constants["u" /* DEPARTURE_DATE_MAX_FACET_ID */], faceting_constants["v" /* DEPARTURE_DATE_MIN_FACET_ID */], faceting_constants["x" /* DURATION_FACET */], faceting_constants["P" /* PRODUCT_FACET_ID */]];
  Object(react["useEffect"])(function () {
    search();
  }, [JSON.stringify(kids), appContext.isCmta && JSON.stringify(numberOfAdults), JSON.stringify(query), isSearchEnabled, departureDate, duration, JSON.stringify((facetingCriteria.filters || []).filter(function (facet) {
    return !filtersKeysToIgnore.includes(facet.id);
  })), props.offer, flexibility]);
  Object(react["useEffect"])(function () {
    navigateToSearch();
  }, [JSON.stringify(activeCustomFacets)]);

  var onSubmit = function onSubmit(event) {
    var searchPageRouteName = props.searchPageRouteName;

    if (event) {
      event.preventDefault();
    }

    var searchQuery = keywords ? {
      label: keywords
    } : query;

    if (keywords) {
      dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(searchQuery));
    }

    if (!keywords && shouldRedirectToResortPage && searchQuery.type === autocompleteItemHelper["a" /* RESORT_PRODUCT_TYPE */]) {
      trackQueryChange(searchQuery, {
        internalSearchEngineNbResults: 'redirection'
      });
      trackSearchResults({
        internalSearchEngineNbResults: 'redirection',
        searchResorts: []
      });
      Object(FacetSearch_utils["e" /* navigateToResortPage */])({
        query: searchQuery,
        router: router,
        searchCriteria: searchCriteria
      });
    } else {
      if (!withSearchResults) {
        trackQueryChange(searchQuery);
        cleanSearch();
      }

      var activeCustomFacetsQueries = Object(facetingUtils["e" /* generateActiveFacetsQueries */])(activeCustomFacets, facetingUtils["a" /* customFacetsQueryParamMapping */]);
      var activeFacetsQueries = Object(facetingUtils["e" /* generateActiveFacetsQueries */])(activeFacets, facetingUtils["b" /* facetsQueryParamMapping */]);
      Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
        activeCustomFacetsQueries: activeCustomFacetsQueries,
        activeFacetsQueries: activeFacetsQueries,
        criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
        router: router,
        searchCriteria: searchCriteria,
        searchPageRouteName: searchPageRouteName
      });
    }
  };

  var orderByPrice = orderByPriceState || orderByPriceProp;

  var getPriceSorter = function getPriceSorter() {
    var uri = new URI_default.a(router.asPath);
    return FacetSearch_jsx(InputSelect["a" /* InputSelect */], {
      dataTestId: "flexibility-input",
      onChange: function onChange(name, value) {
        if (value) {
          track({
            actionGA: 'priceFilter',
            labelGA: "price_sort".concat(value === 'asc' ? 'Ascending' : 'Descending')
          });
        } else {
          track({
            actionGA: 'priceFilter',
            labelGA: 'price_sortByDefault'
          });
        }

        var searchPageUrl = uri.clone().setQuery(Object(defineProperty["a" /* default */])({}, faceting_constants["X" /* SORT_BY_PRICE_QUERY_PARAM */], value || undefined));
        router.replace(searchPageUrl.toString(), undefined, {
          shallow: true,
          scroll: false
        });
      },
      onFocus: function onFocus() {
        track({
          actionGA: 'priceFilter',
          labelGA: 'price_sortOpen'
        });
      },
      options: [{
        label: Object(i18n["h" /* t */])('faceting.sortByPrice.label'),
        value: ''
      }, {
        label: Object(i18n["h" /* t */])('faceting.sortByPrice.ascendingOrder'),
        value: 'asc'
      }, {
        label: Object(i18n["h" /* t */])('faceting.sortByPrice.descendingOrder'),
        value: 'desc'
      }],
      value: orderByPrice
    });
  };

  return FacetSearch_jsx("div", {
    "data-testid": "facetSearch",
    className: classnames_default()('isolate relative', className)
  }, FacetSearch_jsx(CriteriaContext["b" /* CriteriaContextProvider */], {
    value: {
      trackingActionName: 'smartCriterias',
      setFacetHasSeeMore: setFacetHasSeeMore,
      displayActivityFilter: displayActivityFilter,
      displayChildcareFilter: displayChildcareFilter,
      displayDestinationFilter: displayDestinationFilter,
      displaySeasonFilter: displaySeasonFilter,
      displayTypeOfStayFilter: displayTypeOfStayFilter,
      displayFlightDurationFilter: displayFlightDurationFilter
    }
  }, FacetSearch_jsx(CriteriaDisplayContext["b" /* CriteriaDisplayProvider */], null, props.withSearchForm && FacetSearch_jsx(SearchForm_SearchForm, {
    className: "z-2",
    doTrackQueryChange: withSearchResults,
    i18n: props.i18n,
    onSubmit: onSubmit,
    withFacets: props.withSearchFacets,
    withQuery: !props.hideSearchInput,
    showNbResultsInLayer: props.withSearchResults,
    fullScreen: fullScreen,
    layerButtonLabel: props.withSearchResults ? props.i18n.remote && props.i18n.remote.searchAction || 'search' : props.i18n.booking.editCriteria.validateCriteria
  }), FacetSearch_jsx("div", {
    className: "lg:flex lg:flex-row-reverse isolate relative z-1"
  }, FacetSearch_jsx("div", {
    className: "w-full"
  }, props.withSearchResults && FacetSearch_jsx(FacetSearchResults, {
    resortGridProps: resortGridProps,
    i18n: props.i18n,
    initialProducts: props.initialProducts,
    isProductComparisonModeAuthorized: props.isProductComparisonModeAuthorized,
    offer: props.offer,
    orderByPrice: orderByPrice,
    priceSorter: getPriceSorter(),
    resultsHasSeeMore: facetHasSeeMore,
    resultsSeeMore: props.resultsSeeMore,
    isSynchronousGrid: props.isSynchronousGrid,
    searchOptions: searchOptions,
    shouldSetDefaultDepartureCityOnCompare: props.shouldSetDefaultDepartureCityOnCompare,
    virtualizedGrid: props.virtualizedGrid,
    facets: facets,
    withWorldMap: withWorldMap
  })), props.withSearchFacets && isDesktop && FacetSearch_jsx(CriteriaFacets_CriteriaFacets, null), !isDesktop && props.withSearchFacets && FacetSearch_jsx("div", {
    className: "sticky bottom-0 z-2 p-15 bg-white border-t"
  }, FacetSearch_jsx("div", {
    id: "clubmed-search-comparePortal"
  }), FacetSearch_jsx("div", {
    id: "clubmed-search-compareButtonPortal",
    className: "flex gap-20"
  }, props.withSearchFacets && !isDesktop && FacetSearch_jsx(CriteriaFacets_CriteriaFacets, null)))))));
};

/***/ }),

/***/ "pjDv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("I+eb");
var from = __webpack_require__("TfTi");
var checkCorrectnessOfIteration = __webpack_require__("HH4o");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "psri":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("4ygQ"),
    upperFirst = __webpack_require__("TYRa");

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),

/***/ "pteD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TripDatePicker_TripDatePicker; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("oVuX");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-day-picker/DayPicker.js
var DayPicker = __webpack_require__("nFOY");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.jsx + 2 modules
var Datepicker = __webpack_require__("Dm6d");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.themes.js
var Datepicker_themes = __webpack_require__("MZFe");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("rB9j");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("UxlC");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/debounce.js
var debounce = __webpack_require__("RNvQ");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.themes.js

var TripDatePicker_themes_themes = function themes(_ref) {
  var isBestPrice = _ref.isBestPrice,
      isHighlighted = _ref.isHighlighted,
      isSelectable = _ref.isSelectable,
      isSelected = _ref.isSelected,
      isTablet = _ref.isTablet,
      lastAvailability = _ref.lastAvailability,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      siblingOpen = _ref.siblingOpen;
  return {
    "default": {
      thDay: classnames_default()("cursor-pointer flex flex-1 flex-col group items-center justify-center ".concat(isTablet ? 'h-[6.25rem] p-5' : 'h-[3.25rem]', " text-14 text-center duration-250 ease-in transition-all border-t border-r border-grey relative"), {
        'text-black hocus:text-white': isSelectable
      }),
      thDayCornerMark: classnames_default()({
        'corner-mark-tr-turquoise': siblingOpen && isTablet,
        'corner-mark-tr-turquoise-sm': siblingOpen && !isTablet
      }),
      thDayMessage: 'hidden md:inline w-full font-normal text-12',
      thDayNumber: classnames_default()('md:absolute top-0 left-0 md:p-5 text-10', {
        'font-normal md:text-12': !isSelectable,
        'font-bold md:text-16': isSelectable,
        'text-current': siblingOpen
      }),
      thDayOldPrice: 'text-12 line-through hidden md:block text-current',
      thDayPrice: 'text-12 md:text-16',
      thStatusMessage: shouldDisplayDoubleSeasonButton ? "bg-turquoise cursor-pointer font-bold p-1 md:px-5 rounded-2 text-10 md:text-18 text-white uppercase".concat(!isTablet ? ' w-full' : '') : 'hidden md:inline w-full font-normal',
      thFrom: 'hidden md:inline w-full font-normal'
    },
    compact: {
      thDay: 'cursor-pointer flex flex-1 flex-col group items-center justify-center h-[3rem] leading-tight relative text-14 text-center',
      thDayMessage: 'hidden',
      thDayNumberContainer: classnames_default()('isolate relative'),
      thDayNumber: classnames_default()('relative z-1', {
        'text-white': (lastAvailability || isBestPrice || siblingOpen) && isHighlighted,
        'text-grey group-hover:text-white': !lastAvailability && !isBestPrice && !siblingOpen && isHighlighted
      }),
      thDayUnavailable: 'line-through',
      thDayHighlight: 'absolute bg-current group-hover:bg-transparent h-[1.625rem] left-1/2 rounded-4 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[1.625rem]',
      thDayOldPrice: 'hidden',
      thDayPrice: classnames_default()('block font-bold mx-auto -mb-5 mt-5 self-end text-10', {
        'text-black group-hover:text-white': !isSelected,
        'text-white': isSelected
      }),
      thStatusMessage: 'hidden',
      thFrom: 'hidden',
      thShowPricePlaceholder: true
    }
  };
};
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDetails.jsx
var __jsx = react_default.a.createElement;




var DayPriceDetails_DayPriceDetails = function DayPriceDetails(_ref) {
  var day = _ref.day,
      duration = _ref.duration,
      departureCity = _ref.departureCity,
      hasTransport = _ref.hasTransport,
      isJoyview = _ref.isJoyview,
      isVisible = _ref.isVisible,
      setIsVisible = _ref.setIsVisible,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      unit = _ref.unit;
  Object(react["useEffect"])(function () {
    setIsVisible(shouldDisplayDetails);
  }, [shouldDisplayDetails]);
  var dateFormat = Object(i18n["h" /* t */])('resort.startingPrice.dateFormat');
  var startDate = moment_default()(day).format(dateFormat);
  var endDate = moment_default()(day).add({
    days: duration
  }).format(dateFormat);
  return isVisible && shouldDisplayDetails && __jsx("div", {
    className: "absolute font-normal left-1/2 text-initial top-0 transform -translate-x-1/2 z-2",
    style: {
      width: '25rem'
    }
  }, __jsx("div", {
    className: "absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0"
  }, __jsx("div", {
    className: "arrow-down arrow-large arrow-white bg-white after:drop-shadow-md rounded-12 shadow-md"
  }, __jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
    city: departureCity,
    endDate: endDate,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    startDate: startDate,
    unit: unit
  }))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeasonPopin.jsx
var DayPriceDoubleSeasonPopin = __webpack_require__("uMuQ");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeason.jsx
var DayPriceDoubleSeason_jsx = react_default.a.createElement;





var DayPriceDoubleSeason_DayPriceDoubleSeason = function DayPriceDoubleSeason(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      isMouseOverDoubleSeasonPopin = _ref.isMouseOverDoubleSeasonPopin,
      isVisible = _ref.isVisible,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var stopEventBubbling = function stopEventBubbling(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  var closeModal = function closeModal(e) {
    stopEventBubbling(e);
    setInvisible();
  };

  var trackingData = {
    actionGA: 'calendarPrice'
  };
  return (isVisible || isMouseOverDoubleSeasonPopin) && DayPriceDoubleSeason_jsx("div", {
    onClick: stopEventBubbling
  }, isTablet ? DayPriceDoubleSeason_jsx("aside", {
    className: "absolute arrow arrow-bg-lightGrey arrow-down arrow-white animate-fadeIn animation-duration-500 font-normal left-1/2 shadow-diffuse bottom-full transform -translate-x-1/2 w-[17.5rem] z-3"
  }, DayPriceDoubleSeason_jsx("div", {
    className: "bg-white overflow-hidden border border-lightGrey rounded-12 text-initial"
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  }))) : DayPriceDoubleSeason_jsx(Modal["a" /* Modal */], {
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: closeModal,
    size: "small"
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayWithPrice.jsx




var DayWithPrice_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */












var COMPACT_MAX_CHARACTERS = 5;
var DayWithPrice_DayWithPrice = function DayWithPrice(_ref) {
  var day = _ref.day,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 7 : _ref$duration,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? false : _ref$hasInstalment,
      isJoyview = _ref.isJoyview,
      isLoading = _ref.isLoading,
      _ref$isSelectable = _ref.isSelectable,
      isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$isHighlighted = _ref.isHighlighted,
      isHighlighted = _ref$isHighlighted === void 0 ? false : _ref$isHighlighted,
      locale = _ref.locale,
      _ref$price = _ref.price,
      availability = _ref$price.availability,
      currency = _ref$price.currency,
      departureCity = _ref$price.departureCity,
      hasTransport = _ref$price.hasTransport,
      isBestPrice = _ref$price.isBestPrice,
      lastAvailability = _ref$price.lastAvailability,
      formattedPriceValue = _ref$price.price,
      oldPrice = _ref$price.oldPrice,
      priceValue = _ref$price.priceValue,
      _ref$price$siblingOpe = _ref$price.siblingOpen,
      siblingOpen = _ref$price$siblingOpe === void 0 ? false : _ref$price$siblingOpe,
      unit = _ref$price.unit,
      product = _ref.product,
      selectedBestPrice = _ref.selectedBestPrice,
      selectedDuration = _ref.selectedDuration,
      selectedRealPrice = _ref.selectedRealPrice,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      shouldDisplayPrice = _ref.shouldDisplayPrice,
      shouldDisplaySelectedDepartureDateMessage = _ref.shouldDisplaySelectedDepartureDateMessage,
      shouldDisplaySelectedDepartureDateMessageWithPrice = _ref.shouldDisplaySelectedDepartureDateMessageWithPrice,
      shouldDisplaySelectedReturningDateMessage = _ref.shouldDisplaySelectedReturningDateMessage,
      shouldDisplayStatusMessage = _ref.shouldDisplayStatusMessage,
      theme = _ref.theme,
      withPriceDetails = _ref.withPriceDetails;

  var _useState = Object(react["useState"])(false),
      isMouseOverDoubleSeasonPopin = _useState[0],
      setIsMouseOverDoubleSeasonPopin = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isVisible = _useState2[0],
      setIsVisibleState = _useState2[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var statusMessageKey = "booking.priceCalendar.priceStatus.".concat(availability);
  var _themes$theme = TripDatePicker_themes_themes({
    isBestPrice: isBestPrice,
    isHighlighted: isHighlighted,
    isSelectable: isSelectable,
    isSelected: isSelected,
    isTablet: isTablet,
    lastAvailability: lastAvailability,
    shouldDisplayDoubleSeasonButton: shouldDisplayDoubleSeasonButton,
    siblingOpen: siblingOpen
  })[theme],
      thDayCornerMark = _themes$theme.thDayCornerMark,
      thDayMessage = _themes$theme.thDayMessage,
      thDayNumberContainer = _themes$theme.thDayNumberContainer,
      thDayNumber = _themes$theme.thDayNumber,
      thDayHighlight = _themes$theme.thDayHighlight,
      thDayOldPrice = _themes$theme.thDayOldPrice,
      thDayPrice = _themes$theme.thDayPrice,
      thStatusMessage = _themes$theme.thStatusMessage,
      thFrom = _themes$theme.thFrom,
      thShowPricePlaceholder = _themes$theme.thShowPricePlaceholder;

  var setIsVisible = debounce_default()(function (visible) {
    setIsVisibleState(visible);
  }, 150);

  var setVisible = function setVisible() {
    if (!isVisible) {
      setIsVisible(true);
    }
  };

  var setInvisible = function setInvisible() {
    setIsVisible(false);
  };

  var getCompactPrice = function getCompactPrice(rawPrice) {
    var compactPrice = (rawPrice === null || rawPrice === void 0 ? void 0 : rawPrice.replace(/[\s|.,]/gi, '')) || '';
    return compactPrice.length <= COMPACT_MAX_CHARACTERS ? compactPrice : DayWithPrice_jsx("span", {
      className: "text-8 md:px-1 md:mx-1 md:text-10"
    }, compactPrice);
  };

  var price = hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])({
    currency: currency,
    formattedValue: formattedPriceValue,
    value: priceValue
  }, locale) : formattedPriceValue;
  var selectedPrice = selectedRealPrice || selectedBestPrice;
  var isDateSelectable = ['open', 'noDeparture'].includes(availability);
  return DayWithPrice_jsx(react["Fragment"], null, DayWithPrice_jsx("div", {
    className: classnames_default()({
      'absolute h-full inset-0 w-full z-3': withPriceDetails || shouldDisplayDoubleSeasonButton,
      'pointer-events-auto': shouldDisplayDoubleSeasonButton
    }),
    onBlur: function onBlur() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onClick: function onClick(e) {
      if (shouldDisplayDoubleSeasonButton) {
        e.preventDefault();
        e.stopPropagation();

        if (!isDesktop) {
          setVisible();
        }
      }
    },
    onFocus: function onFocus() {
      if (isDesktop) {
        setVisible();
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onMouseOver: function onMouseOver() {
      if (isDesktop) {
        setVisible();
      }
    },
    tabIndex: 0
  }), siblingOpen && DayWithPrice_jsx("span", {
    className: thDayCornerMark
  }), withPriceDetails && DayWithPrice_jsx(DayPriceDetails_DayPriceDetails, {
    duration: duration,
    departureCity: departureCity,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    isVisible: isVisible,
    setIsVisible: setIsVisible,
    shouldDisplayDetails: !!price && shouldDisplayDetails,
    day: day,
    unit: unit
  }), product && siblingOpen && shouldDisplayDoubleSeasonButton && DayWithPrice_jsx(DayPriceDoubleSeason_DayPriceDoubleSeason, {
    availability: availability,
    product: product,
    isMouseOverDoubleSeasonPopin: isMouseOverDoubleSeasonPopin,
    isVisible: isVisible,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    setVisible: setVisible,
    statusMessageKey: statusMessageKey
  }), (!shouldDisplayDoubleSeasonButton || isTablet) && DayWithPrice_jsx("div", {
    className: thDayNumberContainer
  }, DayWithPrice_jsx("span", {
    className: classnames_default()(thDayNumber)
  }, moment_default()(day).format('D')), isHighlighted && DayWithPrice_jsx("div", {
    className: thDayHighlight
  })), shouldDisplayStatusMessage && Object(i18n["f" /* has */])(statusMessageKey) && !price && !isLoading && (siblingOpen ? shouldDisplayDoubleSeasonButton && DayWithPrice_jsx("span", {
    className: classnames_default()(thStatusMessage, {
      'shadow-md': isVisible || isMouseOverDoubleSeasonPopin
    })
  }, Object(i18n["h" /* t */])(statusMessageKey)) : DayWithPrice_jsx("span", {
    className: thStatusMessage
  }, Object(i18n["h" /* t */])(statusMessageKey))), shouldDisplaySelectedDepartureDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedDepartureDateMessage').toUpperCase(), ' ', DayWithPrice_jsx("div", {
    className: "mt-5"
  }, Object(i18n["h" /* t */])('booking.priceCalendar.endDateMessage'))), shouldDisplaySelectedDepartureDateMessageWithPrice && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedDepartureDateMessage').toUpperCase(), selectedPrice && selectedDuration && DayWithPrice_jsx("div", {
    className: "flex flex-col"
  }, DayWithPrice_jsx("span", null, Object(i18n["h" /* t */])('price.format.unitTotalPerTripIndicative').toUpperCase()), DayWithPrice_jsx("span", {
    className: "font-bold leading-tight text-12 md:text-16",
    "data-testid": "selected-date-best-price"
  }, theme === 'compact' ? getCompactPrice(selectedPrice) : selectedPrice))), shouldDisplaySelectedReturningDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedReturningDateMessage').toUpperCase()), isLoading ? DayWithPrice_jsx(Spinner["a" /* Spinner */], {
    size: "tiny",
    color: colors["a" /* COLORS */].BLACK
  }) : DayWithPrice_jsx(react["Fragment"], null, shouldDisplayPrice && !!price && DayWithPrice_jsx("div", {
    className: "flex flex-col text-current",
    "data-testid": "price-calendar-date-price"
  }, !!price && DayWithPrice_jsx("span", {
    className: thFrom
  }, Object(i18n["h" /* t */])('price.format.from')), DayWithPrice_jsx("span", {
    "data-testid": "price",
    className: thDayPrice
  }, theme === 'compact' ? getCompactPrice(price) : price), price !== oldPrice && DayWithPrice_jsx("span", {
    className: thDayOldPrice
  }, oldPrice)), thShowPricePlaceholder && (!shouldDisplayPrice || !price) && DayWithPrice_jsx("span", {
    className: classnames_default()(thDayPrice, {
      'opacity-0': !isDateSelectable
    })
  }, isDateSelectable ? Object(string_util["d" /* truncate */])(Object(i18n["h" /* t */])('faceting.when.dateSelect'), 6) : DayWithPrice_jsx(react_default.a.Fragment, null, "\xA0"))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx








var TripDatePicker_jsx = react_default.a.createElement;














var selector = function selector(state) {
  var _state$calendar;

  return {
    isBookableDatesLoading: state === null || state === void 0 ? void 0 : (_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.bookableDatesLoading
  };
}; // $FlowFixMe


var Weekday = function Weekday(_ref) {
  var weekday = _ref.weekday,
      className = _ref.className,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale;
  var weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return TripDatePicker_jsx("div", {
    className: className,
    title: weekdayName
  }, weekdayName);
};

var TripDatePicker_TripDatePicker = function TripDatePicker(_ref2) {
  var _modifiers;

  var className = _ref2.className,
      departureDate = _ref2.departureDate,
      duration = _ref2.duration,
      hasInstalment = _ref2.hasInstalment,
      isJoyview = _ref2.isJoyview,
      navbarElement = _ref2.navbarElement,
      navigationByYear = _ref2.navigationByYear,
      offsetCalendar = _ref2.offsetCalendar,
      onDayMouseOver = _ref2.onDayMouseOver,
      onSelect = _ref2.onSelect,
      openCalendarToDate = _ref2.openCalendarToDate,
      openingDates = _ref2.openingDates,
      optionsDuration = _ref2.optionsDuration,
      prices = _ref2.prices,
      product = _ref2.product,
      selectedBestPrice = _ref2.selectedBestPrice,
      _ref2$selectedDays = _ref2.selectedDays,
      from = _ref2$selectedDays.from,
      to = _ref2$selectedDays.to,
      selectedDuration = _ref2.selectedDuration,
      selectedMonth = _ref2.selectedMonth,
      selectedRealPrice = _ref2.selectedRealPrice,
      _ref2$shouldAllowSele = _ref2.shouldAllowSelectingSiblingOpenDays,
      shouldAllowSelectingSiblingOpenDays = _ref2$shouldAllowSele === void 0 ? false : _ref2$shouldAllowSele,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      withLongDayFormat = _ref2.withLongDayFormat,
      _ref2$withPriceDetail = _ref2.withPriceDetails,
      withPriceDetails = _ref2$withPriceDetail === void 0 ? false : _ref2$withPriceDetail,
      props = Object(objectWithoutProperties["a" /* default */])(_ref2, ["className", "departureDate", "duration", "hasInstalment", "isJoyview", "navbarElement", "navigationByYear", "offsetCalendar", "onDayMouseOver", "onSelect", "openCalendarToDate", "openingDates", "optionsDuration", "prices", "product", "selectedBestPrice", "selectedDays", "selectedDuration", "selectedMonth", "selectedRealPrice", "shouldAllowSelectingSiblingOpenDays", "theme", "withLongDayFormat", "withPriceDetails"]);

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _props$displayPrices = props.displayPrices,
      displayPrices = _props$displayPrices === void 0 ? Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('datePicker.displayPrices') : _props$displayPrices;

  var _useSelector = Object(es["e" /* useSelector */])(selector),
      isBookableDatesLoading = _useSelector.isBookableDatesLoading;

  var onMouseOver = function onMouseOver(day) {
    onDayMouseOver && onDayMouseOver(day);
  };

  var pricesIds = Object.keys(prices || {});
  var flattenedPrices = prices ? Object(TripDatePicker_utils["f" /* flattenPrices */])(prices) : '';
  var hasPrices = pricesIds.length > 0;
  var doDisplayPricesInDatePicker = hasPrices && displayPrices || theme === 'compact';
  var bothDatesSelected = Boolean(from && to);
  var resolvePrice = Object(react["useCallback"])(function (dayId) {
    return get_default()(prices, "[".concat(dayId, "]"), {});
  }, [flattenedPrices]);
  var isSeller = appContext.isSeller,
      locale = appContext.locale;
  var disabledDays = Object(react["useMemo"])(function () {
    return Object(TripDatePicker_utils["g" /* getDisabledDays */])({
      from: from,
      to: to,
      prices: prices,
      isSeller: isSeller,
      optionsDuration: optionsDuration,
      openingDates: openingDates,
      resolvePrice: resolvePrice,
      shouldAllowSelectingSiblingOpenDays: shouldAllowSelectingSiblingOpenDays
    });
  }, [from, isSeller, optionsDuration.join(), flattenedPrices, to]);
  var dayIsClosed = Object(react["useCallback"])(Object(TripDatePicker_utils["b" /* closedDaysFactory */])(resolvePrice, from, moment_default()(to).subtract(1, 'day').toDate(), shouldAllowSelectingSiblingOpenDays), [from, to, flattenedPrices]);
  var modifiers = (_modifiers = {}, Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].DARK_GREY, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].DARK_GREY,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN_OPACITY_45, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN_OPACITY_45,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREY, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREY,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE_OPACITY_45, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE_OPACITY_45,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].WHITE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].WHITE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].TURQUOISE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].TURQUOISE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, '!text-lightGrey', disabledDays), Object(defineProperty["a" /* default */])(_modifiers, "disabledDays", disabledDays), Object(defineProperty["a" /* default */])(_modifiers, "firstSiblingOpenDayOfSelectedMonth", Object(TripDatePicker_utils["e" /* firstSiblingOpenDayOfSelectedMonthFactory */])(resolvePrice, selectedMonth)), Object(defineProperty["a" /* default */])(_modifiers, "siblingOpenDays", Object(TripDatePicker_utils["k" /* siblingOpenDaysFactory */])(resolvePrice)), Object(defineProperty["a" /* default */])(_modifiers, 'pointer-events-none', function pointerEventsNone(day) {
    var dayIsSelected = from && to && Object(TripDatePicker_utils["d" /* dateToInt */])(day) >= Object(TripDatePicker_utils["d" /* dateToInt */])(from) && Object(TripDatePicker_utils["d" /* dateToInt */])(day) <= Object(TripDatePicker_utils["d" /* dateToInt */])(to);

    if (hasPrices && dayIsSelected) {
      return dayIsClosed(day);
    }
  }), _modifiers);
  var firstDateWithPrices = Object(react["useMemo"])(function () {
    var today = Object(TripDatePicker_utils["d" /* dateToInt */])(new Date());
    var dayWithPrice = pricesIds.find(function (pricesKey) {
      return Object(TripDatePicker_utils["d" /* dateToInt */])(moment_default()(pricesKey, apiDate["a" /* API_DATE_FORMAT */]).toDate()) > today && prices && prices[pricesKey].available;
    });
    return dayWithPrice || null;
  }, [JSON.stringify(flattenedPrices)]);
  var firstDateOpened = Object(react["useMemo"])(function () {
    if (!Array.isArray(openingDates) || openingDates.length === 0) {
      return null;
    }

    var _openingDates = Object(slicedToArray["a" /* default */])(openingDates, 1),
        opening = _openingDates[0].opening;

    return opening;
  }, [JSON.stringify(openingDates)]);
  var thDay = TripDatePicker_themes_themes({
    isTablet: isTablet
  })[theme].thDay; // If bookable dates are loading only define current or selected day as range

  var datesRange = isBookableDatesLoading ? {
    min: moment_default()(from).toDate(),
    max: moment_default()(from).toDate()
  } : {
    min: Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar),
    max: Object(TripDatePicker_utils["i" /* maxDatepickerDate */])()
  };

  var _useState = Object(react["useState"])(openCalendarToDate),
      openCalendarDate = _useState[0],
      setOpenCalendarDate = _useState[1];

  Object(react["useEffect"])(function () {
    setOpenCalendarDate(openCalendarToDate);
  }, [moment_default()(openCalendarToDate).format(apiDate["a" /* API_DATE_FORMAT */])]);
  Object(react["useEffect"])(function () {
    if (from) {
      setOpenCalendarDate(from);
    }
  }, [moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */])]);
  var initialMonth = Object(react["useMemo"])(function () {
    return moment_default()(openCalendarDate || from || firstDateWithPrices || firstDateOpened || Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar)).toDate();
  }, [moment_default()(openCalendarDate).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateWithPrices).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateOpened).format(apiDate["a" /* API_DATE_FORMAT */]), offsetCalendar]);
  return TripDatePicker_jsx(Datepicker["a" /* Datepicker */], Object(esm_extends["a" /* default */])({
    hasRangeMode: true,
    className: className,
    selectedDays: {
      from: from,
      to: to
    },
    disabledDays: disabledDays,
    customModifiers: modifiers,
    hasNavigationByYear: navigationByYear,
    minDate: datesRange.min,
    maxDate: datesRange.max,
    navbarElement: navbarElement,
    initialMonth: initialMonth,
    onSelect: onSelect,
    onMouseOver: onMouseOver,
    onFocus: onMouseOver,
    theme: theme,
    shouldHoverSiblingOpenDays: shouldAllowSelectingSiblingOpenDays,
    weekdayElement: withLongDayFormat ? TripDatePicker_jsx(Weekday, null) : undefined
  }, doDisplayPricesInDatePicker ? {
    // eslint-disable-next-line clubmed/no-fake-component
    renderDay: function renderDay(day, dayModifiers) {
      var shouldDisplayPrice = theme === 'compact' ? hasPrices && !dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected] : hasPrices && !to && !moment_default()(from).isSame(day, 'day');
      var price = resolvePrice(Object(TripDatePicker_utils["d" /* dateToInt */])(day));
      return TripDatePicker_jsx(DayWithPrice_DayWithPrice, {
        day: day,
        duration: duration,
        hasInstalment: hasInstalment,
        hasPrices: hasPrices,
        isSelectable: Boolean(!dayModifiers.disabledDays && from && !to && !DayPicker["DateUtils"].isSameDay(day, from)),
        isSelected: Boolean(dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected]),
        isLoading: departureDate && isBookableDatesLoading && moment_default()(day).isAfter(departureDate) ? true : false,
        isJoyview: isJoyview,
        locale: locale,
        price: price,
        product: product,
        selectedBestPrice: selectedBestPrice,
        selectedDuration: selectedDuration,
        selectedRealPrice: selectedRealPrice,
        isHighlighted: (dayModifiers.today || price.isBestPrice || price.lastAvailability || price.siblingOpen) && !dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected],
        shouldDisplayDetails: withPriceDetails && !!dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected] && !from && !to,
        shouldDisplayDoubleSeasonButton: dayModifiers.firstSiblingOpenDayOfSelectedMonth,
        shouldDisplayPrice: shouldDisplayPrice,
        shouldDisplaySelectedDepartureDateMessage: !!from && !to && moment_default()(from).isSame(day, 'day'),
        shouldDisplaySelectedDepartureDateMessageWithPrice: bothDatesSelected && moment_default()(from).isSame(day, 'day'),
        shouldDisplaySelectedReturningDateMessage: bothDatesSelected && moment_default()(to).isSame(day, 'day'),
        shouldDisplayStatusMessage: !from,
        withPriceDetails: withPriceDetails,
        theme: theme
      });
    },
    datePickerClassNames: {
      day: thDay
    }
  } : null));
};

/***/ }),

/***/ "q/8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProductArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchPrice; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Sj1w");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);






var getProductArgs = function getProductArgs(_ref) {
  var duration = _ref.duration,
      location = _ref.location,
      productId = _ref.productId,
      transport = _ref.transport,
      withDate = _ref.withDate;
  var queryParams = location.queryParams,
      urlParams = location.urlParams;
  var offerName = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["url"].decodePath(queryParams.offer) || '';
  var tripDuration = withDate ? duration || queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DURATION */ "h"]] : null;
  var productArgsToBuild = {};
  productArgsToBuild.offerName = offerName;
  productArgsToBuild.date = withDate ? queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DEPARTURE_DATE */ "g"]] || '' : '';
  productArgsToBuild.departureCity = transport || queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_TRANSPORT */ "m"]] || '';

  if (tripDuration) {
    productArgsToBuild.duration = parseInt(tripDuration, 10);
  }

  return Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams, productArgsToBuild);
};

function fetchPrice(_ref2) {
  var appContext = _ref2.appContext,
      duration = _ref2.duration,
      _ref2$forceAdultPerTr = _ref2.forceAdultPerTrip,
      forceAdultPerTrip = _ref2$forceAdultPerTr === void 0 ? false : _ref2$forceAdultPerTr,
      location = _ref2.location,
      productId = _ref2.productId,
      transport = _ref2.transport,
      _ref2$withDate = _ref2.withDate,
      withDate = _ref2$withDate === void 0 ? true : _ref2$withDate;
  var queryParams = location.queryParams;
  var offerName = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["url"].decodePath(queryParams.offer) || '';
  var _appContext$cmsConten = appContext.cmsContent,
      cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
      _appContext$cmsReleas = appContext.cmsRelease,
      cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
  var productArgs = getProductArgs({
    duration: duration,
    location: location,
    productId: productId,
    transport: transport,
    withDate: withDate
  });
  var cmsArgs = "content: \"".concat(cmsContent, "\", release: \"").concat(cmsRelease, "\"");
  var query = "query {\n    price(".concat(productArgs, ") {\n      offerColor( offerName : \"").concat(offerName, "\")\n      bestPrice(forceAdultPerTrip: ").concat(String(forceAdultPerTrip), ") {\n        value\n        formattedValue\n      }\n      initialPrice(forceAdultPerTrip: ").concat(String(forceAdultPerTrip), ") {\n        value\n        formattedValue\n      }\n      unit(").concat(cmsArgs, ")\n      currency\n      productId\n      termsAndConditions {\n        departureDate\n        duration\n        durationFormatted(").concat(cmsArgs, ")\n        departureCity {\n          value\n          name\n        }\n        numberOfAdults\n        accommodationComfortLabel\n        accommodationId\n        offerId\n      }\n    }\n  }");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* STATE_PRODUCT_PRICE_TICKET */ "pd"]
  });
}



/***/ }),

/***/ "qLhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterWhen; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ub5k");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("1JJ2");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("SPKZ");
/* harmony import */ var _CriteriaWhenReassuranceDropdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("s6y/");
/* harmony import */ var _trip_date_picker_TripDatePicker__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("pteD");
/* harmony import */ var _trip_date_picker_TripDatePicker_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("RqHf");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("kiXb");
/* harmony import */ var _NbNights__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("J8B4");


var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;












var PriceLegend = function PriceLegend(_ref) {
  var seasonLabel = _ref.seasonLabel,
      nbNightsProps = _ref.nbNightsProps;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  return __jsx("div", {
    className: "justify-center flex flex-wrap gap-10 text-14 font-bold"
  }, __jsx("div", {
    className: "bg-green px-10 py-5 rounded-4 text-white"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('faceting.when.bestPrice')), !!seasonLabel && __jsx("div", {
    className: "bg-turquoise px-10 py-5 rounded-4 text-white"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])(seasonLabel)), __jsx("div", {
    className: "bg-orange px-10 py-5 rounded-4 text-white"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('faceting.when.lastAvailability')), __jsx("div", {
    className: "bg-transparent line-through px-10 py-5 rounded-4 text-grey"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('faceting.when.notAvailable')), isDesktop && __jsx("div", {
    className: "ms-40 relative z-1"
  }, __jsx(_CriteriaWhenReassuranceDropdown__WEBPACK_IMPORTED_MODULE_8__[/* CriteriaWhenReassuranceDropdown */ "a"], {
    nbNightsProps: nbNightsProps
  })));
};

var FilterWhen = function FilterWhen(_ref2) {
  var changeDepartureDate = _ref2.changeDepartureDate,
      changeTripDuration = _ref2.changeTripDuration,
      departureDate = _ref2.departureDate,
      duration = _ref2.duration,
      isSubmittable = _ref2.isSubmittable,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? '' : _ref2$label,
      navigationByYear = _ref2.navigationByYear,
      openCalendarToDate = _ref2.openCalendarToDate,
      _ref2$openingDates = _ref2.openingDates,
      openingDates = _ref2$openingDates === void 0 ? [] : _ref2$openingDates,
      _ref2$optionsDuration = _ref2.optionsDuration,
      optionsDuration = _ref2$optionsDuration === void 0 ? [] : _ref2$optionsDuration,
      _ref2$prices = _ref2.prices,
      prices = _ref2$prices === void 0 ? {} : _ref2$prices,
      offsetCalendar = _ref2.offsetCalendar,
      seasonLabel = _ref2.seasonLabel,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'compact' : _ref2$theme;

  var _useAppContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__[/* useAppContext */ "c"])(),
      isSeller = _useAppContext.isSeller;

  var from = departureDate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).toDate() : null;
  var to = from && duration ? moment__WEBPACK_IMPORTED_MODULE_2___default()(from).add({
    days: duration
  }).toDate() : null;
  var hasPrices = Object.keys(prices || {}).length > 0;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(from),
      hovered = _useState[0],
      setHovered = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    if (!departureDate) {
      setHovered(null);
    }
  }, [departureDate]);

  var onDayMouseOver = function onDayMouseOver(day) {
    setHovered(day);
  };

  var nbNightsProps = {
    from: from,
    to: to,
    hovered: hovered,
    duration: duration
  };

  var onSelect = function onSelect(dates) {
    changeDepartureDate(dates.from);

    if (dates.from && dates.to) {
      var updatedDuration = Object(_trip_date_picker_TripDatePicker_utils__WEBPACK_IMPORTED_MODULE_10__[/* dateDiff */ "c"])(dates.from, dates.to);
      changeTripDuration(updatedDuration);
    } else {
      changeTripDuration(null);
    }
  };

  var cls = ['border-b-1 border-grey -mx-10 px-5 py-10', 'lg:border-0 md:mx-auto lg:px-10 lg:pt-20 lg:pb-0'];
  return __jsx("div", {
    "data-testid": "FilterWhen",
    className: "block mb-40 sm:m-0"
  }, // TODO: cleanup !!
  // eslint-disable-next-line no-nested-ternary
  label ? isSubmittable ? __jsx("div", {
    className: "flex font-bold items-center p-20 lg:p-0 text-left text-orange text-12"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_7__[/* ICONS */ "a"].WARNING,
    width: "2.5em",
    className: "flex mr-10"
  }), __jsx("span", null, label)) : __jsx("div", {
    className: "font-bold lg:text-center text-18"
  }, label) : null, __jsx("div", {
    className: cls.join(' ')
  }, hasPrices ? __jsx("div", {
    className: "pb-10 w-full"
  }, __jsx(PriceLegend, {
    seasonLabel: seasonLabel,
    nbNightsProps: nbNightsProps
  })) : null, __jsx("div", {
    className: "max-h-none"
  }, __jsx(_trip_date_picker_TripDatePicker__WEBPACK_IMPORTED_MODULE_9__[/* TripDatePicker */ "a"], {
    className: "pb-0",
    departureDate: departureDate,
    hasInstalment: true,
    navigationByYear: navigationByYear,
    offsetCalendar: offsetCalendar,
    openCalendarToDate: openCalendarToDate,
    openingDates: openingDates,
    optionsDuration: optionsDuration,
    onSelect: onSelect,
    prices: prices,
    selectedDays: {
      from: from,
      to: to
    },
    shouldAllowSelectingSiblingOpenDays: true,
    theme: theme,
    onDayMouseOver: onDayMouseOver
  }), isSeller && __jsx(_NbNights__WEBPACK_IMPORTED_MODULE_12__[/* NbNights */ "a"], nbNightsProps))));
};

/***/ }),

/***/ "qYhz":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("c7Qd"),
    isArrayLike = __webpack_require__("9y2L"),
    isString = __webpack_require__("nDih"),
    toInteger = __webpack_require__("m2YG"),
    values = __webpack_require__("0iyY");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),

/***/ "rJ95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createOptimisticAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function createAction(type, payload) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}

function createOptimisticAction(type, payload, meta) {
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}


/* harmony default export */ __webpack_exports__["b"] = (createAction);

/***/ }),

/***/ "rueY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchCalendarTripPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setPossibleDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setInitialDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setIsPriceCalendarSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setCalendarBlockInputDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearCalendar; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("uDfI");
/* harmony import */ var _calendar_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("VtPb");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("cvSI");
/* harmony import */ var _priceTicket_priceTicket_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("q/8t");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fflk");
/* harmony import */ var _trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Mn1B");
/* harmony import */ var _trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("6wD6");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("L73y");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("nv//");


















function fetchCalendar(options, appContext) {
  return function (dispatch, getState) {
    var _state$calendar, _state$calendar2, _state$calendar$calen, _state$calendar3;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.isLoading) && ((_state$calendar2 = state.calendar) === null || _state$calendar2 === void 0 ? void 0 : _state$calendar2.lastRequestId) !== -1;

    if (calendarRequestInProgress || JSON.stringify(options) === JSON.stringify((_state$calendar$calen = (_state$calendar3 = state.calendar) === null || _state$calendar3 === void 0 ? void 0 : _state$calendar3.calendarCriteria) !== null && _state$calendar$calen !== void 0 ? _state$calendar$calen : {})) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_ABORT */ "i"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR */ "h"], {
      departureCity: options.transport,
      productId: options.resortId,
      options: options
    }, {
      optimist: true,
      promise: Object(_calendar_helper__WEBPACK_IMPORTED_MODULE_7__[/* queryFetchCalendar */ "g"])(appContext, options)
    }));
  };
}
function fetchCalendarTripPrice(options) {
  return function (dispatch, getState) {
    var _state$calendar4, _state$calendar5;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar4 = state.calendar) === null || _state$calendar4 === void 0 ? void 0 : _state$calendar4.isLoading) && ((_state$calendar5 = state.calendar) === null || _state$calendar5 === void 0 ? void 0 : _state$calendar5.lastRequestId) !== -1;

    if (calendarRequestInProgress) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_TRIP_PRICE_ABORT */ "k"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_TRIP_PRICE */ "j"], {}, {
      optimist: true,
      promise: Object(_priceTicket_priceTicket_helper__WEBPACK_IMPORTED_MODULE_9__[/* fetchPrice */ "a"])(options)
    }));
  };
}
function fetchBookableDates(options, appContext) {
  return function (dispatch, getState) {
    var _state$calendar6, _state$calendar7, _state$calendar8, _state$calendar9;

    var state = getState();
    var bookableDateRequestInProgress = ((_state$calendar6 = state.calendar) === null || _state$calendar6 === void 0 ? void 0 : _state$calendar6.bookableDatesLoading) && ((_state$calendar7 = state.calendar) === null || _state$calendar7 === void 0 ? void 0 : _state$calendar7.bookableDateLastRequestId) !== -1;

    if (bookableDateRequestInProgress || options.departureCity === ((_state$calendar8 = state.calendar) === null || _state$calendar8 === void 0 ? void 0 : _state$calendar8.bookableDatesCriteria.departureCity) && options.productId === ((_state$calendar9 = state.calendar) === null || _state$calendar9 === void 0 ? void 0 : _state$calendar9.bookableDatesCriteria.productId)) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_BOOKABLE_DATES_ABORT */ "g"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_BOOKABLE_DATES */ "f"], {}, {
      optimist: true,
      promise: Object(_calendar_helper__WEBPACK_IMPORTED_MODULE_7__[/* queryFetchBookableDates */ "f"])(appContext, options)
    }));
  };
}
function selectMonth(selectedMonth) {
  // format YYYYMM (number)
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_CHANGE_MONTH */ "a"], {
    selectedMonth: selectedMonth
  });
}

function determineDepartureDate(state) {
  if (!Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state)) {
    var departureDateFromUrl = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_17__[/* getQueryParameters */ "k"])(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["windowWrapper"].getLocation()), _utils_uri_constants__WEBPACK_IMPORTED_MODULE_16__[/* QUERY_DEPARTURE_DATE */ "g"]);

    return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__[/* formatTimestampDate */ "b"])(departureDateFromUrl, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]) || Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state);
  }

  return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__[/* formatTimestampDate */ "b"])(Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state), _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]);
}

function setPossibleDepartureDate() {
  return function (dispatch, getState) {
    var findDayInMonths = function findDayInMonths() {
      var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var dayId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var id = parseInt(dayId, 10);
      var allDays = months.reduce(function (acc, m) {
        return [].concat(acc, m.days);
      }, []);
      return allDays.find(function (d) {
        return lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(d, 'dayContent.id') === id;
      });
    };

    var departureDate = determineDepartureDate(getState());

    if (departureDate) {
      var calendarMonth = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(getState(), 'calendar.calendar.months');

      var day = findDayInMonths(calendarMonth, departureDate);

      var dayContent = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(day, 'dayContent', null);

      if (dayContent) {
        if (lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(dayContent, 'canGoToBooking')) {
          var yearAndMonth = parseInt(dayContent.id / 100, 10);
          Object(react_redux__WEBPACK_IMPORTED_MODULE_6__[/* batch */ "b"])(function () {
            dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__[/* updateTripDateCriteria */ "a"])({
              day: dayContent
            })); // makes sure tripCriteria.departureDate in store is synchronised
            // TODO: merge tripDateCriteria into tripCriteria #12563

            dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__[/* setDepartureDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_5___default()("".concat(dayContent.id), _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]).valueOf()));
            dispatch(selectMonth(yearAndMonth));
          });
        } else {
          Object(react_redux__WEBPACK_IMPORTED_MODULE_6__[/* batch */ "b"])(function () {
            dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__[/* updateTripDateCriteria */ "a"])({
              day: null
            }));
            dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__[/* setDepartureDate */ "a"])(null));
          });
        }
      }
    }
  };
}
var setInitialDuration = function setInitialDuration(duration) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_SET_INITIAL_DURATION */ "c"],
    payload: {
      duration: duration
    }
  };
};
var setIsPriceCalendarSelection = function setIsPriceCalendarSelection(isPriceCalendarSelection) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION */ "d"],
    payload: {
      isPriceCalendarSelection: isPriceCalendarSelection
    }
  };
};
var setCalendarBlockInputDepartureDate = function setCalendarBlockInputDepartureDate(blockInputDepartureDate) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE */ "b"],
    payload: {
      blockInputDepartureDate: blockInputDepartureDate
    }
  };
};
var clearCalendar = function clearCalendar() {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CLEAR_CALENDAR */ "e"]
  };
};

/***/ }),

/***/ "s+R0":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("JBn+"),
    arrayIncludes = __webpack_require__("OfKG"),
    arrayIncludesWith = __webpack_require__("sCL+"),
    cacheHas = __webpack_require__("S0iI"),
    createSet = __webpack_require__("9TP6"),
    setToArray = __webpack_require__("XlL0");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "s6y/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaWhenReassuranceDropdown; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("1JJ2");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("U6GL");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Ub5k");
/* harmony import */ var _NbNights__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("J8B4");

var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;









var CriteriaWhenReassuranceDropdown = function CriteriaWhenReassuranceDropdown(_ref) {
  var nbNightsProps = _ref.nbNightsProps;

  var _useAppContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_8__[/* useAppContext */ "c"])(),
      isSeller = _useAppContext.isSeller;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop; // eslint-disable-next-line clubmed/no-fake-component


  var renderTrigger = function renderTrigger() {
    return __jsx("button", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
      type: "button"
    }, isDesktop ? {
      onMouseEnter: function onMouseEnter() {
        setIsExpanded(true);
      },
      onMouseLeave: function onMouseLeave() {
        setIsExpanded(false);
      }
    } : {
      onClick: function onClick() {
        setIsExpanded(!isExpanded);
      }
    }, {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('h-full leading-0', {
        'criteria-arrow': isExpanded && !isDesktop
      })
    }), __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
      name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].INFORMATION,
      width: "calc(18rem / 16)"
    }));
  };

  return __jsx(_frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_7__[/* DropDown */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('h-full', {
      'leading-0': isDesktop
    }),
    contentClassName: "lg:mt-10",
    contentStyle: isDesktop ? {
      width: 380
    } : {},
    hasArrow: isDesktop,
    isExpanded: isExpanded,
    onClose: function onClose() {
      setIsExpanded(false);
    },
    relative: isDesktop,
    renderTrigger: renderTrigger,
    theme: "hollow"
  }, function () {
    return __jsx("div", {
      className: "p-15 lg:p-20 text-12 text-mediumGrey leading-normal"
    }, !isSeller && nbNightsProps.duration && __jsx(_NbNights__WEBPACK_IMPORTED_MODULE_9__[/* NbNights */ "a"], nbNightsProps), Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('faceting.when.reinsurance'));
  });
};

/***/ }),

/***/ "sW3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADULTS_ONLY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTS_NUMBER_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return MAX_PAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return MAX_PAX_SELLER; });
/* unused harmony export AREA_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHILDCARE_CRITERIA_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHILDCARE_FILTER_FACET_ID; });
/* unused harmony export COUNTRY_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DEFAULT_DEPARTURE_CITY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DEPARTURE_CITY_FACET_ID; });
/* unused harmony export DEPARTURE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DEPARTURE_DATE_MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DEPARTURE_DATE_MAX_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DEPARTURE_DATE_MIN_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DURATION_FACET; });
/* unused harmony export KIDS_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return KIDS_NUMBER_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return KIDS_NUMBER_MAX_SELLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return LOCALE_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return MAX_NUMBER_OF_SELECTED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return OFFER_ID_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return PRODUCT_FACET_ID; });
/* unused harmony export WHEN_FACET_ID */
/* unused harmony export WHERE_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DESTINATIONS_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return COUNTRIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SEASON_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return TOP_COUNTRIES_FACET_LIST_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return TYPES_OF_STAY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FLIGHT_DURATION_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return QUERY_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SORT_BY_PRICE_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PRODUCTS_TO_COMPARE_QUERY_PARAM; });
/* unused harmony export FACET_QUERY_PARAMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DEFAULT_CHILDCARE_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FILTERABLE_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CUSTOM_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FILTERABLE_FACETS_TRACKING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GROUP_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHILDCARE_FILTER_FACET_OPTION_0_TO_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CHILDCARE_FILTER_FACET_OPTION_2_TO_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CHILDCARE_FILTER_FACET_OPTION_4_TO_10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHILDCARE_FILTER_FACET_OPTION_11_TO_17; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHILDCARE_FILTER_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHILDCARE_FILTER_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHILDCARE_FILTER_FACET_AVERAGE_MONTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FLIGHT_DURATION_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FLIGHT_DURATION_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FLIGHT_DURATION_FACET_AS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SEASON_FACET_FIRST_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SEASON_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SEASON_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SEASON_FACET_QUERY_PARAM_FR_TO_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SEASON_FACET_QUERY_PARAM_EN_TO_FR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return TYPES_OF_STAY_FACET_BADGE_ICON_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return TYPES_OF_STAY_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return TYPES_OF_STAY_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FILTERABLE_FACETS_TEMPLATE_CONFIG; });
/* unused harmony export FACETS */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");



var ADULTS_ONLY_FACET_ID = 'facette_adult_only';
var ADULTS_NUMBER_MIN = 1;
var MAX_PAX = 6;
var MAX_PAX_SELLER = 8;
var AREA_FACET_PREFIX_ID = 'AREA';
var CHILDCARE_CRITERIA_FACET_ID = 'facette_childcare_age_in_month';
var CHILDCARE_FILTER_FACET_ID = 'facette_childcare_age_in_month_list';
var COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
var DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
var DEPARTURE_DATE = 'date';
var DEPARTURE_DATE_MAX_DATE = {
  years: 2
};
var DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
var DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
var DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
var DURATION_FACET = 'facette_duration';
var KIDS_FACET_ID = 'facette_kids';
var KIDS_NUMBER_MAX = 5;
var KIDS_NUMBER_MAX_SELLER = 7;
var LOCALE_FACET_ID = 'locale';
var MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
var OFFER_ID_FACET_ID = 'facette_offer_id';
var PRODUCT_FACET_ID = 'product_id';
var WHEN_FACET_ID = 'facette_when';
var WHERE_FACET_ID = 'facette_where';
var ACTIVITIES_FACET_ID = 'activities_tree';
var DESTINATIONS_FACET_ID = 'destinations_tree';
var COUNTRIES_FACET_ID = 'facette_destination_country';
var SEASON_FACET_ID = 'seasons_ns';
var TOP_COUNTRIES_FACET_LIST_ID = 'facet_list_top_destination_countries';
var TYPES_OF_STAY_FACET_ID = 'facette_types';
var FLIGHT_DURATION_FACET_ID = 'facette_flight_duration';
var QUERY_QUERY_PARAM = 'search';
var SORT_BY_PRICE_QUERY_PARAM = 'sortByPrice';
var PRODUCTS_TO_COMPARE_QUERY_PARAM = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].productsComparison.productIds;
var FACET_QUERY_PARAMS = [{
  id: 'destination',
  facetId: COUNTRIES_FACET_ID
}, {
  id: 'departure_city',
  facetId: DEPARTURE_CITY_FACET_ID
}];
var DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];
var FILTERABLE_FACETS_IDS = [ACTIVITIES_FACET_ID, CHILDCARE_FILTER_FACET_ID, COUNTRIES_FACET_ID, DESTINATIONS_FACET_ID, SEASON_FACET_ID, TYPES_OF_STAY_FACET_ID];
var CUSTOM_FACETS_IDS = [FLIGHT_DURATION_FACET_ID];
var FILTERABLE_FACETS_TRACKING_CONFIG = [{
  id: ACTIVITIES_FACET_ID,
  trackingPrefixLabel: 'activities'
}, {
  id: CHILDCARE_FILTER_FACET_ID,
  trackingPrefixLabel: 'childcare'
}, {
  id: DESTINATIONS_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: COUNTRIES_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: FLIGHT_DURATION_FACET_ID,
  trackingPrefixLabel: 'flightDuration'
}, {
  id: SEASON_FACET_ID,
  trackingPrefixLabel: 'season'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  trackingPrefixLabel: 'typeofstay'
}];
var GROUP_STRING = 'group::';
var CHILDCARE_FILTER_FACET_OPTION_0_TO_2 = "".concat(GROUP_STRING, "from_0_to_2");
var CHILDCARE_FILTER_FACET_OPTION_2_TO_3 = "".concat(GROUP_STRING, "from_2_to_3");
var CHILDCARE_FILTER_FACET_OPTION_4_TO_10 = "".concat(GROUP_STRING, "from_4_to_10");
var CHILDCARE_FILTER_FACET_OPTION_11_TO_17 = "".concat(GROUP_STRING, "from_11_to_17");
var CHILDCARE_FILTER_FACET_LABELS_PREFIX = 'faceting.filters.childcare.label_';
var CHILDCARE_FILTER_FACET_LABELS = {
  from_0_to_2: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "babyClub"),
  from_2_to_3: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "miniClub"),
  from_4_to_10: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "petitClub"),
  from_11_to_17: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "teenClub")
};
var CHILDCARE_FILTER_FACET_AVERAGE_MONTHS = {
  from_0_to_2: 12,
  from_2_to_3: 30,
  from_4_to_10: 84,
  from_11_to_17: 168
};
var FLIGHT_DURATION_FACET_LABELS_PREFIX = 'faceting.filters.flightDuration.label_';
var FLIGHT_DURATION_FACET_LABELS = {
  '2h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "2h"),
  '4h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "4h"),
  '8h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "8h"),
  '8hmore': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "8h_more")
};
var FLIGHT_DURATION_FACET_AS_LIST = {
  id: FLIGHT_DURATION_FACET_ID,
  name: FLIGHT_DURATION_FACET_ID,
  list: [{
    label: '2h',
    value: '2h',
    count: -1
  }, {
    label: '4h',
    value: '4h',
    count: -1
  }, {
    label: '8h',
    value: '8h',
    count: -1
  }, {
    label: '8hmore',
    value: '8hmore',
    count: -1
  }]
};
var SEASON_FACET_FIRST_OPTION = 'SOLEIL';
var SEASON_FACET_LABELS_PREFIX = 'faceting.filters.season.label_';
var SEASON_FACET_LABELS = {
  NEIGE: "".concat(SEASON_FACET_LABELS_PREFIX, "snow"),
  SOLEIL: "".concat(SEASON_FACET_LABELS_PREFIX, "sun")
};
var SEASON_FACET_QUERY_PARAM_FR_TO_EN = {
  NEIGE: 'SNOW',
  SOLEIL: 'SUN'
};
var SEASON_FACET_QUERY_PARAM_EN_TO_FR = {
  SNOW: 'NEIGE',
  SUN: 'SOLEIL'
};
var NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES = ['CRUISE', 'JOYVIEW', 'TOUR'];
var TYPES_OF_STAY_FACET_BADGE_ICON_PROPS = {
  3: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SAFFRON,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SAFFRON,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLACK,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].TRIDENT3,
    size: 40
  },
  4: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SAFFRON,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SAFFRON,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLACK,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].TRIDENT4,
    size: 40
  },
  5: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].ULTRAMARINE,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].ULTRAMARINE,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].DIAMOND,
    size: 40
  },
  6: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].ULTRAMARINE,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].ULTRAMARINE,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].TRIDENT6,
    size: 40
  },
  CRUISE: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SIENNA,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SIENNA,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].CRUISE,
    size: 40
  },
  JOYVIEW: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLUE_WAVE,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLUE_WAVE,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].TRIDENT_JOYVIEW,
    size: 40
  },
  TOUR: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SIENNA,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SIENNA,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].TOUR,
    size: 40
  }
};
var TYPES_OF_STAY_FACET_LABELS_PREFIX = 'faceting.filters.typesOfStay.label_';
var TYPES_OF_STAY_FACET_LABELS = {
  3: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "3_tridents"),
  4: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "4_tridents"),
  5: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "exclusive_collection"),
  6: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "villa"),
  CRUISE: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "cruise"),
  JOYVIEW: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "joyview"),
  TOUR: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "tour")
};
var FILTERABLE_FACETS_TEMPLATE_CONFIG = [{
  id: DESTINATIONS_FACET_ID,
  dataLabel: 'where',
  facetLists: [{
    deep: false,
    id: DESTINATIONS_FACET_ID,
    titleLabel: 'faceting.filters.where.destinationTitle'
  }, {
    deep: false,
    id: COUNTRIES_FACET_ID,
    titleLabel: 'faceting.filters.where.countriesTitle'
  }],
  titleLabel: 'faceting.filters.where.title'
}, {
  id: ACTIVITIES_FACET_ID,
  dataLabel: 'activities',
  facetLists: [{
    deep: true,
    id: ACTIVITIES_FACET_ID
  }],
  titleLabel: 'faceting.filters.activities.title'
}, {
  id: CHILDCARE_FILTER_FACET_ID,
  dataLabel: 'childcare',
  facetLists: [{
    deep: false,
    id: CHILDCARE_FILTER_FACET_ID,
    facetLabels: CHILDCARE_FILTER_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.childcare.title',
  trackingPrefixLabel: 'childcare'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  dataLabel: 'typeofstay',
  facetLists: [{
    deep: false,
    id: TYPES_OF_STAY_FACET_ID,
    facetLabels: TYPES_OF_STAY_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.typesOfStay.title',
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FLIGHT_DURATION_FACET_ID,
  dataLabel: 'flightDuration',
  facetLists: [{
    deep: false,
    id: FLIGHT_DURATION_FACET_ID,
    facetLabels: FLIGHT_DURATION_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.flightDuration.title',
  trackingPrefixLabel: 'flightDuration'
}, {
  id: SEASON_FACET_ID,
  capitalizeLabels: true,
  dataLabel: 'season',
  facetLists: [{
    deep: false,
    id: SEASON_FACET_ID,
    facetLabels: SEASON_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.season.title',
  trackingPrefixLabel: 'season'
}];
var FACETS = {
  when: 'when',
  who: 'who',
  where: 'where'
};

/***/ }),

/***/ "tRRp":
/***/ (function(module) {

module.exports = JSON.parse("{\"0\":65533,\"128\":8364,\"130\":8218,\"131\":402,\"132\":8222,\"133\":8230,\"134\":8224,\"135\":8225,\"136\":710,\"137\":8240,\"138\":352,\"139\":8249,\"140\":338,\"142\":381,\"145\":8216,\"146\":8217,\"147\":8220,\"148\":8221,\"149\":8226,\"150\":8211,\"151\":8212,\"152\":732,\"153\":8482,\"154\":353,\"155\":8250,\"156\":339,\"158\":382,\"159\":376}");

/***/ }),

/***/ "tUgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FilterWho_FilterWho; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("Rfxz");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/utils/faceting/kidsValidationStateUtils.js
var kidsValidationStateUtils = __webpack_require__("cGFA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("yXV3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("5s+n");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-date/InputDate.themes.js


var themes = {
  "default": function _default(props) {
    return {
      thInputWrapper: 'flex flex-1 h-full items-center relative',
      thInput: classnames_default()(' h-full text-center text-current w-full', Object(form_util["a" /* getCursorClass */])(props))
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-date/InputDate.jsx
























var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var DAY = 'd';
var MONTH = 'm';
var YEAR = 'y';
var DAY_LENGTH = 2;
var MONTH_LENGTH = 2;
var YEAR_LENGTH = 4;

function getInputsState(_ref) {
  var value = _ref.value;
  var date = value ? moment_default()(value) : moment_default()(null);
  return {
    dayValue: date.isValid() ? date.format('DD') : '',
    monthValue: date.isValid() ? date.format('MM') : '',
    yearValue: date.isValid() ? date.format('YYYY') : ''
  };
}

var defaultProps = {
  dateFormat: 'DDMMYYYY',
  onChange: function onChange() {
    return Promise.resolve();
  },
  theme: 'default'
};
var InputDate_InputDate = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputDate, _Component);

  var _super = _createSuper(InputDate);

  function InputDate(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputDate);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (inputRef, value, maxLength, nextRef) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? noop_default.a : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        _this.setState(Object(defineProperty["a" /* default */])({}, inputRef, value), function () {
          return onChange(_this.props.name || '', _this.getDate());
        });

        if (nextRef && value.length === maxLength) {
          var _this$nextRef;

          // $FlowFixMe
          (_this$nextRef = _this[nextRef]) === null || _this$nextRef === void 0 ? void 0 : _this$nextRef.focus();
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? noop_default.a : _this$props$onClear;

      _this.setState({
        dayValue: '',
        monthValue: '',
        yearValue: ''
      }, function () {
        return onClear(e);
      });
    });

    _this.state = _objectSpread({}, getInputsState(props));
    return _this;
  }

  Object(createClass["a" /* default */])(InputDate, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState(getInputsState(nextProps));
      }
    }
  }, {
    key: "getDate",
    value: function getDate() {
      var _this$state = this.state,
          dayValue = _this$state.dayValue,
          monthValue = _this$state.monthValue,
          yearValue = _this$state.yearValue;
      var allFields = dayValue.length === DAY_LENGTH && monthValue.length === MONTH_LENGTH && yearValue.length === YEAR_LENGTH;

      if (allFields) {
        var date = moment_default()([parseInt(yearValue, 10), parseInt(monthValue, 10) - 1, parseInt(dayValue, 10)]);
        return date.isValid() ? date.valueOf() : false;
      }

      return null;
    }
  }, {
    key: "getInputOrder",
    value: function getInputOrder(type) {
      var _this$props$dateForma = this.props.dateFormat,
          dateFormat = _this$props$dateForma === void 0 ? '' : _this$props$dateForma;
      return dateFormat.toLowerCase().indexOf(type);
    }
  }, {
    key: "getInputs",
    value: function getInputs() {
      return [{
        ref: 'dayValue',
        placeholder: this.props.placeholderDay || '',
        value: this.state.dayValue,
        order: this.getInputOrder(DAY),
        maxLength: DAY_LENGTH
      }, {
        ref: 'monthValue',
        placeholder: this.props.placeholderMonth || '',
        value: this.state.monthValue,
        order: this.getInputOrder(MONTH),
        maxLength: MONTH_LENGTH
      }, {
        ref: 'yearValue',
        placeholder: this.props.placeholderYear || '',
        value: this.state.yearValue,
        order: this.getInputOrder(YEAR),
        maxLength: YEAR_LENGTH
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          hasClear = _this$props2.hasClear,
          iconLeft = _this$props2.iconLeft,
          _this$props2$id = _this$props2.id,
          id = _this$props2$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputDate_') : _this$props2$id,
          isDisabled = _this$props2.isDisabled,
          isFilled = _this$props2.isFilled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          isRequired = _this$props2.isRequired,
          label = _this$props2.label,
          notes = _this$props2.notes,
          onBlur = _this$props2.onBlur,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          theme = _this$props2.theme,
          validationState = _this$props2.validationState;
      var _this$state2 = this.state,
          dayValue = _this$state2.dayValue,
          monthValue = _this$state2.monthValue,
          yearValue = _this$state2.yearValue;
      var hasValue = Boolean(dayValue) || Boolean(monthValue) || Boolean(yearValue);
      var hasClearEnabled = Boolean(hasClear && hasValue);

      var inputs = sortBy_default()(this.getInputs(), ['order']);

      var _themes$theme = themes[theme](this.props),
          thInput = _themes$theme.thInput,
          thInputWrapper = _themes$theme.thInputWrapper,
          thSeparator = _themes$theme.thSeparator;

      return __jsx(FormControl["a" /* FormControl */], {
        className: classnames_default()('direction-ltr', className),
        hasClear: hasClearEnabled,
        iconLeft: iconLeft,
        id: id,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        theme: theme,
        validationState: validationState
      }, inputs.map(function (input, index) {
        var nextRef = index + 1 < inputs.length ? inputs[index + 1].ref : null;
        return __jsx(react["Fragment"], {
          key: index
        }, !!index && __jsx("span", {
          className: thSeparator,
          role: "presentation"
        }, "/"), __jsx("span", {
          className: thInputWrapper
        }, __jsx("input", Object(esm_extends["a" /* default */])({
          className: thInput,
          "data-testid": input.ref,
          disabled: isDisabled
        }, index === 0 ? {
          id: id
        } : null, {
          maxLength: input.maxLength,
          onBlur: onBlur,
          onChange: function onChange(e) {
            return _this2.onChange(input.ref, e.target.value, input.maxLength, nextRef);
          },
          onClick: onClick,
          onFocus: onFocus,
          onKeyDown: onKeyDown,
          onKeyUp: onKeyUp,
          placeholder: input.placeholder,
          readOnly: Boolean(isReadOnly || isLoading),
          ref: function ref(node) {
            // $FlowFixMe
            _this2[input.ref] = node;
          },
          required: isRequired,
          type: "tel",
          value: input.value
        }))));
      }));
    }
  }]);

  return InputDate;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputDate_InputDate, "defaultProps", defaultProps);
// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx + 1 modules
var InputNumber = __webpack_require__("xGYs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-who/filter-who/FilterWho.jsx












var FilterWho_jsx = react_default.a.createElement;

function FilterWho_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FilterWho_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FilterWho_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FilterWho_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var FilterWho_FilterWho = function FilterWho(_ref) {
  var addChildcareLabel = _ref.addChildcareLabel,
      adultsLabel = _ref.adultsLabel,
      adultsNumber = _ref.adultsNumber,
      _ref$birthdaysErrorMe = _ref.birthdaysErrorMessage,
      birthdaysErrorMessage = _ref$birthdaysErrorMe === void 0 ? '' : _ref$birthdaysErrorMe,
      changeKidsNumber = _ref.changeKidsNumber,
      changeKid = _ref.changeKid,
      dateFormat = _ref.dateFormat,
      dayPlaceholder = _ref.dayPlaceholder,
      disableKids = _ref.disableKids,
      hasChildcareSwitch = _ref.hasChildcareSwitch,
      _ref$informationLabel = _ref.informationLabel,
      informationLabel = _ref$informationLabel === void 0 ? '' : _ref$informationLabel,
      isShrink = _ref.isShrink,
      kids = _ref.kids,
      kidsAgeLabel = _ref.kidsAgeLabel,
      kidsAgeLimitLabel = _ref.kidsAgeLimitLabel,
      kidsLabel = _ref.kidsLabel,
      kidsValidationState = _ref.kidsValidationState,
      label = _ref.label,
      _ref$minAdultsNumber = _ref.minAdultsNumber,
      minAdultsNumber = _ref$minAdultsNumber === void 0 ? 1 : _ref$minAdultsNumber,
      monthPlaceholder = _ref.monthPlaceholder,
      setAdultsNumber = _ref.setAdultsNumber,
      validateKidsBirthdate = _ref.validateKidsBirthdate,
      yearPlaceholder = _ref.yearPlaceholder;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useState = Object(react["useState"])(kids.some(function (kid) {
    return kid.childcareIncluded;
  })),
      childcareIncluded = _useState[0],
      setChildcareIncluded = _useState[1];

  var handleKidsNumber = function handleKidsNumber(name, value) {
    if (changeKidsNumber) {
      changeKidsNumber(value);
    }
  };

  var handleKidAge = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(index, kid) {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!kid.birthdate) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return validateKidsBirthdate(index, kid);

            case 3:
              // $FlowFixMe
              if (Object(facetingUtils["n" /* isKidMinor */])(kid.birthdate)) {
                changeKid(index, kid);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleKidAge(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var maxPax = appContext.isSeller ? constants["L" /* MAX_PAX_SELLER */] : constants["K" /* MAX_PAX */];

  var getMaxAdultsAvailable = function getMaxAdultsAvailable() {
    return maxPax - kids.length;
  };

  var getMaxKidsAvailable = function getMaxKidsAvailable() {
    return maxPax - adultsNumber;
  };

  Object(react["useEffect"])(function () {
    hasChildcareSwitch && kids.forEach(function (kid, index) {
      return changeKid(index, FilterWho_objectSpread(FilterWho_objectSpread({}, kid), {}, {
        childcareIncluded: childcareIncluded
      }));
    });
  }, [childcareIncluded]);
  return FilterWho_jsx("div", {
    "data-testid": "FilterWho",
    className: "FilterWho"
  }, FilterWho_jsx("div", {
    className: "p-20"
  }, FilterWho_jsx("p", {
    className: "font-bold lg:text-center mb-20 text-18"
  }, label), FilterWho_jsx("div", {
    className: "flex flex-col lg:flex-row lg:items-center gap-20"
  }, FilterWho_jsx(InputNumber["a" /* InputNumber */], {
    ariaLabel: adultsLabel,
    dataTestId: "FilterWho-Adults",
    hasColumnLayout: isShrink,
    label: adultsLabel,
    max: getMaxAdultsAvailable(),
    min: minAdultsNumber,
    onChange: function onChange(name, value) {
      setAdultsNumber(value || 0);
    },
    value: adultsNumber
  }), !disableKids && FilterWho_jsx(InputNumber["a" /* InputNumber */], {
    ariaLabel: kidsLabel,
    dataTestId: "FilterWho-Kids",
    hasColumnLayout: isShrink,
    label: kidsLabel,
    max: getMaxKidsAvailable(),
    notes: kidsAgeLimitLabel,
    onChange: handleKidsNumber,
    value: kids.length
  }))), !disableKids && kids.length > 0 && hasChildcareSwitch && FilterWho_jsx("div", {
    className: "border-lightGrey border-t-1 p-10"
  }, FilterWho_jsx(InputSwitch["a" /* InputSwitch */], {
    inputTestId: "childcare-switch" // $FlowFixMe
    ,
    isChecked: childcareIncluded,
    label: addChildcareLabel,
    onChange: function onChange(name, isChecked) {
      return setChildcareIncluded(isChecked);
    } // $FlowFixMe
    ,
    value: childcareIncluded
  })), !disableKids && kids.length > 0 && FilterWho_jsx("div", {
    className: "border-lightGrey border-t-1 p-10"
  }, FilterWho_jsx("div", {
    className: "mb-10"
  }, FilterWho_jsx("p", {
    className: "font-bold text-14 text-sienna"
  }, kidsAgeLabel), informationLabel && FilterWho_jsx("p", {
    className: "text-10"
  }, informationLabel)), Object(kidsValidationStateUtils["c" /* hasKidWithoutAValidBirthdate */])(kidsValidationState) && birthdaysErrorMessage && FilterWho_jsx(FormFeedback["a" /* FormFeedback */], {
    isError: true,
    message: birthdaysErrorMessage
  }), FilterWho_jsx("div", {
    className: !isShrink ? 'lg:flex lg:flex-wrap lg:-mx-10' : null
  }, kids.map(function (kid, index) {
    return FilterWho_jsx("div", {
      className: !isShrink ? 'flex-none lg:px-10 w-full lg:w-1/2' : null,
      key: String(kid.birthdate) + String(index)
    }, FilterWho_jsx(InputDate_InputDate, {
      className: "mb-10",
      dateFormat: dateFormat,
      onChange: function onChange(name, birthdate) {
        return handleKidAge(index, FilterWho_objectSpread(FilterWho_objectSpread({}, kid), {}, {
          birthdate: birthdate
        }));
      },
      placeholderDay: dayPlaceholder,
      placeholderMonth: monthPlaceholder,
      placeholderYear: yearPlaceholder,
      validationState: kidsValidationState[index],
      value: kid.birthdate
    }));
  }))));
};

/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return titleCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return snakeToCamel; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("uqXc");
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("EnZy");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("SYor");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_8__);










function getValidString(str) {
  return lodash_isString__WEBPACK_IMPORTED_MODULE_8___default()(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function titleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}



/***/ }),

/***/ "tuzA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRateMessagesProperties; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");


var FLEX_RATES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["constants"].FLEX_RATES;
var getRateMessagesProperties = function getRateMessagesProperties(rate) {
  switch (rate) {
    case FLEX_RATES.NRR:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.nonRefundableRateLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.nonRefundableRateLegal')
      };

    case FLEX_RATES.FLR:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.flexibleRateLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.flexibleRateLegal')
      };

    default:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.standardLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.standardLegal')
      };
  }
};

/***/ }),

/***/ "u6DZ":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ"),
    baseOrderBy = __webpack_require__("eHpp"),
    baseRest = __webpack_require__("R3TX"),
    isIterateeCall = __webpack_require__("R5u7");

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ "uM2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputText_InputText; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isInteger.js
var isInteger = __webpack_require__("RYcy");
var isInteger_default = /*#__PURE__*/__webpack_require__.n(isInteger);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-text/InputText.themes.js
var themes = {
  "default": {
    thInput: 'w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-text/InputText.jsx














var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var defaultProps = {
  autoComplete: 'off',
  theme: 'default',
  type: 'text'
};
var InputText_InputText = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputText, _Component);

  var _super = _createSuper(InputText);

  function InputText(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputText);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? noop_default.a : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = e.target.value;

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (e) {
      var _this$props$onKeyDown = _this.props.onKeyDown,
          onKeyDown = _this$props$onKeyDown === void 0 ? noop_default.a : _this$props$onKeyDown;
      e.persist();
      onKeyDown(e);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? noop_default.a : _this$props$onClear;

      _this.setState({
        value: ''
      }, function () {
        return onClear(e);
      });
    });

    _this.state = {
      value: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputText, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          autoComplete = _this$props2.autoComplete,
          className = _this$props2.className,
          dataTestId = _this$props2.dataTestId,
          hasClear = _this$props2.hasClear,
          hasValidationIcon = _this$props2.hasValidationIcon,
          iconLeft = _this$props2.iconLeft,
          _this$props2$id = _this$props2.id,
          id = _this$props2$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputText_') : _this$props2$id,
          isActive = _this$props2.isActive,
          isDisabled = _this$props2.isDisabled,
          isFilled = _this$props2.isFilled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          isRequired = _this$props2.isRequired,
          label = _this$props2.label,
          maxLength = _this$props2.maxLength,
          minLength = _this$props2.minLength,
          name = _this$props2.name,
          notes = _this$props2.notes,
          onBlur = _this$props2.onBlur,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          onKeyUp = _this$props2.onKeyUp,
          pattern = _this$props2.pattern,
          placeholder = _this$props2.placeholder,
          _this$props2$theme = _this$props2.theme,
          theme = _this$props2$theme === void 0 ? 'default' : _this$props2$theme,
          type = _this$props2.type,
          validationState = _this$props2.validationState;
      var value = this.state.value;
      var hasClearEnabled = Boolean(hasClear && value);
      var hasValue = Boolean(value);
      var thInput = themes[theme].thInput;
      return __jsx(FormControl["a" /* FormControl */], {
        className: className,
        hasClear: hasClearEnabled,
        hasValidationIcon: hasValidationIcon,
        iconLeft: iconLeft,
        id: id,
        isActive: isActive,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        theme: theme,
        validationState: validationState
      }, __jsx("input", Object(esm_extends["a" /* default */])({
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        "data-testid": dataTestId,
        id: id
      }, isInteger_default()(maxLength) ? {
        maxLength: maxLength
      } : null, isInteger_default()(minLength) ? {
        minLength: minLength
      } : null, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: this.onKeyDown,
        onKeyUp: onKeyUp // $FlowFixMe

      }, pattern ? {
        pattern: pattern
      } : null, placeholder ? {
        placeholder: Object(form_util["b" /* getFormattedLabel */])(placeholder, isRequired)
      } : null, {
        readOnly: Boolean(isReadOnly || isLoading),
        required: isRequired,
        role: type === 'search' ? 'search' : 'textbox',
        type: type,
        value: value
      })));
    }
  }]);

  return InputText;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputText_InputText, "defaultProps", defaultProps);

/***/ }),

/***/ "uMuQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayPriceDoubleSeasonPopin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("EnZy");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("fGyu");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("05v4");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("e0Ti");
/* harmony import */ var _product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("hA0C");
















var __jsx = react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */








var DayPriceDoubleSeasonPopin = function DayPriceDoubleSeasonPopin(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey,
      trackingData = _ref.trackingData;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__[/* useTracking */ "a"])();
  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_16__["useRouter"])();
  var uri = router.asPath;
  var doubleSeasonPopinMessageKey = "booking.priceCalendar.priceStatus.".concat(availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__[/* API_SIBLING_SUMMER */ "h"] ? 'siblingDescriptionSummer' : 'siblingDescriptionWinter');
  var productCountry = product.destination.country,
      _product$href = product.href,
      href = _product$href === void 0 ? '' : _product$href,
      productName = product.name,
      iconName = product.resortId;
  var splittedHref = href.split('/');
  var siblingHref = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(splittedHref.slice(0, splittedHref.length - 1)), [availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__[/* API_SIBLING_SUMMER */ "h"] ? 's' : 'w']).join('/');

  var handleBlur = function handleBlur() {
    if (setIsMouseOverDoubleSeasonPopin) {
      setTimeout(function () {
        setIsMouseOverDoubleSeasonPopin(false);
      }, 200);
    }

    setInvisible && setInvisible();
  };

  var handleFocus = function handleFocus() {
    return setIsMouseOverDoubleSeasonPopin && setIsMouseOverDoubleSeasonPopin(true);
  };

  return __jsx("div", {
    className: "bg-white cursor-default flex flex-col gap-20 items-center justify-center p-30 pointer-events-auto",
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: function onKeyDown(e) {
      e.preventDefault();
      e.stopPropagation();

      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_21__[/* ENTER */ "f"]) {
        router.push(uri.replace(href, siblingHref));
      } else {
        handleBlur();
      }
    },
    onMouseOver: handleFocus,
    onMouseLeave: handleBlur,
    tabIndex: -1
  }, __jsx("div", {
    className: "flex flex-col gap-10 items-center justify-center"
  }, __jsx(_product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__[/* ProductLogo */ "a"], {
    iconName: iconName,
    productCountry: productCountry,
    productName: productName,
    theme: "calendar"
  }), __jsx("p", {
    className: "bg-turquoise font-bold px-10 py-5 rounded-4 text-12 text-white"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])(statusMessageKey))), __jsx("p", {
    className: "leading-tight sm:leading-normal text-14 text-black text-center"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])(doubleSeasonPopinMessageKey)), __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__[/* Button */ "a"], {
    className: "pointer-events-auto w-full",
    dataTestId: "DayWithPrice-DoubleSeasonPopin-seeOtherSeason",
    onBlur: handleBlur,
    onClick: function onClick(e) {
      track(_objectSpread({
        categoryGA: 'resort',
        labelGA: 'switchSeason'
      }, trackingData));
      e.preventDefault();
      e.stopPropagation();
      router.push(uri.replace(href, siblingHref));
    },
    onFocus: handleFocus,
    size: "medium",
    tabIndex: 0
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('booking.priceCalendar.priceStatus.siblingButton')));
};

/***/ }),

/***/ "uqXc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("I+eb");
var lastIndexOf = __webpack_require__("5Yz+");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "vIa8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ activeCustomFacetsSelector; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ activeFacetsSelector; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ bannersSelector; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ customFiltersSelector; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ facetingCriteriaSelector; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ facetsSelector; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ filteredProductsSelector; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ productsBeforeActiveCustomFacetsFilteringSelector; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ recommandedProductsSelector; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ filteredProductsCountSelector; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ filteredProductsSeasonsSelector; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ filtersSelector; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getFacetingProductIds; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getFiltersSelector; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getSearchFilterList; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ getKidsValidationState; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ searchQuerySelector; });

// UNUSED EXPORTS: facetingSelector, facetingPricesSelector, productsFilteredWithActiveCustomFacetsSelector

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("E9XD");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("T63A");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("JTJg");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("rB9j");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("EnZy");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("nnRT");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqWith.js
var uniqWith = __webpack_require__("SqqE");
var uniqWith_default = /*#__PURE__*/__webpack_require__.n(uniqWith);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/inRange.js
var inRange = __webpack_require__("+ILc");
var inRange_default = /*#__PURE__*/__webpack_require__.n(inRange);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/includes.js
var includes = __webpack_require__("qYhz");
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/utils/faceting/facetingFilters.js


















var facetingFilters_FacetFilters = /*#__PURE__*/function () {
  function FacetFilters(list) {
    Object(classCallCheck["a" /* default */])(this, FacetFilters);

    Object(defineProperty["a" /* default */])(this, "_list", void 0);

    this._list = list || [];
  }

  Object(createClass["a" /* default */])(FacetFilters, [{
    key: "addFilter",
    value: function addFilter(filter) {
      this._list.push({
        id: filter.id,
        name: filter.name
      });

      return this;
    }
  }, {
    key: "addFilters",
    value: function addFilters(filters) {
      if (filters) {
        filters.map(this.addFilter.bind(this));
      }

      return this;
    }
  }, {
    key: "removeFilters",
    value: function removeFilters(ids) {
      this._list = this._list.filter(function (item) {
        return !includes_default()(ids, item.id);
      });
      return this;
    }
  }, {
    key: "addChildcareFilters",
    value: function addChildcareFilters(args) {
      var kids = args.kids,
          _args$childcareFacets = args.childcareFacets,
          facets = _args$childcareFacets === void 0 ? [] : _args$childcareFacets,
          departureDate = args.departureDate;
      var childcareFacets = isEmpty_default()(facets) ? constants["p" /* DEFAULT_CHILDCARE_FACETS */].map(function (f) {
        return {
          label: f,
          value: f
        };
      }) : facets;
      var childcareRanges = childcareFacets.map(function (_ref) {
        var name = _ref.label;
        var facetRange = name.split('-');
        return {
          name: name,
          min: parseInt(facetRange[0], 10),
          max: parseInt(facetRange[1], 10)
        };
      });
      var childcareFilters = kids.filter(function (_ref2) {
        var childcareIncluded = _ref2.childcareIncluded;
        return childcareIncluded;
      }).map(function (_ref3) {
        var birthdate = _ref3.birthdate;
        var kidAgeInMonths = Object(facetingUtils["k" /* getKidAgeInMonths */])({
          birthdate: birthdate,
          departureDate: departureDate
        });
        var matchingFacet = childcareRanges.find(function (_ref4) {
          var min = _ref4.min,
              max = _ref4.max;
          return inRange_default()(kidAgeInMonths, min, max + 1);
        }); // lodash inRange exludes the max value

        if (!matchingFacet || !matchingFacet.name) {
          return null;
        }

        return {
          id: constants["d" /* CHILDCARE_CRITERIA_FACET_ID */],
          name: matchingFacet.name
        };
      }).filter(Boolean);
      this._list = this._list.concat(uniqWith_default()(childcareFilters, isEqual_default.a));
      return this;
    }
  }, {
    key: "addAdultOnlyFilter",
    value: function addAdultOnlyFilter() {
      var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return isEmpty_default()(kids) ? this : this.addFilter({
        id: constants["c" /* ADULTS_ONLY_FACET_ID */],
        name: false
      });
    }
  }, {
    key: "value",
    value: function value() {
      return this._list.map(function (item) {
        return pick_default()(item, ['id', 'name']);
      });
    }
  }]);

  return FacetFilters;
}();
// CONCATENATED MODULE: ./src/client/store/faceting/faceting.selector.js









/* eslint-disable max-params */








var facetingSelector = function facetingSelector(_ref) {
  var faceting = _ref.faceting;
  return faceting || {};
};

var activeCustomFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref2) {
  var activeCustomFacets = _ref2.activeCustomFacets;
  return activeCustomFacets || {};
});
var activeFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref3) {
  var activeFacets = _ref3.activeFacets;
  return activeFacets || {};
});
var searchQuerySelector = Object(lib["createSelector"])(facetingSelector, function (_ref4) {
  var query = _ref4.query;
  return query || {
    label: ''
  };
});
var facetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref5) {
  var facets = _ref5.facets;
  return facets || [];
});
var customFiltersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref6) {
  var customFilters = _ref6.customFilters;
  return customFilters || [];
});
var filtersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref7) {
  var filters = _ref7.filters;
  return filters || [];
});
var facetingPricesSelector = Object(lib["createSelector"])(facetingSelector, function (_ref8) {
  var prices = _ref8.prices;
  return prices;
});
var filteredProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref9) {
  var _ref9$products = _ref9.products,
      products = _ref9$products === void 0 ? [] : _ref9$products;
  return products;
});
var productsBeforeActiveCustomFacetsFilteringSelector = Object(lib["createSelector"])(facetingSelector, function (_ref10) {
  var _ref10$productsBefore = _ref10.productsBeforeActiveCustomFacetsFiltering,
      productsBeforeActiveCustomFacetsFiltering = _ref10$productsBefore === void 0 ? null : _ref10$productsBefore;
  return productsBeforeActiveCustomFacetsFiltering;
});
var productsFilteredWithActiveCustomFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref11) {
  var _ref11$productsFilter = _ref11.productsFilteredWithActiveCustomFacets,
      productsFilteredWithActiveCustomFacets = _ref11$productsFilter === void 0 ? null : _ref11$productsFilter;
  return productsFilteredWithActiveCustomFacets;
});
var recommandedProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref12) {
  var _ref12$recommandedPro = _ref12.recommandedProducts,
      recommandedProducts = _ref12$recommandedPro === void 0 ? [] : _ref12$recommandedPro;
  return recommandedProducts;
});
var bannersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref13) {
  var banners = _ref13.banners;
  return banners || [];
});
var filteredProductsCountSelector = Object(lib["createSelector"])(facetingSelector, function (_ref14) {
  var _ref14$products = _ref14.products,
      products = _ref14$products === void 0 ? [] : _ref14$products;
  return products.length;
});
var filteredProductsSeasonsSelector = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.reduce(function (seasons, product) {
    return seasons.includes(product.seasonName) ? seasons : [].concat(Object(toConsumableArray["a" /* default */])(seasons), [product.seasonName]);
  }, []);
});
var getFacetingProductIds = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.map(function (_ref15) {
    var id = _ref15.id;
    return id;
  });
});
var getKidsValidationState = Object(lib["createSelector"])(facetingSelector, function (_ref16) {
  var _ref16$kidsValidation = _ref16.kidsValidationState,
      kidsValidationState = _ref16$kidsValidation === void 0 ? [] : _ref16$kidsValidation;
  return kidsValidationState;
});
var getSearchFilterList = Object(lib["createSelector"])(facetingSelector, function (_ref17) {
  var _ref17$searchFilterLi = _ref17.searchFilterList,
      searchFilterList = _ref17$searchFilterLi === void 0 ? [] : _ref17$searchFilterLi;
  return searchFilterList;
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * representing active facets to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var activeFacetsCriteriaSelector = Object(lib["createSelector"])(activeFacetsSelector, function (activeFacets) {
  return Object.keys(activeFacets).reduce(function (acc, categoryId) {
    Object.entries(activeFacets[categoryId]).map(function (_ref18) {
      var _ref19 = Object(slicedToArray["a" /* default */])(_ref18, 2),
          filter = _ref19[0],
          isSelected = _ref19[1];

      if (isSelected) {
        acc.push({
          id: categoryId,
          name: filter
        });
      }
    });
    return acc;
  }, []);
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * containing aggregation of both facets and criterias to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'facette_adult_only', name: false },
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var getFiltersSelector = Object(lib["createSelector"])(storeHelper["c" /* getKids */], tripCriteria_selector["b" /* getDepartureDate */], activeFacetsCriteriaSelector, filtersSelector, tripCriteria_selector["a" /* getDepartureCity */], facetsSelector, function (kids, departureDate, activeFacets, filters, departureCity, facets) {
  var allFilters = new facetingFilters_FacetFilters(filters).removeFilters([constants["a" /* ACTIVITIES_FACET_ID */], constants["c" /* ADULTS_ONLY_FACET_ID */], constants["d" /* CHILDCARE_CRITERIA_FACET_ID */], constants["r" /* DEPARTURE_CITY_FACET_ID */]].concat(Object(toConsumableArray["a" /* default */])(constants["y" /* FILTERABLE_FACETS_IDS */]))).addAdultOnlyFilter(kids).addChildcareFilters({
    kids: kids,
    childcareFacets: Object(facetingUtils["g" /* getChildcareFacets */])(facets),
    departureDate: departureDate
  }).addFilters(activeFacets);

  if (departureCity) {
    allFilters.addFilter({
      id: constants["r" /* DEPARTURE_CITY_FACET_ID */],
      name: departureCity
    });
  }

  return allFilters.value();
});
/**
 * Returns an object with an aggregation of criterias for Pertimm:
 *
 * Example:
 * ```json
 * {
 *    departureDate: '',
 *    tripDuration: '7',
 *    filters: [
 *      { id: 'facette_departure_city',  name: 'PAR' },
 *      { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 *    ]
 * }
 * ```
 */

var facetingCriteriaSelector = Object(lib["createSelector"])([tripCriteria_selector["b" /* getDepartureDate */], tripCriteria_selector["c" /* getTripDuration */], getFiltersSelector, storeHelper["c" /* getKids */]], function (departureDate, tripDuration, filters, kids) {
  return {
    departureDate: departureDate,
    tripDuration: tripDuration,
    filters: filters,
    kids: kids
  };
});


/***/ }),

/***/ "wKzQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaWho; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Rfxz");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("//nZ");
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_pick__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("uZih");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("nnRT");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("uDfI");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("SPKZ");
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("XiOS");
/* harmony import */ var _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("TYzI");
/* harmony import */ var _CriteriaTrigger__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("+Rc+");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("PFSw");
/* harmony import */ var _filter_who_FilterWho__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("tUgU");
/* harmony import */ var _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("45yR");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("kiXb");
/* harmony import */ var _store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("loSl");
/* harmony import */ var _store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("ORYz");
/* harmony import */ var _store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("VO7D");
/* harmony import */ var _store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("1bWg");
/* harmony import */ var _store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("Jsmy");
/* harmony import */ var _utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__("cGFA");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__("sRdV");




















var __jsx = react__WEBPACK_IMPORTED_MODULE_20___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var KIDS_ACTIONS = {
  CHANGE_KID: 'CHANGE_KID',
  CHANGE_KIDS_COUNT: 'CHANGE_KIDS_COUNT',
  REMOVE_KIDS: 'REMOVE_KIDS',
  SYNC_KIDS: 'SYNC_KIDS'
};

var getKidBirthdateAndChildcare = function getKidBirthdateAndChildcare(kid) {
  return lodash_pick__WEBPACK_IMPORTED_MODULE_17___default()(kid, ['birthdate', 'childcareIncluded']);
};

var getKidWithoutStatus = function getKidWithoutStatus(kid) {
  return lodash_omit__WEBPACK_IMPORTED_MODULE_18___default()(kid, ['status']);
};

var getKidWithStatus = function getKidWithStatus(kid, isKidBirthdateRequired) {
  return _objectSpread(_objectSpread({}, kid), {}, {
    status: Object(_utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_35__[/* getValidationStateFromKid */ "a"])(kid, isKidBirthdateRequired)
  });
};

var CriteriaWho = function CriteriaWho(props) {
  var disableKids = props.disableKids,
      _props$hasChildcareSw = props.hasChildcareSwitch,
      hasChildcareSwitch = _props$hasChildcareSw === void 0 ? true : _props$hasChildcareSw,
      isKidBirthdateRequired = props.isKidBirthdateRequired,
      isJoyview = props.isJoyview;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_20__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_23__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(_CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_24__[/* useCriteriaDisplayContext */ "c"])(),
      _useCriteriaDisplayCo2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_useCriteriaDisplayCo, 2),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0],
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_21__[/* useDispatch */ "d"])();
  var adultsNumber = Object(react_redux__WEBPACK_IMPORTED_MODULE_21__[/* useSelector */ "e"])(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_34__[/* getAdultsNumber */ "b"]);
  var kids = Object(react_redux__WEBPACK_IMPORTED_MODULE_21__[/* useSelector */ "e"])(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_34__[/* getKids */ "c"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_36__[/* useTracking */ "a"])({
    actionGA: criteriaContext.trackingActionName
  });

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_20__["useState"])(adultsNumber || _store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_31__[/* DEFAULT_ADULTS_NB */ "a"]),
      inputAdultsNumber = _useState[0],
      setInputAdultsNumber = _useState[1];

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_20__["useReducer"])(function (state, action) {
    switch (action.type) {
      case KIDS_ACTIONS.SYNC_KIDS:
        return action.payload;

      case KIDS_ACTIONS.REMOVE_KIDS:
        return [];

      case KIDS_ACTIONS.CHANGE_KIDS_COUNT:
        return action.payload > state.length ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(state), [{
          birthdate: undefined,
          childcareIncluded: false,
          neolid: undefined,
          status: _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_28__[/* NOT_VALIDATED */ "c"]
        }]) : state.slice(0, -1);

      case KIDS_ACTIONS.CHANGE_KID:
        return state.map(function (kid, index) {
          return index === action.payload.index ? getKidWithStatus(action.payload.kid, isKidBirthdateRequired) : kid;
        });

      default:
        return state;
    }
  }, kids.map(getKidWithStatus)),
      inputKids = _useReducer[0],
      setInputKids = _useReducer[1];

  var inputKidsValidationState = inputKids.map(function (kid) {
    return kid.status;
  });
  var hasInvalidKidsStatus = inputKidsValidationState.some(function (status) {
    return status === _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_28__[/* NOT_VALIDATED */ "c"] || status === _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_28__[/* IS_INVALID */ "a"];
  });

  var inputKidsEqualKids = lodash_isEqual__WEBPACK_IMPORTED_MODULE_19___default()(inputKids.map(getKidBirthdateAndChildcare), kids.map(getKidBirthdateAndChildcare));

  var inputAdultsNumberEqualsAdultsNumber = inputAdultsNumber === adultsNumber; // Store update effect

  Object(react__WEBPACK_IMPORTED_MODULE_20__["useEffect"])(function () {
    var adultsAreSet = adultsNumber > 0;
    var kidsAreSet = Object(_utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_35__[/* hasOnlyValidKids */ "d"])(Object(_utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_35__[/* getValidationStateFromKids */ "b"])(kids)); // Is also true when there are no kids

    setCriteriaContext({
      criteriaWhoIsSet: adultsAreSet && kidsAreSet
    });
  }, [adultsNumber, kids]);

  var openCriteriaEventHandler = function openCriteriaEventHandler() {
    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_24__[/* ACTIONS */ "a"].OPEN_CRITERIA,
      payload: 'criteriaWho'
    });
  }; // Open/Close effect


  Object(react__WEBPACK_IMPORTED_MODULE_20__["useEffect"])(function () {
    document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_26__[/* OPEN_CRITERIA_WHO_EVENT */ "a"], openCriteriaEventHandler);
    return function () {
      return document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_26__[/* OPEN_CRITERIA_WHO_EVENT */ "a"], openCriteriaEventHandler);
    };
  }, []);

  var saveParticipants = function saveParticipants() {
    if (disableKids) {
      criteriaContext.setFacetHasSeeMore(false);
      dispatch(Object(_store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_33__[/* setKids */ "b"])([]));
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_30__[/* setKidsValidationState */ "o"])([]));
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_30__[/* changeKidsNumber */ "b"])(0));
      setInputKids({
        type: KIDS_ACTIONS.SYNC_KIDS,
        payload: []
      });
    }

    if (!disableKids && !inputKidsEqualKids) {
      criteriaContext.setFacetHasSeeMore(false);
      dispatch(Object(_store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_33__[/* setKids */ "b"])(inputKids.map(getKidWithoutStatus)));
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_30__[/* setKidsValidationState */ "o"])(inputKidsValidationState));

      if (kids.length !== inputKids.length) {
        dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_30__[/* changeKidsNumber */ "b"])(inputKids.length));
      }
    }

    if (!disableKids && inputKidsEqualKids) {
      // Sync kids store with inputKids
      setInputKids({
        type: KIDS_ACTIONS.SYNC_KIDS,
        payload: inputKids
      });
    }

    if (inputKids.length > 0 && inputAdultsNumber === 0) {
      dispatch(Object(_store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_32__[/* setAdultsNumber */ "a"])(_store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_31__[/* DEFAULT_ADULTS_NB */ "a"]));
    } else if (!inputAdultsNumberEqualsAdultsNumber) {
      dispatch(Object(_store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_32__[/* setAdultsNumber */ "a"])(inputAdultsNumber));
    }

    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_24__[/* ACTIONS */ "a"].CLOSE_CRITERIA,
      payload: 'criteriaWho'
    });
  };

  var labelParts = '';
  var labelPartsMobile = '';

  if (adultsNumber > 0) {
    var labelPartsTmp = [];
    var lengthPeople = adultsNumber + kids.length;

    if (lengthPeople) {
      labelPartsMobile = lengthPeople.toString(10);

      if (adultsNumber >= 1) {
        labelPartsTmp.push(Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('booking.form.selectAdultsLabels', {
          count: adultsNumber
        }));
      }

      if (kids.length >= 1) {
        labelPartsTmp.push(Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('booking.form.selectChildrenLabels', {
          count: kids.length
        }));
      }

      labelParts = labelPartsTmp.join(' - ');
    }
  } else {
    labelParts = Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.who.title');
  }

  var buttonLabel = __jsx(react__WEBPACK_IMPORTED_MODULE_20__["Fragment"], null, __jsx("span", {
    className: "hidden lg:inline truncate"
  }, labelParts), __jsx("span", {
    className: "lg:hidden"
  }, labelPartsMobile));

  var trackKidsNumberChange = function trackKidsNumberChange(value) {
    if (criteriaContext.trackingActionName) {
      track({
        labelGA: 'who_child',
        valueGA: value
      });
    }
  };

  var trackAdultsNumberChange = function trackAdultsNumberChange(value) {
    if (criteriaContext.trackingActionName) {
      track({
        labelGA: 'who_adult',
        valueGA: value
      });
    }
  };

  var onOpen = Object(react__WEBPACK_IMPORTED_MODULE_20__["useCallback"])(function () {
    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_24__[/* ACTIONS */ "a"].OPEN_CRITERIA,
      payload: 'criteriaWho'
    });
  }, []);
  var onClear = Object(react__WEBPACK_IMPORTED_MODULE_20__["useCallback"])(function () {
    setCriteriaContext({
      criteriaWhoIsSet: false
    });
    dispatch(Object(_store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_32__[/* setAdultsNumber */ "a"])(0));
    dispatch(Object(_store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_33__[/* setKids */ "b"])([]));
    dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_30__[/* changeKidsNumber */ "b"])(0));
    dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_30__[/* setKidsValidationState */ "o"])([]));
    setInputKids({
      type: KIDS_ACTIONS.REMOVE_KIDS
    });
    setInputAdultsNumber(_store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_31__[/* DEFAULT_ADULTS_NB */ "a"]);
  }, []);
  return __jsx(_CriteriaTrigger__WEBPACK_IMPORTED_MODULE_25__[/* CriteriaTrigger */ "a"], {
    buttonLabel: buttonLabel,
    buttonIcon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].PEOPLE_DOUBLE,
    buttonIsFilled: criteriaContext.criteriaWhoIsSet,
    dataTestId: "CriteriaWho",
    dropDownMinWidth: 500,
    isOpen: criteriaDisplayContext.criteriaWhoIsOpen,
    isJoyview: isJoyview,
    trackingLabel: "who",
    onOpen: onOpen,
    onClose: saveParticipants,
    onClear: onClear,
    buttons: [{
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.reset'),
      dataTestId: 'criteria-who-reset',
      onClick: function onClick() {
        setInputAdultsNumber(_store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_31__[/* DEFAULT_ADULTS_NB */ "a"]);
        setInputKids({
          type: KIDS_ACTIONS.REMOVE_KIDS
        });
      },
      theme: 'link'
    }, {
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.validate'),
      dataTestId: 'criteria-who-validate',
      isDisabled: isKidBirthdateRequired && hasInvalidKidsStatus,
      onClick: function onClick() {
        saveParticipants();
        dispatchCriteriaDisplayContext({
          type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_24__[/* ACTIONS */ "a"].OPEN_NEXT_CRITERIA,
          payload: {
            currentCriteria: 'criteriaWho',
            criteriaContext: criteriaContext
          }
        });
      }
    }]
  }, __jsx(_filter_who_FilterWho__WEBPACK_IMPORTED_MODULE_27__[/* FilterWho */ "a"], {
    adultsLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.who.adults'),
    adultsNumber: inputAdultsNumber,
    disableKids: disableKids,
    hasChildcareSwitch: hasChildcareSwitch,
    kids: inputKids,
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.who.title'),
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.who.subTitle'),
    kidsLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.who.kids'),
    kidsAgeLabel: isKidBirthdateRequired ? Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.who.ageSectionSubtitle') : Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.who.ageSectionChildcareSubtitle'),
    kidsAgeLimitLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.who.kidsAgeLimit'),
    dateFormat: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('booking.form.dateFormat'),
    dayPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('booking.form.dayPlaceholder'),
    monthPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('booking.form.monthPlaceholder'),
    yearPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('booking.form.yearPlaceholder'),
    informationLabel: !isKidBirthdateRequired ? Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.who.ageComment') : undefined,
    addChildcareLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('faceting.who.addChildcare'),
    birthdaysErrorMessage: isKidBirthdateRequired ? Object(_i18n__WEBPACK_IMPORTED_MODULE_29__[/* t */ "h"])('booking.form.errors.birthdayFormat') : '',
    changeKidsNumber: function changeKidsNumber(value) {
      setInputKids({
        type: KIDS_ACTIONS.CHANGE_KIDS_COUNT,
        payload: value
      });
      trackKidsNumberChange(value);
    },
    changeKid: function changeKid(index, kid) {
      setInputKids({
        type: KIDS_ACTIONS.CHANGE_KID,
        payload: {
          index: index,
          kid: kid
        }
      });
    },
    kidsValidationState: inputKidsValidationState,
    validateKidsBirthdate: function validateKidsBirthdate(index, kid) {
      setInputKids({
        type: KIDS_ACTIONS.CHANGE_KID,
        payload: {
          index: index,
          kid: kid
        }
      });
    },
    setAdultsNumber: function setAdultsNumber(number) {
      setInputAdultsNumber(number);
      trackAdultsNumberChange(number);
    }
  }));
};

/***/ }),

/***/ "wQ38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_UPDATE_KID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIP_INFORMATION_RESET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_KID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATION_STATE_ENUM; });
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3KgV");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__);

var TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
var TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS = 'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
var TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
var TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';
var DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true
};
var VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED'
});

/***/ }),

/***/ "wRBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputDatalist_InputDatalist; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isFunction.js
var isFunction = __webpack_require__("2q8g");
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isUndefined.js
var isUndefined = __webpack_require__("CZlo");
var isUndefined_default = /*#__PURE__*/__webpack_require__.n(isUndefined);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/striptags/striptags.js
var striptags = __webpack_require__("47go");
var striptags_default = /*#__PURE__*/__webpack_require__.n(striptags);

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-text/InputText.jsx + 1 modules
var InputText = __webpack_require__("uM2S");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/widgets/exclusive-collection-badge/ECBadge.jsx
var ECBadge = __webpack_require__("Itgl");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.layouts.jsx
var __jsx = react_default.a.createElement;





var InputDatalist_layouts_DefaultLayout = function DefaultLayout(_ref) {
  var icon = _ref.icon,
      isActive = _ref.isActive,
      label = _ref.label,
      subLabel1 = _ref.subLabel1,
      subLabel2 = _ref.subLabel2,
      type = _ref.type;

  var _useState = Object(react["useState"])(false),
      hover = _useState[0],
      setHover = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!label) {
    return null;
  }

  return __jsx("div", {
    className: classnames_default()('hocus:bg-black cursor-pointer flex gap-10 items-center overflow-hidden p-10 hocus:text-white transition-colors duration-250 ease-in', {
      'bg-black text-white': isActive
    }),
    onMouseEnter: function onMouseEnter() {
      return isDesktop && setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return isDesktop && setHover(false);
    }
  }, icon ? __jsx(Icon["a" /* Icon */], {
    className: classnames_default()('shrink-0', {
      'text-black': !hover && !isActive
    }),
    name: icon,
    width: "1.25rem"
  }) : __jsx(ECBadge["a" /* ECBadge */], {
    className: "shrink-0",
    height: 30
  }), __jsx("div", {
    className: "decorator-match flex-1 text-16"
  }, !!subLabel1 && !!subLabel2 && __jsx("div", {
    className: classnames_default()('leading-1 text-12', {
      'text-black': !isActive && !hover,
      'text-current': isActive || hover
    })
  }, !!subLabel1 && __jsx("span", {
    className: "font-bold uppercase"
  }, subLabel1), !!subLabel1 && !!subLabel2 && __jsx("span", null, " - "), !!subLabel2 && __jsx("span", null, subLabel2)), __jsx("div", {
    className: classnames_default()({
      'font-brand': type === 'resort'
    }) // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: label
    }
  })));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.themes.js
var themes = {
  "default": {
    thRoot: 'isolate relative',
    thDatalist: 'absolute arrow-up arrow-large arrow-white arrow-bg arrow-bg-lightGrey bg-white border-1 border-lightGrey divide-y divide-lightGrey  mt-20 p-10 rounded-12 shadow-lg top-full w-full z-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.jsx
























var InputDatalist_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-env browser */







var defaultProps = {
  dataList: [],
  theme: 'default'
};
var InputDatalist_InputDatalist = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(InputDatalist, _PureComponent);

  var _super = _createSuper(InputDatalist);

  function InputDatalist(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputDatalist);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "dataListElementRef", null);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickOutside", function (e) {
      var isActive = _this.state.isActive;

      if (!_this.dataListElementRef || !isActive) {
        return;
      }

      var dataListNode = _this.dataListElementRef.current;

      if (!dataListNode || !dataListNode.contains(e.target)) {
        _this.setState({
          isActive: false
        });

        if (_this.props.onClickOutside) {
          _this.props.onClickOutside();
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openList", function () {
      _this.setState(function (prevState) {
        if (!prevState.isActive) {
          return {
            isActive: true
          };
        }
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (e) {
      var _this$props = _this.props,
          _this$props$dataList = _this$props.dataList,
          dataList = _this$props$dataList === void 0 ? [] : _this$props$dataList,
          onClear = _this$props.onClear,
          onKeyDown = _this$props.onKeyDown,
          onValidate = _this$props.onValidate;
      var _this$state = _this.state,
          index = _this$state.index,
          selected = _this$state.selected;

      if (e.keyCode === keyCodes["a" /* ARROW_DOWN */] && index < dataList.length - 1) {
        _this.goToIndex(1);
      } else if (e.keyCode === keyCodes["d" /* ARROW_UP */] && index > 0) {
        _this.goToIndex(-1);
      } else if (e.keyCode === keyCodes["f" /* ENTER */]) {
        var item = dataList[index];

        _this.setState({
          isActive: false
        });

        if (item) {
          _this.onSelect(item);
        } else if (selected === '' && isFunction_default()(onClear)) {
          onClear();
        } else if (isFunction_default()(onValidate)) {
          onValidate();
        }
      }

      if (isFunction_default()(onKeyDown)) {
        onKeyDown(e);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onFocus", function (e) {
      var onFocus = _this.props.onFocus;

      if (isFunction_default()(onFocus) && !_this.state.isActive) {
        onFocus(e);
      }

      _this.openList();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (name, value) {
      _this.setState({
        isActive: true,
        selected: value
      }, function () {
        if (_this.props.onChange) {
          _this.props.onChange(name, value);
        }
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? noop_default.a : _this$props$onClear;

      _this.setState({
        index: -1,
        isActive: false,
        selected: ''
      }, function () {
        return onClear(e);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickItem", function (item) {
      return function () {
        return _this.onSelect(item);
      };
    });

    _this.dataListElementRef = /*#__PURE__*/Object(react["createRef"])();
    _this.state = {
      index: -1,
      isActive: false,
      selected: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputDatalist, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (true) {
        document.addEventListener('click', this.onClickOutside);
        document.addEventListener('focus', this.onClickOutside);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (true) {
        document.removeEventListener('click', this.onClickOutside);
        document.removeEventListener('focus', this.onClickOutside);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var selected = this.props.value;

      if (!isUndefined_default()(selected) && !prevState.isActive && prevState.selected !== selected) {
        this.setState({
          selected: selected
        });
      }
    }
  }, {
    key: "goToIndex",
    value: function goToIndex(offset) {
      this.setState(function (prevState) {
        var index = prevState.index + offset;
        return {
          index: index
        };
      });
    }
  }, {
    key: "onSelect",
    value: function onSelect(item) {
      var _this$props$onSelect = this.props.onSelect,
          onSelect = _this$props$onSelect === void 0 ? noop_default.a : _this$props$onSelect;
      var sanitizedItem = {
        item: item,
        label: striptags_default()(get_default()(item, 'label'))
      };
      this.setState({
        index: -1,
        isActive: false,
        selected: sanitizedItem.label
      });
      onSelect(sanitizedItem);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          dataList = _this$props2.dataList,
          id = _this$props2.id,
          isAnimated = _this$props2.isAnimated,
          isDisabled = _this$props2.isDisabled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          itemLayout = _this$props2.itemLayout,
          itemTitle = _this$props2.itemTitle,
          theme = _this$props2.theme;
      var _themes$theme = themes[theme],
          thDatalist = _themes$theme.thDatalist,
          thRoot = _themes$theme.thRoot;
      var _this$state2 = this.state,
          isActive = _this$state2.isActive,
          selected = _this$state2.selected;
      return InputDatalist_jsx("div", {
        className: classnames_default()(thRoot, className),
        ref: this.dataListElementRef
      }, InputDatalist_jsx(InputText["a" /* InputText */], Object(esm_extends["a" /* default */])({}, pick_default()(this.props, ['hasClear', 'hasValidationIcon', 'iconLeft', 'isDisabled', 'isFilled', 'isLoading', 'isReadOnly', 'isRequired', 'label', 'name', 'notes', 'onBlur', 'onClick', 'onKeyUp', 'placeholder', 'theme', 'validationState']), {
        autoComplete: "off",
        dataTestId: "InputDatalistQuery",
        id: id,
        isActive: isActive && !isReadOnly,
        onChange: this.onChange,
        onClear: this.onClear,
        onFocus: this.onFocus,
        onKeyDown: this.onKeyDown,
        type: "text",
        value: selected
      })), isActive && !isReadOnly && !isDisabled && !isLoading && !!dataList.length && InputDatalist_jsx("ul", {
        className: classnames_default()(thDatalist, {
          'animate-fadeIn animation-duration-500': isAnimated
        }),
        "data-testid": "InputDatalistList",
        role: "listbox"
      }, !!itemTitle && InputDatalist_jsx("li", null, itemTitle), dataList.map(function (item, index) {
        if (!item.label) {
          return null;
        }

        var indexFromState = _this2.state.index;

        var newItem = _objectSpread(_objectSpread({}, item), {}, {
          isActive: index === indexFromState
        });

        var hasCustomLayout = isFunction_default()(itemLayout);

        return InputDatalist_jsx("li", {
          "data-testid": item.id,
          key: item.id ? item.id : index,
          onClick: // $FlowFixMe
          _this2.onClickItem(item)
        }, // $FlowFixMe
        hasCustomLayout ? itemLayout(newItem) : InputDatalist_jsx(InputDatalist_layouts_DefaultLayout, newItem));
      })));
    }
  }]);

  return InputDatalist;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(InputDatalist_InputDatalist, "defaultProps", defaultProps);

/***/ }),

/***/ "waz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToastContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ToastContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__["createContext"]({
  ref: null
});

/***/ }),

/***/ "wg0c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("2oRo");
var fails = __webpack_require__("0Dky");
var uncurryThis = __webpack_require__("4zBA");
var toString = __webpack_require__("V37c");
var trim = __webpack_require__("WKiH").trim;
var whitespaces = __webpack_require__("WJkJ");

var $parseInt = global.parseInt;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "x0AG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("I+eb");
var $findIndex = __webpack_require__("tycR").findIndex;
var addToUnscopables = __webpack_require__("RNIs");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "xGYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputNumber_InputNumber; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("qePV");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.themes.js

var themes = {
  "default": function _default(_ref) {
    var hasColumnLayout = _ref.hasColumnLayout,
        hasValue = _ref.hasValue,
        isDisabled = _ref.isDisabled,
        isReadOnly = _ref.isReadOnly,
        validationState = _ref.validationState;
    return {
      thRoot: classnames_default()('flex items-center', {
        'flex-col gap-5 text-center': hasColumnLayout,
        'gap-10 justify-between': !hasColumnLayout
      }),
      thLabel: classnames_default()('text-14', {
        'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thNotes: 'block text-10',
      thInputs: 'flex gap-5 items-center shrink-0',
      thInput: classnames_default()('font-bold text-18 text-center outline-custom', {
        'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thButton: 'aspect-square cursor-pointer disabled:cursor-default bg-saffron hocus:enabled:bg-saffron-active disabled:bg-pearl h-[3rem] rounded-pill shrink-0 disabled:text-grey transition-colors duration-250 ease-in w-[3rem]',
      thButtonIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx














var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var InputNumber_InputNumber = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputNumber, _Component);

  var _super = _createSuper(InputNumber);

  function InputNumber(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputNumber);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? noop_default.a : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = Number(e.target.value);

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "decrease", function () {
      var _this$props2 = _this.props,
          _this$props2$name = _this$props2.name,
          name = _this$props2$name === void 0 ? '' : _this$props2$name,
          _this$props2$min = _this$props2.min,
          min = _this$props2$min === void 0 ? 0 : _this$props2$min,
          _this$props2$step = _this$props2.step,
          step = _this$props2$step === void 0 ? 1 : _this$props2$step,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === void 0 ? noop_default.a : _this$props2$onChange;
      var currentValue = _this.state.value || min;
      var decreasedValue = currentValue - step;
      var nextValue = decreasedValue >= min ? decreasedValue : min;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "increase", function () {
      var _this$props3 = _this.props,
          _this$props3$name = _this$props3.name,
          name = _this$props3$name === void 0 ? '' : _this$props3$name,
          _this$props3$min = _this$props3.min,
          min = _this$props3$min === void 0 ? 0 : _this$props3$min,
          _this$props3$max = _this$props3.max,
          max = _this$props3$max === void 0 ? 10 : _this$props3$max,
          _this$props3$step = _this$props3.step,
          step = _this$props3$step === void 0 ? 1 : _this$props3$step,
          _this$props3$onChange = _this$props3.onChange,
          onChange = _this$props3$onChange === void 0 ? noop_default.a : _this$props3$onChange;
      var currentValue = _this.state.value || min;
      var increasedValue = currentValue + step;
      var nextValue = increasedValue <= max ? increasedValue : max;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    _this.state = {
      value: props.value
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputNumber, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          ariaLabel = _this$props4.ariaLabel,
          autoComplete = _this$props4.autoComplete,
          className = _this$props4.className,
          _this$props4$dataTest = _this$props4.dataTestId,
          dataTestId = _this$props4$dataTest === void 0 ? 'InputNumber' : _this$props4$dataTest,
          _this$props4$hasColum = _this$props4.hasColumnLayout,
          hasColumnLayout = _this$props4$hasColum === void 0 ? false : _this$props4$hasColum,
          _this$props4$id = _this$props4.id,
          id = _this$props4$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputNumber_') : _this$props4$id,
          isDisabled = _this$props4.isDisabled,
          isLoading = _this$props4.isLoading,
          isReadOnly = _this$props4.isReadOnly,
          isRequired = _this$props4.isRequired,
          label = _this$props4.label,
          _this$props4$max = _this$props4.max,
          max = _this$props4$max === void 0 ? 10 : _this$props4$max,
          _this$props4$min = _this$props4.min,
          min = _this$props4$min === void 0 ? 1 : _this$props4$min,
          name = _this$props4.name,
          notes = _this$props4.notes,
          onBlur = _this$props4.onBlur,
          onClick = _this$props4.onClick,
          onFocus = _this$props4.onFocus,
          onKeyDown = _this$props4.onKeyDown,
          onKeyUp = _this$props4.onKeyUp,
          placeholder = _this$props4.placeholder,
          step = _this$props4.step,
          theme = _this$props4.theme,
          validationState = _this$props4.validationState;
      var value = this.state.value;
      var hasValue = Boolean(value);
      var decreaseDisabled = isDisabled || isLoading || Number(value) <= min;
      var increaseDisabled = isDisabled || isLoading || Number(value) >= max;

      var _themes$theme = themes[theme]({
        hasColumnLayout: hasColumnLayout,
        hasValue: hasValue,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        validationState: validationState
      }),
          thButton = _themes$theme.thButton,
          thButtonIconWidth = _themes$theme.thButtonIconWidth,
          thInput = _themes$theme.thInput,
          thInputs = _themes$theme.thInputs,
          thLabel = _themes$theme.thLabel,
          thNotes = _themes$theme.thNotes,
          thRoot = _themes$theme.thRoot;

      if (false) {}

      return __jsx("div", {
        className: classnames_default()(thRoot, className),
        "data-testid": dataTestId
      }, !!label && __jsx("label", {
        className: thLabel,
        htmlFor: id
      }, label, !!notes && __jsx("span", {
        className: thNotes
      }, notes)), __jsx("div", {
        className: thInputs
      }, !isReadOnly && __jsx("button", {
        className: thButton,
        "data-testid": "".concat(dataTestId, "-decrease"),
        disabled: decreaseDisabled,
        onClick: this.decrease,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].MINUS,
        width: thButtonIconWidth
      })), __jsx("input", Object(esm_extends["a" /* default */])({
        "aria-label": ariaLabel,
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        id: id,
        max: max,
        min: min // $FlowFixMe

      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
      }, placeholder ? {
        placeholder: placeholder
      } : null, {
        readOnly: true,
        required: isRequired,
        step: step,
        style: {
          width: "".concat(max.toString().length + 0.5, "em"),
          height: '1.875em',
          lineHeight: '1.875em'
        },
        type: "number",
        value: value
      })), !isReadOnly && __jsx("button", {
        className: thButton,
        "data-testid": "".concat(dataTestId, "-increase"),
        disabled: increaseDisabled,
        onClick: this.increase,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].PLUS,
        width: thButtonIconWidth
      }))));
    }
  }]);

  return InputNumber;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputNumber_InputNumber, "defaultProps", {
  autoComplete: 'off',
  max: 10,
  min: 0,
  step: 1,
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "y0S3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return composeFiltersAsPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLocaleFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFlexibilityDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureDateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDurationFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getProductIdsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getOfferFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFacetsFilters; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_flattenDeep__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("cdI6");
/* harmony import */ var lodash_flattenDeep__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_flattenDeep__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash_flatten__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("1xil");
/* harmony import */ var lodash_flatten__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_flatten__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_findLast__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("GFPz");
/* harmony import */ var lodash_findLast__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_findLast__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("4+vj");
/* harmony import */ var _faceting_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("sW3P");
















var FILTER_PARAM = 'filters';
function composeFiltersAsPayload() {
  for (var _len = arguments.length, filters = new Array(_len), _key = 0; _key < _len; _key++) {
    filters[_key] = arguments[_key];
  }

  var formData = lodash_flattenDeep__WEBPACK_IMPORTED_MODULE_9___default()(filters).reduce(function (acc, _ref) {
    var name = _ref.name,
        value = _ref.value,
        operation = _ref.operation;

    if (value) {
      acc.push("".concat(FILTER_PARAM, "[").concat(name, "][values][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_13___default.a.encode(value)));
    }

    if (value && operation) {
      acc.push("".concat(FILTER_PARAM, "[").concat(name, "][operations][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_13___default.a.encode(operation)));
    }

    return acc;
  }, []);

  return formData.join('&');
}

function buildFilters(_ref2) {
  var name = _ref2.name,
      value = _ref2.value,
      operation = _ref2.operation;
  return value ? [{
    name: name,
    value: value,
    operation: operation
  }] : [];
}

function getLocaleFilters(locale) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* LOCALE_FACET_ID */ "I"],
    value: locale,
    operation: operation
  });
}
var getFlexibilityDates = function getFlexibilityDates(_ref3) {
  var departureDate = _ref3.departureDate,
      flexibility = _ref3.flexibility;

  if (!flexibility || !departureDate) {
    return {
      minDepartureDate: departureDate,
      maxDepartureDate: departureDate
    };
  }

  var minDepartureDate = moment__WEBPACK_IMPORTED_MODULE_12___default()(departureDate).subtract(flexibility, 'days');
  return {
    minDepartureDate: minDepartureDate.isAfter(moment__WEBPACK_IMPORTED_MODULE_12___default()().add(1, 'days')) ? minDepartureDate.valueOf() : moment__WEBPACK_IMPORTED_MODULE_12___default()().add(1, 'days').valueOf(),
    maxDepartureDate: moment__WEBPACK_IMPORTED_MODULE_12___default()(departureDate).add(flexibility, 'days').valueOf()
  };
};
function getDepartureDateFilters(_ref4) {
  var departureDate = _ref4.departureDate,
      _ref4$flexibility = _ref4.flexibility,
      flexibility = _ref4$flexibility === void 0 ? 0 : _ref4$flexibility,
      locale = _ref4.locale,
      _ref4$operation = _ref4.operation,
      operation = _ref4$operation === void 0 ? 'and' : _ref4$operation;

  var _getFlexibilityDates = getFlexibilityDates({
    departureDate: departureDate,
    flexibility: flexibility
  }),
      minDepartureDate = _getFlexibilityDates.minDepartureDate,
      maxDepartureDate = _getFlexibilityDates.maxDepartureDate;

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_DATE_MIN_FACET_ID */ "v"],
    value: minDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_14__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_12___default()(minDepartureDate), locale),
    operation: operation
  })), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_DATE_MAX_FACET_ID */ "u"],
    value: maxDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_14__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_12___default()(maxDepartureDate), locale),
    operation: operation
  })));
}
function getDepartureCityFilters(_ref5) {
  var _ref5$facets = _ref5.facets,
      facets = _ref5$facets === void 0 ? [] : _ref5$facets,
      _ref5$defaultValue = _ref5.defaultValue,
      defaultValue = _ref5$defaultValue === void 0 ? '' : _ref5$defaultValue,
      _ref5$operation = _ref5.operation,
      operation = _ref5$operation === void 0 ? 'and' : _ref5$operation;
  var departureCityFacet = lodash_findLast__WEBPACK_IMPORTED_MODULE_11___default()(facets, function (_ref6) {
    var id = _ref6.id;
    return id === _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_CITY_FACET_ID */ "r"];
  }) || {};
  var value = departureCityFacet.name || defaultValue;
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_CITY_FACET_ID */ "r"],
    value: value,
    operation: operation
  });
}
function getDurationFilters(duration) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DURATION_FACET */ "x"],
    value: duration,
    operation: operation
  });
}

function getProductIdFilters(id) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* PRODUCT_FACET_ID */ "P"],
    value: id,
    operation: operation
  });
}

function getProductIdsFilters() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 ? arguments[1] : undefined;
  return lodash_flatten__WEBPACK_IMPORTED_MODULE_10___default()(ids.map(function (id) {
    return getProductIdFilters(id, operation);
  }));
}
function getOfferFilters(offerId) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* OFFER_ID_FACET_ID */ "N"],
    value: offerId,
    operation: operation
  });
}
var FACETS_TO_OMIT = [_faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_DATE_MIN_FACET_ID */ "v"], _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_DATE_MAX_FACET_ID */ "u"], _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_CITY_FACET_ID */ "r"], _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DURATION_FACET */ "x"], _faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* OFFER_ID_FACET_ID */ "N"]];
function getFacetsFilters() {
  var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  var filters = facets.filter(function (facet) {
    return !FACETS_TO_OMIT.includes(facet.id);
  }).map(function (facet) {
    return buildFilters({
      name: facet.id,
      value: facet.name,
      operation: operation
    });
  });
  return lodash_flatten__WEBPACK_IMPORTED_MODULE_10___default()(filters);
}

/***/ }),

/***/ "y316":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ suggest; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ search; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ searchWithFacets; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getIdsFromProducts; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/memoize.js
var memoize = __webpack_require__("pFSi");
var memoize_default = /*#__PURE__*/__webpack_require__.n(memoize);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/pertimm-client/filters.js
var filters = __webpack_require__("y0S3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("qePV");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");

// EXTERNAL MODULE: /opt/webapp/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/utils/pertimm-client/request.js












function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var PertimmRequestFailed = error_js_default.a.create({
  name: 'PertimmRequestFailed',
  message: 'The Pertimm request failed'
});

var request_getAxiosConfig = function getAxiosConfig() {
  var proxyConfig = config_default.a.get('pertimm.proxy');
  var httpsAgent;

  if (false) {}

  return {
    httpsAgent: httpsAgent,
    proxy: httpsAgent ? false : undefined
  };
};

var START_INDEX_PARAM = 'res_sf';

function recursivePostRequest(_ref) {
  var axiosConfig = _ref.axiosConfig,
      url = _ref.url,
      payload = _ref.payload,
      queryparams = _ref.queryparams,
      acc = _ref.acc;
  return Object(axios["request"])(_objectSpread(_objectSpread({}, axiosConfig), {}, {
    method: 'POST',
    url: url,
    data: payload,
    params: queryparams
  })).then(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref2.data;

    if (!acc) {
      acc = _objectSpread({}, data);
    } else {
      acc.answers = [].concat(Object(toConsumableArray["a" /* default */])(acc.answers), Object(toConsumableArray["a" /* default */])(data.answers || []));
    }

    var nextStart = Number(data.start_answer) + Number(data.returned_answers_count) - 1;
    var hasMoreAnswers = nextStart + 1 < Number(data.available_answers_count);
    return hasMoreAnswers ? recursivePostRequest({
      axiosConfig: axiosConfig,
      url: url,
      payload: payload,
      queryparams: _objectSpread(_objectSpread({}, queryparams), {}, Object(defineProperty["a" /* default */])({}, START_INDEX_PARAM, nextStart)),
      acc: acc
    }) : acc;
  })["catch"](function () {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _error$response = error.response;
    _error$response = _error$response === void 0 ? {} : _error$response;
    var _error$response$statu = _error$response.status,
        status = _error$response$statu === void 0 ? 500 : _error$response$statu,
        _error$response$data = _error$response.data,
        data = _error$response$data === void 0 ? '' : _error$response$data;
    throw new PertimmRequestFailed({
      statusCode: status,
      errors: data
    });
  });
}

function postSearchRequest(_ref3) {
  var _objectSpread3;

  var locale = _ref3.locale,
      _ref3$payload = _ref3.payload,
      payload = _ref3$payload === void 0 ? '' : _ref3$payload,
      _ref3$queryparams = _ref3.queryparams,
      queryparams = _ref3$queryparams === void 0 ? {} : _ref3$queryparams;
  return recursivePostRequest({
    url: config_default.a.get('pertimm.apiUrl'),
    axiosConfig: request_getAxiosConfig(),
    payload: payload,
    queryparams: _objectSpread((_objectSpread3 = {
      enable_interpretation_explanation: true
    }, Object(defineProperty["a" /* default */])(_objectSpread3, START_INDEX_PARAM, 0), Object(defineProperty["a" /* default */])(_objectSpread3, "search_locale", locale), Object(defineProperty["a" /* default */])(_objectSpread3, "user_locale", locale), _objectSpread3), queryparams),
    acc: undefined
  });
}
// CONCATENATED MODULE: ./src/utils/pertimm-client/index.js







var ACTIONS = {
  WORD_WHEEL: 'wordWheel',
  PERTIMM_SEARCH: 'pertimmSearch'
};

var pertimm_client_getApiKey = memoize_default()(function getApiKey(appContext) {
  return config_default.a.get( // eslint-disable-next-line no-nested-ternary
  appContext.isCmta ? 'api.cm_ta_api_key' : Object(sellerUtils["g" /* isSeller */])(appContext) ? 'api.seller.api_key' : 'api.api_key');
});

function suggest(_ref) {
  var appContext = _ref.appContext,
      _ref$criteria = _ref.criteria,
      criteria = _ref$criteria === void 0 ? {} : _ref$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords = criteria.keywords,
      keywords = _criteria$keywords === void 0 ? '' : _criteria$keywords,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.WORD_WHEEL,
      max_suggests: config_default.a.get('pertimm.max_suggests'),
      enable_interpretation_explanation: 'true',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }))
  });
}

function search(_ref2) {
  var appContext = _ref2.appContext,
      _ref2$criteria = _ref2.criteria,
      criteria = _ref2$criteria === void 0 ? {} : _ref2$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords2 = criteria.keywords,
      keywords = _criteria$keywords2 === void 0 ? '' : _criteria$keywords2,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  });
}

function searchWithFacets(_ref3) {
  var _ref3$criteria = _ref3.criteria,
      criteria = _ref3$criteria === void 0 ? {} : _ref3$criteria,
      appContext = _ref3.appContext;
  var departureDate = criteria.departureDate,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: criteria.query || '',
      'contexts[boutique]': criteria.boutique,
      'contexts[screenSize]': criteria.screenSize
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale), Object(filters["b" /* getDepartureCityFilters */])({
      facets: criteria.filters,
      defaultValue: criteria.defaultDepartureCity
    }), Object(filters["d" /* getDurationFilters */])(criteria.tripDuration), Object(filters["i" /* getProductIdsFilters */])(criteria.productIds), Object(filters["e" /* getFacetsFilters */])(criteria.filters), Object(filters["h" /* getOfferFilters */])(criteria.offerId))
  });
}

function getIdsFromProducts(appContext) {
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      disable_catalogs: 1
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  }).then(function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$answers = _ref4.answers,
        answers = _ref4$answers === void 0 ? [] : _ref4$answers;

    return answers.map(function (result) {
      return get_default()(result, 'meta.product_id[0]');
    });
  });
}



/***/ }),

/***/ "yjkv":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("S3pA"),
    baseUniq = __webpack_require__("s+R0");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ "z3uz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFacetTemplateConfig; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("yXV3");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sW3P");




var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["constants"].NO_TRANSPORT_VALUE;
var getFacetTemplateConfig = function getFacetTemplateConfig(criteriaContext, departureCity) {
  var displayActivityFilter = criteriaContext.displayActivityFilter,
      displayChildcareFilter = criteriaContext.displayChildcareFilter,
      displayDestinationFilter = criteriaContext.displayDestinationFilter,
      displayFlightDurationFilter = criteriaContext.displayFlightDurationFilter,
      displaySeasonFilter = criteriaContext.displaySeasonFilter,
      displayTypeOfStayFilter = criteriaContext.displayTypeOfStayFilter;
  var enabledFilterIds = [displayActivityFilter ? _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* ACTIVITIES_FACET_ID */ "a"] : null, displayChildcareFilter ? _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* CHILDCARE_FILTER_FACET_ID */ "f"] : null, displayDestinationFilter ? _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* DESTINATIONS_FACET_ID */ "w"] : null, displayFlightDurationFilter && departureCity && departureCity !== NO_TRANSPORT_VALUE ? _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* FLIGHT_DURATION_FACET_ID */ "C"] : null, displaySeasonFilter ? _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* SEASON_FACET_ID */ "S"] : null, displayTypeOfStayFilter ? _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* TYPES_OF_STAY_FACET_ID */ "ab"] : null];
  return _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* FILTERABLE_FACETS_TEMPLATE_CONFIG */ "z"].filter(function (_ref) {
    var id = _ref.id;
    return enabledFilterIds.indexOf(id) !== -1;
  });
};

/***/ }),

/***/ "zCbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_PREFIX_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTrackingTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCityName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSummer; });
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_toUpper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9BmX");
/* harmony import */ var lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_toUpper__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_inRange__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("+ILc");
/* harmony import */ var lodash_inRange__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_inRange__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_tracking_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("829J");





var WITH_TRANSPORT = 'with Transport';
var WITHOUT_TRANSPORT = 'without Transport';
var NO_DEPARTURE_CITY = 'NO';
var TRACKING_PREFIX_MAPPING = {
  ACTIVITIES: 'activities',
  CHILDCARE: 'childcare'
};
function getTrackingTransport(departureCityCode) {
  return departureCityCode && lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default()(departureCityCode) !== NO_DEPARTURE_CITY ? WITH_TRANSPORT : WITHOUT_TRANSPORT;
}
function getDepartureCityCode(departureCityCode) {
  return departureCityCode && lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default()(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityCode : WITHOUT_TRANSPORT;
}
function getDepartureCityName(departureCityCode, departureCityName) {
  return departureCityName && departureCityCode && lodash_toUpper__WEBPACK_IMPORTED_MODULE_1___default()(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityName : '';
}
function isSummer(date) {
  return lodash_inRange__WEBPACK_IMPORTED_MODULE_2___default()(Number(moment__WEBPACK_IMPORTED_MODULE_3___default()(date).format('MMDD')), _client_tracking_constants__WEBPACK_IMPORTED_MODULE_4__[/* SUMMER_DATE_START */ "z"], _client_tracking_constants__WEBPACK_IMPORTED_MODULE_4__[/* SUMMER_DATE_END */ "y"]);
}

/***/ }),

/***/ "zjU+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getActiveFacetTabTrackingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFacetLocalizedLabelKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTypesOfStayFacetBadgeIconProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFacetLocalizedLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return trackFilterChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackFacetChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onClearFacets; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("EnZy");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("LKBx");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("zygG");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("sW3P");




















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




function getLabelGA(facetId) {
  switch (facetId) {
    case 'activities':
      return 'whichActivities';

    case 'destinations':
      return 'whichDestinations';

    default:
      // 'when', 'who', 'where'
      return facetId;
  }
}

var getActiveFacetTabTrackingData = function getActiveFacetTabTrackingData(_ref) {
  var facetId = _ref.facetId;
  return {
    actionGA: 'smartCriterias',
    labelGA: getLabelGA(facetId)
  };
};
var getFacetLocalizedLabelKey = function getFacetLocalizedLabelKey(facetValue) {
  if (facetValue === null || facetValue === void 0 ? void 0 : facetValue.startsWith(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* GROUP_STRING */ "F"])) {
    return facetValue.replace(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* GROUP_STRING */ "F"], '');
  }

  var _facetValue$split = facetValue.split('_'),
      _facetValue$split2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(_facetValue$split, 2),
      firstPart = _facetValue$split2[0],
      secondPart = _facetValue$split2[1]; // Some facet values are localized so we need to extract the first part of the value that is the same for every locale to identify which value we are dealing with (example of some values returned by Pertimm for types of stay filter: ['0_JOYVIEW', '0_TOUR', '3_3 tridents', '3_三颗海神戟']


  return secondPart && _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES */ "M"].includes(secondPart) ? secondPart : firstPart;
};
var getTypesOfStayFacetBadgeIconProps = function getTypesOfStayFacetBadgeIconProps(_ref2) {
  var facetBadgeIcons = _ref2.facetBadgeIcons,
      facetLabel = _ref2.facetLabel,
      facetValue = _ref2.facetValue;
  return _objectSpread(_objectSpread({}, facetBadgeIcons[getFacetLocalizedLabelKey(facetValue)]), {}, {
    alt: facetLabel
  });
};
var getFacetLocalizedLabel = function getFacetLocalizedLabel(_ref3) {
  var facetValue = _ref3.facetValue,
      facetLabels = _ref3.facetLabels;
  var splitedValue = facetValue.split('_');
  var labelKey = getFacetLocalizedLabelKey(facetValue);
  var localizedLabel = facetLabels[labelKey] ? Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])(facetLabels[labelKey]) : splitedValue[1] || facetValue;
  return localizedLabel;
};

var getFacetTrackingSuffix = function getFacetTrackingSuffix(name, value) {
  var _CHILDCARE_FILTER_FAC, _FLIGHT_DURATION_FACE, _SEASON_FACET_LABELS$, _TYPES_OF_STAY_FACET_;

  var stringValue = value.toString();

  var _stringValue$split = stringValue.split('_'),
      _stringValue$split2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(_stringValue$split, 2),
      firstPart = _stringValue$split2[0],
      secondPart = _stringValue$split2[1];

  var labelKey = getFacetLocalizedLabelKey(stringValue);

  switch (name) {
    case _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* CHILDCARE_FILTER_FACET_ID */ "f"]:
      return ((_CHILDCARE_FILTER_FAC = _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* CHILDCARE_FILTER_FACET_LABELS */ "g"][labelKey]) === null || _CHILDCARE_FILTER_FAC === void 0 ? void 0 : _CHILDCARE_FILTER_FAC.replace(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* CHILDCARE_FILTER_FACET_LABELS_PREFIX */ "h"], '')) || firstPart.toLowerCase();

    case _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* FLIGHT_DURATION_FACET_ID */ "C"]:
      return ((_FLIGHT_DURATION_FACE = _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* FLIGHT_DURATION_FACET_LABELS */ "D"][labelKey]) === null || _FLIGHT_DURATION_FACE === void 0 ? void 0 : _FLIGHT_DURATION_FACE.replace(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* FLIGHT_DURATION_FACET_LABELS_PREFIX */ "E"], '')) || firstPart.toLowerCase();

    case _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* SEASON_FACET_ID */ "S"]:
      return ((_SEASON_FACET_LABELS$ = _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* SEASON_FACET_LABELS */ "T"][labelKey]) === null || _SEASON_FACET_LABELS$ === void 0 ? void 0 : _SEASON_FACET_LABELS$.replace(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* SEASON_FACET_LABELS_PREFIX */ "U"], '')) || firstPart.toLowerCase();

    case _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* TYPES_OF_STAY_FACET_ID */ "ab"]:
      return ((_TYPES_OF_STAY_FACET_ = _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* TYPES_OF_STAY_FACET_LABELS */ "bb"][labelKey]) === null || _TYPES_OF_STAY_FACET_ === void 0 ? void 0 : _TYPES_OF_STAY_FACET_.replace(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* TYPES_OF_STAY_FACET_LABELS_PREFIX */ "cb"], '')) || secondPart.toLowerCase();

    default:
      return stringValue.replace(/[|\s]/g, '_').toLowerCase();
  }
};

var trackFilterChange = function trackFilterChange(name) {
  var trackingConfig = _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_20__[/* FILTERABLE_FACETS_TRACKING_CONFIG */ "A"].find(function (_ref4) {
    var id = _ref4.id;
    return id === name.replace('[]', '');
  });

  if (!trackingConfig) {
    return;
  }

  return "".concat(trackingConfig.trackingPrefixLabel);
};
var trackFacetChange = function trackFacetChange(name, checked, value) {
  if (!checked) {
    return;
  }

  var labelSuffix = getFacetTrackingSuffix(name, value);
  var trackingPrefixLabel = trackFilterChange(name);

  if (!trackingPrefixLabel) {
    return;
  }

  return "".concat(trackingPrefixLabel, "_").concat(labelSuffix);
};
var onClearFacets = function onClearFacets(clearFacetList, id, templateConfig) {
  if (!templateConfig) {
    return;
  }

  clearFacetList(id);
  templateConfig.facetLists.forEach(function (_ref5) {
    var facetListId = _ref5.id;
    clearFacetList(facetListId);
  });
};

/***/ }),

/***/ "zr3P":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("kn3Q");

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ "zwLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPLECategoryGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPLEPaymentConfirmationSiteSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSearchMappedTypeForLabelGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return noCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pascalCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSiteSection; });
/* unused harmony export TRACKING_ROOM_TYPE */
/* unused harmony export TRACKING_ROOM_TYPE_BY_ACCOMMODATION_CATEGORY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTrackingRoomType; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("yXV3");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("EnZy");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("2dTi");
/* harmony import */ var lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lodash_fp_last__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("cFQB");
/* harmony import */ var lodash_fp_last__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_last__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_fp_flow__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("lozs");
/* harmony import */ var lodash_fp_flow__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_flow__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("TYRa");
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_upperFirst__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_toLower__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Eu1I");
/* harmony import */ var lodash_toLower__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_toLower__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("psri");
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_startCase__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("S0cN");
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_camelCase__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("829J");




















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_19__["b2cPagesService"].PAGE_TYPES;
var formatPayload = function formatPayload(payload, options) {
  return Object.keys(payload).reduce(function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])({}, key, Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__["messageFormat"])(payload[key]).format(options)));
  }, {});
};
function getPLECategoryGA(isUserQuickLogged) {
  return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_20__[/* PLE_QUICK */ "n"] : _constants__WEBPACK_IMPORTED_MODULE_20__[/* PLE */ "l"];
}
function getPLEPaymentConfirmationSiteSection(_ref) {
  var isOption = _ref.isOption,
      isUserQuickLogged = _ref.isUserQuickLogged;

  if (isOption) {
    return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_20__[/* PLE_QUICK_OPTION */ "o"] : _constants__WEBPACK_IMPORTED_MODULE_20__[/* PLE_OPTION */ "m"];
  }

  return getPLECategoryGA(isUserQuickLogged);
}
function getSearchMappedTypeForLabelGA(type) {
  return _constants__WEBPACK_IMPORTED_MODULE_20__[/* SEARCH_LABEL_GA_MAP */ "q"][type || 'none'];
}
function noCase(string) {
  return lodash_toLower__WEBPACK_IMPORTED_MODULE_16___default()(lodash_startCase__WEBPACK_IMPORTED_MODULE_17___default()(string));
}
function pascalCase(string) {
  return lodash_upperFirst__WEBPACK_IMPORTED_MODULE_15___default()(lodash_camelCase__WEBPACK_IMPORTED_MODULE_18___default()(string));
}
function getSiteSection(_ref2) {
  var _ref2$isOption = _ref2.isOption,
      isOption = _ref2$isOption === void 0 ? false : _ref2$isOption,
      _ref2$isUserQuickLogg = _ref2.isUserQuickLogged,
      isUserQuickLogged = _ref2$isUserQuickLogg === void 0 ? false : _ref2$isUserQuickLogg,
      pageType = _ref2.pageType;

  switch (pageType) {
    case PAGE_TYPES.DESTINATION_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.DESTINATION));

    case PAGE_TYPES.HOME_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.HOME));

    case PAGE_TYPES.LANDING_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.LANDING));

    case PAGE_TYPES.RESORT_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.RESORT));

    case PAGE_TYPES.PREBOOKING:
      var siteSection = pageType.split('-')[0];
      return "Shopping_".concat(pascalCase(siteSection));

    case _constants__WEBPACK_IMPORTED_MODULE_20__[/* STATIC_PAGE_TYPES */ "x"].BE:
      return _constants__WEBPACK_IMPORTED_MODULE_20__[/* BE */ "a"];

    case _constants__WEBPACK_IMPORTED_MODULE_20__[/* STATIC_PAGE_TYPES */ "x"].PLE:
      return getPLECategoryGA(isUserQuickLogged);

    case _constants__WEBPACK_IMPORTED_MODULE_20__[/* STATIC_PAGE_TYPES */ "x"].PLE_PAYMENT_CONFIRMATION:
      return getPLEPaymentConfirmationSiteSection({
        isOption: isOption,
        isUserQuickLogged: isUserQuickLogged
      });

    default:
      return "Shopping_".concat(pascalCase(pageType));
  }
}
var TRACKING_ROOM_TYPE = {
  CLUB: 'club',
  DELUXE: 'deluxe',
  SUITE: 'suite',
  CHALET: 'chalet',
  VILLA: 'villa'
};
var TRACKING_ROOM_TYPE_ORDER = [TRACKING_ROOM_TYPE.CLUB, TRACKING_ROOM_TYPE.DELUXE, TRACKING_ROOM_TYPE.SUITE, TRACKING_ROOM_TYPE.CHALET, TRACKING_ROOM_TYPE.VILLA];
var TRACKING_ROOM_TYPE_BY_ACCOMMODATION_CATEGORY = {
  '000017': TRACKING_ROOM_TYPE.CLUB,
  // club
  '000048': TRACKING_ROOM_TYPE.CLUB,
  // club seaside view
  '000061': TRACKING_ROOM_TYPE.CLUB,
  // superior
  '000022': TRACKING_ROOM_TYPE.CLUB,
  // superior
  '000018': TRACKING_ROOM_TYPE.DELUXE,
  // deluxe
  '000039': TRACKING_ROOM_TYPE.DELUXE,
  // deluxe zen
  '000047': TRACKING_ROOM_TYPE.DELUXE,
  // deluxe seaside view
  '000056': TRACKING_ROOM_TYPE.DELUXE,
  // Deluxe Exclusive
  '000019': TRACKING_ROOM_TYPE.SUITE,
  // suite
  '000020': TRACKING_ROOM_TYPE.SUITE,
  // suite 5 tridents
  '000024': TRACKING_ROOM_TYPE.CHALET,
  // chalet
  '000028': TRACKING_ROOM_TYPE.VILLA // villa

};
function getTrackingRoomType(accommodations) {
  var accommodation = lodash_fp_flow__WEBPACK_IMPORTED_MODULE_14___default()(lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_12___default()(function (_ref3) {
    var categoryId = _ref3.categoryId;
    return TRACKING_ROOM_TYPE_ORDER.indexOf(TRACKING_ROOM_TYPE_BY_ACCOMMODATION_CATEGORY[categoryId]);
  }), lodash_fp_last__WEBPACK_IMPORTED_MODULE_13___default.a // $FlowFixMe issue with lodash typings
  )(accommodations);

  return TRACKING_ROOM_TYPE_BY_ACCOMMODATION_CATEGORY[accommodation === null || accommodation === void 0 ? void 0 : accommodation.categoryId];
}

/***/ })

}]);